import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Search, ChefHat, Heart, Printer } from 'lucide-react';
import { supabase } from './supabase';

const RECIPES_DATA = [
{
"id": 258,
"name": "Aardappelcurry met kip en bloemkool",
"recipe": "Verhit de olie in een hapjespan. Bestrooi de kip met peper en zout en bak op middelhoog vuur in 3 min. rondom goudbruin. Neem uit de pan en houd apart. Doe de bloemkool in de pan en bak 3 min. Voeg de saus toe, doe de deksel op de pan en laat op laag vuur 5 min. koken. Doe de aardappelschijfjes erbij en kook nog 15 min. totdat de schijfjes gaar zijn. Voeg eventueel wat water toe als de saus heel dik wordt. Doe de laatste 5 min. de kip erbij. Breng op smaak met peper en zout, bestrooi met de pinda's en serv2eer.",
"ingredients": "300 g kipfilet, in blokjes\n1 bloemkool, in kleine roosjes\n1 pot tikka massalasaus\n800 g aardappelschijfjes\n3 el pinda's ongezouten, grof gehakt",
"servings": 4,
"serveWith": "knoflook-koriander naanbrood",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/d8VDQbd.jpeg"
},
{
"id": 476,
"name": "Aardappelgratin met wintergroenten",
"recipe": "Verwarm de oven voor op 180ºC. Breng een pan water aan de kook. Schil de pastinaak en wortelen en snijd in stukjes. Kook de stukjes pastinaak en wortel in ca. 8 min. beetgaar. Klop ondertussen het ei los en meng met de room, voeg hier 2/3 van de geraspte kaas aan toe. Breng op smaak met een snufje nootmuskaat en flink wat peper en zout. Giet de pastinaak en wortels af en leg in een ovenschaal samen met de aardappelpartjes. Giet het roommengsel over de groenten en strooi de overige geraspte kaas over het gerecht. Bak de gratin in ca. 30 min. in de oven goudbruin.",
"ingredients": "1 pastinaak\n2 wortelen\n1 ei\n200 ml kookroom\n100 g geraspte kaas\nsnufje nootmuskaat\npeper en zout\n300 g voorgegaarde aardappelpartjes",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/1rkI2tu.jpeg"
},
{
"id": 253,
"name": "Aardappel-groentecurry",
"recipe": "Schil de aardappelen, snijd ze in blokjes van 2 cm en kook ze 8 min. in water met zout. Verhit de olie in een hapjespan en fruit de ui 1 min. Verwijder de steelaanzet en het puntje van de sperziebonen. Voeg de sperziebonen en erwten toe en bak 2 min. mee. Doe de boemboe erbij en bak 1 min. mee. Voeg de kokosmelk toe en breng aan de kook. Giet de aardappelen af en leg in de curry. Kook de groentecurry op laag vuur in 20 min. gaar. Kook ondertussen de eieren in 8 min. hard. Laat ze schrikken, pel ze en halveer. Schep de curry in 4 kommen en leg de eieren erop.",
"ingredients": "1 kg aardappelen, vastkokend\n2 el zonnebloemolie\n2 uien, gesnipperd\n400 g sperziebonen\n1/2 pak tuinerwten extra fijn\n100 g boemboe groene curry\n400 ml kokosmelk\n4 eieren",
"servings": 4,
"serveWith": "Naanbrood",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/O3nQSKc.jpeg"
},
{
"id": 1,
"name": "Aardappelsalade met tonijn",
"recipe": "Kook de aardappelen in 10 min. gaar. Kook ondertussen de eieren in 7 min. hard, spoel ze onder koud stromend water af, pel ze en snijd ze in plakken. Verwijder de steelaanzet en het puntje van de sperziebonen. Kook de bonen in 6 min. beetgaar. Verdeel de sla over 4 borden. Giet de sperziebonen en de aardappelen af en schep ze over de sla. Verdeel dan de uiringen, de tonijn, de olijven en de plakken ei over de sla en vervolgens de dressing.",
"ingredients": "700 g krielaardappelen, in plakjes\n4 eieren\n600 g sperziebonen\n200 g krulsla melange\n1 ui, in ringen\n2 blikjes tonijnmoot op olie (à 160 g)\n100 g zwarte olijven\n6 el honing-mosterd sladressing",
"servings": 4,
"serveWith": "warm stokbrood",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/MYextD1.jpeg"
},
{
"id": 2,
"name": "Aardappelwortelschotel",
"recipe": "Verwarm oven voor op 200 °C. Bekleed ovenschaal tot over rand met spek. Schep aardappel en wortel in kom met melk, room, eieren, tijm en knoflook. Voeg zout en peper toe. Schep mengsel in ovenschaal. Strooi kaas erover en vouw spek terug. Bedek met aluminiumfolie en plaats 40 min. in de oven. Verwijder folie en gratineer 10 min. onder grill.",
"ingredients": "300 g dunne plakjes katenspek\n1 kg vastkokende aardappelen in plakken\n1 kg winterpeen in dikke plakken\n250 ml volle melk\n250 ml slagroom\n2 eieren losgeklopt\n1 el tijm\n1 teentje knoflook\n50 g geraspte oude kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/J07pxc9.jpeg"
},
{
"id": 266,
"name": "Andijvie met kipspiesen",
"recipe": "Doe de kipfilet in een kom. Schenk er 3 el ketjap bij, schep om en laat afgedekt in de koelkast 15 min. marineren. Kook ondertussen de rijst volgens de aan­wijzingen op de verpakking. Rijg de kip aan de satéprikkers. Verhit 2 el olie in een wok en fruit de knoflook 1 min. Voeg de andijvie, kokosmelk en de rest van de ketjap toe en laat 8 min. smoren. Verhit de rest van de olie in een ruime koeken­pan en bak de kipspiesen in 6 min. rondom gaar. Verdeel de rijst, spiesen en het andijviemengsel over 4 diepe borden en bestrooi met de pinda's",
"ingredients": "300 g kipfilet, in blokjes\n5 el ketjap manis\n275 g meergranenrijst\n4 el zonnebloemolie\n1 teen knoflook, fijngesneden\n1 krop andijvie, in repen\n200 ml kokosmelk\n50 g pinda's ongezouten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/krz2YSP.jpeg"
},
{
"id": 245,
"name": "Appel-jachtschotel",
"recipe": "Verwarm de oven voor op 200 °C. Schil de aardappelen, snijd in stukken en kook in 20 min. gaar. Verhit ondertussen 25 g boter in een hapjespan en bak het gehakt in 5 min. rul. Voeg de ui, prei en champignons toe en bak 4 min. mee. Voeg de tomatenpuree, sauce en tijm toe en verwarm nog 2 min. Schep in de ingevette ovenschaal. Giet de aardappelen af en vang 100 ml kookvocht op. Stamp ze met de rest van de boter en het kookvocht tot een grove puree met de pureestamper. Breng op smaak met peper en zout. Snijd 2 appels in vieren, schil ze, verwijder het klokhuis en snijd in blokjes. Meng door de puree en verdeel over het gehakt. Snijd de 2 appels ongeschild in plakjes van 2 mm en verwijder de pitjes. Leg de plakjes dakpansgewijs op de puree, de appelkroosjes worden zacht in de oven. Bak in de oven in ca. 25 min. goudbruin en gaar.",
"ingredients": "800 g aardappelen, kruimig\n50 g boter\n500 g rundergehakt\n2 uien, gesnipperd\n1 prei, in halve ringen\n250 g champignons, in kwarten\n70 g blikje tomatenpuree\n1 el worcestershiresauce\n2 tl gedroogde tijm\n4 braeburn appels",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/k1r2xJ5.jpeg"
},
{
"id": 3,
"name": "Argentijnse biefstuk",
"recipe": "Cranberry's wassen. In pan berry's met sinaasappelsap en tijm 10 min koken. Berry's boven andere pan door zeef wrijven. Fond, port en suiker door berrypuree roeren en 10 min inkoken. Maïzena aan vocht toevoegen. In kom de magor smeuïg roeren en in spuitzak doen. Biefstukken 4 min bakken. Saus door bakvet roeren en aan kook brengen. Saus naast biefstuk serveren, magor erover spuiten en peperbessen erover strooien.",
"ingredients": "250 g cranberry's\n1 dl sinaasappelsap\n2 tl tijm\n190 ml vleesfond\n2 dl rode port\n1 el suiker\n2 tl maïzena\n50 g magor kaas\n2 Argentijnse biefstukken\n25 g boter\n2 tl roze peperbessen",
"servings": 2,
"serveWith": "aardappelpuree, gegrillde courgetten",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 370,
"name": "Aubergine gevuld met gekruide kip",
"recipe": "Verwarm de oven voor op 200ºC. Halveer de aubergines in de lengte en leg ze met het snijvlak op de bakplaat. Bestrijk de schil met olie en dek af met aluminiumfolie. Bak circa 30 minuten in de oven en laat afkoelen onder het folie. Hak intussen de kipfilet fijn in de keukenmachine. Schep het meeste vruchtvlees uit de auberginehelften, maar laat nog minimaal 1 cm vruchtvlees aan de schil zitten. Hak het verwijderde vruchtvlees fijn. Verhit de rest van de olie en fruit hierin de ui in 5 minuten goudbruin. Voeg de pijnboompitten en oregano toe en bak nog 1 minuut mee. Laat afkoelen en voeg ze samen met het fijngehakte vruchtvlees, de specerijen en de rozijnen toe aan het gehakt. Kneed goed door en breng op smaak met zout en peper. Verlaag de oventemperatuur naar 180ºC. Leg de auberginehelften in een ovenschaal en vul met het kipmengsel. Bestrijk met olie en bak de aubergines in de oven in circa 30 minuten gaar.\n",
"ingredients": "2 aubergines\n2 el olijfolie\n200 g kipfilet (in blokjes)\n1 ui (fijngesnipperd)\n25 g pijnboompitten\n1 el oregano\nmespunt kaneelpoeder\nnootmuskaat\n50 g rozijnen",
"servings": 4,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/Yoalwx4.jpeg"
},
{
"id": 407,
"name": "Bami met verse gember",
"recipe": "Bereid de noedels volgens de aanwijzingen op de verpakking. Giet af. Schil de gember en snijd deze zo fijn mogelijk. Snijd de knoflook fijn en de ui in halve ringen. Snijd het steeltje van de rode peper. Halveer de peper in de lengte en verwijder met een scherp mesje de zaadlijsten. Snijd de peper in dunne reepjes. Verhit de olie in een wok en fruit de gember, rode peper en knoflook 1 min. Voeg de ui en ketjap toe en roerbak 2 min. Voeg de rest van de groente toe en roerbak nog 3 min. Neem de groente uit de wok. Verhit de olie in de wok en breek de eieren erboven. Roerbak 3 min. Voeg de noedels en groente toe en roerbak nog 1 min. Serveer de bami met atjar en kroepoek.",
"ingredients": "250 g woknoedels\n3 cm verse gember\n1 teen knoflook\n2 uien\n450 g nasi-bamigroente\n3 el rijstolie\n4 el ketjap manis\n4 middelgrote eieren\n4 porties atjar tjampoer\n4 porties kroepoek",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Noedels",
"photo": "https://i.imgur.com/Axxe1Am.jpeg"
},
{
"id": 297,
"name": "Bami met zalm",
"recipe": "Kook de mie volgens de aanwijzingen op de verpakking. Snijd het steeltje van de rode peper uit het groentepakket. Halveer de peper in de lengte en verwijder met een scherp mesje de zaadlijsten. Snijd de peper fijn. Snijd de tomaat uit het groentepakket in plakjes en bewaar voor garnering. Meng de knoflook met de ketjap. Marineer de zalm in het ketjapmengsel. Verhit de olie in een wok. Voeg de rode peper, kruidenmix en groenten toe en bak 2 min. mee. Schuif de groenten in de wok aan de kant. Voeg de zalm en marinade toe en bak 3-4 min. mee. Schep de mie erdoor. Garneer met de tomaat.",
"ingredients": "250 g Chinese mie\n1 schaal nasi-bamigroenten\n2 tenen knoflook, geperst\n3 el ketjap asin\n4 Schotse zalmfilets, in stukjes\n3 el Oosterse roerbakolie\n1 zakje kruidenmix voor bami",
"servings": 4,
"serveWith": "kroepoek",
"protein": "Vis",
"starch": "Noedels",
"photo": "https://i.imgur.com/BGTGeoT.jpeg"
},
{
"id": 277,
"name": "Bangers & mash",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Schil en snijd de aardappels in gelijke stukken. Kook de aardappels in circa 15 minuten gaar. Giet af en stoom droog. Pureer de aardappels met een pureestamper. Verwarm de melk.Maak de puree smeuïg met de melk en een klontje boter. Roer de mosterd erdoor en breng op smaak met een beetje zout en versgemalen peper. Verhit een klontje boter in een pan en bak de worsten rondom goudbruin in circa 5 minuten. Haal uit de pan en leg op een bordje. Pel en snipper de uien. Ris en hak de rozemarijn fijn. Snijd de champignons in plakjes. Schil en snijd de wortel in blokjes. Bak de uien, rozemarijn, champignons en de wortel circa 5 minuten in de pan waar de worsten in gebakken zijn.Schenk de fond er bij en breng het geheel aan de kook. Voeg de worsten en de doperwten toe en laat circa 8 minuten zachtjes meekoken.Breng het geheel op smaak met versgemalen peper. Verdeel de mash over borden en schep de bangers eroverheen. Lepel de jus van de bangers er royaal overheen.",
"ingredients": "800 g kruimige aardappels\n100 ml melk\n1 klontje boter\n1 el grove mosterd\n4 varkensworsten\n3 rode uien\n4 takjes rozemarijn\n250 g kastanjechampignons\n1 winterwortel\n200 ml vleesfond\n200 g diepvriesdoperwten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/IBaeTCC.jpeg"
},
{
"id": 4,
"name": "Baskische kip",
"recipe": "Paprika's, champignons en ham in stukjes snijden. Kippenbout inwrijven met zout en peper en bestrooien met bloem. In braadpan olie verhitten. Voeg kippenbout en knoflook toe en bak rondom licht bruin. Voeg gepelde tomaten met vocht, paprika's, champignons, ham en cayennepeper toe. Breng aan de kook met deksel op pan en laat 15 min zachtjes sudderen. Deksel verwijderen en 30 min zachtjes laten pruttelen. Peterselie erboven fijnknippen.",
"ingredients": "2 groene paprika's\n250 g champignons\n100 g rauwe ham\n4 kippebouten\n3 el bloem\n4 el olijfolie\nknoflook\nblik gepelde tomaten (400 g)\ncayennepeper\npeterselie\nzout\npeper",
"servings": 4,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ktqpUWs.jpeg"
},
{
"id": 5,
"name": "Basmatirijst met gekruide kippenboutjes",
"recipe": "Meng in kom sojasaus, gembersiroop, citroensap, peper en zout. Marineer hierin kip 1 uur. Verhit kruidenboter. Fruit knoflook. Bak kip rondom bruin. Voeg marinade en wijn toe en stoof 25 min. Bindt vocht met maïzena. Kook intussen rijst.",
"ingredients": "250 g basmatirijst\n 0,5 dl gembersiroop\n1 el citroensap\n2 kuikenbouten\n50 g kruidenboter\n1 fijngehakt teentje knoflook\n1 dl witte wijn\nmaïzena\n3 el sojasaus",
"servings": 2,
"serveWith": "broccoli",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/CJAsfxQ.jpeg"
},
{
"id": 6,
"name": "Beef Bourguignon",
"recipe": "Bak wortel, ui en bleekselderij 3 minuten in olie. Voeg wijn, tijm, knoflook en 2 laurierblaadjes toe. Kook zachtjes 15 minuten. Af laten koelen. Schenk marinade over vlees en zet ovenacht in de koelkast. Schenk marinade af en bewaar. Bak spek krokant, voeg sjalotjes toe en doe in ovenschaal. Dep het vlees droog en bak in porties bruin in olie. Haal uit de pan en voeg aan ovenschaal toe. Doe 3 grote el marinade in pan en roer aanbaksels los. Giet ook in ovenschaal. Roer bloem, rest marinade en runderbouillon door ovenschaal. Breng aan de kook, doe deksel erop en zet in 3 tot 3½ uur in oven (150 °C) tot het vlees erg zacht is. Bak halverwege de champignons bruin in boter, voeg de cognac toe en kook enkele minuten. Voeg champignons toe aan ovenschaal en roer door elkaar.",
"ingredients": "1,5 kg riblappen in blokjes\n1 grote wortel in blokjes\n1 grote ui in blokjes\n2 stengels bleekselderij in stukjes\n2 flessen rode bourgogne\n2 takjes tijm\n1 teentje knoflook doormidden\n4 laurierblaadjes\n225 g rookspek\n450 g gepelde sjalotjes\n30 g bloem\n375 g kastanjechampignons\n75 ml cognac\nverse peterselie",
"servings": 6,
"serveWith": "nieuwe aardappelen met peterselie en broccoli",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 7,
"name": "Bief Stroganoff",
"recipe": "Uien, paprika, champignons en bieflappen in stukjes snijden. 25 g boter verhitten. Vlees in 3 minuten bruin bakken. Met vocht uit de pan halen. Rest boter verhitten. Uien en paprika 2 minuten bakken. Champignons toevoegen en 3 minuten roerbakken. Stroganoffsauspoeder door gezeefde tomaten roeren. Mengsel aan champignons toevoegen. Crème fraîche erdoor roeren. Vlees met vocht erdoor scheppen en door en door heet laten worden. Naar smaak zout en peper toevoegen.",
"ingredients": "2 uien\n1 rode paprika\n500 g champignons\n500 g bieflappen\n50 g boter\n1 zakje stroganoffsaus\n1 dl gezeefde tomaten\n1 bekertje crème fraîche\nzout\npeper",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/zLoa1mg.jpeg"
},
{
"id": 8,
"name": "Biefstuk met oesterzwammen",
"recipe": "Biefstuk, lente-ui, kool, oesterzwammen, paprika en peper klein snijden. Vlees 2-3 uur marineren in mengsel van honing, kruiden, knoflook, gember, ketjap, olie en 1½ dl water. Vlees uit marinade nemen en in wok 1 min roerbaken. Lente-ui en paprika 2 min meebakken. Kool en oesterzwammen 2 min meebakken. Spaanse peper erdoor scheppen.",
"ingredients": "500 g kogelbiefstuk\n1 bosje lente-uitjes\n0,5 Chinese kool\n150 g oesterzwammen\n1 gele paprika\n1 rode Spaanse peper\n2 el honing\n1 el Chinese kruiden\n2 teentjes knoflook\n2 el ketjap manis\n2 el olie\n2 el gemberpoeder",
"servings": 4,
"serveWith": "pandan rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/WRGmoDm.jpeg"
},
{
"id": 357,
"name": "Biefstuk met sesam en boontjes",
"recipe": "Neem het vlees circa 30 minuten voor het bereiden uit de koelkast en dep het droog. Bestrooi met zout en peper. Verhit de boter en bak hierin de biefstukken circa 2 minuten per kant. Verpak het vlees in aluminiumfolie en laat het rusten. Kook intussen de sperziebonen 7-8 minuten. Rooster de sesamzaadjes en pinda’s in een droge, hete koekenpan. Verhit de arachideolie en bak hierin de krieltjes 4-5 minuten. Voeg de sesamolie toe aan het bakvet van het vlees en bak hierin de, eventueel iets kleiner gescheurde, oesterzwammen circa 2 minuten. Blus af met de sherry en sojasaus. Serveer de biefstuk met de krieltjes en oesterzwammen. Schep de sesamzaadjes en pinda’s door de sperziebonen en serveer ze erbij.",
"ingredients": "4 biefstukken\n50 g boter of vloeibaar bakproduct\n500 g sperziebonen\n1 el sesamzaad\n1 el gehakte pinda’s\n2 el arachideolie\n450 g voorgekookte krieltjes\n1 tl sesamolie\n250 g oesterzwammen\n2 el sherry",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/fhMQuUA.jpeg"
},
{
"id": 391,
"name": "Bietenrisotto met geitenkaas",
"recipe": "Verwarm de oven voor op 180 °C. Breng het bietensap aan de kook. Pel en snipper de ui. Verhit een scheutje olie in een hapjespan en fruit de ui, risottorijst en roze peper op laag vuur. Schil en snijd de bieten in kleine blokjes. Voeg toe aan de rijst en fruit kort mee. Voeg beetje bij beetje bietensap toe zodat de risottorijst langzaam gaart en mooi paars kleurt. Laat de rijst in circa 20 minuten gaar worden. Snijd de geitenkaas in plakken. Verdeel de pompoenpitten en notenmix over een met bakpapier beklede bakplaat, besprenkel met honing en bestrooi met een beetje zout en versgemalen peper. Leg de plakken geitenkaas erbovenop en bak het geheel circa 10 minuten in de oven. Breng de risotto op smaak met een scheutje frambozenazijn, zout en versgemalen peper. Rasp de Parmezaanse kaas en voeg toe aan de risotto. Schep de risotto in een diep bord. Bestrooi met de noten uit de oven en leg de geitenkaas erbovenop.",
"ingredients": "750 ml bietensap\n1 ui\n1 el roze peperbes\nolijfolie om in te bakken\n400 g risottorijst\n4 rode rauwe bieten\n300 g geitenkaas met korst\n50 g pompoenpitten\n50 g ongezouten notenmix\n1.5 el honing\n2 el frambozenazijn\n50 g Parmezaanse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/VbrhexK.jpeg"
},
{
"id": 9,
"name": "Bikburgers",
"recipe": "Kneed het gehakt met zout, peper en paprikapoeder goed door elkaar. Maak er 4 ronde ballen van en druk ze plat tot echte hamburgers. Pel het uitje en snij het in kleine stukjes. Meng in een kommetje ui, mayonaise en curry door elkaar. Was de tomaat en de slablaadjes. Snij de augurk en de tomaat in dunne plakjes. Verhit in een koekenpan de boter en bak de hamburgers 5 minuten aan de ene, en 5 minuten aan de andere kant. Snij intussen de broodjes open. Smeer de onderkant dun in met de saus, en leg blaadjes sla op de broodjes. Daarop leg je de hamburgers. Schep de rest van de saus op de hamburgers. Plakjes augurk en tomaat erop.",
"ingredients": "350 g rundergehakt\n1 tl zout\npeper\n0,5 tl milde paprikapoeder\n1 kleine ui\n2 el mayonaise\n1 el curry-ketchup\n1 grote zoetzure augurk\n4 blaadjes sla\n1 tomaat\n2 el boter of margarine\n4 zachte witte bolletjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/rP7zPjI.jpeg"
},
{
"id": 427,
"name": "Bladerdeegtaart met gorgonzola, venkel en pecan",
"recipe": "Laat het deeg in de verpakking ontdooien. Schaaf de venkel en ui in zeer dunne plakken en schep met de olijfolie en wat versgemalen peper in een kom door elkaar. Verwarm de oven voor op 200ºC. Spreid het deeg uit op de bakplaat en druk bij losse deegplakjes alle randen goed op elkaar. Bestrijk de buitenste centimeter vanaf de rand met water en vouw naar binnen zodat je een iets verdikte rand krijgt. Verdeel de geschaafde venkel en ui gelijkmatig erover en bak de taart circa 10 minuten in het midden van de oven. Neem uit de oven. Verkruimel de gorgonzola over de groenten en bestrooi met de pecannoten. Schuif de bakplaat onder in de oven en bak nog circa 15 minuten verder goudbruin.\n",
"ingredients": "10 plakjes bladerdeeg\n1 venkelknol\n1 kleine ui\n1 el olijfolie\n150 g gorgonzola\n50 g pecannoten",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/u9kGlxe.jpeg"
},
{
"id": 227,
"name": "Bleekselderijstamppot",
"recipe": "Kook aardappelen in 20 min gaar. Voeg laatste 2 min de bleekselderij toe. Bak spekblokjes krokant. Schep ze uit pan en bak bacon in spekvet. Giet aardappelen en selderij af. Meng spekblokjes, lente-ui en crème fraîche door aardappelen en stamp tot grove stamppot. Serveer met bacon erop.",
"ingredients": "1,3 kg aardappelen\n1 bos bleekselderij in boogjes\n200 g gerookte spekblokjes\n150 g bacon\n3 lente-uitjes in stukjes van 2 cm\n125 ml crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/ZcEhdOS.jpeg"
},
{
"id": 451,
"name": "Bloemkoolcurry met rijst",
"recipe": "Verwarm de oven voor tot 200 °C. Bereid de rijst volgens de aanwijzingen op de verpakking. Verdeel de bloemkool in kleine roosjes. Bekleed een bakplaat met bakpapier en verdeel er de bloemkoolroosjes over. Bestrooi de bloemkool met de kerrie en het uienpoeder en besprenkel met de olie. Rooster de bloemkool 20 min. in de oven. Kook intussen de eieren in 8 min. hard. Laat ze schrikken en pel ze. Verwarm de kormasaus in een pan. Haal de bloemkool uit de oven en doe in een schaal. Schenk de saus over de bloemkool. Halveer de eieren en leg op de bloemkoolcurry. Snijd de koriander grof en garneer er de curry mee. Serveer met de rijst.",
"ingredients": "300 g basmatirijst\n1 bloemkool\n2 tl kerrie\n1 tl uienpoeder\n2 el zonnebloemolie\n4 eieren\n450 g original kormasaus\n4 takjes koriander",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/HwlmPL5.jpeg"
},
{
"id": 10,
"name": "Bloemkoolrisotto met tijm",
"recipe": "Rasp 2 el bloemkool fijn. Snijd de rest in grove stukken. Snijd uien en knoflook fijn en bak 5 min. Voeg bloemkool, 3 takjes tijm en bouillon toe. Kook 10 min. Verwijder tijm en pureer tot gladde soep. Pureer peterselie met 200 ml olie en wat zout. Bak rijst even en voeg wijn toe. Schep bloemkoolsoep lepel voor lepel door risotto. Roer kaas en peterselieolie door risotto. Garneer met bloemkoolrasp en peterselie.",
"ingredients": "1 kleine (Romanesco) bloemkool\n2 uien\n1 teentje knoflook\n5 takjes tijm\n1 l kippenbouillon\n1 klein bosje peterselie\n200 ml olijfolie\n350 g arboriorijst\n200 ml droge witte wijn\n4 el Parmezaanse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": null
},
{
"id": 347,
"name": "Boerensalade met ricotta",
"recipe": "Bak de ciabatta volgens de aanwijzingen op de verpakking lichtbruin. Kook intussen de sperziebonen in 6 min. beetgaar. Giet af en spoel kort koud onder stromend water. Meng in een schaal de sperziebonen, tomaten, komkommer en rode uien met de olijfolie. Breng op smaak met peper en eventueel zout en schep de peterselie erdoor. Verdeel er de ricotta in kleine bergjes over en serveer met de ciabatta.",
"ingredients": "1 ciabatta (afbak)\n200 g sperziebonen\n3 tomaten\n1 komkommer\n2 rode uien\n4 el olijfolie extra vierge\n20 g peterselie\n250 g ricotta\n1 snufje peper\n1 snufje zout",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/ivRPyAv.jpeg"
},
{
"id": 336,
"name": "Bonenschotel met kip",
"recipe": "Snijd de stengels bleekselderij in plakjes. Verhit de boter in een hapjespan. Bak de bleekselderij en de ui 5 min. Voeg de drie soorten bonen en de kipreepjes toe en warm ze mee. Verwarm ondertussen de crème fraîche in een steelpan, voeg de mosterd toe en meng tot een saus. Roer de saus door de bonenschotel. Verdeel over 4 borden en verkruimel per bord 1 plak kaas.",
"ingredients": "1 stronk bleekselderij\n2 rode uien in halve ringen\n425 g Spaanse reuzenbonen\n400 g kidneybonen\n400 g groene kidneybonen\n380 g gerookte kipfiletreepjes\n125 ml crème fraîche\n2 el grove mosterd\n4 plakken oude kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/R4umOMD.jpeg"
},
{
"id": 11,
"name": "Bonenschotel met salami",
"recipe": "Bak salamiblokjes in olie tot ze bruin beginnen te kleuren. Voeg ui en paprika toe. Bak tot ui begint te kleuren. Roer chilibonen, tomatenblokjes en maïs erdoor. Kook nog 5 minuten.",
"ingredients": "1 salami (250 g) in blokjes\n1 grote ui fijngesnipperd\n1 gele paprika in reepjes\n1 blik chilibonen (425 g)\n1 blik tomatenblokjes (400 g)\n1 blik maïs (300 g)",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/pkV4fqH.jpeg"
},
{
"id": 248,
"name": "Bonenschotel met vis",
"recipe": "Verwarm de oven voor op 200 °C. Verhit olie in een koekenpan en bak de ui en knoflook 2 min. Meng de roerbakmix en bonen erdoor en bak 1 min. mee. Schep in de braadslee. Snijd de vis in 4 stukken en leg tussen de bonen. Bestrooi met peper en zout naar smaak. Dek af met aluminiumfolie en stoof in de oven in 20 min. gaar.",
"ingredients": "2 uien, in halve ringen\n2 tenen knoflook geperst\n400 g Italiaanse roerbakmix\n420 g witte bonen in tomatensaus\n300 g tilapiafilet, ontdooid",
"servings": 4,
"serveWith": "Gebakken aardappelen",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/vbavt4W.jpeg"
},
{
"id": 12,
"name": "Bonensoep met salami",
"recipe": "Bak de worst een paar minuten. Voeg wortel, bleekselderij, ui en kruiden toe. Fruit 5 min. Voeg prei toe en fruit nog een paar minuten. Doe bouillon, bonen en tomaat in pan en laat een paar minuten koken. Breng soep op smaak met zout en peper",
"ingredients": "1 grote wortel in stukjes\n2 stelen bleekselderij in boogjes\n1 grote ui gesnipperd\n1 grote prei in ringetjes\n250 g salami in blokjes\n2 tl Italiaanse kruiden\n1 l kippenbouillon\n400 g witte bonen\n400 g rode bonen\n400 g gepelde tomaten in blokjes",
"servings": 4,
"serveWith": "brood en geraspte kaas over soep strooien",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/KDSBnNQ.jpeg"
},
{
"id": 339,
"name": "Bonen-tomatenstoof met rozemarijn & chipolataworstjes",
"recipe": "Houd de oregano uit de bak roerbakgroente apart. Halveer de broccoliroosjes. Verhit 2/3 van de olie in een hapjespan en roerbak alle groenten 5 min. Verhit ondertussen de rest van de olie in een koekenpan en bak de worstjes in 10 min. bruin en gaar. Voeg ondertussen de tomato frito toe aan de groente en breng aan de kook. Zet het vuur laag, voeg de rozemarijn en bonen toe en verwarm 5 min. met de deksel op de pan. Verwijder de takjes rozemarijn. Snijd de worstjes in stukken van 2 cm en meng met het bonenmengsel. Verdeel de stoof over de borden en bestrooi met de kaas en oregano.\n",
"ingredients": "400 g Italiaanse roerbakgroente bonen-broccoli\n225 g varkenschipolata's\n330 g tomato frito\n4 takjes rozemarijn\n425 g borlottibonen (uitgelekt)\n90 g geraspte Parmigiano Reggiano",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/UIA5RVw.jpeg"
},
{
"id": 13,
"name": "Bredie",
"recipe": "Vlees inwrijven met peper en bestrooien met bloem. Vlees in braadpan 4-6 min op hoog vuur bruin bakken. Ui, knoflook en gember toevoegen en 2-3 min zachtjes meebakken. kardemom, koriander, Italiaanse kruiden, rode peper, tomaat, bruine suiker en fond erdoor scheppen. 45-60 min afgedekt gaar sudderen. Geregeld roeren. Deksel van pan en in 15-20 min vocht laten verdampen tot dikke saus ontstaat.",
"ingredients": "500 g romatomaten ontveld in stukjes\n2 rode pepers gesnipperd\n600 g lamslapjes in grove stukken\n2 el bloem\n2 kleine uien in ringen\n3 teentjes knoflook fijngehakt\n1 cm gemberwortel fijngeraspt\n1 tl gemalen kardemom\n1 tl gemalen koriander (ketoembar)\n1,5 el verse Italiaanse kruidenmix\n1 el bruine basterdsuiker\n150 ml vleesfond (380 ml)",
"servings": 4,
"serveWith": "gekookte aardappels",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 326,
"name": "Bretonse bonenschotel",
"recipe": "Schil de aardappels en snijd ze in kleine stukjes. Snijd de ui klein. Schil de wortel en snijd hem in halve dunne plakjes. Snijd de broccoli in kleine roosjes. Laat de witte bonen uitlekken. Snijd de ham in kleine blokjes. Kook 300 ml bouillon met het bouillonblokje. Fruit in een ruime kookpan in ca. 2 min. de ui glazig in 3 el olie. Voeg de aardappel, tomatenpuree en de winterpeen toe. Bak alles in 10 min. aan op hoog vuur. Schep regelmatig om. Voeg de bouillon toe en laat aan de kook komen. Laat met de deksel op de pan 20 min. zachtjes pruttelen. Voeg de witte bonen, hamblokjes en de broccoli toe en laat nog 8 min. zachtjes doorkoken met de deksel op de pan. Breng op smaak met de zout en versgemalen peper. Schep de bonenschotel in kommen.",
"ingredients": "600 g vastkokende aardappels\n1 ui\n2 middelgrote winterpenen\n400 g broccoli\n350 g witte bonen\n2 dikke plakken schouderham\n1 kippenbouillonblokje\n6 el olie\n1 blikje tomatenpuree",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/v0qkqAF.jpeg"
},
{
"id": 220,
"name": "Briequiche met appel",
"recipe": "Verwarm de oven voor op 200 °C. Bekleed de vorm met het deeg. Verhit de olie in een koekenpan en bak de bleekselderij 5 min. Schep met 3/4 van de walnoten in de vorm. Klop de eieren los met de kwark. Schenk over de bleekselderij. Snijd de ongeschilde appel in kwarten, verwijder het klokhuis en snijd elk kwart in 3 parten. Leg dakpansgewijs en in een cirkel de brie en appel op de vulling. Bestrooi met de rest van de walnoten. Bak in 35-40 min. goudbruin en gaar",
"ingredients": "6 plakjes bladerdeeg (diepvries), ontdooid\n1 struik bleekselderij, in boogjes\n1 bakje walnoten (60 g), grof gehakt\n4 eieren\n200 g volle Franse kwark\n1 friszure appel\n1 stuk roombrie (200 g), in plakken",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/zxnrzMD.jpeg"
},
{
"id": 458,
"name": "Britse gehaktpasteitjes met pastinaak",
"recipe": "Verwarm de oven voor op 200 °C. Schil de pastinaak en rasp grof. Snipper de ui en snijd de selderij fijn. Meng het gehakt in een kom met de pastinaak, ui, selderij, worcestershiresauce en paprikapoeder. Breng op smaak met peper en eventueel zout. Snijd de hoekjes van de plakjes bladerdeeg rond af. Verdeel het gehakt-pastinaakmengsel over het midden van de plakjes. Vouw dicht en druk met duim en wijsvinger een schulppatroon in de rand. Leg de pasteitjes op een met bakpapier beklede bakplaat. Klop het ei los. Bestrijk de pasteitjes met het losgeklopte ei. Bak ze in de oven in ca. 25 min. goudbruin en gaar.",
"ingredients": "200 g pastinaak\n1 ui\n10 g verse selderij\n300 g rundergehakt\n2 el Worcestershiresauce\n2 tl milde paprikapoeder\n6 plakjes diepvries bladerdeeg\n1 ei",
"servings": 6,
"serveWith": "salade",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/1Kt4znd.jpeg"
},
{
"id": 273,
"name": "Broccoliquiche",
"recipe": "Verwarm de oven voor op 200 °C. Laat het bladerdeeg ontdooien. Kook de broccoliroosjes 4 min. Bak de spekreepjes in blue band vloeibaar knapperig. Maak de lente uitjes schoon en snijd ze in ringetjes. Giet de broccoli af en spoel er koud water over en laat de roosjes uitlekken. Bekleed de quichevorm met het bladerdeeg en snij evt de randen van het deeg bij. Prik de bodem in met een vork. Verdeel de broccoli, lenteuitjes en de spekreepjes over de bodem van de vorm. Bestrooi met de helft van de kaas. Klop de eieren los met de Finesse en breng op smaak met zout, peper en nootmuskaat. Roer de rest van de geraspte kaas erdoor. Schenk de room over de quiche en zet deze in het midden van de oven. Bak de quiche goudkleurig en gaar in ca 30 min.",
"ingredients": "8 plakjes diepvriesbladerdeeg\nca 400 g broccoliroosjes\n100 g magere spekreepjes\n1 kneepje blue band vloeibaar\n2 lente uitjes\n150 geraspte Goudse kaas\n4 eieren\n2 dl blue band finesse voor koken\nnootmuskaat",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/D2Udxyo.jpeg"
},
{
"id": 385,
"name": "Broccolistamppot met noten en geitenkaas",
"recipe": "Schil de aardappelen en snijd ze in stukken van 2 cm. Kook in een ruime pan in 15 min. gaar. Kook de laatste 4 min. de bevroren broccoli mee. Giet af en vang een kopje kookvocht op. Snijd ondertussen de salade-ui in ringetjes en verkruimel de geitenkaas. Verhit een koekenpan zonder olie of boter en rooster de noten op middelhoog vuur in 3 min. goudbruin. Laat afkoelen op een bord. Hak grof. Voeg een ½ kopje kookvocht, de salade-ui en dragon toe aan de aardappelen en broccoli en stamp dit met de pureestamper tot een grove puree. Voeg de helft van de geitenkaas toe. Doe de tomaten met de olie uit het bakje erbij en schep om. Voeg kookvocht toe als de stamppot te droog is. Breng de stamppot op smaak met peper en eventueel zout. Bestrooi met de rest van de geitenkaas en de noten.",
"ingredients": "1 kg kruimige aardappel\n900 g diepvries broccoliroosjes\n1 bosje salade-ui\n200 g geitenkaas naturel 45+\n80 g saladenotenmix\n1 el gedroogde dragon\n120 g zongedroogde tomaten in pot",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/pfQI5i8.jpeg"
},
{
"id": 406,
"name": "Broccoli-velouté met blauwe kaas en pijnboompitten",
"recipe": "Rooster de pijnboompitten in een droge, hete koekenpan en houd apart. Verhit de boter in een soeppan en fruit de ui en knoflook circa 2 minuten. Voeg de broccoli, aardappels en bouillon toe en laat circa 20 minuten pruttelen. Voeg de slagroom en de helft van de kaas toe en pureer de soep met een staafmixer. Breng op smaak met zout en peper. Serveer de soep in kommen. Verbrokkel de rest van de blauwe kaas erboven en bestrooi met de geroosterde pijnboompitten en wat peper. Garneer de broccoli-velouté eventueel met wat blaadjes oregano.\n",
"ingredients": "2 el pijnboompitten\n2 el boter\n1 ui (gesnipperd)\n1 teentje knoflook, geperst\n500 g broccoli; in roosjes\n250 g aardappels, in blokjes\n1 l groentebouillon\n125 ml slagroom\n150 g blauwe kazen\noreganoblaadje (om te garneren)",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/xNaSMWN.jpeg"
},
{
"id": 14,
"name": "Bruine bonenschotel met ijsbergsla",
"recipe": "Ui, paprika en salami in stukjes snijden. Ui, paprika en knoflook 3 min fruiten. Gehakt toevoegen en in 3 min rul bakken. ½ tl zout, peper en paprikapoeder toevoegen. Bruine bonen, tomatenketchup, salami en 1 dl water erdoor roeren. Mengsel in 2 min. heel heet laten worden. Sla in dunne repen snijden en 1 min mee verwarmen. Op smaak brengen met tabasco en geraspte kaas.",
"ingredients": "760 g bruine bonen\n1 grote ui\n1 rode paprika\n50 g salami\nknoflook\n250 g rundergehakt\n2 tl paprikapoeder\n1 dl hot tomatenketchup\n¼ krop ijsbergsla\ntabasco\n50 g geraspte oude kaas",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/uWQxGff.jpeg"
},
{
"id": 15,
"name": "Butter chicken curry",
"recipe": "Uien en knoflook kleinsnijden. Cashewnoten in keukenmachine fijnmalen. In pannetje met klein laagje water ui en knoflook ongeveer 5 min zacht koken, hierna pureren met staafmixer. Gepelde tomaten laten uitlekken en in keukenmachine pureren met yoghurt, paprikapoeder, slagroom, suiker en maïzena. Kipfilet in stukken snijden. Djinten en gemalen koriander 2 minuten zachtjes roerbakken in boter. Gember-, chili- en cashewnootpoeder toevoegen en 4 minuten al roerend meebakken. Ui-knoflookpuree toevoegen en 2 minuten meebakken. Kip toevoegen en goed mengen met kruiden. Kokosmelk en zout naar smaak toevoegen en 5 tot 8 minuten laten koken tot kip bijna gaar is. Tomatenmengsel toevoegen en aan kook brengen. Masala onafgedekt 20 minuten zachtjes koken, af en toe roeren. Koriander erboven fijnknippen.",
"ingredients": "2 uien\n6-8 teentjes knoflook\n10 cashewnoten\n1 blikje gepelde tomaten (400 g)\n3 el yoghurt\n1 el paprikapoeder\n3 el slagroom\n0,5 el suiker\n1 el maïzena\n4 kipfilets (520 g)\n150 g boter\n0,5 el djinten (gemalen komijn)\n1 el gemalen koriander\n1 el gemberpoeder\n2 el chilipoeder\n125 ml kokosmelk\n2 takjes koriander",
"servings": 4,
"serveWith": "rijst, broccoli",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/k0xtv1Q.jpeg"
},
{
"id": 293,
"name": "Cajun ovenschotel",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Boen de aardappels schoon. Snijd de aardappels in plakjes en kook ze in circa 8 minuten beetgaar. Giet de aardappels af en laat ze uitwasemen. Verwarm de oven voor op 200 °C. Pel en snipper de uien. Pel en snijd de knoflook grof. Halveer de paprika’s in de lengte, verwijder de zaadlijsten en snijd de paprika’s in blokjes. Verwijder de harde draden van de bleekselderij en snijd de bleekselderij in gelijke stukken. Verwarm de boter in een pan en fruit de ui, knoflook en cajunkruiden circa 2 minuten. Voeg de paprika’s en de bleekselderij toe en bak circa 3 minuten. Voeg de bloem toe en bak de bloem in circa 2 minuten gaar. Schenk het water erbij en voeg het bouillonblokje toe. Breng aan de kook. Roer de mascarpone erdoor en rasp de helft van de Parmezaanse kaas erboven. Roer goed door en laat circa 5 minuten zachtjes doorkoken. Pluk en snijd de peterselie fijn. Verdeel de aardappels over een met olie ingevette ovenschaal. Schenk het cajunmengsel erover, rasp de resterende kaas erover en bestrooi met de helft van de peterselie. Bak de cajun ovenschotel in de oven in circa 15 minuten goudbruin en gaar. Strooi de resterende peterselie eroverheen.",
"ingredients": "500 g vastkokende aardappels\n2 uien\n3 teentjes knoflook\n2 rode puntpaprika's\n5 stengels bleekselderij\n25 g boter\n1 el cajunkruiden\n30 g bloem\n200 ml water\n1 groentebouillonblokje\n125 ml mascarpone\n100 g Parmezaanse kaas\n0,5 bosje bladpeterselie",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/yYTBqU6.jpeg"
},
{
"id": 232,
"name": "Captain's dinner",
"recipe": "Giet de kapucijners af, spoel er koud water over en laat ze uitlekken. Bak de spekblokjes licht krokant in een wok of hapjespan. Schep ze uit de pan. Verhit de olie en fruit hierin de ui lichtbruin. Voeg peper, zout en tomatenpuree toe en bak nog 2 minuten. Schep de kapucijners en de helft van de spekblokjes erdoor en verwarm zonder te koken. Serveer het gerecht met schaaltjes augurk, sjalot, piccalilly, appelcompote, de overige spekjes, worstjes en zilveruitjes eromheen.",
"ingredients": "1 grote pot kapucijners\n200 g mager gerookt spek in blokjes\n2 el olie\n2 uien gesnipperd\n70 g tomatenpuree\n4 augurken in plakjes\n4 sjalotjes gesnipperd\n4 el piccalilly\n1 potje appelcompote\n1 blikje cocktailworstjes\nzilveruitjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/dBE7Dsg.jpeg"
},
{
"id": 327,
"name": "Caribische jambalaya",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Giet af en laat met de deksel op de pan staan tot gebruik. Halveer ondertussen de paprika's, verwijder de zaadlijsten en snijd in ringen van 1 cm. Snijd de knoflook fijn. Verhit de olie in een wok en roerbak de knoflook, kip en caribbean spice 2 min. Voeg de paprika, snijbonen en garnalen toe en roerbak 3 min. Verkruimel het bouillonblokje erboven en voeg het water toe. Laat op middelhoog vuur 5 min. met de deksel op de pan stoven. Voeg de rijst toe en roerbak nog 2 min. mee. Schep alles goed om.",
"ingredients": "325 g gele rijst\n1 zak puntpaprikamix\n2 tenen knoflook\n2 el arachideolie\n200 g kipdijfiletreepjes\n2,5 el Carribbean spice\n400 g gesneden snijbonen\n200 g rauwe gepelde roze garnalen\n1 kippenbouillontablet\n50 ml water",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/pUknC0f.jpeg"
},
{
"id": 16,
"name": "Cassoulet met tonijn",
"recipe": "Snij ui, tomaten en bleekselderij klein. Spoel bonen af en laat uitlekken. Bak ui in olie zacht. Voeg tomaten en bleekselderij toe. Voeg na enkele minuten bonen en olijven toe. Giet scheutje water in pan om aanbakken te voorkomen. Verwarm cassoulet terwijl vis wordt gebakken. Bak tonijnfilet ca. 3 minuten per kant.",
"ingredients": "2 uien\n4 el zongedroogde tomaten\n2 stengels bleekselderij\n4 stukken tonijnfilet van 200 g\n0,5 blik flageolets, kidneybeans o.i.d.\n1 blik witte bonen\n20 groene olijven zonder pit",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/1MlUasF.jpeg"
},
{
"id": 17,
"name": "Chakchouka",
"recipe": "Ontvel tomaten en snij in plakken. Snij paprika in reepjes. Snipper ui. Bak paprika zacht in koekenpan. Voeg ui, paprikapoeder, cayennepeper en komijn toe. Voeg knoflook, plakken tomaat en gezeefde tomaat toe en verwarm 5 min. Breek eieren tussen mengsel en laat dooiers heel. Laat eieren zachtjes stollen.",
"ingredients": "2 tomaten\n1/2 groene paprika\n1 kleine ui\n1/2 tl paprikapoeder\nsnufje cayennepeper\n1/2 tl komijn\n2 teentjes knoflook\n200 ml gezeefde tomaten\n2 eieren",
"servings": 2,
"serveWith": "oerbrood",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/AkaXTa9.jpeg"
},
{
"id": 405,
"name": "Champignon-pastinaaksoep",
"recipe": "Verhit in een soeppan de olie. Fruit de uien 3 min. Voeg de champignons toe en bak 3 min. mee. Voeg de pastinaak, de bouillon en de bonen toe en breng aan de kook. Draai het vuur laag en kook de soep 30 min. Schep de helft van de soep uit de pan. Pureer de rest van de soep met de staafmixer. Voeg de resterende soep en de shiitake toe en verwarm de soep nog 5 min. Voeg peper en zout naar smaak toe. Schep de soep in de kommen en bestrooi met de bieslook.",
"ingredients": "1 el koolzaadolie\n2 uien\n125 g gesneden champignons\n700 g pastinaak\n1 l groentebouillon\n400 g bruine bonen\n125 g shiitake\n2 el bieslook\n1 snufje zout\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/EPTX74m.jpeg"
},
{
"id": 369,
"name": "Chicken-pie",
"recipe": "Bestrooi de kip met zout en peper. Verhit de boter en bak hierin de kip om en om bruin. Voeg de ui toe en bak een paar minuten mee. Voeg de basilicum, kaneel en pruimen toe. Roer dit samen met een paar el water of kippenbouillon goed door en smoor met het deksel op de pan circa 10 minuten op een lage stand. Laat de vulling afkoelen. Bestuif intussen de vormpjes met bloem. Bekleed elk vormpje met een plakje bladerdeeg en snijd de randen netjes bij. Zet de vormpjes eventueel circa 30 minuten in de koelkast om het deeg te koelen. Verwarm de oven voor op 200°C. Verdeel de kipvulling over de vormpjes en bedek met de resterende plakjes deeg. Druk de deegrandjes goed op elkaar en snijd netjes bij. Snijd met een scherp mes een klein (hartvormig) gat in het deksel en bestrijk de deksels met ei. Bestrooi met de amandelen en bak de taartjes in de oven in circa 25 minuten goudbruin. Laat een beetje afkoelen en neem ze dan uit de vormpjes.\n",
"ingredients": "voor de ragout\n200 g kipfilets (in kleine blokjes)\n1 el boter\n1 ui (fijngesnipperd)\n1 tl basilicum (gedroogd) of\n1 tl oregano (gedroogd)\nmespunt kaneelpoeder\n100 g gedroogde pruimen (in kleine stukjes)\nevt. kippenbouillon\nvoor de taartjes\n1 el bloem\n8 plakjes diepvriesbladerdeeg (ontdooid)\n1 ei (losgeklopt)\n20 g amandelschaafsel",
"servings": 4,
"serveWith": "frisse salade",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/aXKsbEm.jpeg"
},
{
"id": 18,
"name": "Chili con carne met muntyoghurt",
"recipe": "Fruit ui met 1 teen knoflook. Voeg gehakt toe en bak rul. Bak paprika 5 min mee en schep komijn erdoor. Voeg gepelde tomaten toe en druk ze met spatel stuk. Voeg bonen en chilipeper toe en laat 20 min stoven. Meng 1 teen knoflook en munt door yoghurt en breng op smaak met peper en zout.",
"ingredients": "1 zoete ui gesnipperd\n2 tenen knoflook geperst\n300 g gehakt\n1 rode paprika's in reepjes\n1 tl gemalen komijn\n1 blik (à 400 g) gepelde tomaten\n1 blik (à 800 g) bruine bonen\n1/2 tl gemalen chilipoeder\n7 g verse munt\n150 ml Griekse yoghurt",
"servings": 4,
"serveWith": "salade van ijsbergsla, maïs en rode ui",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/QUgAkrX.jpeg"
},
{
"id": 19,
"name": "Chinese kip met groenten",
"recipe": "Snij vlees in reepjes. Verhit olie. Voeg kip en zout toe en roerbak 5 min. Voeg sojasaus toe en meng goed. Snij paprika en bleekselderij in dunne reepjes. Doe ze met taugé, bouillon, bamboescheuten en champignons bij de kip. Laat afgedekt 15 min pruttelen. Roer maïzena met wat water tot papje en giet het in de pan. Breng al roerend aan de kook. Voeg zout peper en amandelen toe.",
"ingredients": "300 g kipfilet\n3 el olie\n2 el sojasaus\n2 bleekselderij\n1 paprika\n300 g taugé,\n100 g bamboescheuten\n50 g champignons\n1,5 dl kippenbouillon\n1 el maïzena\n50 g amandelsnippers\nzout\npeper",
"servings": 2,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/45d17jG.jpeg"
},
{
"id": 373,
"name": "Citroenrisotto met venkel en dille",
"recipe": "Verhit de boter in een grote pan en bak hierin de ui en venkel zacht. Voeg de rijst toe en roer tot de korrels glanzen. Voeg 250 ml bouillon toe en blijf roeren tot alle bouillon is opgenomen. Herhaal deze stap tot alle bouillon na circa 20 minuten op is en de rijst beetgaar is. Rasp de schil van 1 citroen. Schil beide citroenen dik en snijd de partjes vruchtvlees uit de vliesjes. Roer de citroenrasp, partjes citroen, dille en crème fraîche door de risotto. Verdeel over 4 diepe borden en bestrooi de citroenrisotto met de Parmezaanse kaas.",
"ingredients": "50 g boter\n1 ui (gesnipperd)\n2 venkelknollen (in dunne plakjes)\n400 g risottorijst\n1.5 l groentebouillon\n2 citroenen (schoongeboend)\n1 bosje dille (fijngehakt)\n100 ml crème fraîche\n30 g Parmezaanse kaas (geschaafd)",
"servings": 4,
"serveWith": "Gegrillde zalmmoot",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/1piHOdc.jpeg"
},
{
"id": 20,
"name": "Cordonette",
"recipe": "Bestrooi de schnitzels aan weerszijde met peper en zout. Verdeel de smeerkaas over de lapjes. Snij plakken ham doormidden en leg een plakje op elk lapje. Rol schnitzels op en steek vast met prikker. Verhit olie in pan en schroei vlees aan alle zijden dicht. Verwarm calvados in sauslepel, steek aan en giet over de rolletjes. Snij tomaten in 4 stukken. Voeg tomaten en zilveruitjes aan vlees toe. Laat warm worden en serveer direct.",
"ingredients": "8 zeer dunne kalfsschnitzels (à 100 g)\npeper\nzout\n1 pakje Franse kruidensmeerkaas\n4 dunne plakken ham\n2 el olie\n2 el calvados\n2 gepelde tomaten\nenkele zoetzure zilveruitjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 409,
"name": "Courgette-lasagne",
"recipe": "Snij de courgettes in plakken van ongeveer 3 mm. Het beste kan je hier een mandoline voor gebruiken, maar dit lukt ook met een mes of een kaasschaaf. Zet een grillpan op het vuur en laat deze goed warm worden. Bestrijk de courgettelinten met de knoflookolie en grill ze in ongeveer 1 minuut per kant goudbruin. Laat de courgettes uitlekken op een keukenpapiertje. Dep ze goed droog anders wordt de lasagne erg nat. Verwarm de oven alvast voor op 180 °C. Voor de tomatensaus snipper je de ui en hak je de knoflook fijn. Fruit dit aan in wat olijfolie. Snij de paprika en de aubergine in blokjes en bak deze kort mee. Voeg de tomatenpassata toe en breng de saus op smaak met de Provençaalse kruiden en wat peper en zout. Laat de saus ongeveer 15 minuten pruttelen. Snij de mozzarella in plakken. Neem een ovenschaal en verdeel wat van de saus over de bodem van de schaal. Leg hierop de courgette linten. Verdeel een paar plakjes mozzarella over de courgette en verdeel daarover weer een laagje saus. Herhaal deze stappen totdat de saus op is. Eindig met een laag courgette met daarop een paar plakken mozzarella. Bak de courgette lasagne in ongeveer 20 minuten af op 180 °C.",
"ingredients": "3 courgettes\n2 uien\n2 teentjes knoflook\n1 aubergine\n1 rode paprika\n500 ml tomaten passata\n2 bollen mozzarella\n2 tl Provençaalse kruiden\nknoflookolie\npeper en zout\nolijfolie",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/V2QEKyn.jpeg"
},
{
"id": 21,
"name": "Couscous met kip",
"recipe": "Snij kip in blokjes en bestrooi met zout, peper en komijn. Laten intrekken. Bak ui en knoflook lichtbruin. Bak kip 1 minuut mee. Tomaten met vocht en abrikozen toevoegen en 10 minuten laten sudderen. Couscous volgens gebruiksaanwijzing bereiden.",
"ingredients": "400 g kipfilet\n2 tl gemalen komijn (djinten)\n2 uien gesnipperd\n3 teentjes knoflook\n400 g tomatenblokjes\n100 g gewelde abrikozen in reepjes\n300 g couscous",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Couscous",
"photo": null
},
{
"id": 280,
"name": "Couscoussalade en lamsworstjes",
"recipe": "Bereid de couscous volgens de aanwijzingen op de verpakking. Snijd de tomaten in kwarten, verwijder de zaadlijsten en snijd het vruchtvlees in reepjes. Roer de couscous met een vork los. Schep de tomaat, komkommer en ui erdoor. Snijd de munt in dunne reepjes en voeg toe. Voeg de olie toe en knijp 1/2 citroen boven de couscous uit. Breng op smaak met peper en zout. Snijd de andere 1/2 citroen in partjes. Verhit de grillpan en grill de worstjes in ca. 8 min. gaar. Schep de couscous op een schaal. Leg de lamsworstjes ernaast en garneer met de citroen.",
"ingredients": "300 g couscous\n3 trostomaten\n1 komkommer, in blokjes\n1 ui, gesnipperd\n15 g munt, alleen de blaadjes\n3 el olijfolie extra vierge\n1 citroen\n4 lamsworstjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Couscous",
"photo": "https://i.imgur.com/lqCpXqq.jpeg"
},
{
"id": 22,
"name": "Cowboyschotel",
"recipe": "Fruit ui en knoflook. Voeg vlees toe en bak lichtbruin. Roer tomatenpuree los met 2 dl bouillon. Giet erbij. Voeg cayennepeper toe em laat 1½ uur stoven. Voeg wortelen, selderij en paprika toe. ½ uur stoven. Witte en sperziebonen erbij en goed doorwarmen.",
"ingredients": "600 g runderbraadlapjes (in dobbelsteentjes)\n2 gesnipperde uien\n2 teentjes knoflook\n1 pot worteltjes\n(groot)\n1 groene paprika in reepjes\n1 rode paprika in reepjes\n1 blikje tomatenpuree\n2 dl vleesbouillon\ncayennepeper\n1 pot witte bonen\n1 pot sperziebonen\nselderij",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/pcMjFem.jpeg"
},
{
"id": 298,
"name": "Cream and chives chicken",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Boen de aardappels schoon. Kook de aardappels in circa 20 minuten gaar. Giet de aardappels af en stoom ze droog. Plet de aardappels met een pureestamper. Verhit een scheutje olie en de boter in een koekenpan en bak de aardappels in circa 10 minuten goudbruin en krokant. Breng de aardappels op smaak met een beetje zout en versgemalen peper. Verwarm de oven voor op 200 °C. Snijd de bieslook fijn. Pel en snijd de knoflook fijn. Meng in een kommetje de roomkaas, bieslook en de knoflook. Breng op smaak met een beetje zout en versgemalen peper. Snijd de zongedroogde tomaten in reepjes. Halveer de olijven. Snijd de kipfilets in porties en snijd ze horizontaal in en klap ze open. Bestrijk de binnenkant van de kipfilets met de bieslookroomkaas. Verdeel de zongedroogde tomaten en de olijven over de bieslookroomkaas en klap de kipfilets dicht. Leg de kipfilets in een met olie ingevette ovenschaal. Bedek de kipfilets met de plakjes ontbijtspek. Bak de kip in de oven in circa 15 minuten goudbruin en gaar. Snijd de cream & chives chicken in gelijke stukken. Breng een pan met water en een beetje zout aan de kook. Snijd de broccoli in roosjes. Kook de broccoli in circa 4 minuten beetgaar en giet de broccoli af.\n",
"ingredients": "800 g vastkokende aardappels\nolijfolie om in te bakken\n1 klontje boter\n0,5 bos bieslook\n2 teentjes knoflook\n100 g verse roomkaas\n75 g zongedroogde tomaten\n75 g zwarte olijven zonder pit\n300 g kipfilet\n75 g ontbijtspek in dunne plakken\n2 stronken broccoli",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/E3ys8Gz.jpeg"
},
{
"id": 23,
"name": "Driebonenchili",
"recipe": "Gehakt met chilipoeder rul bakken. Soepgroenten toevoegen en 3 min meebakken. Kidneybonen, kapucijners en groenteschotel voor chili con carne toevoegen. 5 min verwarmen",
"ingredients": "400 g gehakt\n2 tl chilipoeder\n400 g kidneybonen\n720 g kapucijners\n250 g soepgroenten\n1 pot groenteschotel voor chili con carne",
"servings": 4,
"serveWith": "ijsbergsla, tacochips",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/9R4dZSq.jpeg"
},
{
"id": 24,
"name": "Eendenborst met groene groenten en cashewnoten",
"recipe": "Bak eendenborsten 4 min zacht in wok in olie op huid zodat deze smelt. Andere zijde 3 min bakken. Eendenborsten in plakjes snijden (vlees is medium gaar). Vet in wok laten. Meng in kom knoflook, peultjes, broccoli, peper, cashewnoten, oestersaus, sesamolie, witte wijn en eendenborstplakjes. Verhit 2 el olie met vet in wok. Groente-eendmengsel 5 minuten roerbakken. Voeg maïzena toe en laat 1 min binden. Garneren met koriander.",
"ingredients": "3 el arachideolie\n2 eendenborsten (à 150 g)\n200 g peultjes gehalveerd\n300 g broccoli in 3 cm roosjes\n0,5 teentje knoflook\n1 Spaanse peper\n40 g ongezouten cashewnoten\n3 el oestersaus\n3 tl sesamolie\n5 el droge witte wijn\n3 tl maïzena in water\n2 takjes koriander fijngeknipt",
"servings": 4,
"serveWith": "witte rijst, komkommer en atjar tjampoer",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/Ef87GkU.jpeg"
},
{
"id": 25,
"name": "Eendenborstfilet met portsaus",
"recipe": "Fond en port aan kook brengen. Maïzena toevoegen. Bak filets 3 min. Dragon aan saus toevoegenen 1 min verwarmen. Filets in dunne plakjes snijden. Saus op bord en eend erop.",
"ingredients": "5 el port\n3 el gevogeltefond\n1 tl maïzena\n25 g boter\n2 eendenborstfilets\n0,5 tl dragon",
"servings": 2,
"serveWith": "gegratineerde aardappels",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 26,
"name": "Eieren op zigeunerwijze",
"recipe": "Chorizo in reepjes, ui en knoflook fijn snijden. Chorizo 3 min fruiten in olie en uit pan halen. Wat olie toevoegen. Ui 3 min fruiten. Tomatenblokjes met sap, knoflook, paprika, bouillon, suiker en peper toevoegen. 8 min koken. Ovenschaaltjes invetten. Saus over schaaltjes verdelen. In elk schaaltje 2 eieren. Chorizo erover strooien. 10 min in oven op 225 °C.",
"ingredients": "150 g chorizoplakjes\n1 ui\n1 teentje knoflook\n2 el olijfolie\n400 g tomatenblokjes\n175 g paprika (gesneden)\n1 tablet kruidenbouillon\n1 tl suiker\n0,5 tl cayennepeper\n8 eieren",
"servings": 4,
"serveWith": "chiabatta",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/oxntiRx.jpeg"
},
{
"id": 335,
"name": "Ei-visovenschotel",
"recipe": "Verwarm de oven op 190 °C. Snijd vis in grove stukken en verwarm ze met melk in een pan. Neem pan van het vuur als melk gaat koken en laat afkoelen. Laat vis uitlekken. Breng slagroom aan de kook en neem pan van het vuur Roer mosterd erdoor en breng op smaak met zout en peper. Leg vis erin en laat afkoelen. Vet ovenschaal in. Schep vismengsel erin en breek voorzichtig de eieren ertussen. Zet oven in braadslee met kokend water. Bak gerecht in 15 min in oven. Garneer met basilicum.",
"ingredients": "200 g kabeljauwfilet\n200 g zalmfilet\n300 ml melk\n200 ml slagroom\n2 el grove mosterd\n4 eieren\nbasilicum",
"servings": 4,
"serveWith": "stokbrood, salade",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/2GP4miy.jpeg"
},
{
"id": 344,
"name": "Enchilada's met zomerse chili con carne",
"recipe": "Verwarm de oven voor op 180 ºC. Snijd de paprika's in reepjes. Bak gehakt rul. Voeg paprika's en chili con carne toe. Bak 6 min op hoog vuur. Verdeel mengsel over wraps. Rol wraps op en leg in ovenschaal. Strooi kaas over wraps en bak 15 min in oven. Serveer met salsasaus",
"ingredients": "1 rode paprika\n1 gele paprika\n1 pot chili con carne bonenmix\n300 g gehakt\n8 meergranen tortillawraps\n150 g gemalen belegen kaas\n300 g salsasaus mild",
"servings": 4,
"serveWith": "gemengde sla",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/XYZOnfK.jpeg"
},
{
"id": 27,
"name": "Entrecote met rozemarijn-wijnsaus",
"recipe": "Sjalotjes en knoflook fijn hakken. Entrecotes droogdeppen. In koekenpan boter smelten en entrecotes 6 min licht bruin bakken. Warm houden onder aluminiumfolie. In vet sjalotjes, knoflook en spekreepjes 1 min bakken. Wijn, fond en slagroom erbij schenken. Rozemarijn erover en aan kook brengen. In kopje bloem met 3 el water gladroeren. Al roerend aan saus toevoegen tot lichtgebonden saus ontstaat. Saus onafgedekt 3 min zachtjes koken.",
"ingredients": "2 sjalotjes\n2 teentjes knoflook\n15 g verse rozemarijn\n4 entrecotes (125 g pp)\n250 g spekreepjes\n2 dl droge rode wijn\n2 dl vleesfond\n3 el slagroom\n2 el bloem",
"servings": 4,
"serveWith": "gegratineerde aardappelen peultjes",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 349,
"name": "Fajita met zalm en tomaten-bonensalsa",
"recipe": "Verwarm de oven voor tot 180 °C. Leg de zalmfilets op de bakplaat en bestrooi met de fajita-kruidenmix. Besprenkel met 2 el olijfolie. Bak de zalmfilets in de voorverwarmde oven in 20 min gaar. Meng intussen voor de salsa de maïs, zwarte bonen, tomaten, koriander, limoen en de rest van de olijfolie. Verwarm de tortilla’s volgens de aanwijzingen op de verpakking. Maak de ranchdip met de crème fraîche. Leg de tortilla’s op de borden. Verdeel de salsa en zalmfilets over de tortilla’s. Schep de ranchdip erop en bestrooi met peper naar smaak.",
"ingredients": "1 zakje Santa Maria Fajita Seasoning Mix\n1 zakje Santa Maria American Ranch Dip\n4 zalmfilets zonder huid\n3 el olijfolie\n1 blikje crispy maïs\n1 blikje zwarte bonen\n2 tomaten\n15 g koriander\n1 limoen\n12 minitortilla's\n200 g crème fraîche\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/tGr8ykx.jpeg"
},
{
"id": 394,
"name": "Farfalle met blauwe kaas en broccoli",
"recipe": "Rooster de walnoten in een droge, hete koekenpan en hak ze fijn. Kook de farfalle volgens de aanwijzingen op de verpakking. Kook intussen de broccoli in circa 5 minuten beetgaar. Verhit de boter in een (steel)pan en voeg de bloem toe. Blijf roeren tot er een roux ontstaat. Voeg vervolgens langzaam de melk toe en roer met een garde tot een romige saus. Voeg de knoflook en kaas toe en roer door totdat de kaas is gesmolten. Breng op smaak met zout en peper. Meng de kaassaus en de broccoli door de pasta. Bestrooi met de walnoten.",
"ingredients": "50 g walnoten\n300 g farfalle\n600 g broccoli, in kleine roosjes\n70 g boter\n40 g bloem\n500 ml melk\n1 teentje knoflook, geperst\n150 g blauwe kazen",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/Tihq54h.jpeg"
},
{
"id": 426,
"name": "Farfalle met paddenstoelen",
"recipe": "Kook de pasta in ruim water met zout volgens de aanwijzingen op de verpakking. Verhit de olijfolie in een koekenpan. Bak de paddenstoelen met de salie 5 min. Voeg de funghi porcini en de wijn toe en verwarm 2 min. Roer af en toe. Roer de mascarpone en de gorgonzola door de saus. Roer tot de kaas is gesmolten en voeg naar smaak een beetje zout en peper toe. Giet de farfalle af en meng door de pastasaus. Schep de farfalle op de borden en garneer naar wens met een paar extra fijngesneden salieblaadjes.",
"ingredients": "400 g farfalle\n1 pot funghi porcini\n2 el olijfolie\n200 g luxe paddenstoelenmix\n2 takjes salie\n75 ml droge witte wijn\n125 g mascarpone\n200 g gorgonzola",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/6Y50znk.jpeg"
},
{
"id": 321,
"name": "Farfalle met venkel en blauwe kaas",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking beetgaar. Verhit ondertussen 2 el olie in een koekenpan en bak de ui 13 min. op middelhoog vuur. Schep regelmatig om. Voeg de laatste 3 min de knoflook toe. Snijd ondertussen de onderkant van de venkel en een stukje van de bovenkant, halveer en verwijder de kern. Snijd in reepjes. Verhit de rest van de olie in een hapjespan en bak de venkel, peper en eventueel zout 8 min. op middelhoog vuur. Schep regelmatig om. Snijd ondertussen de kaas in stukjes. Voeg de melk en twee derde van de kaas bij de gebakken venkel en laat de kaas al roerend smelten. Giet de pasta af. Meng door de venkel-kaassaus en schep de kappertjes en 2 el van het kappertjesvocht erdoor. Verdeel de gebakken ui, de rest van de kaas en de kappertjes erover en serveer direct.\n",
"ingredients": "300 g farfalle\n2 tenen knoflook\n3 el olijfolie\n300 g gesneden ui\n2 venkelknollen\n150 g blauwe kaas\n75 ml halfvolle melk\n100 g kappertjes",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/oL5YrSm.jpeg"
},
{
"id": 389,
"name": "Flatbread met gekarameliseerde ui, Parmaham en Beemster",
"recipe": "Verwarm oven voor op 220 °C. Snijd de ui in dunne halve ringen. Smelt de boter in een koekenpan en fruit de ui 15 min tot deze goudbruin is. Bekleed een bakplaat met bakpapier. Rol pizzadeeg uit op met bloem bestoven werkvlak en rol uit tot rechthoek met 3 cm dikte. Meng olijfolie, knoflook en salie in een kom. Bestrijk pizzadeeg met mengsel. Scheur Beemster in plakken en verdeel deze samen met ui over de pizza. Scheur Parmaham in stukken en verdeel over uien. Bak pizza in ca. 15 min in de oven tot kaas gesmolten is.",
"ingredients": "1 ui\n1 tl boter\n1 pizzabodem\n2 el bloem\n1 teen knoflook\n2 el fijngesneden salie\n150 g Beemster\n85 g Parmaham",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/0qTWU4z.jpeg"
},
{
"id": 486,
"name": "Franse uientaart",
"recipe": "Fruit de uien met wat zout goudbruin in de helft van de olijfolie. Voeg suiker en tijm toe en laat uien karameliseren (45-60 min). Laat afkoelen. Hak olijven, 3 ansjovisfilets, knoflook en olijfolie in keukenmachine tot tapenade en breng op smaak met peper. (houd genoeg olijven over voor garnering) Rol bladerdeeg uit op met bakpapier beklede bakplaat en vouw de randen 1 cm omhoog. Plak die vast met water. Prik het bladerdeeg ruimschoots in met een vork en bestrijk met de tapenade. Bedek deze met de uien en vervolgens met de ansjovisfilets in een ruitpatroon. Leg in elke ruit een olijf. Bestrijk de randen met losgeklopte eierdooier en bak 25 min in een een oven op 180 °C.",
"ingredients": "750 g witte uien (in ringen)\n150 ml olijfolie\n50 g bruine basterdsuiker\n3 takjes tijm (gerist)\n200 g olijven\n20 ansjovisfilets\n1 teen knoflook (fijngesneden)\n300 g bladerdeeg\n1 eierdooier",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/m5sUSGR.jpeg"
},
{
"id": 368,
"name": "Franse visburger met brie en walnoten",
"recipe": "Verhit in een koekenpan de olie. Bak de visburgers in 13 min aan beide kanten goudbruin en gaar. Kook de broccoli in 5 min beetgaar. Snijd intussen de broodjes open. Meng de mayonaise, honing en mosterd. Leg na 10 min. de brie op de visburgers zodat de kaas een beetje smelt. Beleg de onderste helft van de broodjes met de saus, visburgers met brie, appel, sla en walnoten en leg de bovenste helft erop. Leg de visburgers op 4 borden en serveer met de broccoli.",
"ingredients": "4 Iglo Fish Burger Classic\n2 el zonnebloemolie\n600 g broccoli\n4 harde broodjes\n4 el mayonaise\n2 tl honing\n2 tl mosterd\n100 g brie\n1 friszoete handappel\n40 g sla\n60 g walnoten",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/mooTFRz.jpeg"
},
{
"id": 345,
"name": "Frisse doperwtenrisotto",
"recipe": "Breng het water met de bouillontabletten aan de kook. Verhit de vloeibare margarine in een pan met een dikke bodem. Fruit de ui en de bleekselderij 5 min. zonder dat deze verkleuren. Voeg de rijst toe en bak 1 min. mee. Blus af met de wijn. Schenk de helft van de bouillon erbij en breng alles al roerende aan de kook. Schep nadat het 10 min. gekookt heeft de doperwten erdoor. Voeg beetje bij beetje de rest van de bouillon toe en breng telkens aan de kook, roer regelmatig door. Kook de rijst op laag vuur in nog ca. 10 min. gaar. Breng de risotto op smaak met de munt en zout en peper. Roer de resterende margarine door de risotto. Draai het vuur uit en laat de risotto nog 5 min. staan om alle smaken maximaal te laten intrekken. Verdeel de risotto over de diepe borden en bestrooi royaal met Parmezaanse kaas.",
"ingredients": "3 groentebouillontabletten\n2 el vloeibare margarine\n1 ui\n3 stengels bleekselderij\n300 g risottorijst\n100 ml droge witte wijn\n450 g doperwten\n4 el munt\n100 g Parmezaanse kaas",
"servings": 4,
"serveWith": "gerookte forelfilet",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/MyHlPcy.jpeg"
},
{
"id": 361,
"name": "Fruitige rijst met groenten, kip en chorizo",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Verhit een koekenpan, rooster het amandelschaafsel goudbruin en schud op een bord. Verhit in een hapjespan de olijfolie. Bak de ui en chorizo 4 min. Voeg de kipblokjes toe en bak 4 min. mee. Schep de roerbakgroenten door de kip en bak in nog 4-5 min. beetgaar. Giet de rijst af. Schep de rijst door het kip-groentemengsel. Voeg de ananas toe en bak nog 1 min.",
"ingredients": "300 g witte rijst\n2 el amandelschaafsel\n2 el olijfolie\n2 uien\n75 g chorizo\n400 g kipfilet\n400 g Hollandse roerbakmix\n250 g Italiaanse roerbakmix\n1 blikje ananasstukjes op siroop",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ysub7n5.jpeg"
},
{
"id": 318,
"name": "Fusilli met geroosterde tomaat-amandelpesto",
"recipe": "Verwarm de oven voor op 200 °C. Leg de tomaatjes en knoflook op de met bakpapier beklede bakplaat en besprenkel met de olie, azijn en zout. Rooster de tomaten circa 25 minuten in de oven en laat afkoelen. Druk de knoflook uit de schil. Rooster de amandelen in een droge, hete koekenpan en laat afkoelen. Kook de pasta beetgaar. Maal ondertussen de amandelen, Parmezaanse kaas, basilicum en rode peper in een keukenmachine en voeg 2/3 van de geroosterde tomaatjes en de knoflook toe. Mix tot een pesto en breng op smaak met zout en peper. Giet de pasta af en bewaar wat kookvocht. Meng de pesto, overige tomaatjes en de kappertjes door de pasta. Voeg eventueel wat kookvocht toe en roer goed door. Serveer met een schep ricotta.\n",
"ingredients": "400 g cherry-/kerstomaatjes (gehalveerd)\n2 teentjes knoflook (ongepeld)\n3 el olijfolie\n1 el balsamicoazijn\n100 g blanke amandelen\n300 g fusilli\n50 g Parmezaanse kaas\n1 bosje verse basilicum\n1 rode peper (in ringetjes)\n2 el kappertjes\n250 g ricotta",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/s2Bci7D.jpeg"
},
{
"id": 28,
"name": "Fusilli met kipgehaktsaus",
"recipe": "Bak knoflook zachtjes. Schep gehakt erdoor en bak rul. Strooi paprikapoeder erover. Schep roerbakgroenten door gehakt en bak 2 min. Schenk pastasaus erbij en kook 10 minuten zachtjes. Kook fusilli beetgaar. Schenk saus over pasta.",
"ingredients": "2 teentjes knoflook\n400 g kippengehakt\n2 tl paprikapoeder\n400 g Toscaanse roerbakgroenten\n1 pot pastasaus traditioneel (500 ml)\n300 g fusilli tri colore",
"servings": 4,
"serveWith": "geraspte kaas en salade van bladsla met tomaatjes en olijven",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/jGnuFmY.jpeg"
},
{
"id": 377,
"name": "Fusilli met paprika en worst",
"recipe": "Kook de fusilli beetgaar. Verhit intussen de olijfolie op middelhoge stand. Voeg het venkelzaad en de plakjes worst toe en bak deze in circa 7 minuten goudbruin. Schep de worst uit de pan en voeg de knoflook, gepelde tomaten, alle paprika, oregano, suiker en chilipeper naar smaak toe aan het bakvet. Laat deze tomatensaus circa 10 minuten pruttelen en breng op smaak met zout. Voeg de worst weer toe aan de saus en warm kort door. Giet de fusilli af en serveer met de tomatensaus. Bestrooi met de Parmezaanse kaas.\n",
"ingredients": "300 g fusilli\n2 el olijfolie\n1 tl venkelpoeder\n4 braadworsten in plakjes\n2 teentjes knoflook geperst\n1 blik gepelde tomaat\n1 rode paprika in stukjes\n1 gele paprika in stukjes\n2 el gedroogde oregano\n2 tl suiker\n1 tl chilipepervlokken\nhandje Parmezaanse kaas grof geraspt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/Xbb9X5C.jpeg"
},
{
"id": 29,
"name": "Gamepie",
"recipe": "Bladerdeeg ontdooien; citroen raspen. Ui en paddenstoelen fijnsnijden. Kip en kalkoen elk in 3 stukken snijden. Kalkoen op bodem ovenschaal leggen. In pan ui 2 min fruiten. Paddenstoelen 3 min (op hoog vuur) meebakken, vocht moet weg zijn. Citroenrasp, peterselie en tijm erdoor (en zout en peper) over kalkoen verdelen. Baconreepjes en kip erop. In zelfde pan fond tot helft inkoken en over kip gieten. Aanrecht bestuiven met bloem. Bladerdeeg op elkaar leggen en uitrollen tot ronde lap van 26 cm. Over ovenschaal leggen. Rand van deeg met mooie plooien vastdrukken (leuk: versieringen erop!). Ei loskloppen. Met appelboor in midden van deeg enkele gaatjes maken. Deeg bestrijken met ei. 45-50 min in oven 175 °C. Als het te bruin wordt afdekken met aluminiumfolie.",
"ingredients": "5 plakjes roomboter bladerdeeg\n1 citroen\n4 takjes peterselie\n2 takjes tijm\n1 grote ui\n200 g paddenstoelmengsel\n300 g kipfilet\n300 g kalkoenschnitzel\n100 g baconreepjes\n1 dl gevogeltefond\n1 ei",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/Ix7KzKB.jpeg"
},
{
"id": 30,
"name": "Garnalenschotel",
"recipe": "Kook rijst en kook worteltjes een paar minuten mee. Roer kruiden, citroensap, peper en zout door halvanaise. Voeg zoveel water toe tot het een gebonden gietbare saus is. Bak paprika, worteltjes en prei tot prei begint te kleuren. Voeg rijst toe en bak even mee. Voeg bouillonblokjes toe. Schep garnalen erdoor. Serveer gerecht en giet saus erover.",
"ingredients": "200 g notenrijst\nenkele worteltjes in plakjes\n3 el halvanaise\n3 el gehakte groene kruiden\n1 el citroensap\n1 rode paprika in blokjes\n1 prei in ringen\n2 groentebouillonblokjes\n300 g gepelde garnalen",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/WBFfTMN.jpeg"
},
{
"id": 31,
"name": "Gebakken ham in roomsaus",
"recipe": "Sjalotjes snipperen en 2 min fruiten. Azijn toevoegen en 5 min op matig hoog vuur verdampen. Bloem erdoor. Al roerend fond toevoegen en roeren tot gladde saus. Bessen, zout en peper toevoegen. 5 min zachtjes sudderen. Crème fraîche erdoor. 5 min sudderen. In koekenpan ham 3 min bakken. Voor serveren, bessen uit saus verwijderen.",
"ingredients": "5 sjalotjes\n50 g boter\n1 dl wittewijnazijn\n2 el bloem\n380 ml vleesfond\n4 jeneverbessen\n125 ml crème fraîche\n4 dikke plakken achterham",
"servings": 4,
"serveWith": "broccoli krielaardappeltjes",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 348,
"name": "Gegratineerde courgette met zalmcrème",
"recipe": "Verwarm de oven voor tot 200 °C. Halveer de courgettes in de lengte en schraap de zaadlijsten er met een tl uit. Leg de courgettehelften op de bolle kant op de bakplaat. Rasp de gele schil van de citroen. Meng de zalm, knoflook, kaas, citroenrasp en crème fraîche. Schep de zalmcrème in de courgettes. Bak de courgettes in de voorverwarmde oven in 15-20 min. knapperig gaar. Verhit intussen de olijfolie in een koekenpan. Bak de krieltjes in 10-12 min. goudbruin en gaar. Leg de courgettes op 4 borden. Schep de krieltjes erbij. Bestrooi eventueel met grofgehakte peterselie.",
"ingredients": "2 courgettes\n1 citroen\n150 g zalmsnippers\n1 teen knoflook\n100 g geraspte jong belegen kaas\n125 g crème fraîche\n2 el olijfolie\n700 g krieltjes (duopak)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/QqJpbPZ.jpeg"
},
{
"id": 32,
"name": "Gegratineerde paprika met risotto",
"recipe": "Risotto gaar koken. Paprika's wassen, halveren en zaadlijsten verwijderen. In pan met ruim water paprika's 4 min koken en daarna uit laten lekken. Oesterzwammen fijn snijden. Oesterzwammen in koekenpan met olie 4 min bakken. Grill voorverwarmen op hoogste stand. Gorgonzola in stukjes snijdenen door risotto roeren. Oesterzwammen erdoor scheppen. Ovenschaal invetten. Paprika opvullen met risotto. In ovenschaal zetten en bestrooien met kaas. Onder grill tot goudbruin (8 min).",
"ingredients": "175 g risottorijst\n1 groene paprika\n1 rode paprika\n150 g oesterzwammen\n1 el olijfolie\n50 g gorgonzola\n4 el Parmezaanse kaas",
"servings": 2,
"serveWith": "salade",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/4zMunfj.jpeg"
},
{
"id": 33,
"name": "Gegratineerde tilapiafilet",
"recipe": "Bestrooi vis met zout en peper. Schenk citroensap erover en laat 15 min intrekken. Meng in kom koksroom met Philadelphia. Leg tilapia in ovenschaal. Verdeel roommengsel over vis. Bestrooi met Parmezaanse kaas en grill 8-10 min op 10 cm onder grill.",
"ingredients": "2 tilapiafilets\n1 el citroensap\n2 el koksroom\n125 g Philadelphia\n3 el Parmezaanse kaas geraspt",
"servings": 2,
"serveWith": "wortelsalade en gekookte krieltjes met peterselie",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 34,
"name": "Gegratineerde vis",
"recipe": "Snij bosui fijn. Meng zalm met room en bosui en schenk in schaal. Leg pangasiusfilet erop. Verdeel krieltjes over vis. Bestrooi eerst met peterselie en dan met kaas. Stoof 20 min in oven.",
"ingredients": "2 bosuitjes\n100 g gerookte zalmblokjes\n200 ml slagroom\n500 g pangasiusfilet\n2 el peterselie\n450 g kleine krieltjes\n50 g geraspte belegen kaas",
"servings": 4,
"serveWith": "peultjes en sugarsnaps",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/wmWr5Nh.jpeg"
},
{
"id": 35,
"name": "Gegrilde haaskarbonade",
"recipe": "Grill voorverwarmen. Karbonades bestrooien met zout en peper. Peperkorrels kneuzen. Honing, mosterd, boter en peperkorrels mengen en karbonades met helft bestrijken. Karbonades 9 minuten grillen. Halverwege keren en rest boter erover. Opgevangen braadvocht in pan schenken. Wijn en cognac erdoor. Saus 5 min iets inkoken. 15 g koude boter in blokjes snijden en door saus mengen. Goed kloppen zodat saus bindt.",
"ingredients": "4 haaskarbonades\n1 volle el zwarte peperkorrels\n3 el honing\n3 el mosterd\n125 ml droge witte wijn\n2 el cognac\n40 g zachte boter",
"servings": 4,
"serveWith": "broccoli, uitgebakken spek, gebakken krieltjes",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 241,
"name": "Gegrilde ham met Vlaamse friet",
"recipe": "Snijd de bleekselderij in heel smalle boogjes. Meng ze in een grote schaal met de sladressing. Dep ondertussen de plakken ananas droog. Bestrijk de ananas en de ham met een klein beetje olie en grill ze in een grillpan of op de hete barbecue om en om een beetje bruin. Maak ondertussen de friet volgens de aanwijzingen op de verpakking en bestrooi ze met wat zout. Voeg de sla aan de schaal met bleekselderijsalade toe. Leg de plakken ham met daarop een schijf ananas op 4 borden. Schep de friet en de salade ernaast.",
"ingredients": "400 g Vlaamse friet\n200 g gemengde sla\n4 schijven ananas\n4 dikke plakken ham\n400 g bleekselderij\n6 el sladressing honing/mosterd",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/WhS1bdv.jpeg"
},
{
"id": 36,
"name": "Gehaktballetjes met rijst en kropsla",
"recipe": "Was tomaten en snijd in stukken. Verhit olijfolie en doe tomaten erin. Voeg knoflook toe. Hak kruiden grof en strooi over tomaten. Breng op smaak met zout, peper en suiker. Schenk er 100 ml water bij en laat 50 minuten koken. Kook rijst. Schep gehaktballetjes door tomatensaus en laat ze in 10 minuten gaar koken. Scheur sla in grove stukken. Snij ui in ringen. Bak spekreepjes knapperig. Schep spek, ui en olijven door sla. Besprenkel met olijfolie en azijn.",
"ingredients": "2 kg tomaten\n2 teentjes knoflook\n2 takjes rozemarijn\n1 bos verse basilicum\n1 el suiker\n400 g witte rijst\n500 g gehaktballetjes\n1 kropsla\n1 kleine ui\n50 g spekreepjes\n16 zwarte olijven zonder pit\n1 el witte wijnazijn",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/S9RFHts.jpeg"
},
{
"id": 37,
"name": "Gehaktbrood met couscous",
"recipe": "Kneed gehakt met paneermeel en ei. Zet in koelkast. Bereid couscous met 200 ml water volgens gebruiksaanwijzing. Hak champignons fijn en bak in boter. Snijd mozzarella en tomaatjes in stukjes en schep met champignons en kruiden door couscous. Druk gehakt uit tot rechthoekige plak op aluminiumfolie. Verdeel 50 g rauwe ham over het gehakt en verdeel couscousmengsel in het midden erover. Druk vulling goed aan en rol gehakt op. Druk uiteinden dicht. Leg gehaktbrood zonder folie met opening naar beneden in schaal en dek af met rest rauwe ham. Laat in oven op 220 °C in 45 minuten gaar worden. Dek af met aluminiumfolie als het te donker wordt.\n",
"ingredients": "750 g gemengd gehakt\n50 g paneermeel\n1 ei\n100 g couscous Maroc\n100 g champignons\n125 g mozzarella\n2 zongedroogde tomaatjes\n0,5 el Provençaalse kruiden\n125 g rauwe ham",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Couscous",
"photo": null
},
{
"id": 243,
"name": "Gehakthachee met rijst",
"recipe": "Verhit een hapjespan met antiaanbaklaag en bak het gehakt in 5 min. rul. Voeg de uien toe en bak 5 min. mee. Voeg de tomatenpuree, champignons, kruidnagels, azijn, het bouillon­tablet en 300 ml water toe. Roer door, breng aan de kook en zet het vuur laag. Laat 15 min. op laag vuur zachtjes koken. Kook ondertussen de rijst volgens de aanwijzingen op de verpakking. Serveer de rijst met de gehakthachee.",
"ingredients": "300 g rundergehakt\n4 uien, in halve ringen\n140 g tomatenpuree\n250 g champignons, in kwarten\n3 kruidnagels\n1 el azijn\n1 runderbouillontablet\n300 g zilvervliesrijst",
"servings": 4,
"serveWith": "sperziebonen",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/JIg8r2A.jpeg"
},
{
"id": 38,
"name": "Gehaktschotel met tomaat",
"recipe": "Aardappelen koken en in plakjes snijden. Olie verhitten en ui 10 min bakken. Gehakt toevoegen en 5 min rul bakken. Peper 3 min meebakken. Mosterd, ketchup, zout, paprika en oregano toevoegen. Helft aardappelen in ovenschaal schikken. Gehaktmengsel met helft tomaat mengen. Over aardappelen verdelen en met 3 el kaas bestrooien. Rest aardappelen en tomaat om en om op gehakt leggen. Met kaas bestrooien. 30 min in oven op 200°C.",
"ingredients": "700 g vastkokende aardappelen\n3 el olie\n1 grote gesneden ui\n400 g rundergehakt\n1 gesneden Spaanse peper\n1 el mosterd\n4 el tomatenketchup\n1 tl paprikapoeder\n1 tl oregano\n500 g tomaten in plakken\n150 g geraspte belegen kaas",
"servings": 4,
"serveWith": "groene salade",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/lcxJWno.jpeg"
},
{
"id": 39,
"name": "Gelakte varkensmedaillons met port-saliesaus",
"recipe": "Honing met 1 el fond door elkaar roeren. In pan ½ el boter verhitten en sjalotje en knoflook 1 min fruiten. Port, azijn en rest fond toevoegen. Tot 1,5 dl laten inkoken. Varkenshaas in 12 plakken van 3 cm snijden en plat slaan. Plakken bestrooien met zout en peper. In pan 2 el boter verhitten. Vlees in 4 minuten om en om bakken. Dun bestrijken met honing en nog ½ min om en om bakken. Saus opnieuw verwarmen met salieblaadjes. Salie verwijderen. Van vuur af rest boter in gedeelten erdoor kloppen.",
"ingredients": "1 sjalotje gesnipperd\n0,5 teentje knoflook\n1 el honing\n380 ml vleesfond\n5 el boter of margarine\n1 dl rode port\n2 el rode wijnazijn\n2 varkenshaasjes (à 300 g)\n4 salieblaadjes",
"servings": 4,
"serveWith": "aardappelkroketjes spruitjes",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 40,
"name": "Gele nasi",
"recipe": "Kook rijst gaar met koenjit erbij. Groenten in plakjes snijden. Fruit de lente-ui 1 min in olie. Schep uit pan. Bak geweekte groenten, sugarsnaps en worteltjes. Voeg santenpoeder en 2 dl water toe. Stoof enkele minuten. Roer rijst, garnalen en lente-ui erdoor. Breng op smaak met sambal.",
"ingredients": "1 pak rijst\n2 tl koenjit\n200 g worteltjes\n150 g sugarsnaps\n1 bosje lente-uitjes\n1 zakje nasigroenten, geweekt\n1 zakje santenpoeder\n250 g roze garnalen\nsambal",
"servings": 4,
"serveWith": "kroepoek",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/DQlkr65.jpeg"
},
{
"id": 41,
"name": "Gele rijst met Mexicaanse kip",
"recipe": "Bereid gele rijst zoals op pak staat. Bak kip in 5 min goudbruin. Voeg ui en knoflook toe en fruit 2 min mee. Voeg paprika en tomaten toe en bak 3 min mee. Roer chilibonen en bouillonblokje erdoor en laat 10 min sudderen zonder deksel op pan.",
"ingredients": "1 pak gele rijst\n400 g kipfilet in blokjes\n1 ui gesnipperd\n1 teentje knoflook geperst\n1 groene paprika in blokjes\n200 g tomaten in blokjes\n400 g chilibonen of kidneybonen\n1/2 kippenbouillonblokje",
"servings": 4,
"serveWith": "tortillachips en guacamole en komkommersalade",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/bS5KcNI.jpeg"
},
{
"id": 278,
"name": "Gele rijstsalade met taugé en pinda's",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking en laat uitgespreid op een platte schaal helemaal afkoelen. Blancheer de sugarsnaps 1 minuut en giet ze onder koud stromend water af. Snijd ze in schuine dunne repen. Klop de dressing. Vermeng alle ingrediënten en de dressing met elkaar en serveer in een grote schaal.",
"ingredients": "400 g gele rijst\n150 g sugarsnaps\n5 bosuitjes, in ringetjes\n200 g taugé, gewassen en gedroogd\n1 bosje koriander, grof gehakt\n150 g pinda’s, grof gehakt\nVoor de dressing:\n1 el wittewijnazijn of limoensap\n1 el gembersiroop\n1 mespuntje sambal\n3 el zonnebloemolie",
"servings": 4,
"serveWith": "kipspies",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/lntYUkw.jpeg"
},
{
"id": 42,
"name": "Gemarineerde hamlappen met Provençaalse tomatensaus",
"recipe": "Snijd vlees in grote dobbelstenen. Doe in een kom met ui, kruiden, knoflook en wijn. Laat 24 uur in koelkast marineren. Zeef vlees en vang marinade op. Haal knoflook uit marinade. Bak vlees rondom bruin in boter. Voeg bouillon, tomaten en knoflook toe. Stoof 10 min met deksel op pan. Giet marinade in pan en laat nu zonder deksel nog 20 min stoven. Bind met maïzena.",
"ingredients": "750 g hamlappen\n1 ui, gesnipperd\n2 teentjes knoflook\n1 tl Provençaalse kruiden\n1/4 l rode wijn\n50 g boter\n1,5 l vleesbouillon\n1 blik gepelde tomaten",
"servings": 4,
"serveWith": "fusilli",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/1icAOi2.jpeg"
},
{
"id": 342,
"name": "Gember-kip met honing",
"recipe": "Verwarm de oven voor op 200 °C. Ris de blaadjes van de takjes tijm en hak ze fijn. Meng de verse gember, stemgember, knoflook, ketjap, honing, olie en tijm in een ruime kom. Bestrooi de drumsticks met zout en wrijf in met het gember- en chilipoeder. Wentel de kip goed door de marinade en laat minimaal 1 uur afgedekt staan (een nacht is beter). Schep halverwege om. Verwijder ondertussen de schil van de ananas en snijd het vruchtvlees in dikke plakken van de harde kern en vervolgens in stukken van 5 centimeter. Verwijder de stelen van de venkelknol en houd het groen apart. Snijd de knollen tussen de steelaanzet doormidden en verdeel de helften elk in 5 parten. Leg de drumsticks met wat tussenruimte op de bakplaat. Haal de ananas en venkel door de achtergebleven marinade en leg tussen de kip. Rooster het gerecht 40 minuten in het midden van de oven. Schep halverwge om. Bestrooi met het venkelgroen en serveer.",
"ingredients": "paar takjes tijm\nverse gember (ca. 5 cm, geraspt)\n5 bolletjes stemgember (fijngehakt)\n3 teentjes knoflook (fijngehakt)\n2 el ketjap\n2 el honing\n2 el olie\n1 kg kipdrumsticks\n1 el gemberpoeder\n1 tl chilipoeder\n1 ananas\n2 venkelknollen",
"servings": 4,
"serveWith": "nasi",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/UCCs0GK.jpeg"
},
{
"id": 43,
"name": "Gepocheerde kipfilet in witte wijn",
"recipe": "Pel en halveer druiven en verwijder pitjes Was spinazie. In pan kip, wijn, 1 dl water en bouillontablet aan kook brengen. In ± 8 min kip tegen kook aan gaar laten worden. Met schuimspaan filet uit pan op bord scheppen en afdekken met aluminiumfolie. Boven maatbeker achtergebleven pocheervocht zeven. 1 dl afmeten, rest kan weg. In steelpan boter smelten. Bloem erdoor roeren. Pocheervocht toevoegen. Blijven roeren tot gebonden saus ontstaat. Slagroom en 2 el druiven erdoor roeren. 5 min zachtjes verwarmen. Zout en peper toevoegen naar smaak. Spinazie op borden leggen. Kipfilet in schuine plakjes snijden en op spinazie leggen. Saus op en naast kip schenken. Garneren met rest druiven.",
"ingredients": "100 g witte druiven\n50 g verse spinazie\n2 kipfilets\n2 dl droge witte wijn\n0,5 kippenbouillontablet\n1 el boter\n1 el bloem\n0,125 l slagroom\nzout\npeper",
"servings": 2,
"serveWith": "witte rijst wortels",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 44,
"name": "Gepocheerde sliptong",
"recipe": "Oven verwarmen 175 °C. Sjalotjes snipperen. Schaal invetten en tong erin leggen. Bestrooien met zout, peper en sjalot. Wijn erover schenken. 6 min in oven. Tomaten ontvellen en in vieren snijden. Schotel uit oven en vocht voorzichtig in pan gieten. Mosselen en tomaatpartjes aan vis toevoegen. Warm houden onder aluminiumfolie in oven (uit). Crème fraîche door vocht roeren. Op hoog vuur in 5 min inkoken tot sausdikte. Bieslook erover knippen.",
"ingredients": "2 sjalotjes\n200 g sliptongfilet\n1 dl droge witte wijn\n4 tomaten\n250 g gekookte mosselen\n200 ml crème fraîche\n25 g verse bieslook",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 434,
"name": "Geroosterde groenten-ovenschotel",
"recipe": "Verwarm de oven voor op 180 °C. Smeer de ovenschaal in met olie. Snij het knoflookteentje doormidden en wrijf de zijkanten en bodem van de schaal in met de knoflook. Snij de courgette, tomaten, aubergine en venkelknollen in schijven van ongeveer 0,5 cm dik. Leg de plakjes groenten om en om (dus eerst een plakje courgette, dan tomaat, aubergine en tenslotte venkel en blijf dat herhalen) in de schaal. Besprenkel met olie. Bestrooi met de Italiaanse kruiden en rasp de kaas erover. Schuif 40 minuten in de oven. Controleer om de 10 minuten of de groenten niet te bruin worden. Dek in dat geval af met aluminiumfolie.",
"ingredients": "1 teentje knoflook\n1 courgette\n4 romatomaten\n1 aubergine\n2 venkelknollen\nItaliaanse kruiden\nOude kaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/kiZsuHD.jpeg"
},
{
"id": 45,
"name": "Gesmoorde kip in tomaten-honingsaus",
"recipe": "Tomaten ontvellen en in stukjes snijden. Sjalotje raspen. Peterselie fijnknippen. Kip inwrijven met zout en peper. In pan boter smelten. Kip erdoor wentelen. Gezeefde tomaten, stukjes tomaat en geraspte sjalot toevoegen. Met deksel op pan in 1 uur zachtjes gaar smoren. Kip af en toe keren en mengsel doorroeren. Kip in voorverwarmde schaal leggen en warm houden. Honing en kaneel door tomatenmengsel roeren. Op hoog vuur al roeren inkoken in 5 minuten tot sausdikte. Over kip schenken. Bestrooien met peterselie.",
"ingredients": "500 g tomaten\n1 sjalotje\n4 takjes peterselie\n1 kip\n50 g boter\n500 g gezeefde tomaten\n2 el honing\n1,5 tl kaneel",
"servings": 4,
"serveWith": "aardappelpuree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/obJGF7a.jpeg"
},
{
"id": 46,
"name": "Gestoofde paling",
"recipe": "Snij de paling in stukjes van 6 cm. Breng in pan visfond, 1 dl wijn en de vermout aan de kook. Laat het zonder deksel op hoog vuur tot een vijfde inkoken. Verdeel 100 g boter in klontjes. Roer van het vuur af de klontjes door kookvocht. Laat saus afkoelen. Breng in andere pan ½ l water aan de kook met de rest van de witte wijn en 100 g boter. Zout toevoegen. Voeg de stukjes paling toe. Laat in 15 min zachtjes gaar koken. Intussen saus verwarmen en slagroom en tuinkruiden erdoor roeren. Voeg zout en peper toe. Neem paling uit pan en schep in voorverwarmde schaal. Schenk de saus erover",
"ingredients": "600 g palingfilet\n3 dl visfond\n2 dl witte wijn\n0,5 dl witte vermout\n200 g boter\nzout\n3 el slagroom\n3 el tuinkruiden\npeper",
"servings": 4,
"serveWith": "gekookte aardappels, salade",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 47,
"name": "Gestoomde najaarsgroenten met rosbief",
"recipe": "Snij aardappels in lengte in 8 partjes. Snij uien in zessen. Schil bospeen. Stoom alle groenten (behalve haricots verts) 15 minuten. Voeg haricots verts toe en stoom nog 5 minuten. Fruit sjalotje. Voeg wijn en sinaasappelsap toe en kook 5 minuten in tot hij stroperig is. Leg groenten met rosbief op borden en serveer saus apart.",
"ingredients": "2 grote aardappels, schoongeboend\n2 rode uien\n1 bos bospeen\n100 g bloemkoolroosjes\n150 g haricots verts\n1 sjalotje fijngesneden\n125 ml rode wijn\n125 ml sinaasappelsap\n150 g rosbief in plakken",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 48,
"name": "Geurig gestoofde kip en paprika",
"recipe": "Verwarm de oven voor op 175 °C. Meng de knoflook in een kom met het paprikapoeder, de kaneel, komijn en peper en zout naar smaak. Roer de olie erdoor. Leg de kippenbouten in de ovenschaal en bestrijk ze met de helft van het knoflookmengsel. Meng de rest van het mengsel met de paprika, ui en tomaten en schep dit tussen de kippenbouten. Schenk de bouillon in de schaal. Stoof de schotel in de oven in 1 uur gaar. Schep af en toe wat van het vocht over de bouten.",
"ingredients": "3 tenen knoflook, geperst\n1 el paprikapoeder mild\n2 tl kaneel\n1 tl gemalen komijn\n3 el olijfolie\n4 kippenbouten\n2 rode paprika's, in repen\n1 grote ui, grof gesneden\n4 tomaten, in stukjes\n150 ml kippenbouillon",
"servings": 4,
"serveWith": "veldsla rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/GCdu5wa.jpeg"
},
{
"id": 466,
"name": "Gevulde paprika met kerrierijst",
"recipe": "Bereid de rijst volgens aanwijzing op de verpakking. Warm de oven voor op 200 °C. Snijd de paprika's overlangs doormidden, verwijder de zaadjes en de zaadlijsten. Pel en snipper de ui fijn. Verhit in een koekenpan ca. 20 g margarine en bak de ui met de kerriepoeder. Pers het teentje knoflook erboven uit. Bak de gekookte rijst ca 2 minuten mee. Schep de rozijnen en gehakte noten erdoor. Vul de paprikahelften hoog op met dit mengsel en zet ze in een ovenschotel. Bestrooi ze met geraspte kaas en paneermeel. Schenk er wat margarine over. Bak de paprika's in de oven in ca. 20 minuten bruin en gaar.",
"ingredients": "2 rode paprika's\n1 ui\n1 el kerriepoeder\n1 teentje knoflook\n2 el rozijnen\n30 g vloeibare margarine\n4 el geraspte 30+ kaas\n1 volkorenbeschuit fijn gemalen tot paneermeel\n150 g zilvervliesrijst\n50 g ongezouten gehakte noten",
"servings": 2,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/GPcQEaz.jpeg"
},
{
"id": 49,
"name": "Gevulde paprika's met gehakt en tuinbonen",
"recipe": "Ontdooi tuinbonen. Snipper uien. Snijd kapje van paprika's en hol ze uit. Kook rijst. Bak uien zacht en glazig. Bak gehakt mee. Meng in kom de rijst, uien en gehakt en de tuinbonen. knijp knoflook erboven uit. Voeg zout, peper, dille en gezeefde tomaten erdoor. Vul paprika's met mengsel. Leg kapjes terug en bak de paprika's 30 minuten in oven op 190 °C.",
"ingredients": "200 g tuinbonen (diepvries)\n2 uien\n4 rode paprika's\n1 teentje knoflook\n100 g rijst\n200 g kalfsgehakt of rundergehakt\n2 el fijngehakte dille\n125 ml gezeefde tomaten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/8dug3wy.jpeg"
},
{
"id": 482,
"name": "Gevulde paprika's met gehakt en pesto",
"recipe": "Verwarm de oven voor tot 200 °C. Snijd van elke paprika het kapje inclusief steel. Verwijder de zaadlijsten. Zet de paprika’s rechtop in de ovenschaal en leg er de kapjes naast. Verhit een droge koekenpan en bak het gehakt rul. Laat intussen de bonen uitlekken in een zeef. Voeg de pesto en bonen toe aan het gehakt en bak 3 min. mee. Meng er 100 g kaas door en zet het vuur uit. Schep de vulling in de paprika’s en bestrooi met de rest van de kaas. Bak de paprika’s 15 min. in de oven. Neem uit de oven, zet de kapjes op de paprika’s en serveer.",
"ingredients": "4 rode paprika’s\n300 g gemengd gehakt\n2 el groene pesto\n420 g kidneybonen\n150 g Tex-Mex geraspte kaas",
"servings": 4,
"serveWith": "rijst en guacamole",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/cBn5iUq.jpeg"
},
{
"id": 50,
"name": "Gevulde tomaten met kruidenrijst",
"recipe": "Kapje en plakje van onderkant van tomaten afsnijden. Tomaten met tl uithollen. Plakjes, pulp en zaadjes van uithollen fijnsnijden. Tomaten omgekeerd op keukenpapier laten uitlekken. Pijnboompitten in droge koekenpan roosteren en dan grof hakken. Binnenkant van tomaten met zout en peper bestrooien. In koekenpan olie verhitten en ui met knoflook 2 min. fruiten. Tomatenpuree 1 min. meebakken. Rijst en tomatenpulp toevoegen en geheel doorwarmen. Mengsel pittig op smaak brengen met zout en (cayenne)peper. Van vuur af pijnboompitten, munt en basilicum erdoor scheppen. Tomaten hoog opvullen met rijst en in ingevette ovenschaal zetten. Oven voorverwarmen op 200 °C. Schaal in oven zetten en tomaten 20 min. bakken.",
"ingredients": "4 grote vleestomaten\n2 el pijnboompitten\n2 el olie\n1 rode ui, gesnipperd\n1 teentje knoflook, geperst\n1 el tomatenpuree\n250 g basmatirijst (voorgekookt)\n2 el fijngehakte verse munt\n2 el fijngehakte basilicum",
"servings": 4,
"serveWith": "scholrolletjes",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 317,
"name": "Gewokte lemongrass-chilikip",
"recipe": "Bereid de noedels volgens de aanwijzingen op de verpakking. Verhit in de wok de olie. Bak de kipfiletblokjes 2 min. op hoog vuur. Voeg de sugarsnaps en de paprika toe en bak de groenten in 4 min. knapperig gaar. Voeg de bosuitjes toe en bak nog 1 min. Draai het vuur laag. Voeg de wokpasta toe en meng goed. Voeg de goed uitgelekte noedels toe en bak alles nog 1-2 min. Verdeel de noedels met de lemongrass-chilikip en groenten over 4 kommen.",
"ingredients": "2 zakjes Conimex wok paste curry lemongrass & chili\n1 pak Conimex woknoedels\n2 el Conimex wokolie\n400 g kipfiletblokjes\n300 g sugarsnaps\n2 rode paprika's\n3 bosuitjes",
"servings": 4,
"serveWith": "geroosterd sesamzaad",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/4jAOBQj.jpeg"
},
{
"id": 289,
"name": "Gnocchi met gerookte zalm en sperziebonen",
"recipe": "Gnocchi volgens gebruiksaanwijzing koken. Sperziebonen in 8 min. beetgaar koken. Uien en knoflook pellen en snipperen. In braadpan olie verhitten en ui met knoflook zachtjes bakken. Zalm in stukjes snijden. Bieslook fijnknippen. Crème fraîche, bonen en zalm door uien roeren en verwarmen. Met zout en peper op smaak brengen. Gnocchi over vier borden verdelen. Romig groente-zalmmengsel erop scheppen. Met bieslook garneren.",
"ingredients": "750 g gnocchi di patate\n450 g sperziebonen\n2 uien\n2 teentjes knoflook\n2 el (olijf)olie\n200 g gerookte zalm\n25 g verse bieslook\n200 ml crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/KBy6AVo.jpeg"
},
{
"id": 429,
"name": "Gnocchi met paddenstoelen",
"recipe": "Verhit de olie en fruit hierin de uien 5 minuten op middelhoge stand. Voeg de paddenstoelen toe en bak 10 minuten mee. Voeg de knoflook toe en bak 1 minuut mee. Voeg de bouillon en wijn toe, breng aan de kook en laat circa 8 minuten pruttelen. Kook de gnocchi volgens de aanwijzingen op de verpakking. Voeg vervolgens het citroensap, de room en peterselie toe aan de saus. Giet de gnocchi af, roer door de saus en kook de saus een beetje in op een lage stand. Verdeel de gnocchi over borden en bestrooi met de kaas.\n",
"ingredients": "2 uien (in ringen)\n400 g gemengde paddenstoelen (grof gehakt)\n2 teentjes knoflook (gehakt)\n100 ml paddenstoelenbouillon of\n100 ml groentebouillon\n100 ml witte wijn\n1 pak gnocchi\n1 el citroensap\n4 el room\n0.5 bosje peterselie (fijngehakt)\n30 g Parmezaanse kaas (geraspt)",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/Meb4ZCe.jpeg"
},
{
"id": 281,
"name": "Gnocchi met pittige worstjes en tuinbonen",
"recipe": "Breng een ruime pan water met wat zout aan de kook. Voeg de gnocchi toe zodra het water kookt en kook de pasta gaar volgens de aangegeven tijd op de verpakking. Roer af en toe en giet af. Verhit ondertussen de olie in een ruime koekenpan en fruit hierin de ui en knoflook 3 min. Gebruik van de Italiaanse kruiden alleen de salie en oregano en hak de kruiden fijn. Houd een paar salieblaadjes apart als garnituur. Voeg de gehakte kruiden en chipolataworstjes toe en bak ze 3 min. mee. Schep goed om en laat de worstjes bruin kleuren. Giet de tomatensaus bij de worstjes in de pan en voeg de tuinbonen toe. Breng de saus tegen de kook aan en laat alles nog 5 min. goed doorwarmen. Verdeel de gnocchi over borden en schep de saus erover. Bestrooi met de grana padano en peper en garneer met de achtergehouden salieblaadjes.",
"ingredients": "500 g gnocchi\n3 el olijfolie\n2 uien gesnipperd\n2 teentjes knoflook geperst\n20 g verse Italiaanse kruiden\n500 g chipolataworstjes gehalveerd\n1 pot pastasaus basilicum\n300 g tuinbonen\n75 g grana padano geraspt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/M8ExISc.jpeg"
},
{
"id": 375,
"name": "Gnocchi met tonijnsaus",
"recipe": "Kook de gnocchi kort voor het serveren. Verhit 2 el olijfolie en bak hierin de ui, bleekselderij, prei en knoflook 2-3 minuten. Schep de tonijn en pastasaus erdoor en verwarm. Verwarm de ovengrill. Verhit de rest van de olijfolie en bak hierin de tomaatjes met de Italiaanse kruiden circa 2 minuten. Schep de gnocchi met de tonijnsaus in een ovenschaal en verdeel de tomaatjes en mozzarella erover. Gratineer het gerecht onder de ovengrill tot de mozzarella smelt.\n",
"ingredients": "1 pak gnocchi\n4 el olijfolie\n1 ui gesnipperd\n0.5 struik bleekselderij in boogjes\n1 prei in ringen\n2 teentjes knoflook fijngehakt\n2 blikjes tonijn uitgelekt\n1 pot pastasaus\n200 g cherry-/kerstomaatjes gehalveerd\n1 el Italiaanse kruiden\n1 bol mozzarella in plakjes",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/OoI7tgx.jpeg"
},
{
"id": 439,
"name": "Gnocchi ovenschotel met romige kip",
"recipe": "Verwarm de oven voor op 200 °C. Verhit de helft van de olie in een grote koekenpan en bak de gnocchi in 15 min. goudgeel. Maak ondertussen de champignons schoon met keukenpapier en snijd in vieren. Snijd de kipdijfilet in blokjes. Verhit de rest van de olie in een hapjespan en bak de kip 3 min. op middelhoog vuur. Voeg de champignons toe en bak 5 min. mee. Halveer de cherrytomaten en voeg samen met de gnocchi toe aan de kip. Roer de Paturain Cuisine erdoor en warm 1 min. mee. Breng op smaak met peper. Verdeel het mengsel over de ovenschaal en strooi de kaas erover. Bak de gnocchischotel ca. 15 min. in het midden van de oven tot de kaas gesmolten en lichtbruin is. Snijd het basilicum grof en verdeel over de ovenschotel.\n",
"ingredients": "4 el milde olijfolie\n800 g koelverse gnocchi\n250 g kastanjechampignons\n350 g kipdijfilet\n250 g cherrytomaten\n185 g Paturain Cuisine knoflook & fijne kruiden\n100 g geraspte belegen kaas\n7,5 g verse basilicum",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/BzrxSUV.jpeg"
},
{
"id": 354,
"name": "Gnocchi, ricotta en selderij",
"recipe": "Kook de gnocchi volgens de aanwijzingen op de verpakking. Snijd de bleekselderij in reepjes. Verhit de olie in een koekenpan en bak de champignons 4 min. Schep de bleekselderij erdoor en bak 3-4 min. op middelhoog vuur. Voeg de knoflook toe en bak nog 1 min. Breng op smaak met peper en zout. Verdeel de gnocchi over 4 borden en schep de ricotta erop. Verdeel de groenten erover.\n",
"ingredients": "2 pakken gnocchi di patate (pasta, a 500 g)\n1 struik bleekselderij\n2 el olijfolie\n250 g champignons, in kwarten\n2 tenen knoflook (geperst)\n250 g ricotta",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/6dHx8bT.jpeg"
},
{
"id": 456,
"name": "Goulashsoep",
"recipe": "Snipper de uien. Hak de knoflook fijn en snijd de paprika’s in reepjes. Smelt in een (soep)pan de boter. Bak de ui, knoflook en paprika 3 min. Snijd de runderriblap in blokjes. Schep het vlees door de groenten en bak 2 min. mee. Schep er de tomatenpuree, het paprikapoeder, karwijzaad en de bloem door en bak nog 1 min. Voeg de gepelde tomaten, 1 L water, het bouillonblokje en de laurierblaadjes toe en breng aan de kook. Draai het vuur laag en stoof de soep met het vlees afgedekt in 2 uur zachtjes gaar. Schil de aardappelen en snijd ze in blokjes van 1 cm. Kook de aardappelblokjes de laatste 15 min. in de soep mee gaar. Hak de peterselie fijn. Breng de soep op smaak en verwijder de laurierblaadjes. Schep de soep in 4 kommen en bestrooi met de peterselie.",
"ingredients": "2 uien\n3 tenen knoflook\n1 rode paprika\n1 gele paprika\n50 g boter\n500 g runderriblap\n70 g tomatenpuree\n1 el milde paprikapoeder\n2 tl karwijzaad\n3 el bloem\n400 g gepelde tomaten\n1 runderbouillonblokje\n2 laurierblaadjes\n2 vastkokende aardappelen\n1 takje peterselie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/l4iF3OG.jpeg"
},
{
"id": 51,
"name": "Gratin van knolselderij en Port Salut",
"recipe": "Over verwarmen op 180 °C. Snij knolselderij in dunne plakken en kook 5 min. Afgieten en afspoelen met koud water. Paddenstoelen met tijm en knoflook kort bakken. Tomaat in plakken snijden en puree bereiden. Maak in ovenschaal laagjes: knolselderij, puree, paddenstoelen, tomaat tot alles op is. Leg Port Salut erop en bak 20 min in oven.",
"ingredients": "1 knolselderij\n200 g paddenstoelenmelange\n1 el tijm\n1 teentje knoflook\n4 tomaten\n1 pak aardappelpuree (180 g)\n120 g Port Salut in plakjes",
"servings": 4,
"serveWith": "groene salade",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/CTWtNLz.jpeg"
},
{
"id": 301,
"name": "Grieks rundvlees uit de oven",
"recipe": "In ovenschaal vlees mengen met azijn, olie, oregano en chilipoeder. Smaken 15 min. laten intrekken. Tomatenpuree, zout en peper door vlees scheppen. Bouillon erdoor roeren. Ovenschaal met deksel erop in koude oven schuiven. Oven inschakelen op 175 °C. Vlees in minstens 2 uur zachtjes gaarstoven. Vlees af en toe omscheppen en na 1 uur tomaten en paprika erdoor mengen. Schaal uit oven nemen en kaasblokjes erboven verkruimelen.",
"ingredients": "600 g riblappen of runderlappen, in grove stukken\n2 el rode-wijnazijn\n3 el olijfolie\n1 el gedroogde oregano\n2 tl chilipoeder\n1 el tomatenpuree\n125 ml vleesbouillon\n4 tomaten, in partjes\n2 gele paprika's, in grove stukken\n200 g feta",
"servings": 4,
"serveWith": "witte rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/Lx5JMoZ.jpeg"
},
{
"id": 414,
"name": "Groentecurry met naanbrood",
"recipe": "Verwarm de oven voor op 200 °C. Bestrijk het naanbrood met 1 el olie. Verhit de rest van de olie in een wok of hapjespan en roerbak hierin de wokgroenten met de kerrie 3-4 minuten. Giet de kokosmelk erbij, roer de pindakaas erdoor en verwarm. Bak het naanbrood in de oven volgens de aanwijzingen op de verpakking. Rooster de pinda's kort in een droge, hete koekenpan. Hak de helft van de pinda's grof. Schep de hele pinda's en de helft van de koriander door de groentecurry. Verdeel de curry over 4 kommen en bestrooi met de gehakte pinda's en de rest van de koriander. Serveer het naanbrood erbij.\n",
"ingredients": "4 naanbroden\n4 el wokolie of\n800 g oosterse wokgroenten\n1 el kerriepoeder\n400 ml kokosmelk\n2 el pindakaas\n125 g gezouten pinda’s\n2 e lkoriander, gehakt",
"servings": 4,
"serveWith": "salade van wortel en komkommer",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/FkOrsna.jpeg"
},
{
"id": 402,
"name": "Groentekorma",
"recipe": "Verhit de olie en fruit hierin de ui 3-4 minuten. Voeg de gember en knoflook toe en bak deze 1 minuut mee. Schep de aardappelblokjes, wortel, rode peper, cashewnoten, tomatenblokjes met sap, kerrie en een snuf zout toe. Stoof zachtjes circa 10 minuten. Voeg de doperwten, paprika en kookroom toe en stoof afgedekt nog 10-15 minuten op een lage stand tot de aardappel gaar is. Bestrooi de korma met cashewnoten en bosui.",
"ingredients": "1 ui, gesnipperd\n1 verse gember, fijngehakt, geschild, ca. 5 cm\n4 teentjes knoflook, fijngehakt\n3 aardappels in kleine blokjes\n2 winterwortels in dunne plakjes\n1 rode peper in stukjes\n125 g cashewnoten, gemalen\n25 g cashewnoten om te garneren\n1 blik tomatenblokjes (400 g)\n1.5 el kerriepoeder\n250 g diepvriesdoperwten\n1 rode paprika in blokjes\n1 gele paprika in blokjes\n200 ml kookroom\n2 lente-/bosuitjes in ringetjes",
"servings": 4,
"serveWith": "gele rijst",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/au2qTzM.jpeg"
},
{
"id": 230,
"name": "Groenterijst met Yorkham",
"recipe": "Bak bevroren snijbonen en erwten 3 min in olie. Schep rijst en kerriepoeder erdoor en bak nog 2 min. Schenk bouillon bij rijst en breng aan de kook. Kook op laag vuur in 10 min gaar. Schep hamreepjes en rozijnen erdoor.",
"ingredients": "300 g gesneden snijbonen\n300 g tuinerwten\n300 g witte rijst\n2 tl kerriepoeder\n750 ml groentebouillon\n200 g gegrilde Yorkhamreepjes\n3 el rozijnen",
"servings": 4,
"serveWith": "bosui",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/MLhpRyy.jpeg"
},
{
"id": 395,
"name": "Groenterisotto met knoflookgarnalen",
"recipe": "Sjalotjes pellen en fijnsnijden. Paprika's in dunne repen snijden. Dille fijnsnijden. 2 el olijfolie in braadpan verhitten en sjalotjes ca. 1 min. bakken. Rijst toevoegen en meebakken tot alle korrels glanzen. Bouillon deel voor deel toevoegen en risotto in ca. 20 min. gaarkoken. Paprika en dille laatste 10 min. laten meekoken. Zout en peper naar smaak toevoegen. Intussen rest olijfolie in wok verhitten en mosselen en garnalen ca. 2 min. omscheppend bakken. Risotto over 4 diepe borden verdelen. Mossel-garnalenmengsel erover verdelen.",
"ingredients": "2 sjalotjes\n3 paprika's (rood, groen en geel)\n0,5 bakje verse dille\n4 el olijfolie\n300 g risottorijst\n600 ml kruidenbouillon\n150 g gekookte mosselen\n200 g garnalen (wok met knoflook)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/yAqaqvN.jpeg"
},
{
"id": 52,
"name": "Groentetajine met gegrild vlees",
"recipe": "Snijd aubergines in de lengte in vieren en snijd deze delen in 4 stukken. Snijd courgettes in de lengte in vieren en snijd deze delen doormidden. Bak aubergine in olie tot die bruin kleurt. Schep courgette, ui en knoflook erbij. Schep als ui bruin kleurt de koriander, komijn, een tl zout en tomatenblokjes erbij. Breng het geheel aan de kook. Giet kikkererwten af en voeg toe. Laat 30 minuten op laag vuur doorkoken. Kwast worstjes en lamskoteletjes in met olie en bestrooi koteletjes met zout en peper. Gril vlees 2-3 minuten per kant",
"ingredients": "2 aubergines\n2 courgettes\n2 grote uien gesnipperd\n2 teentjes knoflook fijngesneden\n1 tl korianderpoeder\n1 tl komijnpoeder\n2 blikken tomatenblokjes (400 g)\n1 blik kikkererwten (400 g)\n12 kalkoenworstjes\n8 lamskoteletjes",
"servings": 8,
"serveWith": "couscous",
"protein": "Vlees",
"starch": "Couscous",
"photo": null
},
{
"id": 411,
"name": "Grove knolselderijstamppot met wortel en rookworst",
"recipe": "Kook de aardappelen met de winterpeen in 20 min. gaar. Smelt in een braadpan de helft van de boter. Schep de knolselderij erdoor en bak goudbruin. Draai het vuur laag en smoor de knolselderij, eventueel met 3-4 el water, in 15 min. gaar. Schep regelmatig om. Wel de rookworst 15 min. Rooster in een droge koekenpan de hazelnoten goudbruin en schud ze op een bord. Verwarm intussen de melk met de resterende boter in een steelpannetje. Giet de aardappelen af. Stamp ze met het melk-botermengsel tot een fijne puree. Schep de helft van de knolselderij door de puree. Schep de rest van de knolselderij met de hazelnoten erover. Schep de stamppot op 4 borden. Snijd de rookworst in plakjes en leg ernaast. Bestrooi met de tuinkers en serveer met de piccalilly.",
"ingredients": "1 kg kruimige aardappelen\n250 g winterpeen\n50 g boter\n1 knolselderij\n1 verse rookworst grof\n75 g hazelnoten\n150 ml melk\n3 el tuinkers\n8 el piccalilly",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/vus28U4.jpeg"
},
{
"id": 488,
"name": "Ham-camembertsalade",
"recipe": "Was de sla en verdeel deze in smalle reepjes. Snij ham in luciferstokjes. Verdeel camembert in plakjes. Schil appel, verwijder klokhuis, snij vruchtvlees in plakjes en sprenkel er citroensap over. Rooster sesamzaadjes in olijfolie. Hak noten voor dressing fijn en voeg notenolie, citroensap, knoflook, peper, zout en crème fraîche toe. Roer bieslook door dressing. Schik ham, camembert, appel, rozijnen en noten op de sla. Giet dressing erover en garneer met sesamzaadjes.",
"ingredients": "gemengde sla\n250 g gekookte ham\n250 g camembert\n1 appel\n1 el citroensap\n50 g rozijnen\n50 g pecannoten\n2 el sesamzaad\n0,5 el olijfolie\nDressing:\n25 g pecannoten\n2 el notenolie\n2 el citroensap\n1 teentje knoflook\npeper\nzout\n2 el fijngehakte bieslook\n125 ml crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/JdM4zfk.jpeg"
},
{
"id": 53,
"name": "Hamburgerballetjes in groentekerriesaus",
"recipe": "Elke hamburger in 6 stukjes verdelen en met natte handen tot balletjes draaien. Balletjes 5 min in 25 g boter bakken. In braadpan rest boter verhitten. Prei met kerriepoeder 3 min bakken. Paprikareepjes in stukjes snijden. Taugé, en paprika aan prei toevoegen en 2 min bakken. 2 dl water toevoegen. Met garde kerriesaus erdoor roeren. 3 min zachtjes koken. Balletjes en sojasaus toevoegen en even mee verwarmen.",
"ingredients": "4 ongepaneerde hamburgers\n50 g boter\n250 g gesneden prei\n2 tl kerriepoeder\n2 el zoetzure paprikareepjes\n250 g taugé,\n1 pakje Chinese eiermie\n1 zakje kerriesaus\nsojasaus\nzout\npeper",
"servings": 4,
"serveWith": "mie",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/Cl4ZNKN.jpeg"
},
{
"id": 244,
"name": "Ham-preigratin",
"recipe": "Verwarm de oven voor op 200 °C. Verhit de boter in een koekenpan en bak de prei 5 min. Schep de hamblokjes en krieltjes erdoor. Breng op smaak met peper en zout en schep in de ovenschaal. Meng in een kom de crème fraîche met de mosterd en 100 g kaas. Breng op smaak met peper en zout en verdeel dit over de preischotel. Strooi de rest van de kaas erover. Bak de ham-preigratin in het midden van de oven in ca. 30 min. goudbruin en gaar.",
"ingredients": "3 preien, gewassen en in ringen gesneden\n250 g hamblokjes\n800 g krieltjes\n200 ml crème fraîche\n1 el grove mosterd\n175 g gemalen kaas jong",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/OMgWEoa.jpeg"
},
{
"id": 423,
"name": "Hartige groentetaart met pastinaak",
"recipe": "Verwarm de oven op 200 °C. Kook de blokjes pompoen een minuut of 5 voor in een pan met water. Snijd de pastinaak en de courgette in kleine blokjes en fruit aan in een pan met een beetje olie en de fijngesneden knoflook. Voeg na een paar minuten de voorgekookte pompoen toe en schep er doorheen en breng op smaak met wat peper, zout en tijm. Bekleed de bakvorm met de velletjes hartig deeg. Besmeer de bodem met de geitenkaas en bestrooi deze met paneermeel. Voeg de gebakken groenten toe en bestrooi met kaas. Bak de hartige taart met groenten nog een minuut of 30 in de oven. Garneer met lente ui.",
"ingredients": "6 vellen deeg hartige taart\n400 g blokjes pompoen\n150 g smeerbare geitenkaas\n1 courgette\nhandje geraspte kaas\n400 g pastinaak\nsnuf tijm\n2 tenen knoflook\npeper en zout\n2 el paneermeel\n1 lente ui (in ringen)",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/l2aOLu0.jpeg"
},
{
"id": 231,
"name": "Hartige taart met garnalen en roomkaas",
"recipe": "Oven op 220 °C voorverwarmen. Bladerdeeg laten ontdooien. Uien pellen en snipperen. In wok olie verhitten en uien fruiten. Groente, garnalen en naar smaak zout en peper toevoegen en 5 min. roerbakken. Groente en garnalen laten uitlekken. Taartvorm met bladerdeeg bekleden. Bodem op verschillende plaatsen met vork inprikken en met bloem bestrooien. Groente en garnalen over bodem verdelen. Eieren met Boursin loskloppen en over groente schenken. Taart in midden van oven in 30 min. gaarbakke",
"ingredients": "5 plakjes bladerdeeg\n2 uien\n2 el (olijf)olie\n400 g Hollandse roerbakmix\n375 g roze garnalen\n1 el bloem\n3 eieren\n1 pot boursin cuisine knoflook-fijne kruiden",
"servings": 4,
"serveWith": "komkommersalade",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/BTykuw6.jpeg"
},
{
"id": 54,
"name": "Herfstsalade",
"recipe": "Oven op 225 °C voorverwarmen. Ricotta met room losroeren en met zout en peper op smaak brengen. Ricottamengsel in ovenschaal scheppen. Tijm en enkele druppels olie erover. In midden van oven 20 min goudgeel bakken. Sjalot in azijn leggen en 5 min marineren. Mosterd erdoor roeren en rest olie toevoegen. Gerookte kip en bospeen door dressing scheppen. Ricotta uit oven halen en even laten afkoelen. In kom veldsla met witlof en helft kipmengsel omscheppen. Salade op borden verdelen en ricotta en rest kipmengsel eromheen scheppen.",
"ingredients": "250 g ricotta\n2 el slagroom\n1 el tijm\n4 el olijfolie\n3 sjalotten gesnipperd\n1 el rode wijnazijn\n1 tl Dijon mosterd\n100 g gerookte kip fijngesneden\n2 bospeentjes geschild en geraspt\n2 struikjes witlof; blaadjes in lengte gehalveerd\n75 g veldsla",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/qa0LlBN.jpeg"
},
{
"id": 386,
"name": "Hertenbiefstuk met paddenstoelen en madeiraroom",
"recipe": "Kook de papardelle in ruim water met zout volgens de aanwijzingen op de verpakking beetgaar. Kook de broccoli in water met zout in 5-6 min. knapperig gaar. Verhit in een koekenpan de helft van de olijfolie. Bestrooi de biefstukken met zout en peper. Bak het vlees in 2 min. per kant bruin en vanbinnen rosé. Neem het vlees uit de pan en laat onder aluminiumfolie 5 min. rusten. Schenk de laatste olijfolie in de koekenpan. Fruit de sjalot met de knoflook en de salie 1 min. Schep de paddenstoelen erdoor en bak 3 min mee. Voeg de madeira toe. Roer de crème fraîche door de paddenstoelen en verwarm de saus nog 2-3 min. Voeg naar smaak 1-2 el extra madeira en zout en peper toe. Verdeel de papardelle over de borden. Schep de paddenstoelen met de madeiraroom erover. Leg de biefstukken erbij. Serveer met de broccoli.",
"ingredients": "350 g papardelle\n500 g broccoli\n4 el olijfolie\n4 hertenbiefstukken\n1 sjalot\n1 teen knoflook\n1 takje salie\n100 g luxe paddenstoelen\n50 ml madeira\n200 g crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/4FpHuK1.jpeg"
},
{
"id": 55,
"name": "Hertenbiefstuk met sjalottensaus",
"recipe": "Kook wijn met fond tot eenderde in. Bak sjalotten zachtjes in 15-20 min gaar in boter. Oven voorverwarmen tot 100 °C. Roer stroop door sjalotjes en verwarm zachtjes. Bak biefstuk 3 min, halverwege keren. Biefstuk 8-10 min in oven. Snij gember in plakjes. In bakvet gember, 1 el tijm en kardemom 2 min bakken. Ingekookt wijnmengsel erbij en 3 min inkoken. Jus door zeef in sauskom schenken. Tijm en peper over biefstukken strooien.",
"ingredients": "350 ml rode wijn\n380 ml wildfond\n250 g sjalotten, gepeld en gehalveerd\n3 cm gemberwortel\n2 el appelstroop\n4 hertenbiefstukjes\n2 el tijmblaadjes\n1 tl gemalen kardemom",
"servings": 4,
"serveWith": "aardappelpuree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/8muWPau.jpeg"
},
{
"id": 262,
"name": "Hertenbiefstuk met tijmjus en krieltjesclafoutis",
"recipe": "Verwarm de oven voor op 200 °C. Haal het vlees uit de koelkast en laat het op kamertemperatuur komen. Begin met de clafoutis. Verdeel de krieltjes over de ovenschaaltjes. Bak de spekreepjes licht krokant in een droge hete koekenpan. Leg de spekreepjes tussen de aardappeltjes. Klop de eieren los. Meng ze door de crème fraîche met zout, peper en de gemengde kruiden. Schenk het mengsel op de krieltjes en zet de schaaltjes 25 minuten in het midden van de oven tot het ei gestold is. Dek af met aluminium­folie als het te donker wordt. Bestrooi de hertenbiefstukken met zout en peper. Verhit de vloeibare margarine of boter en bak het vlees 2-3 minuten per kant. Schep de biefstukken uit de pan, houd ze warm en laat ze even rusten. Blus het bakvet af met port, giet de fond of bouillon erbij en laat alles iets inkoken. Schep de tijm erdoor",
"ingredients": "4 hertenbiefstukken\n50 g vloeibare margarine of boter\n1 glas rode of witte port\n200 ml wildfond of vleesbouillon\n1 el gehakte tijm of 1 tl gedroogd\n450 g voorgekookte krieltjes (koelvers)\n100 g ontbijtspek, in reepjes\n3 eieren\n200 g demi crème fraîche\n1 tl Provençaalse of Italiaanse kruiden, gedroogd",
"servings": 4,
"serveWith": "cranberrycompote broccoliroosjes",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/r7znSwb.jpeg"
},
{
"id": 307,
"name": "Hete bliksem met witte kool en Emmentaler",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Schil en snijd de aardappels in gelijke stukken. Snijd de witte kool doormidden, verwijder de kern en snijd de witte kool in dunne reepjes. Kook de aardappels en de witte kool circa 6 minuten. Schil en snijd de goudrenet en de peer in gelijke stukken. Voeg de appel en peer toe aan de witte kool en kook ze circa 8 minuten mee. Giet alles af en stoom droog. Pureer met een pureestamper. Verwarm een pan en rooster de pecannoten circa 4 minuten. Verwarm de melk. Snijd de Emmentaler in blokjes. Maak de puree smeuïg met de melk, Emmentaler en de boter. Breng de puree op smaak met de nootmuskaat, een beetje zout en versgemalen peper. Snijd de peterselie fijn en roer drie vierde door de het bliksem. Verdeel de hete bliksem met witte kool en Emmentaler over borden. Strooi de pecannoten en de resterende peterselie eroverheen.",
"ingredients": "800 g kruimige aardappels\n0,5 witte kool\n1 goudrenet\n1 handpeer\n65 g pecannoten\n100 ml melk\n200 ml Emmentaler\n1 klontje boter\n1 tl nootmuskaat\n0,5 bosje bladpeterselie",
"servings": 4,
"serveWith": "Worst",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/sFKr31v.jpeg"
},
{
"id": 428,
"name": "Hollandse visschotel",
"recipe": "Verwarm de oven voor op 200 °C. Laat de visfilets ontdooien. Snijd de bloemkool in roosjes en kook in water met zout in 8 min. beetgaar. Snijd de ui in ringen. Verhit de olie in een koekenpan en fruit de ui 4 min. Snijd ondertussen de vis in stukken. Bestrooi met het kerriepoeder en breng op smaak met peper en zout. Vet de ovenschaal in met wat olie. Verdeel de bloemkool over de bodem van de ovenschaal. Leg de ui en de vis ertussen en verdeel de aardappelschijfjes erover. Meng de crème fraîche met de kaas en verdeel over de aardappelschijfjes. Bak in de oven in ca. 25 min. goudbruin en gaar.\n",
"ingredients": "300 g diepvries kabeljauwfilets\n1 bloemkool\n2 uien\n2 el traditionele olijfolie\n2 tl kerriepoeder\n700 g aardappelschijfjes\n200 g crème fraîche\n100 g geraspte jonge kaas",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/jeb5JkC.jpeg"
},
{
"id": 366,
"name": "Hollandse witlofschotel met beenham en kaas",
"recipe": "Verwarm de oven voor tot 200 °C. Smelt in een koekenpan de boter. Bak de witlofreepjes in 5 min. beetgaar. Leg de helft van de aardappelschijfjes in de ovenschaal. Verdeel de witlof en de hamreepjes erover en dek af met de rest van de aardappelschijfjes. Meng de mix voor ovenschotel met het water en de kookroom. Klop er het ei door. Schenk ó van het mengsel over de ovenschotel, wacht 2 min. en schenk de rest erover. Leg er de paprika op en bestrooi met de kaas. Bak de witlofschotel in de voorverwarmde oven in 45 min. goudbruin en gaar.",
"ingredients": "1 zakje Maggi mix voor ovenschotel witlof crèmesaus\n25 g roomboter\n500 g witlof\n500 g aardappelschijfjes (duopak)\n250 g gerookte beenham\n150 ml kookroom light\n1 ei\n1 rode paprika\n150 g geraspte jong belegen kaas\n200 ml water",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/0lPESQV.jpeg"
},
{
"id": 263,
"name": "Hollandse wraps met rookworst",
"recipe": "Verhit in een koekenpan de olijfolie. Fruit één ui 1 min. Voeg de bonen toe. Schep er de kruidenmix met de worst en 75 ml water door en verwarm 5 min. op laag vuur. Verwarm intussen de tortilla’s volgens de gebruiksaanwijzing op de verpakking. Meng de wortel met de laatste ui, de sladressing en zout en peper naar smaak. Verdeel de bonenschotel over de wraps en rol ze op.",
"ingredients": "2 uien, gesnipperd\n800 g bruine bonen, uitgelekt\n1 zakje burrito saesoning mix\n1 rookworst, in plakjes\n8 wrap tortillas\n330 g wortel zoetzuur, uitgelekt\n2 el sladressing yoghurt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/Sh8sJGG.jpeg"
},
{
"id": 299,
"name": "Hongaarse kipschotel",
"recipe": "Tomaten ontvellen, zaadjes verwijderen en vruchtvlees in blokjes snijden. In braadpan olie verhitten en spekblokjes uitbakken. Ui en knoflook erdoor scheppen en in 3-4 min. zachtjes glazig bakken. Paprikapoeder erover strooien. Braadsticks door uimengsel scheppen en nog 5 min. bakken. Af en toe omscheppen. Tomaat, paprika en tijm aan kip toevoegen en 1 min. meebakken. Zout en peper naar smaak erover strooien en bouillon toevoegen. Met deksel op pan kip in 15-20 min. zachtjes gaarstoven.",
"ingredients": "3 trostomaten\n2 el olijfolie\n50 g gerookte spekblokjes\n1 grote ui, grofgesnipperd\n1 teentje knoflook, fijngehakt\n1 el pikante paprikapoeder\n400 g kipbraadsticks\n2 zoete puntpaprika's, in reepjes\n1 tl gedroogde tijm\n125 ml kippenbouillon",
"servings": 4,
"serveWith": "gebakken aardappelen",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/VIHz6v1.jpeg"
},
{
"id": 56,
"name": "Indiase amandelcurry met kip en paprika",
"recipe": "Snij paprika's, ui en knoflook fijn. Hak amandelen fijn. Kook rijst. Bak kip 5 min. Voeg ui, paprika, knoflook, amandel, kerriepoeder en kaneelstokje toe. Bak 3 min mee. Voeg crème fraîche en bouillon toe en kook 5 min. Verwijder kaneelstokje.",
"ingredients": "2 paprika's\n1 ui\n1 teentje knoflook\n50 g amandelschaafsel\n300 g basmatirijst\n400 g blokjes kipfilet\n0,5 el kerriepoeder\n1 kaneelstokje\n200 ml crème fraîche\n100 ml kippenbouillon",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/H4z3Kna.jpeg"
},
{
"id": 222,
"name": "Indiase kabeljauwschotel",
"recipe": "Kabeljauw in stukjes van 2 cm snijden. In grote braadpan olie verhitten. Groente ca. 2 minuten fruiten. Aardappelpartjes en kerriesaus toevoegen en ca. 7 minuten zachtjes koken. Vis toevoegen en afgedekt nog ca. 5 minuten zachtjes koken zonder te roeren. Intussen naanbrood verwarmen volgens gebruiksaanwijzing. Amandelen grof hakken. Indiase schotel op smaak brengen met zout en peper en garneren met amandelen. Serveren met naanbrood.",
"ingredients": "450 g kabeljauwfilet\n400 g roerbakgroentemix\n450 g aardappeltjes (pak)\n1 pot Indiase kerriesaus Korma\n2 pakken naanbrood\n50 g gezouten amandelen",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/n8dexDG.jpeg"
},
{
"id": 57,
"name": "Indische kipsmoor met tuinerwten",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Verhit ondertussen de olie in een wok en bak de kip in 2 min. rondom bruin. Voeg de ui toe en bak nog 1 min mee. Voeg de boemboe, de atjar tjampoer met het vocht en 50 ml water toe. Breng aan de kook. Laat de kipsmoor in ca. 15 min. op laag vuur zonder deksel op de pan gaar worden. Voeg de laatste 2 min. de tuinerwten toe. Verdeel de rijst over 4 kommen of diepe borden en serveer met het kipmengsel.",
"ingredients": "300 g witte rijst\n2 el zonnebloemolie\n500 g kipfilet, in stukjes\n1 ui, in halve ringen\n1 bakje boemboe ajam smoor (125 g)\n1 potje atjar tjampoer (350 g)\n1 pak tuinerwten extra fijn (450 g, diepvries)",
"servings": 4,
"serveWith": "Indonesische kroepoek naturel",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/tXbL8Le.jpeg"
},
{
"id": 271,
"name": "Ingepakte saucijsjes",
"recipe": "Klop in een kom de bloem met melk, eieren, zout en peper tot een beslag en zet dit 30 min. afgedekt in de koelkast. Verwarm de oven voor op 200 °C Omwikkel de saucijzen met bacon en bak ze in boter in een koekenpan in ca. 10 min. goudbruin. Verwarm intussen de ovenschaal in de oven en snijd de bosuitjes in schuine stukken. Schep saucijzen en braadvet in de ovenschaal en bestrijk de binnenzijde ervan met het vet. Verdeel de tomaten, paddenstoelen en bosuitjes over de schaal. Roer het beslag door en schenk dit over saucijzen en groenten. Bak de schotel 20 min. in het midden van de oven. Schakel daarna de oven terug naar 160 °C en bak het gerecht in 20-25 min. goudbruin en gaar",
"ingredients": "125 g bloem\n225 ml melk\n2 eieren\nzout en versgemalen peper\n4 saucijzen\n8 plakjes bacon\n2 el bakboter\n2 bosuitjes\n300 g cherry-trostomaten\n200 g gesneden paddenstoelenmix",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/fETZWrS.jpeg"
},
{
"id": 291,
"name": "Italiaans salami-bonenpot",
"recipe": "Kook de penne gaar volgens de bereidingswijze op de verpakking. Breng op smaak met versgemalen peper en roer er een scheutje olijfolie extra vierge door. Pel en snipper de uien. Pel en snijd de knoflook fijn. Verwijder het velletje van de salami en snijd de salami in blokjes. Verhit een scheutje olie in een brede pan en bak de salami, rode uien en de knoflook circa 5 minuten. Verwijder de uiteindes van de haricots verts en halveer de haricots verts. Halveer de cherrytomaten. Ris en hak de kruiden fijn. Voeg de kruiden, haricots verts en de cherrytomaten toe aan de salami en bak circa 5 minuten mee. Schenk de rode wijn erbij, breng aan de kook en laat circa 2 minuten koken.Schenk de passata erbij en breng aan de kook. Giet de cannelinibonen af en roer de bonen erdoor. Kook circa 4 minuten en breng het geheel op smaak met versgemalen peper. Verwarm een pan en rooster de pijnboompitten in circa 3 minuten goudbruin. Verdeel de pasta over borden. Verdeel de Italiaanse salami-bonenpot over de pasta. Strooi de pijnboompitten erover.",
"ingredients": "300 g penne\nolijfolie extra vierge\n2 rode uien\n2 teentjes knoflook\n250 g salami\nolijfolie om in te bakken\n250 g haricots verts\n250 g cherrytomaten\n3 takjes rozemarijn\n4 takjes tijm\n200 ml rode wijn\n400 g passata\n400 g cannelini bonen\n65 g pijnboompitten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/Adwxvyb.jpeg"
},
{
"id": 290,
"name": "Italiaanse aardappelsalade",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Snijd de aardappels in gelijke kleine blokjes. Kook de aardappelblokjes in circa 10 minuten gaar. Giet de aardappels af en laat ze uitlekken op keukenpapier. Verhit een scheutje olie in een pan en bak de saucijsjes in circa 10 minuten goudbruin en gaar. Snijd de worst in plakken. Rooster de hazelnoten circa 5 minuten in een droge pan. Pel de knoflook. Pureer de basilicum, hazelnoten, Parmezaanse kaas en olijfolie extra vierge met een staafmixer tot pesto. Breng de pesto op smaak met een beetje zout en versgemalen peper. Breng een pan met water en een beetje zout aan de kook. Snijd de broccoli in kleine roosjes. Kook de broccoliroosjes in circa 2 minuten beetgaar. Giet de broccoliroosjes af en spoel ze koud. Halveer de cherrytomaten. Pel en snijd de ui in halve ringen. Meng in een grote kom de aardappels, hazelnotenpesto, broccoli, cherrytomaten, rode ui en de rucola. Verdeel de Italiaanse aardappelsalade en de saucijsjes over borden.",
"ingredients": "800 g vastkokende aardappels\n1 stronk broccoli\n250 g cherrytomaten\n1 rode ui\n75 g rucola\n4 saucijsjes\n65 g hazelnoten\n1 teentje knoflook\n1 bos basilicum\n100 g Parmezaanse kaas\n60 ml olijfolie exra vierge",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/QNNjlHm.jpeg"
},
{
"id": 309,
"name": "Italiaanse biefreepjes",
"recipe": "Knoflook en sjalotje pellen en fijnsnipperen. Olijven in vieren snijden. Tomaten laten uitlekken. In wok olie verhitten en sjalotje en knoflook ca. 1 minuut zachtjes fruiten. Biefreepjes toevoegen en op hoog vuur in ca. 3 minuten bruinbakken. Italiaanse kruiden erdoor roeren. Tomaten boven wok in vieren snijden. Olijven erdoor scheppen en ca. 3 à 4 minuten roerbakken. Kappertjes, sojasaus en balsamicoazijn erdoor roeren en op smaak brengen met peper",
"ingredients": "1 teentje knoflook\n1 sjalotje\n150 g zwarte olijven\n1 blik gepelde tomaten\n2 el olijfolie\n1,5 bakje biefreepjes\n1 el italiaanse kruiden\n1 el kappertjes\n1 el sojasaus\n1 el balsamicoazijn\nversgemalen peper",
"servings": 4,
"serveWith": "pasta",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/e4BYm4Z.jpeg"
},
{
"id": 355,
"name": "Italiaanse bonenbasilicumsoep",
"recipe": "Verhit in een soeppan de olijfolie. Fruit de knoflook 1 min. Voeg de tomatenblokjes en de bouillon toe en breng aan de kook. Kook de soep 5 min. zachtjes. Pureer de soep met de staafmixer. Voeg de bonen toe en verwarm de soep nog 3 min. Breng op smaak met de basilicum, zout en peper.",
"ingredients": "2 el olijfolie\n3 tenen knoflook\n800 g tomatenblokjes\n750 ml vleesbouillon\n800 g borlottibonen\n20 g basilicum\n1 snufje zout\n1 snufje peper",
"servings": 4,
"serveWith": "geroosterd stokbrood",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/JcT30Zn.jpeg"
},
{
"id": 58,
"name": "Italiaanse gehakttaart",
"recipe": "Tomaat, bouillontablet en basilicum mengen. 10 min koken Oven vooverwarmen op 200 °C. Ui 5 min bakken in olie. Knoflook en gehakt toevoegen. 5 min bakken. Tomatensaus en kaas door gehakt roeren. Deeg uitrollen tot lap 30-30 cm. Op ingevette bakplaat leggen. Vulling op helft deeg scheppen. Randen met eidooier bestrijken. Deeg over vulling dubbelvouwen. Randen met vork op elkaar drukken. Deeg met dooier bestrijken. Taart 30 min in oven.",
"ingredients": "1 blik tomatenblokjes\n0,5 tablet kruidenbouillon\n1 el basilicum\n2 gesnipperde uien\n1 teentje knoflook\n250 g rundergehakt\n75 g geraspte belegen kaas\n1 blikje croissantdeeg\n1 eidooier (losgeklopt)",
"servings": 2,
"serveWith": "salade",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 315,
"name": "Italiaanse kip",
"recipe": "Bereid de aardappelpartjes in de oven. Breng de olie op smaak met de Italiaanse tuinkruiden, peper en zout. Marineer de kip 15 min. in de kruidenolie. Schep af en toe om. Snijd ondertussen de paprika's in stukken. Verhit de rest van de olie en bak de paprika 3 min. Voeg de knoflook (in plakjes), de rest van de Italiaanse tuinkruiden en het water toe. Laat met de deksel op de pan op laag vuur 20 min. stoven. Neem de laatste 5 min. de deksel van de pan zodat het vocht verdampt. Verhit een koekenpan zonder boter of olie en bak de kip op niet te hoog vuur in ca. 5 min. gaar. Keer halverwege. Serveer de kip met de aardappelpartjes en de paprika.\n",
"ingredients": "600 g aardappelpartjes\n400 g kipfilet in stukjes\n5 el olijfolie\n1,5 el Italiaanse tuinkruiden\n4 paprika's\n3 tenen knoflook",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/m8Suy8Z.jpeg"
},
{
"id": 338,
"name": "Italiaanse Knolselderijsoep",
"recipe": "Snipper de uien fijn. Snijd de knolselderij in blokes van 1 bij 1 cm. Hak de knoflook fijn. Verhit de olie in een ruime soeppan. Voeg de uien toe en bak 5 minuten, zonder ze te laten kleuren. Voeg de spekblokjes toe en bak 5 minuten mee. Voeg de knolselderij en de knoflook toe en schep om. Voeg de bouillon en uitgelekte en afgespoelde bonen toe en breng aan de kook. Draai het vuur laag en kook de soep 25 minuten. Haal de pan van het vuur. Schep de helft van de soep uit de pan. Pureer de rest van de soep met de staafmixer. Voeg de resterende soep weer toe en breng opnieuw aan de kook. Breng op smaak met zout en peper. Schep de soep in 4 kommen en bestrooi met de peterselie. Schenk naar wens nog een extra straaltje olijfolie in de soep.",
"ingredients": "2 uien\n250 g gerookte spekblokjes\n1 kleine knolselderij\n4 teentjes knoflook\n1,5 l kippenbouillon\n400 g borlottibonen\n3 el peterselie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/8TFKTE4.jpeg"
},
{
"id": 59,
"name": "Italiaanse koteletten",
"recipe": "Snij vetrandjes van koteletten. Bak ze 2 min aan elke kant. Leg ze op bord. Snipper ui en bak glazig. Voeg knoflook, rozemarijn, citroenschil en chilipepertjes toe. Bak 1 min. Doe koteletten terug in pan. Voeg bouillon en tomaten toe. Kook 10-15 min.",
"ingredients": "4 magere varkenskoteletten\n1 ui\n2 teentjes knoflook\n1 el rozemarijn\n1 tl geraspte citroenschil\n1/4 tl geplette gedroogde chilipepertjes\n150 ml kippenbouillon\n400 g gepelde tomaten",
"servings": 4,
"serveWith": "gebakken aardappelen",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/2oxXxOp.jpeg"
},
{
"id": 322,
"name": "Italiaanse ovenkarbonades",
"recipe": "Verwarm de oven voor op 225 °C. Wrijf het vlees in met een mengsel van 4 el olie, geperste knoflook, Italiaanse keukenkruiden, zout & peper. Braad het vlees in circa 25 minuten in een braadslee in de oven gaar. Tussentijds omkeren. Snipper de ui. Halveer de paprika, verwijder de zaadlijsten en snijd de helften in blokjes. Fruit de ui en paprika circa 5 minuten in 2 el olie, voeg de tomatenblokjes toe en laat de saus circa 15 minuten afgedekt sudderen. Breng de saus op smaak met zout & peper. Kook intussen de pasta volgens de gebruiksaanwijzing en de broccoliroosjes in circa 5 minuten beetgaar.\n",
"ingredients": "500 g schouderkarbonades\n6 el bakolie\n1 teentje knoflook\n2 tl Italiaanse keukenkruiden\nzout & versgemalen peper\n1 ui\n1 rode paprika\n400 g tomatenblokjes uit blik\n300 g gnocchi pasta\n500 g broccoli",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/MibC9WH.jpeg"
},
{
"id": 483,
"name": "Italiaanse risotto met prei",
"recipe": "Snipper de ui en snijd de knoflook fijn. Halveer de venkel. Verwijder de kern. Snijd de venkel in kleine blokjes. Snijd de courgette in kleine blokjes. Schil de wortel, halveer in de lengte en snijd in kleine blokjes. Ris de tijm en oregano en hak fijn. Los de twee bouillonblokjes op in 900 ml kokend water. Verhit 3 el olijfolie in een braadpan en bak de ui 2 min. op middelhoog vuur. Bak de knoflook de laatste 30 sec. mee. Voeg de rest van de groenten toe en bak 3 min. mee. Voeg de risottorijst toe en bak dit 1 min. mee, totdat de korrels glazig zijn. Schenk er de helft van de bouillon bij. Voeg verse kruiden toe en roer goed door. Laat op lage temperatuur zachtjes koken en roer regelmatig door. Rasp ondertussen de kaas. Voeg de bouillon in delen toe, steeds wanneer het vorige deel volledig is opgenomen. Proef tussendoor of de rijst gaar is. Dit duurt ca. 20 min. Kook ondertussen de eieren ca. 8 min. Hak de hazelnoten grof. Verwarm 1 el olijfolie in een andere hapjespan. Verwijder het groen en het uiteinde van de prei en verdeel in 4 gelijke stukken. Stoof de prei in 10 min. gaar met de deksel op de pan. Spatel de crème fraîche en de geraspte kaas door de risotto. Houd een beetje kaas over ter garnering. Breng op smaak met versgemalen peper. Verdeel de risotto en prei over de borden. Halveer de eitjes en leg deze op de prei. Garneer het gerecht met de gehakte hazelnoten en nog wat geraspte kaas.",
"ingredients": "1 courgette\n1 venkel\n1 winterpeen\n150 g risottorijst\n4 el olijfolie\n80 g parmigiano reggiano kaas\n4 eieren\n20 g hazelnoten\n2 preien\n125 g crème fraîche\ntijm\norgano",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/jvRdDxT.jpeg"
},
{
"id": 457,
"name": "Italiaanse tomatensoep met balletjes",
"recipe": "Pel en snipper de uien. Pel en snijd de knoflook fijn. Snijd de tomaten in blokjes. Verhit een scheutje olie in een diepe pan en fruit de uien en de knoflook circa 2 minuten. Voeg de gesneden tomaten en tomatenpuree toe en bak circa 1 minuut mee. Voeg tomatenblokjes, kippenbouillonblokjes, het water en de Italiaanse kruiden toe en breng de soep aan de kook. Kook circa 10 minuten en pureer de soep met een staafmixer. Meng het gehakt met het ei, paneermeel, rasp de Parmezaanse kaas erboven en kneed goed door elkaar. Breng op smaak met een beetje zout en versgemalen peper. Vorm met je handen ballen ter grootte van knikkers van het gehakt. Voeg de balletjes toe aan de gepureerde soep. Kook de balletjes in circa 8 minuten gaar. Bak de ciabatta af volgens op de bereidingswijze op de verpakking. Snijd de ciabatta in plakken. Pluk de basilicum. Voeg de bonen en de helft van de basilicum toe aan de soep en warm goed door. Breng de soep op smaak met een beetje versgemalen peper.Verdeel de soep over soepkommen/soepborden. Verdeel de resterende basilicum over de soep. Serveer de ciabatta ernaast.\n",
"ingredients": "2 rode uien\n2 teentjes knoflook\n5 pomodori tomaten\n1 el tomatenpuree\n400 g tomatenblokjes\n2 kippenbouillonblokjes\n1.2 l water\n2 tl gedroogde Italiaanse kruiden\n300 g half-om-half gehakt\n1 ei\n2 el paneermeel\n75 g Parmezaanse kaas\n1 ciabatta\n1 bosje basilicum\n400 g cannelini bonen",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/rwEODmw.jpeg"
},
{
"id": 475,
"name": "Italiaanse tomatentaart",
"recipe": "Vet een quichevorm in en bekleed deze met bladerdeeg. Snij de uien en lente-ui in dunne ringen. Verhit de olijfolie in een koekenpan en bak hierin de uien aan. Besprenkel met de balsamico en de suiker, bak het geheel totdat het vocht verdampt is en laat vervolgens iets afkoelen. Meng de eieren met de room, de geraspte kaas en wat zout en peper. Verdeel het uienmengsel over de bodem van de quiche, leg er wat plukjes ricotta op en giet het eimengsel erover. Snij de Prosciutto in reepjes en de tomaat in plakjes en verdeel beiden over de quiche. Bestrooi met wat rozemarijn en bak de quiche af in circa 40 minuten.",
"ingredients": "6 plakken bladerdeeg (ontdooid)\nolijfolie\n2 rode uien\n4 lente-uien\n2 el balsamicoazijn\n1 el suiker\n150 g ricotta\n100 g Prosciutto\n4 tomaten\n4 eieren\n125 ml slagroom\n60 g geraspte Parmezaanse kaas\nzout\npeper\nrozemarijn",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/b0d7330.jpeg"
},
{
"id": 234,
"name": "Italiaanse witte bonen op toast",
"recipe": "Snij salami in stukjes en bak bruin. Halveer ciabatta en wrijf in met knoflook en olijfolie. Bestrooi met 2 el parmesaanse kaas en grill 8 min op 200 °C. Verwarm bonen in soffritto. Voeg fond toe en kook 3 minuten. Voeg tomaten en salami toe en eventueel nog wat water als het te dik geworden is (met maïzena als het juist te slap is). Kook nog 3 minuten. Roer 2 el parmesaanse kaas erdoor.\n",
"ingredients": "2 ciabatta's\n4 el geraspte parmezaanse kaas\n800 g cannellini bonen\n200 ml soffritto\n250 ml fond\n200 g cherry tomaten gehalveerd\n1 salami",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/lZWEQbz.jpeg"
},
{
"id": 60,
"name": "Jachtschotel",
"recipe": "Bak ui en vlees 4 minuten in boter. Roer paprikapoeder erdoor en voeg wijn toe. Schenk er na 3 minuten 200 ml heet water bij en verkruimel bouillonblokje erboven. Steek kruidnagels in laurierblaadjes en voeg toe. Laat 1½ uur stoven. Kook aardappelen 20 minuten. Giet af en stamp fijn. Verwarm melk en roer door aardappelen met zout en peper. Verwijder laurier met kruidnagels. Verwarm oven voor op 220 °C. Schil appels, snij in stukjes en schep door vlees. Schep vlees in schaal en verdeel puree erover. Bestrooi met beschuitkruimels en 25 g boter in stukjes. Zet 30 min in oven.",
"ingredients": "600 magere riblappen in blokjes\n4 uien gesnipperd\n1 kg kruimige aardappelen\n75 g boter\n2 tl paprikapoeder pikant\n200 ml stevige rode wijn\n1 blokje runderbouillon\n3 kruidnagels\n2 blaadjes laurier\n200 ml melk\n2 grote handappels\n2 beschuiten",
"servings": 4,
"serveWith": "rode kool",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/onajlU3.jpeg"
},
{
"id": 61,
"name": "Jambalaya",
"recipe": "Ui, paprika, peterselie, bleekselderij, bosuitjes, kip en ham klein snijden ; boter verhitten ; ui, paprika bleekselderij en kip en knoflook 5 min zachtjes bakken ; ham, spice mix, rijst, tomatenblokjes (+vocht) en 3 dl water toevoegen ; doorelkaar scheppen ; laten koken ; afdekken en 30 min laten koken ; af en toe omscheppen ; bosuitjes en peterselie erdoor scheppen ; 2 min verwarmen.",
"ingredients": "1 ui\n1 groene paprika\n2 stengels bleekselderij\n3 bosuitjes\n3 takjes peterselie\n200 g kipfilet\n1 plak schouderham (200 g)\n50 g boter\nknoflook\n1,5 el cajun blended spice mix\n250 g rijst\n1 blik tomatenblokjes (400 g)",
"servings": 4,
"serveWith": "koolmix rauwkost",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/zkmmhn5.jpeg"
},
{
"id": 62,
"name": "Jolanda's rijst",
"recipe": "Hamlappen in kleine blokjes snijden. 1 zakje tandoorikruiden en scheutje citroensap erdoor. Champignons en uien klein snijden. Fruiten in olie. Hamlappen in wok in olie bakken. Rijst koken. Champignons en uien en rijst bij vlees en even meebakken. Prei snijden en erbij doen.",
"ingredients": "500 g hamlappen\n250 g champignons\n2 uien\n2 preitjes\n1 pak pandanrijst\ntandoori kruiden\ncitroensap",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/K5omAOg.jpeg"
},
{
"id": 356,
"name": "Kaasravioli met kip en citroensaus",
"recipe": "Kook de broccoli circa 2 minuten. Voeg de ravioli toe en kook deze 3-4 minuten mee. Giet af en laat uitlekken. Verhit de olie en bak hierin de kipfilet met zout en peper goudbruin. Voeg het citroensap, de honing en kookroom toe en stoof zachtjes circa 2 minuten. Meng de ravioli met de broccoli en bestrooi met de bieslook en de Parmezaanse kaas.\n",
"ingredients": "500 g broccoli (in kleine roosjes)\n500 g ravioli gevuld met kaas (koelvers) of\n2 el olijfolie\n400 g kipfilets (in blokjes)\n5 el citroensap\n1 tl honing\n200 ml kookroom\n2 el bieslook (gehakt)\n100 g Parmezaanse kaas (geraspt)",
"servings": 4,
"serveWith": "salade van groene groenten",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/ZVI91LK.jpeg"
},
{
"id": 63,
"name": "Kabeljauw met mozzarella",
"recipe": "Bestrooi kabeljauw met peper, zout, tijm en citroensap. Snij fijn: paprika, prei, tomaat en mozzarella. Oven 200 °C. Kabeljauw in ovenschaal. Tomaten erover. Bak paprika en prei 5 minuten en over kabeljauw. 15 min in oven. Mozzarella erover en nog 5 min in oven.",
"ingredients": "2 bolletjes mozzarella\n600 g kabeljauwfilet\n1 blik gepelde tomaten (400 g)\n1 rode paprika\n2 prei\ntijm\ncitroensap",
"servings": 4,
"serveWith": "krieltjes",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/dzoaLBI.jpeg"
},
{
"id": 64,
"name": "Kabeljauw met paprika-saffraansaus",
"recipe": "Visfond met saffraan 10 min inkoken. Oven 200 °C. Paprika's in stukjes. Azijn en 1 el olie door paprika mengen. Aluminiumfolie bestrijken met olie. Filets op folie leggen. Vis bestrijken met olie, tijm, zout en peper. Dichtvouwen en 15 min in oven. Peterselie fijnknippen. Fond met paprika 5 min koken. Van vuur af boter in kleine klontjes door saus roeren.",
"ingredients": "2 rode paprika's\n2 dl visfond\n0,5 g saffraan\n1 el rode wijn azijn\n2,5 el olijfolie\n400 g kabeljauwfilet\n2 tl tijm\npeterselie\n2 el boter",
"servings": 4,
"serveWith": "groene tagliatelle, veldsla",
"protein": "Vis",
"starch": "Pasta",
"photo": null
},
{
"id": 384,
"name": "Kabeljauwfilet met groenten en rösti",
"recipe": "Verwarm de oven voor op 200 °C. Verdeel de courgette, paprika en ui over tweederde van een bakplaat. Bestrooi met zout en peper. Leg de bevroren rösti ernaast en bestrooi met paprikapoeder, zout en peper. Besprenkel de groenten en rösti met olijfolie en zet de bakplaat 15 minuten in het midden van de oven. Neem de bakplaat uit de oven en leg de kabeljauw op de groenten. Bestrooi met de gehakte tijm, zout en peper. Verdeel de tomaatjes eromheen en knijp de citroenhelften uit over de groenten en vis. Leg de takjes tijm ertussen en zet de bakplaat nog circa 10 minuten terug in de oven tot de kabeljauwfilet gaar is.\n",
"ingredients": "2 courgettes in plakken van ca. 1 cm dik\n1 rode paprika in dunne repen\n1 gele paprika in dunne repen\n2 rode uien in halve ringen\n750 g diepvriesrösti\npaprikapoeder\n2 el olijfolie\n600 g kabeljauwfilets\n1 el tijm gehakt\n4 takjes tijm\n200 g cherry- of kerstomaatjes\n1 citroen gehalveerd",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/t1XLAtn.jpeg"
},
{
"id": 65,
"name": "Kabeljauwpakketjes met oesterzwammen",
"recipe": "Oven 200 °C. Vet 4 grote stukken aluminiumfolie in. Prei in ringen snijden en oesterzwammen in reepjes. Tomaten ontvellen en in reepjes snijden. Plakjes spek even bakken. Uit pan halen. Prei en oesterzwammen 3 min bakken. Tomaat, zout, peper, dragon en sherry toevoegen. 1 min koken. Schep in midden elk vel aluminiumfolie een kwart prei-mengsel. Leg vis erop. Leg daarop spekplakjes. Sluit pakketjes losjes. 20 min in oven.",
"ingredients": "2 preien\n250 g oesterzwammen\n2 tomaten\n4 plakjes ontbijtspek\n1 tl dragon\n4 el droge sherry\n4 stukken kabeljauwfilet",
"servings": 4,
"serveWith": "aardappelpuree doperwtjes",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/gRsMug2.jpeg"
},
{
"id": 238,
"name": "Kabeljauwroerbak",
"recipe": "Wel de mihoen volgens de gebruiksaanwijzing op de verpakking. Rooster de sesamzaadjes in een droge wok in enkele minuten goudbruin. Verhit 2 el olie in een wok, bak de ui 30 sec. op hoog vuur. Voeg de paksoi toe en bak of wok ca. 4 min. op hoog vuur. Voeg de gemberwortel toe, breng het gerecht op smaak met zout en peper en houd het warm onder aluminiumfolie. Verhit opnieuw 2 el olie in de wok. Bestrooi de vis met zout en peper. Roerbak de vis in ca. 4 min. op hoog vuur gaar. Schep op het laatste moment de mihoen door de vis. Verhit intussen een koekenpan met 2 el olie en bak hierin achter elkaar 4 spiegeleitjes. Verdeel de mihoen over 4 diepe borden. Schep de paksoi ernaast, strooi de sesamzaadjes erover. Leg het ei ernaast.",
"ingredients": "250 g rijstmihoen\n1,5 el sesamzaadjes\n2 rode uien in plakjes\n1 grote paksoi in brede repen\n1 el gember\n300 g kabeljauw ontdooid in blokjes\n4 eieren",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Noedels",
"photo": "https://i.imgur.com/901w6wS.jpeg"
},
{
"id": 66,
"name": "Kalfslapjes met salie",
"recipe": "Tomaten ontvellen. Tomaten en knoflook fijnsnijden. Kalfslapjes inwrijven met zout, peper en kaneel. Vlees tien minuten bakken. Uit pan op bord scheppen. In vet knoflook een halve minuut bakken. Tomaten, wijn en salie erdoor. Aan kook brengen. Vlees erin en afgedekt 35 minuten zachtjes stoven. Vlees eruit en onder aluminiumfolie warm houden. Kookvocht 3 minuten inkoken. Maïzena toevoegen en roeren tot het bindt. Saus over vlees schenken.",
"ingredients": "3 tomaten\n4 teentjes knoflook\n600 g kalfslapjes\n1 tl kaneelpoeder\n3 el olijfolie\n1,5 dl droge witte wijn\n1,5 tl salie\n2 el maïzena",
"servings": 4,
"serveWith": "farfalle en sperziebonen",
"protein": "Vlees",
"starch": "Pasta",
"photo": null
},
{
"id": 67,
"name": "Kalfsoester in spek en ansjovis",
"recipe": "Bak kalfsoester 1 minuut aan één kant aan. Haal vlees uit pan en leg met gebakken kant naar boven op plakjes spek. Leg op iedere kalfsoester 2 ansjovisfilets en rol de spek erom heen. Leg de kalfsoesters in ovenschaal met opening naar beneden. Bak 15 min in oven op 200 °C. Giet wijn en bouillon in pan met bakvet en laat tot kwart inkoken. Roer crème fraîche, kappertjes en mosterd erdoor en verwarm.",
"ingredients": "4 kalfsoesters (à 120 g) beetje platgeslagen\n4 plakjes gerookt spek\n8 gezouten ansjovisfilets\n4 el rode wijn\n8 el kippenbouillon\n2 el crème fraîche\n1/2 el kappertjes\n1 el mosterd",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 68,
"name": "Kalfsoester met citroensaus",
"recipe": "Kook rijst 8 minuten. Giet af en laat 15 min staan. Meng in diep bord de bloem, citroenrasp met zout en peper. Dep kalfsoesters droog en wentel door bloem. Kook broccoliroosjes in 5-7 min beetgaar. Bak kalfsoesters op hoog vuur 2-3 min per kant bruin. Neem ze uit pan en houd warm in aluminiumfolie. Giet broccoli af. Voeg wijn en citroensap een braadvet toe en verwarm. Verdeel rijst, broccoli en kalfsoesters over borden. Schenk saus erover en garneer met peterselie en partje citroen.",
"ingredients": "1 pak Lassie notenrijst\n2 el bloem\n1 tl citroenrasp\n2 kalfsoesters (à 125 g)\n300 g broccoliroosjes\n3 el droge witte wijn\n2 el citroensap\n1 el fijngehakte peterselie\n2 partjes citroen",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 254,
"name": "Kalfsreepjes met broccoli en bloemkool in witte wijnsaus",
"recipe": "Snijd de uitjes in ringetjes en de kalfslapjes in smalle reepjes. Verdeel de bloemkool en broccoli in roosjes. Kook de bloemkool en broccoli beetgaar in 7-8 minuten in water met zout. Verhit de olie en boter en roerbak hierin de kalfsreepjes goudbruin in 3 minuten. Voeg peper, zout en kerriepoeder toe. Giet de wijn en kookroom erbij en stoof zachtjes tot de saus iets indikt. Schep de uitjes erdoor. Serveer het gerecht op een bord of in een schaal in een rand van broccoli en bloemkool.",
"ingredients": "3 lente-/bosuitjes\n450 g magere kalfslapjes\n250 g bloemkool\n250 g broccoli\n2 el. arachideolie of olijfolie\n2 el. boter\nversgemalen peper\nzout\n1 tl. kerriepoeder\n100 ml droge witte wijn\n200 ml kookroom",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/9AtwoZV.jpeg"
},
{
"id": 69,
"name": "Kalkoen met prei en witte bonen",
"recipe": "Mozzarella in zeef uit laten lekken en in plakjes snijden. Kalkoen in lengte halveren. In 20 g boter kalkoen 2 min bakken. Zout en peper erover, Nog 4 min bakken op middelhoog vuur. Kalkoen uit pan op bord scheppen. Rest boter verhitten. Prei 2 min roerbakken. Zout, peper en azijn toevoegen. Bonen door prei scheppen. 5 min verwarmen. Kalkoen erop leggen. Mozzarella erover verdelen. Afgesloten 5 min verwarmen tot mozzarella gesmolten is. Zonnebloempitten erover strooien.",
"ingredients": "100 g mozzarellakaas\n4 ongepaneerde kalkoenschnitzels\n40 g boter\n250 g gesneden prei\n1 el azijn\n1 pot witte bonen in tomatensaus (720 g) 50 g zonnebloempitten",
"servings": 4,
"serveWith": "ijsbergsla met komkommer",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/sKSFLCO.jpeg"
},
{
"id": 70,
"name": "Kalkoen Provençal",
"recipe": "Kalkoen, tomaat en sjalotjes fijnsnijden. Olie verhitten en kalkoen op hoog uur 5 min roerbakken. Uit pan nemen. Sjalotjes 2 min bakken. Tomaten en tijm toevoegen. 3 min bakken. Slagroom erdoor roeren en op hoog vuur 5 min laten inkoken. Kalkoen terug en opwarmen. Basilicum erover.",
"ingredients": "600 g kalkoenfilet\n3 el gedroogde tomaten\n3 sjalotjes\n2 el olijfolie\n1 tl tijm\n2 dl slagroom\n2 el fijngesneden basilicum",
"servings": 4,
"serveWith": "pasta",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/VwavWXL.jpeg"
},
{
"id": 71,
"name": "Kalkoen tournedos",
"recipe": "50 g boter, curry, chilipoeder en peperbessen tot mengsel roeren. Mengsel op stuk plasticfolie scheppen en tot een worstje rollen. Twee uur in koelkast laten opstijven. Tournedos inwrijven met kaneel, zout en peper. Rest boter verhitten en tournedos 8 minuten bakken. Neem de tournedos uit de pan en bak de oesterzwammen 1 minuut. Peperboter uit folie nemen en in plakken snijden. Op elke tournedos een oesterzwam en twee plakjes peperboter leggen.",
"ingredients": "75 g boter\n2 tl curry\n0,5 tl chilipoeder\n4 grote oesterzwammen\n1 el gedroogde roze peperbessen\n4 kalkoentournedos\nmespunt kaneel\nzout\npeper\npeterselie",
"servings": 4,
"serveWith": "rijst, gemengde sla",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 479,
"name": "Kalkoenfricassee",
"recipe": "Bestrooi de kalkoen met peper en zout. Verhit de helft van de boter in een hapjespan en bak de kalkoen in 4 min. rondom bruin. Neem uit de pan. Voeg de rest van de boter toe en fruit de sjalot 4 min. Voeg de knoflook en de champignons toe en bak 5 min. op middelhoog vuur mee. Voeg de bloem toe en bak nog 1 min. Schenk de wijn en de kookroom erbij. Laat de saus op laag vuur indikken en breng op smaak met peper en zout. Voeg de kalkoen weer toe en warm nog 2 min. door.",
"ingredients": "400 g kalkoenfilet\n50 g boter\n2 sjalotten\n1 teen knoflook\n1 bakje champignons\n2 el bloem\n150 ml droge witte wijn\n1 flesje kookroom",
"servings": 4,
"serveWith": "aardappelgratin en haricots verts",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/GQFlCH4.jpeg"
},
{
"id": 72,
"name": "Kalkoenragout",
"recipe": "Snij kalkoenfilet in blokjes, champignons in plakjes en ui en knoflook fijn. Bak kalkoenblokjes rondom aan. Haal ze uit pan en bak spek kort uit. Voeg champignons toe en laat 5 minuten meebakken. Voeg ui toe en fruit glazig. Fruit knoflook, dragon en tijm kort mee. Blus af met bouillon en wijn en doe vlees terug. Laat 15 minuten stoven (NIET koken) met deksel op pan. Breng ragout tegen de kook en roer er crème fraîche door. Bind ragout met maïzena. Breng op smaak met zout, peper en citroensap. Bestrooi voor serveren met groene kruiden.",
"ingredients": "800 g kalkoenfilet\n400 g champignons\n2 uien\n2 teentjes knoflook\n200 g mager rookspek\n1 tl dragon\n1 tl tijm\n¼ l kippenbouillon of fond\n¼ l droge witte wijn\n250 g crème fraîche\nmaïzena\ncitroensap\n3 el fijngehakte dille, bieslook of peterselie",
"servings": 8,
"serveWith": "rijst, broccoli",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/LuVrmfp.jpeg"
},
{
"id": 333,
"name": "Kalkoensaltimbocca, risotto & gebakken tomaat",
"recipe": "Leg de kalkoenfilets tussen vershoudfolie en sla ze plat met de bodem van een koekenpan of de platte kant van een koksmes. Verdeel de ham over de filets. Leg er een blaadje salie uit de kruidenmix op. Rol de filets op en steek ze vast met een cocktailprikker. Snipper de ui. Ris de naaldjes van de takjes rozemarijn en haal de blaadjes van de takjes tijm, oregano en de rest van de salie. Snijd fijn. Verhit ⅔ van de olie in een pan met dikke bodem. Fruit de ui 3 min. op laag vuur. Voeg de kruiden en rijst toe. Voeg een scheut bouillon toe aan de rijst en roer tot deze is opgenomen. Herhaal dit tot de rijst beetgaar is. Dit duurt ca. 25 min. Verhit ondertussen in een koekenpan de helft van de rest van de olie en bak de kalkoenrolletjes in 15 min. rondom goudbruin en gaar. Snijd ondertussen de tomaten in kwarten. Verhit de rest van de olie in een hapjespan en bak ze 5 min. Schep regelmatig om. Serveer met de risotto en de saltimbocca.\n",
"ingredients": "280 g kalkoenfilet à la minute\n70 g parmaham\n10 g verse Italiaanse kruidenmix\n1 ui\n6 el olijfolie\n300 g risottorijst\n1 l hete kippenbouillon\n2 schalen tastytom-trostomaten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/BPITuAt.jpeg"
},
{
"id": 401,
"name": "Kapucijnerschotel met rookworst en appel",
"recipe": "Verhit een wok of hapjespan en bak hierin de spekblokjes knapperig. Schep ze uit de pan. Verhit de helft van de olie in de pan en bak hierin het gehakt rul. Schep de prei, wokgroenten en paprikapoeder erdoor en roerbak 4-5 minuten. Verwarm de rookworst volgens de aanwijzingen op de verpakking. Schil intussen de appels, boor de klokhuizen eruit en snijd de appels in plakken van circa 1 cm dik. Verhit de rest van de olie in een koekenpan en bak hierin de appels aan beide kanten goudbruin. Besprenkel met de honing. Schep de kapucijners en spekjes door het gehaktmengsel en verwarm zonder te koken. Breng op smaak met zout en peper. Snijd de rookworst in plakjes en serveer met de appelplakken op de kapucijnerschotel.\n",
"ingredients": "200 g gerookte ontbijtspekblokjes\n2 el olijfolie\n300 g rundergehakt\n2 preien (in smalle ringen)\n400 g Hollandse wokgroenten\n1 tl paprikapoeder\n1 rookworst\n2 appels\n2 el honing\n800 g kapucijners",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/nXOd16B.jpeg"
},
{
"id": 249,
"name": "Karbonade in zoetzure ketjapsaus",
"recipe": "Kook de mie 6 min. Verhit ondertussen 2 el olie in een hapjespan. Bestrooi de karbonades met peper en zout en bak ze in 3 min. rondom bruin. Neem het vlees uit de pan. Fruit de ui 2 min. in het achtergebleven bakvet. Voeg de tomatenpuree, ketjap, de helft van de atjar tjampoer en 100 ml water toe. Leg de karbonades terug in de pan en stoof ze met de deksel op de pan 15 min. Verhit de rest van de olie in een wok. Roerbak de groenten al omscheppend 4 min. Voeg de mie toe en bak nog 1 min. Schep de mie en groenten op 4 borden en leg er een karbonade met ketjapsaus bij. Serveer met de rest van de atjar tjampoer",
"ingredients": "300 g mienestjes fijn\n4 stuks ribkarbonades\n1 ui, gesnipperd\n1 blikje tomatenpuree (70 g)\n100 ml ketjap manis\n350 g atjar tjampoer\n600 g Chinese roerbakmix",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/X8ovvBD.jpeg"
},
{
"id": 73,
"name": "Kari-kari",
"recipe": "Vlees op hoog vuur in 5 min bruinbakken. Uit pan halen. In vet ui, knoflook en chilipoeder 3 min fruiten. Vlees en vleesfond toevoegen. Pittig op smaak brengen met zout en peper. Afgedekt 2-3 uur gaar sudderen. In droge koekenpan rijst goudbruin roosteren. Op bord laten afkoelen. In keukenmachine rijst en pinda's fijnmalen, hierna door stoofvocht roeren. Sperziebonen en aubergine door stoofvlees scheppen en 30 min zachtjes stoven. Voeg scheutje water toe indien saus te dik wordt. Breng op smaak met vissaus en sojasaus.",
"ingredients": "500 g doorregen runderlappen in stukken\n1 grote ui gesnipperd\n2 teentjes knoflook\n1 el chilipoeder\n1 pot vleesfond (380 ml)\n25 g witte rijst\n40 g pinda's\n250 g sperziebonen\n1 grote aubergine in blokjes\n2-3 el Thaise vissaus\n1-2 el sojasaus",
"servings": 4,
"serveWith": "rijst gesnipperde bosui",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 363,
"name": "Kartoffel-Selleriesalat",
"recipe": "Kook de aardappelblokjes in 5 min. gaar, giet ze af en laat ze uitdampen en afkoelen tot lauwwarm. Klop een dressing van de mayonaise, yoghurt en het water en breng op smaak met versgemalen peper. Meng op 2 el na het gesneden bleekselderijblad door de dressing. Schep de aardappelblokjes met de appel en bleekselderij voorzichtig door elkaar. Schep de dressing voorzichtig door de salade. Laat de salade 30 min. in de koelkast op smaak komen. Strooi vlak voor het serveren de walnoten en het achtergehouden bleekselderijblad erover.",
"ingredients": "1 kg vastkokende aardappelen\n4 el mayonaise\n75 ml volle yoghurt\n0,5 struik bleekselderij\n2 appels met rode schil\n75 g walnoten, grof gehakt\n100 ml koud water",
"servings": 4,
"serveWith": "gegrilde worstjes",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/lQ0S8We.jpeg"
},
{
"id": 74,
"name": "Käseschnitten",
"recipe": "Snij kaas en tomaat in plakken en ui in ringen. Bak sneetjes brood 1 voor 1 goudgeel. Bedek grote platte ovenschaal met sneetjes. Overgiet met beetje wijn. Leg daarop plakjes ham en daarna met helft ui en tomaat. Daarop plakjes kaas. Herhaal laagjes. 15 min in oven op 180 °C. Bak 4 eieren. Leg eieren op schaal.",
"ingredients": "0,5 witbrood\n50 g roomboter\n2 glazen droge witte wijn\n300 g jong belegen kaas (of Bagnes)\n3 uien\n200 g schouderham in dunne plakjes\n3 ontvelde tomaten\n4 eieren",
"servings": 4,
"serveWith": "wijn, frisse salade",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/GBoCXSj.jpeg"
},
{
"id": 75,
"name": "Katriens kerrieschotel",
"recipe": "Snij bleekselderij, paprika en worst in stukjes. Bak bleekselderij en paprika 5 min. Voeg rookworst, bonen en kerriesaus toe. 5 min verwarmen. Voeg ananas en peterselie toe. Opwarmen.",
"ingredients": "4 bleekselderijen\n2 rode paprika's\n250 g rookworst\n700 g witte bonen\n1 potje kerriesaus (Heinz)\npeterselie\n1 blikje stukjes ananas",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/aXWnLNG.jpeg"
},
{
"id": 76,
"name": "Kedgeree",
"recipe": "Kook rijst. Fruit kerriepoeder 1 min in boter. Roer rijst, doperwten, peper, zout, room en 1 dl water erdoor. Verwarm zachtjes. Schep vis erdoor. Rrijst in schaal. Leg eieren erop en garneer met peterselie.",
"ingredients": "375 g rijst\n2 tl kerriepoeder\n300 g diepvriesdoperwten\nmespunt cayennepeper\n2 dl room culinair\n200 g gerookte forelfilet in reepjes\n3 hardgekookte eieren\n2 el peterselie",
"servings": 4,
"serveWith": "spinaziesalade",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/Z9rcDNc.jpeg"
},
{
"id": 283,
"name": "Kerriekip met bloemkool",
"recipe": "Verwarm de oven voor op 200 °C. Doe de kip, de ui en de bloemkool in de ovenschaal. Verdeel de kerriesaus erover en dek af met aluminiumfolie. Bak in ca. 40 min. gaar in de oven. Kook ondertussen de rijst volgens de aanwijzingen op de verpakking. Rooster het amandelschaafsel in een koekenpan zonder olie of boter in 3 min. goudbruin. Laat afkoelen op een bord. Bestrooi de ovenschotel voor het serveren met het amandelschaafsel. Serveer met de rijst.",
"ingredients": "400 g kipfilet, in stukjes\n1 ui, in ringen\n600 g bloemkool, in roosjes\n1 pot Indiase kerriesaus\n300 g witte rijst\n2 el amandelschaafsel",
"servings": 4,
"serveWith": "naanbrood",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/9Tbjo5k.jpeg"
},
{
"id": 77,
"name": "Kerrierijst met broccoli",
"recipe": "Ontdooi de garnalen. Ui, wortel, broccoli in plakjes snijden. Olie verhitten. Ui met kerriepoeder 2 minuten fruiten. Rijst 2 minuten meebakken. Wortel en rozijnen erdoor scheppen. Bouillontablet erboven verkruimelen. Halve l water toevoegen. 20 minuten zachtjes koken. Na 10 minuten broccoli toevoegen. Garnalen en noten door rijst scheppen en 2 minuten mee verwarmen. Ondertussen banaan in plakken snijden. Van vuur af banaan door rijst scheppen.",
"ingredients": "100 g Noorse garnalen\n1 ui\n1 winterwortel (150 g)\n300 g broccoli\n3 el olie\n1,5 el kerriepoeder\n300 g parboiled rijst\n1 kruidenbouillontablet\n100 g rozijnen\n100 g zoute cashewnoten\n1 banaan",
"servings": 4,
"serveWith": "gemengde sla",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/5jGjkDq.jpeg"
},
{
"id": 78,
"name": "Kerrierisotto met banaan",
"recipe": "Amandelschaafsel in droge koekenpan in 5 min goudbruin roosteren. Doe op bord en strooi er zout over> Ui en paprika in stukjes snijden. In pan 2 el olie verhitten. Ui en paprika 1 min zachtjes fruiten. Voeg rauwe rijst, kerriepoeder en rozijnen toe. Bak 2 min. Voeg 6 dl water en bouillontablet toe. Breng aan kook. Kook in 18 min gaar met deksel op pan. Ondertussen bieflapjes in blokjes snijden. In rest olie blokjes 5 min bakken. Bananen in plakjes snijden. Vlees en banaan door rijst scheppen en even mee warmen. Strooi peterselie en amandelschaafsel erover.",
"ingredients": "25 g amandelschaafsel\n2 kleine uien\n1 rode paprika\n4 el olie\n2 el rozijnen\n300 g langkorrel rijst\n1.5 el kerriepoeder\n1 kruidenbouillon tablet\n400 g bieflapjes\n2 bananen\npeterselie\npeper\nzout",
"servings": 4,
"serveWith": "gemengde salade",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ollY19R.jpeg"
},
{
"id": 346,
"name": "Kikkererwtensalade met chorizo en tonijn",
"recipe": "Verwarm de oven voor op 200 °C. Verhit 2 el olijfolie en bak hierin de chorizo en paprika. Schep dit met het bakvet door de kikkererwten. Voeg de tonijn, olijven, pesto, eventueel extra olijfolie, zout en peper toe aan het kikkererwtenmengsel. Verwarm de broodrepen circa 5 minuten in de oven. Schep de rucola door de salade en serveer de salade met het brood en wat olijfolie om te dippen.\n",
"ingredients": "3 el olijfolie\n200 g chorizo (in reepjes)\n2 rode puntpaprika’s (in blokjes, zonder zaadjes)\n2 blikken kikkererwten\n2 blikjes tonijn naturel\n100 g groene olijven (gehalveerd, zonder pit)\n2 el pesto\nciabatta (in brede repen)\n75 g rucola (grof gesneden)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/goLuOIT.jpeg"
},
{
"id": 449,
"name": "Kip chow mein",
"recipe": "Snijd de kipfilet in reepjes. Verhit de zonnebloemolie in een wok. Meng de kip met de maizena. Schud overtollige maizena eraf. Bak de kip in 3 porties telkens 2 min. Schep op een bord. Maak de paprika schoon en snijd in reepjes. Breng een pan water aan de kook en kook de paprika 1 min. Schep uit het water. Kook de shiitake 30 sec. in hetzelfde water. Laat uitlekken. Kook de noedels volgens de aanwijzingen op de verpakking. Schil en snijd de gember samen met de knoflook in plakjes. Snijd de bosui in stukjes. Schenk de olie uit de wok. Maak de wok schoon. Verhit de olie en bak de gember, knoflook en bosui 1 min. Voeg de paprika en shiitake toe en bak nog 1 min. Voeg de kip, oestersaus en het water toe en verwarm 1 min. Schep de noedels, peen en taugé erdoor. Breng op smaak met peper en zout.\n",
"ingredients": "500 g kipfilet\n200 ml zonnebloemolie\n3 el maïzena\n1 rode paprika\n100 g shiitakes\n250 g woknoedels\n5 cm verse gember\n3 tenen knoflook\n3 bosuien\n1 el traditionele olijfolie\n2 el oestersaus\n2 el kraanwater\n150 g peen julienne\n125 g taugé",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/HBLHL8r.jpeg"
},
{
"id": 435,
"name": "Kip in amandelsaus",
"recipe": "Verhit de olijfolie in een braadpan en fruit hierin de ui en knoflook 2-3 minuten. Bestrooi de kip met zout en peper en voeg met de wortel toe aan de pan. Bak 3 minuten mee. Giet de bouillon erbij en voeg de aardappel, laurier, rozemarijn en kurkuma toe. Stoof zachtjes circa 25 minuten, tot de kip gaar is. Schep de kip met de wortel, aardappel, laurier en rozemarijn uit de pan en houd even warm. Laat de bouillon tot de helft (circa 250 ml) inkoken. Kook de eieren hard en snijd ze in stukken. Pureer de ingekookte bouillon met de eieren en 100 g amandelen tot een dikke saus. Voeg als de saus te dik is een extra scheutje bouillon toe. Zeef de saus eventueel en giet over de kip met de wortel en aardappel. Bestrooi eventueel met de basilicum en de rest van de amandelen.\n",
"ingredients": "3 el olijfolie\n2 uien (gesnipperd)\n3 teentjes knoflook (fijngehakt)\n8 drumsticks\n1 winterwortel (in plakjes)\n500 ml kippenbouillon\n2 grote aardappels (in blokjes)\n2 laurierblaadjes\n1 el rozemarijn (gehakt)\n1 tl kurkuma of\n1 tl kerriepoeder\n3 eieren\n125 g blanke amandelen\nevt. 2 el basilicumblaadjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/VPGRA9G.jpeg"
},
{
"id": 79,
"name": "Kip in zoetzure saus",
"recipe": "Ui en knoflook fijnsnijden. Gember raspen. Peper in dunne reepjes snijden. In kom ketjap, ui, knoflook, gember en peper mengen. Limoen boenen en schil raspen. Limoen uitpersen. Oven 175 °C. Kip inwrijven met limoen en zout. Kip 6 min bakken en uit pan halen. In zelfde pan ketjap mengsel 1 min bakken. Limoenschil, limoensap, santen en 2,5 dl water erbij. Koken tot santen gesmolten zijn. Kip erbij. Onafgedekt 40 min in oven.",
"ingredients": "1 ui\n2 teentjes knoflook\nverse gember (3 cm)\n2 rode Spaanse pepers\n3 el ketjap\n1 limoen\n4 kippenbouten\n50 g santen",
"servings": 4,
"serveWith": "witte rijst, atjar, seroendeng, kroepoek",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/BrWz0so.jpeg"
},
{
"id": 80,
"name": "Kip met groenten in witbier",
"recipe": "Snij wortel, prei, ui, gember en kip in stukjes. Bestrooi kip met zout, peper en gemberpoeder. Bak kip 5 minuten in boter. Voeg wortel, prei, gember, bier, bouillon en gembersiroop toe. Stoof met deksel op pan 45 minuten. Voeg laatste 15 minuten bonen toe. Bind met maïzena. Strooi bosuitjes erover.",
"ingredients": "200 g winterwortel\n400 g prei\n250 g sperziebonen\n2 bosuitjes\n5 bolletjes gember\n500 g kipfilet\n1 tl gemberpoeder\n1 flesje witbier\n150 ml kippenbouillon\n2 el gembersiroop\n1 el maïzena",
"servings": 4,
"serveWith": "aardappelen",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/ODNiqL6.jpeg"
},
{
"id": 81,
"name": "Kip met paddenstoelen",
"recipe": "Spek kort in olie bakken. Spek uit pan en kippenbouten per 2 rondom aanbraden. Kip uit pan nemen. In bakvet ui, champignons en helft knoflook 2 minuten bakken. Spek en kip weer in pan leggen. Marsala in pan schenken. Zodra die kookt bouillon erbij gieten. Kip afgedekt 40 minuten laten sudderen. Af en toe keren. Paddenstoelen in grove stukken snijden. In koekenpan rest knoflook 30 seconden fruiten. Paddenstoelen toevoegen en 4-5 minuten omscheppend bakken. Paddenstoelen over kip scheppen. Bestrooien met peterselie",
"ingredients": "250 g kastanjechampignons\n4 kippenbouten\n125 g magere spekreepjes\n3 uien in ringen\n4 teentjes knoflook fijngehakt\n200 ml Marsala\n100 ml kippenbouillon\n200 g paddenstoelmelange\n3 takjes peterselie fijngesneden",
"servings": 4,
"serveWith": "aardappelpuree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/n4YGH6q.jpeg"
},
{
"id": 82,
"name": "Kip met reuzengarnalen in amandelsaus",
"recipe": "Pel garnalen, bewaar schalen. Snij garnalen op de rug open en verwijder draadjes. Fruit sjalotjes en schalen van garnalen 5 minuten zachtjes. Roer regelmatig. Voeg font toe en kook zachtjes 10 minuten. Zeef font boven kommetje en druk schillen goed uit. Maal amandelen zo fijn mogelijk. Bestrooi kipfilet met kipkruiden naar smaak. Verhit boter en bak kip in 8 min gaar. Bak garnalen laatste 3 min mee. Schep alles uit pan. Bak in vet amandelen en knoflook 1 min. Voeg wijn toe en laat deze 1 min koken. Voeg font toe en kook 5 min zachtjes. Roer crème fraîche erdoor en breng aan de kook. Schep garnalen en kip weer in saus en laat warm worden.",
"ingredients": "12 reuzengarnalen\n2 sjalotten gesnipperd\n200 ml gevogeltefont\n100 g blanke amandelen\n300 g kipfilethaasjes\nkipkruiden\n25 g boter\n1 teen knoflook\n100 ml zoete witte wijn\n125 ml crème fraîche",
"servings": 4,
"serveWith": "rijst en salade",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 83,
"name": "Kip met rode ui en champignons",
"recipe": "Snij kip in dobbelsteentjes. Snij champignons en ui in stukjes. Bak ui glazig. Bak kip 1 minuut mee. Voeg witte wijn, bouillon, tijm, knoflook en zout en peper toe. Laat 25 minuten stoven. Voeg na 20 minuten champignons toe. Roer als gerecht klaar is crème fraîche erdoor. Bind eventueel met maïzena.",
"ingredients": "500 g kipfilet\n250 g champignons\n4 rode uien\n3 teentjes knoflook\n125 ml witte wijn\n125 ml kippenbouillon\n1 tl tijm\n4 el crème fraîche",
"servings": 4,
"serveWith": "rijst en broccoli",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/IpCwRHi.jpeg"
},
{
"id": 312,
"name": "Kip teriyaki",
"recipe": "Voeg de sojasaus, sherry, gembersiroop en donkere basterdsuiker bij elkaar en roer tot de suiker is opgelost. Leg de kiprepen in de marinade. Kook intussen de rijst gaar. Verhit een koekenpan en voeg de gemalen kokos toe. Rooster de kokos tot deze lichtbruin is. Neem de kokos uit de pan en houd apart. Rooster vervolgens de cashewnoten lichtbruin, haal ze uit de pan en houd apart. Rooster vervolgens de cashewnoten lichtbruin. Haal uit de pam en houd apart. Verhit de olie in een wok, neem de kiprepen uit de marinade en bak ze rondom bruin en gaar. Voeg eventueel een deel van de marinade toe als de kip tijdens het bakken te droog wordt. Neem de kip uit de pan en houd deze warm onder aluminiumfolie. Voeg bosui, Chinese kool en ananasstukjes bij de in de wok achtergebleven marinade toe en bak kort. Voeg de overige marinade en eventueel een scheutje ananassap toe. Meng de kokos en de cashewnoten door de rijst en serveer bij het ananas-kool mengsel en de teriyaki kip.",
"ingredients": "100 ml Japanse sojasaus\n50 ml sherry\n30 ml gembersiroop\n75 g donkere basterdsuiker\n300 g kipfilet in reepjes\n300 g pandanrijst\n6 el gemalen kokos\n100 g cashewnoten grof gehakt\n3 bosuitjes in ringen\n1 Chinese kool gesneden\n1 blik ananasschijven op sap in stukjes (sap bewaren)",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ZBcBY7k.jpeg"
},
{
"id": 84,
"name": "Kipdrumsticks op tomatenrijst",
"recipe": "Kook rijst en giet af. Bak kipdrumsticks in olijfolie rondom bruin. Schenk 100 ml water in pan en voeg honing toe. Smoor met deksel schuin op pan 25 min. Keer kipdrumsticks af en toe. Bak paprika in olie 5 min. Bak blokjes tomaat 2 min mee. Schep rijst erdoor en warm 1 min mee. Breng op smaak met basilicum, zout en peper. Serveer drumsticks op rijst",
"ingredients": "300 g witte rijst\n600 g kipdrumsticks\n3 el honing\n1 rode paprika in blokjes\n500 g tomaten in blokjes\n1 el basilicum fijngesneden",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/jW4NlGl.jpeg"
},
{
"id": 85,
"name": "Kipfilet met cashewnoten",
"recipe": "Snij kipfilet, lente-ui, paprika en gember in kleine stukjes. verhit olie en bak gember en lente-ui 1 minuut. Voeg dan cashewnoten en kip toe en roerbak 3 minuten. Doe paprika erbij en roerbak nog eens 3 minuten. Meng sojasaus, sherry en maïzena en roer goed. Giet mengsel bij kip en laat 1 minuut pruttelen tot saus indikt.",
"ingredients": "4 kipfilets\n1 bosje lente-uitjes\n2,5 cm verse gember\n2 groene paprika's\n100 g cashewnoten\n2 el sojasaus\n2 el sherry\n1 tl maïzena",
"servings": 4,
"serveWith": "gebakken rijst en wortelsalade",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/hh7gdP2.jpeg"
},
{
"id": 86,
"name": "Kipfilet met chinese kool en sesamzaad",
"recipe": "In droge koekenpan sesamzaad roosteren in 7 min. Snij kool, paprika, kipfilet en ui in dunne reepjes. Olie verhitten. Bak in 2 min kipfilet gaar. Haal uit pan en houd warm. Bak ui 3 min. Voeg chinese kool en paprika toe en bak 3 min. Voeg pindakaas, rozijnen, ketjap en sambal toe. Stoof zachtjes 2 min. Kipfilet, ananas en 3/4 deel sesamzaad erdoor scheppen. 1 min verwarmen. Op bord rest sesamzaad erover strooien.",
"ingredients": "75 g sesamzaad\n1 middelgrote Chinese kool\n2 rode paprika's\n1 ui\n1 blikje ananasstukjes (227 g)\n300 g scharrelkipfilet\n3 el zonnebloem olie\n4 el pindakaas\n100 g rozijnen\n2 el ketjap manis\n1 tl sambal oelek",
"servings": 4,
"serveWith": "rijst gebakken banaan",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 267,
"name": "Kipfilet met kruidenkaas en rauwe ham",
"recipe": "Verwarm de oven voor op 200 °C. Kook de aardappelen 5 minuten en giet ze af. Snijd de kipfilets over de lengte open tot een soort envelop. Vul ze met de kruidenroomkaas en vouw ze weer dicht. Bestrijk de buitenkant met pesto of tapenade en wikkel de kip strak in de rauwe ham. Zet de kippakketjes niet te dicht tegen elkaar aan in een ovenschaal met de aardappelen er omheen. Sprenkel de olijfolie erover. Zet het gerecht 20-25 minuten in het midden van de oven tot de kip gaar is. Meng ondertussen de witlof en appel met slasaus, honing, zout en peper. Serveer de kipschotel met deze salade.",
"ingredients": "4 aardappelen, geschild, in partjes of dikke plakken\n4 kipfilets\n100 g kruidenroomkaas\n2 el rode pesto of tapenade\n8 plakken rauwe ham\n2 el olijfolie\n2 struikjes witlof, in smalle reepjes\n1 appel, geschild, in stukjes\n6 el slasaus\n1 el honing",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/bm00ZHN.jpeg"
},
{
"id": 320,
"name": "Kipfiletpakketjes met camembert",
"recipe": "Verwarm de oven voor op 220 °C. Snijd de kipfilets in de lengte aan een kant door en klap het vlees open. Bestrooi met zout en peper. Verdeel de camembert over de kipfilets en klap het vlees weer dicht. Steek vast met een cocktailprikker en bestrooi rondom met tijm, zout en peper. Schep de aardappelschijfjes met de sjalotten om in een ovenschaal en breng op smaak met zout en peper. Klop het ei met de room goed door en giet gelijkmatig over de aardappelschijfjes. Bestrooi met de Gruyère en bak in het midden van de oven in circa 15 minuten gaar en goudbruin. Verhit intussen het bakproduct en braad hierin de kip op een hoge stand rondom aan. Zet de warmtebron lager en bak de kip in circa 15 minuten om en om gaar. Serveer met de aardappelgratin.",
"ingredients": "4 kipfilets\n100 g camembert (in 4 stukken)\n2 el verse tijm (alleen de blaadjes)\n450 g aardappelschijfjes\n2 sjalotjes (in dunne schijfjes)\n1 ei\n100 ml room\n50 g Gruyère (geraspt)\n2 el vloeibaar bakproduct",
"servings": 4,
"serveWith": "Tomatensalade met basilicum en ui",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/WbEa1DZ.jpeg"
},
{
"id": 236,
"name": "Kipkebab met kaaspitabroodjes",
"recipe": "Meng knoflook, citroensap, citroenschil en kruiden. Schep kipblokjes erdoor en zet minimaal 1 uur in koelkast. Rijg kipblokjes om en om met courgette aan satéstokjes. Grill stokjes op grillpan tot kip gaar is. Snij pitabroodjes open en vul met mozzarella, jonge kaas, peterselie en munt. Druk broodjes dicht en zet vast met cocktailprikker. Grill (of verwarm in oven) tot kaas gesmolten is.",
"ingredients": "1 teentje knoflook\n2 el citroensap\n1 tl geraspte citroenschil\n2 el Tikka Masala kruiden\n500 g kipfilet in blokjes\n1 courgette in blokjes\n8 pitabroodjes\n2 bolletjes mozzarella in plakjes\n200 g geraspte jonge kaas\n2 el peterselie\n2 el munt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/Li1TqG2.jpeg"
},
{
"id": 87,
"name": "Kippastasalade",
"recipe": "Vermeng roomkaas met citroensap, dressing en tomatenketchup. Voeg peper en zout toe. Kook kipfilet gaar in bouillon. Snij kip in blokjes. Ontvel tomaten en snij in stukjes. Kook pasta. Spatel kip, pasta, maïs, doperwten en tomaten door dressing.",
"ingredients": "200 g roomkaas\n1 el citroensap\n3 el dressing\n1 el tomatenketchup\npeper\nzout\n250 g kipfilet\n4 dl bouillon\n125 g doperwten\n125 g maïs\n2 tomaten\n50 g pasta",
"servings": 2,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/9AGIJrR.jpeg"
},
{
"id": 88,
"name": "Kippenpoten met champignons en wortel in witte wijn",
"recipe": "Snij ui, wortel, knolselderij en champignons klein. Bak kip bruin. Haal uit pan en fruit ui. Voeg kip, wortel, selderij, wijn, champignons en tijm toe. Laat 30 minuten stoven. Schep kip eruit en laat saus iets inkoken. Roer crème fraîche erdoor. Leg kip terug en warm goed door.",
"ingredients": "4 kippenpoten\n2 ui\n1 winterwortel\n1/4 knolselderij\n200 g champignons\n3 dl witte wijn\n1 el gehakte tijm\n150 ml crème fraîche",
"servings": 4,
"serveWith": "aardappelpuree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/3GQPHuq.jpeg"
},
{
"id": 89,
"name": "Kip-pie",
"recipe": "Meng bloem met zout. Voeg boter toe en snijd deze door bloem. Kneed er deeg van onder toevoeging van water. Laat deeg 30 min afgedekt in koelkast rusten. Kook kip in bouillon 15 min. Schep kip uit bouillon. Verwarm oven op 180 °C. Fruit ui en knoflook. Schep paprika, tomatenblokjes, ham, kip en peper erdoor en bak nog 4 minuten. Verdeel deeg in 2 porties en rol er dunne lappen van. Leg één lap in ovenvorm en prik bodem in. Schep vulling erop en strooi maïzena erover. Leg tweede deeglap erover. Zorg dat randen deeglappen met water goed op elkaar geplakt zijn. Maak in midden pie een opening. Bestrijk bovenkant met room. bak pie 40-45 min.",
"ingredients": "400 g bloem\n1,5 tl zout\n200 g boter\n4-5 el koud water\n1 l kippenbouillon\n500 g kipfilet in blokjes\n2 uien gesnipperd\n2 teentjes knoflook\n1 rode paprika in blokjes\n1 groene paprika in blokjes\n2 vleestomaten gepeld en in blokjes\n100 g rauwe ham in reepjes\n1 el maïzena\n2 el koffieroom",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 261,
"name": "Kippilav met rozijnen",
"recipe": "Verhit de olie in een hapjespan. Bak de ui en de wortel 3 min. Voeg de komijn toe en bak 1 min. mee. Voeg de rijst en de rozijnen toe en bak 2 min. mee. Schenk de hete bouillon in de pan en breng al roerende aan de kook. Kook de rijst ca. 16 min. op matig vuur. Roer regelmatig. Voeg de kip toe en warm nog 1 min mee.",
"ingredients": "2 uien, gesnipperd\n500 g winterpeen, in halve plakjes\n2 tl gemalen komijn (djinten)\n300 g zilvervliesrijst\n3 el rozijnen\n500 ml kippenbouillon\n300 g gerookte kipfilet, in plakjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/tlVMh0B.jpeg"
},
{
"id": 90,
"name": "Kipsalade",
"recipe": "Kook kipfilets met bouillontablet 15-20 min. Haal vlees uit pan en laat afkoelen. Snij gewassen andijvie of friseesalade in smalle reepjes. Snij mango of abrikoos in blokjes. Verdeel feta in blokjes. Snij tomaten in reepjes. Rooster pijnboompitten goudbruin. Meng olijfolie, sjalot, azijn, mayonaise, witte wijn, kerriepoeder en abrikozenjam. Snij kip in reepjes. Meng kip met mango/abrikoos, feta, gedroogde tomaten en bieslook. Schep dressing er luchtig door. Schik op bedje van andijvie of friseesla. Strooi pijnboompitten erover.",
"ingredients": "500 g kipfilet\n1 kippenbouillontablet\n1 krop andijvie of friseesla\n2 mango's of enkele abrikozen\n150 g feta (of kruidenroomkaas)\n6 gedroogde tomaten\n2 el pijnboompitten\n3 el fijngehakte bieslook\n4 el olijfolie\n1 gesnipperd sjalotje\n2 el (rode vruchten) azijn\n2 el mayonaise\n1 dl witte wijn\n1 tl kerriepoeder\n1 el abrikozenjam",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/ZRbNWN1.jpeg"
},
{
"id": 360,
"name": "Klassieke goulash",
"recipe": "Smelt in een braadpan de boter. Fruit de uit met de knoflook 2 min. Schep het vlees erdoor en bak 3 min. mee. Voeg de paprikareepjes toe en bak nog 2 min. Schep de tomatenpuree, het paprikapoeder en de bloem erdoor. Schenk de gepelde tomaten in de pan. Maak de tomaten met een spatel klein. Voeg de bouillon en het laurierblad toe. Breng aan de kook. Draai het vuur laag. Stof de goulash afgedekt in 2 uur zachtjes gaar. Roer af en toe goed door de pan. Kook aan het einde van de stooftijd de sperziebonen in 8 min. beetgaar. Breng de goulash op smaak met zout en peper. Serveer de goulash met de sperziebonen, een flinke lepel zure room en het stokbrood.",
"ingredients": "25 g roomboter\n1 ui\n2 tenen knoflook\n525 g sucadelappen\n2 paprika's\n70 g tomatenpuree\n2 tl paprikapoeder mild\n25 g bloem\n400 g gepelde tomaten\n500 ml vleesbouillon\n1 laurierblad\n500 g gebroken sperziebonen\n125 g zure room\n1 stokbrood\n1 snufje zout\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/GpuhVcD.jpeg"
},
{
"id": 380,
"name": "Knapperige uienpizza met ricotta en gerookte kip",
"recipe": "Verwarm oven voor tot 220 °C. Meng de tomaatjes met de dressing. Rol het pizzadeeg met het bakpapier uit en leg op de bakplaten. Roer de ricotta los en verdeel gelijkmatig over het deeg. Beleg de ricotta met de uienringen, kipreepjes en mozzarella. Bestrooi met de rozemarijn en peper naar smaak. Bak de pizza’s in de voorverwarmde oven in 15 min. goudbruin en gaar. Leg de pizza’s op een grote plank en snijd ze in driehoekige stukken. Schep de tomatensalade in 4 kommetjes en serveer bij de pizza.",
"ingredients": "1 kg snacktomaatjes\n50 ml honing-mosterddressing\n400 g pizzadeeg\n125 g ricotta\n250 g rode uien in ringen\n175 g gerookte kipfiletreepjes\n2 bollen buffelmozzarella (à 125 g)\n2 takjes rozemarijn\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/SG01NfY.jpeg"
},
{
"id": 91,
"name": "Knolselderij Cajunschotel",
"recipe": "Knolselderij, paprika, ui, tomaten en rookworst in stukjes snijden. Knolselderij, ui, paprika en Cajunkruiden 5 min bakken. Tomaat, worst en tomatenpuree toevoegen. Afgedekt 5 min stoven. Zout en peper erdoor. Ovenschaal invetten. Mengsel in schaal. Rösti erover. In kom ei loskloppen met melk en zout. Kaas erdoor roeren. Mengsel over rösti schenken. Onafgedekt 45 min in oven op 200 °C.",
"ingredients": "1 grote knolselderij (1 kg)\n1 rode paprika\n1 ui\n3 tomaten\n350 g rookworst\n2 el boter\n1,5 el Cajunkruiden\n70 g tomatenpuree\n600 g rösti\n1 ei\n4 el melk\n100 g geraspte kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/IKimnZT.jpeg"
},
{
"id": 467,
"name": "Knolselderijrisotto met truffel",
"recipe": "Schil de knolselderij en snijd in plakken van een ½ cm dik. Snijd die plakken in reepjes van een ½ cm en de reepjes weer in blokjes. Snipper de ui fijn. Verhit 25 g boter in een pan met dikke bodem en fruit de ui 4 min. Voeg de risottorijst toe en fruit 3 min mee. Breng in een andere pan 1,2 L water met het bouillonblokje aan de kook. Voeg een flinke scheut groentebouillon toe aan de rijst en roer tot de bouillon is opgenomen. Voeg de knolselderij en weer een flinke scheut bouillon toe en laat de risotto al roerend garen. Voeg steeds wat bouillon toe als de vorige hoeveelheid is opgenomen door de rijst. Ga door met bouillon toevoegen totdat de rijst gaar is. Neem de risotto van het vuur en rasp er de Parmezaanse kaas boven. Voeg de rest van de boter toe en roer tot de kaas en boter door de risotto zijn gesmolten. Snijd de selderij fijn en meng samen met de truffeltapenade door de risotto.",
"ingredients": "1 ui\n50 g roomboter\n250 g risottorijst\n1 groentebouillonblokje\n50 g Parmezaanse kaas\n20 g selderij\n1 el truffeltapenade\n800 g knolselderij",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/2wLhwGx.jpeg"
},
{
"id": 92,
"name": "Knolselderijstamppot",
"recipe": "Kook aardappelen gaar. Kook in andere pan in dezelfde tijd knolselderij gaar. Beide afgieten. Verwarm de room met mosterd. Maak van de aardappels puree. Roer er de room door. Schep de knolselderij en de bladselderij door. Serveer met warme rookworst",
"ingredients": "750 g kruimige aardappels\n1 kleine knolselderij in blokjes\n1 bosje bladselderij\n4 el mosterd\n125 ml slagroom\n1 rookworst",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/gPaxi7r.jpeg"
},
{
"id": 93,
"name": "Kofta curry",
"recipe": "Gehakt, gemberpoeder, paneermeel, zout en ei door elkaar mengen. Tot 20 balletjes rollen. Ui en peper snipperen. Tomaten ontvellen en in stukjes snijden. Paprika in stukjes snijden. Olie verhitten. Balletjes in 5 minuten rondom bruin bakken. Uit pan nemen. Ui, knoflook, pepertje, kerriepoeder, ketoembar en kaneel toevoegen. Kruidenmengsel 3 minuten roerbakken. Tomaten, paprika, tomatenpuree en 3 dl water toevoegen. Bouillontablet erboven verkruimelen. 10 minuten zachtjes stoven. Af en toe roeren. Gehaktballetjes toevoegen en nog 10 minuten stoven. Op smaak brengen met zout en chilipoeder.",
"ingredients": "500 g rundergehakt\n2 tl gemberpoeder\n3 el paneermeel\nzout\n1 ei\n1 ui\n1 klein groen pepertje\n500 g tomaten\n1 groene paprika\n4 el olie\n2 el kerriepoeder\n2 tl ketoembar\n1 tl kaneel\nknoflook\n1 blikje tomatenpuree (70 g)\n1 vleesbouillontablet\nchilipoeder",
"servings": 4,
"serveWith": "komkommer salade, rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ISO0xes.jpeg"
},
{
"id": 433,
"name": "Kokosrijst met gemengde bonen en garnalen",
"recipe": "Verhit de helft van de olie en fruit hierin de ui glazig. Voeg de knoflook, rode peper en paprika toe en bak 1 minuut. Voeg alle bonen toe en bak circa 15 minuten op een lage stand. Breng de kokosmelk met 150 ml water en de suiker aan de kook en roer tot de suiker is opgelost. Voeg de rijst toe en kook de rijst volgens de aanwijzingen op de verpakking in de kokosmelk. Voeg de gekookte rijst toe aan de bonen en schep voorzichtig om, zodat de bonen en de rijst mengen maar niet breken. Voeg de rest van de olie toe en bak 1 minuut op middelhoge stand. Voeg de garnalen toe en bak afgedekt circa 8 minuten op een lage stand, tot de garnalen gaar zijn. Roer de limoenrasp en -sap erdoor en bestrooi met de koriander.\n",
"ingredients": "1 ui (gesnipperd)\n2 teentjes knoflook (geperst)\n0.5 rode peper (in ringetjes)\n1 groene paprika (in blokjes)\n0.5 blik witte bonen\n0.5 blik zwarte bonen\n0.5 blik kidneybonen\n150 ml kokosmelk\n2 el bruine basterdsuiker\n200 g rijst\n500 g grote garnalen\n2 limoenen (rasp en sap)\n1 bosje koriander (grof gehakt)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/QEDVwh5.jpeg"
},
{
"id": 460,
"name": "Komkommerroerbak met garnalen en mie",
"recipe": "Spoel de garnalen af en dep droog met keukenpapier. Rooster het sesamzaad in een droge, hete koekenpan en houd apart. Bereid de mie. Spoel onder koud water af en laat uitlekken. Halveer de komkommers in de lengte en verwijder de zaadlijsten. Snijd het vruchtvlees in plakjes. Verhit de olie in een wok of hapjespan en fruit hierin de ui circa 5 minuten. Voeg de rode peper, knoflook en garnalen toe en roerbak 1 minuut op een hoge stand. Voeg de komkommer toe en roerbak 1 minuut mee. Schep de mie en oestersaus erdoor en roerbak nog 2 minuten op middelhoge stand. Serveer in kommen en bestrooi met de bosui en sesam.",
"ingredients": "400 g diepvrieswokgarnalen\n2 el sesamzaad\n300 g eiermie\n2 grote komkommers\n2 el wokolie\n2 el zonnebloemolie\n1 ui\n1 rode peper\n2 teentjes knoflook\n4 el oestersaus\n2 lente-/bosuitjes",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Noedels",
"photo": "https://i.imgur.com/D03JNxM.jpeg"
},
{
"id": 94,
"name": "Koolvisfilet met ansjovis en olijven",
"recipe": "Verwarm de oven voor op 220 °C. Meng de ansjovis, knoflook, olijven, tomaatjes, basilicum, olie en wijn door elkaar in een braadslee. Bestrooi de koolvisfilets rondom met zout en peper. Wentel ze door de saus in de braadslee en leg ze erin. Bak de vis in de oven gaar (10-15 min)",
"ingredients": "4 ansjovisfilets in olie fijngehakt\n2 teentjes knoflook fijngehakt\n50 g zwarte olijven grof gehakt\nhandje basilicumblaadjes\n2 el olijfolie\n1 glas droge witte wijn\n4 koolvisfilets\ncherrytomaatjes",
"servings": 4,
"serveWith": "stokbrood en groene salade",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/1PF5oAm.jpeg"
},
{
"id": 452,
"name": "Krieltjessalade met venkel en zalm",
"recipe": "Verwarm de oven voor op 220 °C. Schud de krieltjes op een bakplaat om met de olie en een snuf zeezout. Rooster hoog in de oven in circa 15 minuten goudbruin. Schaaf de venkel in dunne plakken en meng met de kruiden en kappertjes. Klop de ingrediënten voor de dressing los en breng op smaak met peper. Laat de krieltjes op de plaat iets afkoelen en schep ze met de zalm door de venkel. Besprenkel de salade met de dressing en maal nog wat peper erover.\n",
"ingredients": "600 g krieltjes (gehalveerd)\n2 el olijfolie\n1 grote venkelknol\n0.5 bosje dragon of\n1 tl gedroogde dragon\n0.5 bosje peterselie\n2 el kappertjes\n300 g warmgerookte zalmfilets\ndressing:\n3 el yoghurt\n1 el mayonaise\n1 tl wittewijnazijn\n1 el olijfolie",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/E1sPRps.jpeg"
},
{
"id": 350,
"name": "Krokante salade met tortillachips",
"recipe": "Meng de tomaatjes, kaas, bosui en ¾ van de koriander met 2 el limoensap, de olijfolie en zout en peper naar smaak. Prak het vruchtvlees van de avocado met de rest van het limoensap grof of naar wens iets fijner (guacamole). Strooi de chips op een platte schaal. Schep er de guacamole op. Verdeel de tomatensalade erover. Schep de zure room over de salade en bestrooi met de komijn, de rest van de koriander en peper naar smaak.",
"ingredients": "250 g snacktomaatjes\n100 g jonge kaas\n2 bosuitjes\n15 g koriander\n1 limoen\n3 el olijfolie extra vierge\n1 snufje peper\n1 snufje zout\n1 avocado\n85 g nacho's\n2 el zure room\n0,5 tl gemalen komijn",
"servings": 4,
"serveWith": "chipolataworstjes",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/RlqJg7j.jpeg"
},
{
"id": 372,
"name": "Krokante tomatenplaattaart met geitenroom en kruiden",
"recipe": "Verwarm de oven voor tot 200 °C. Leg 6 deegplakjes in een rechthoek op de bakplaat, laat de randen overlappen en druk licht aan, zodat een grote deeglap ontstaat. Snijd van de laatste deegplakjes 10 repen en leg ze als rand op de zijkanten. Meng de crème fraîche met de kaas, knoflook, 2 el. peterselie en peper naar smaak. Schep de cr@eme fraiche met de kaas op de deegbodem. Verdeel alle tomaten erover. Bak de tomatentaart in 20-25 min. goudbruin en gaar. Bestrooi de taart uit de oven met de rest van de peterselie en besprenkel met de olijfolie.\n",
"ingredients": "8 plakjes bladerdeeg ontdooid\n200 g crème fraîche\n75 g geraspte geitenkaas\n1 teentje knoflook, geperst\n4 el platte peterselie, fijngehakt\n4 trostomaten, in plakjes\n250 g snacktomaatjes mix, gehalveerd\n250 g cherrytomaatjes\n2-3 el olijfolie extra vierge",
"servings": 4,
"serveWith": "Veldsla met een dressing van pesto en olijfolie",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/r8MjW4v.jpeg"
},
{
"id": 247,
"name": "Kruidige kalkoen met rijst",
"recipe": "Rijst koken volgens gebruiksaanwijzing. Kalkoenfilet in reepjes snijden. Kool schoonmaken en in repen snijden. Paprika schoonmaken en in stukjes snijden. In wok of braadpan 2 el olie verhitten. Kalkoen ca. 5 minuten roerbakken en uit pan scheppen. Rest van olie in wok verhitten en paprika en kool ca. 3 minuten roerbakken. Kalkoen, boemboe en 100 ml water toevoegen. Geheel ca. 10 minuten zachtjes laten koken. Op smaak brengen met ketjap, zout en peper. Kalkoenschotel garneren met cashewnoten, serveren met rijst.",
"ingredients": "300 g snelkookrijst\n500 g kalkoenfilet\n1 Chinese kool\n1 rode paprika\n3 el zonnebloemolie\n1 cup boemboe ajam smoor (100 g)\n2 el ketjap (zout)\n75 g ongezouten cashewnoten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/jQ6ZtEx.jpeg"
},
{
"id": 95,
"name": "Lauwwarme aardappel- maaltijdsalade",
"recipe": "Bereid de krieltjes in de magnetron volgens de aanwijzingen op de verpakking. Doe een laagje water in een pan en hang er een zeef in (of gebruik een stoompan). Laat de zeef het water niet raken. Breng het water aan de kook met de deksel op de pan en stoom de sperziebonen in 10-14 minuten gaar. Spoel de sperziebonen onder stromend water af, zodat ze niet te gaar worden. Halveer de langste exemplaren. Verhit in een wok de olie en roerbak hierin op hoog vuur het rundvlees in 5-7 minuten bruin en krokant. Schenk het limoensap bij het vlees en roer de honing en knoflook erdoor, breng op smaak met zout en (versgemalen) peper en draai het vuur uit. Schep de aardappels en de sperziebonen door het vlees en bestrooi de salade met de bosui.",
"ingredients": "500 g krieltjes\n500 g sperziebonen, schoongemaakt\n2 el olie\n400 g runderreepjes\n0,5 limoen, uitgeperst\n1 tl honing\n1 teentje knoflook, fijngesneden\n1 bosuitje, fijngesneden",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/6jwyEbY.jpeg"
},
{
"id": 331,
"name": "Lauwwarme boerensalade met Brabantse ham",
"recipe": "Verhit olie in een hapjespan. Bak de krieltjes in 4 min. goudbruin. Schep de worteltjes en de champignons erdoor en bak in nog 4 min. beetgaar. Neem de pan van het vuur en laat afkoelen tot lauwwarm. Kook intussen de erwtjes in water met zout in 3 min. beetgaar. Giet de erwtjes af. Meng in een kom de erwtjes met de hamreepjes. Schep de krieltjes met de groenten erdoor. Voeg de peterselie, zout, peper en naar wens een extra scheutje olijfolie toe.",
"ingredients": "300 g Brabantse ham\n600 g mini-krieltjes\n275 g mini-worteltjes\n250 g champignons\n450 g tuinerwtjes extra fijn\n3 el peterselie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/as7gZjR.jpeg"
},
{
"id": 225,
"name": "Lenteminestrone",
"recipe": "Verhit de olie in een ruime pan met dikke bodem en bak het spek 10 min. Snijd ondertussen de winterpeen in dunne plakjes. Voeg samen met de knoflook, ui en bleekselderij toe en fruit 10 min. op laag vuur. Voeg de bouillontabletten, tomatenblokjes en 1 l water toe en breng aan de kook. Roer door en laat 15 min. op laag vuur doorkoken. Voeg de pasta, tuinerwten en bonen toe en laat nog 5 min. zachtjes koken. Voeg de peterselie toe en breng op smaak met peper en zout.",
"ingredients": "2 el olijfolie\n150 g gerookt ontbijtspek, in blokjes\n250 g winterpeen\n2 tenen knoflook, fijngesneden\n1 ui, gesnipperd\n3 stengels bleekselderij, in plakjes\n2 kippenbouillontabletten\n1 blik tomatenblokjes (400 g)\n75 g pasta\n200 g tuinerwten extra fijn\n1 blik limabonen (400 g), uitgelekt\n1 bakje platte peterselie (20 g), grof gesneden",
"servings": 4,
"serveWith": "Versgeraspte Parmezaanse kaas",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/Wq1YGTz.jpeg"
},
{
"id": 313,
"name": "Limburgse aspergesoep",
"recipe": "Was de asperges, verwijder de houtachtige onderkant van de asperges en schil ze rondom met een dunschiller vanaf vlak onder het kopje naar beneden. Breng de asperges met de schillen en het bouillontablet (in een aspergepan) met 1.5 l water aan de kook. Neem na 15 min. de asperges uit de pan en laat de schillen nog 30 min. op laag vuur doorkoken. Zeef het kookvocht en gooi de schillen weg. Snijd de gekookte asperges in stukjes. Smelt in een soeppan de boter, strooi de bloem erover en roer deze door de boter. Laat dit even bruisen en voeg al roerend scheut voor scheut het kookvocht van de asperges erbij. Laat de soep 15 min. op laag vuur doorkoken. Kook het ei hard, laat schrikken en prak fijn met een vork. Voeg het ei, de aspergestukjes, hamreepjes en de slagroom toe aan de soep. Breng het geheel op smaak met zout en (versgemalen) peper en strooi de fijngesneden peterselie erover.\n",
"ingredients": "500 g witte asperges\n1 vleesbouillontablet\n1,5 l kraanwater\n30 g boter\n30 g bloem\n1 ei\n150 g gekookte ham\n4 el slagroom\n2 el peterselie",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/XdqWMD0.jpeg"
},
{
"id": 410,
"name": "Linzensalade met bietjes en geitenkaas",
"recipe": "Meng de linzen met de tomaatjes, veldsla en biet. Rooster de walnoten in een droge, hete koekenpan. Klop de ingrediënten voor de dressing door elkaar en giet over de salade. Bestrooi met de geitenkaas en walnoten.\n",
"ingredients": "800 g linzen\n250 g cherry-/kerstomaatjes\n100 g veldsla\n2 gekookte bieten, in blokjes\n50 g walnoten, grof gehakt\n150 g zachte geitenkaas, verkruimeld\n2 el wittewijnazijn\n1 el honing\n2 el olijfolie\n1 el mosterd",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/B7nac9s.jpeg"
},
{
"id": 275,
"name": "Linzenschotel met saucijsjes",
"recipe": "Bak de spekblokjes in 1 el olijfolie. Voeg de ui en knoflook toe en bak 3 minuten mee. Roer de linzen erdoor en giet er zoveel water bij dat ze net onderstaan. Breng aan de kook en kook zachtjes 25-30 minuten. Roer regelmatig tot de linzen gaar zijn en het vocht is opgenomen. Voeg de laatste 10 minuten van de kooktijd de paprika en bleekselderij toe. Breng op smaak met zout en peper. Schep er 3 el olijfolie en citroensap door. Laat afkoelen tot lauwwarm. Bak intussen de saucijsjes in de rest van de olijfolie. Leg de worstjes op de linzenschotel en bestrooi met de peterselie.",
"ingredients": "100 g magere spekblokjes\n5 el olijfolie\n1 ui, gesnipperd\n2 teentjes knoflook, gehakt\n350 g gedroogde linzen\n1 rode en 1 groene paprika, zonder zaadjes, in reepjes\n2 stengels bleekselderij, in smalle boogjes\n1 el citroensap of rodewijnazijn\n500 g saucijsjes, chipolataof merguezworstjes\n3 el gehakte verse peterselie",
"servings": 4,
"serveWith": "Stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/BAkEucP.jpeg"
},
{
"id": 96,
"name": "Luxe aardappelsalade met spekjes",
"recipe": "Snijd de aardappelen in partjes. Kook ze in water met zout in ca. 10 min. gaar en giet ze af. 2 Verhit ondertussen de olie in een koekenpan en bak het spek knapperig. Spoel de tuinerwten in een zeef onder warm stromend water tot ze net zijn ontdooid. 3 Roer de dressing los met 2 el water. Doe de aardappelen met de rode ui en de erwten in een schaal en schep er voorzichtig de dressing door. Breng op smaak met peper en zout. Verdeel de botersla over een schaal of 4 kommen en schep de aardappelsalade erop. Verkruimel het spek erover. Serveer de salade lauwwarm of op kamertemperatuur.",
"ingredients": "1 kg aardappelen vastkokend, ongeschild\n1 el olijfolie\n100 g ontbijtspek, in plakjes\n300 g tuinerwten\n6 el bieslook sladressing met yoghurt\n1 rode ui, in ringen\n100 g botersla",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/LDP9Od6.jpeg"
},
{
"id": 237,
"name": "Maaltijdsalade met meergranenrijst",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Giet af en laat de rijst snel afkoelen door deze in een grote schaal om te scheppen. Roer de mayonaise met wat water tot een vloeibare dressing en breng op smaak met peper en zout. Schep de rijst in de kom om met de komkommer, tomaten, ui, kapucijners, sla, kaas en dressing.",
"ingredients": "200 g meergranenrijst\n75 ml mayonaise\n1 komkommer, in halve plakjes\n250 g cherrytomaten, gehalveerd\n1 ui, in halve dunne ringen\n400 g jonge kapucijners, uitgelekt\n100 g eikenbladslamelange\n150 g belegen boerenkaas, in reepjes",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/IznjfKx.jpeg"
},
{
"id": 340,
"name": "Maaltijdsalade met spek, haricots verts en gebakken bonen",
"recipe": "Breng een steelpan met water aan de kook en kook de eieren in 7 min. bijna hard. Laat schrikken onder koud stromend koud water, pel en halveer. Breng ondertussen een pan water met eventueel zout aan de kook. Verwijder de steelaanzet van de haricots verts en kook de boontjes in 4 min. beetgaar. Giet af in een vergiet, spoel koud onder stromend water en laat uitlekken. Verhit een koekenpan zonder olie of boter en bak het ontbijtspek in 5 min. krokant. Keer halverwege. Neem uit de pan, maar laat het vet zitten. Laat het spek uitlekken op keukenpapier. Maak de knoflook schoon en snijd fijn. Doe de kidneybonen in een vergiet, spoel af onder koud stromend water en laat uitlekken. Bak de bonen met de knoflook, tijm, peper en eventueel zout in het achtergebleven spekvet 5 min. op middelhoog vuur. Schud regelmatig om. Was ondertussen de tomaten en snijd in partjes. Meng de haricots verts, tomaten en sla op de grote platte schaal en verdeel de bonen erover. Besprenkel met de caesardressing, verkruimel het spek erboven, leg de eihelften erop en garneer met de tuinkers.\n",
"ingredients": "2 eieren\n150 g haricots verts\n4 plakken ontbijtspek\n1 teen knoflook\n400 g kidneybonen\n1 tl gedroogde tijm\n2 romatomaten\n200 g romainesla\n50 g caesardressing\n0,5 bakje tuinkers",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/n22baaL.jpeg"
},
{
"id": 388,
"name": "Macaroni met gerookte zalm en roomkaas",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking. Verhit de olie in een koekenpan en fruit hierin de ui circa 3 minuten. Voeg de courgette toe en bak in circa 10 minuten zacht en lichtbruin. Roer de roomkaas los met het citroensap en breng op smaak met zout en peper. Schep het roomkaasmengsel door de warme pasta, voeg de courgette en zalmsnippers toe en bestrooi met dille.\n",
"ingredients": "300 g grote macaroni\n2 el olijfolie\n1 rode ui, gesnipperd\n2 kleine courgettes, in plakjes\n250 g roomkaas\n1 el citroensap\n200 g gerookte zalmsnippers\n1 handje dille, fijngehakt",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/QBs4RRn.jpeg"
},
{
"id": 97,
"name": "Macaroni met ham, kaas en ei",
"recipe": "Kook eieren hard. Snij ui en knoflook fijn. Kook macaroni. Pel eieren en wip de dooiers eruit. Snij eiwit in blokjes en prak dooiers fijn met mosterd en scheutje water. Fruit ui, knoflook en ham. Voeg tijm, cayennepeper en room toe. Roer eiwitten en dooiermengsel erdoor. Schep saus door macaroni. Bestrooi met kaas en peterselie.",
"ingredients": "2 eieren\n1 ui\n1 teentje knoflook\n75 g hamblokjes\n150 g macaroni\n2 tl mosterd\n0,5 tl cayennepeper\n0,5 tl tijm\n125 cl kookroom\n50 g geraspte kruidenkaas\npeterselie",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/NrYWnCZ.jpeg"
},
{
"id": 98,
"name": "Macaroni met Italiaanse groentemix",
"recipe": "Macaroni koken. Groentemix 6 min roerbakken in olie. Macaroni afgieten. Macaroni, ham-kaas reepjes, room en oregano door groente scheppen. 2 min verwarmen Kaas erover strooien.",
"ingredients": "400 g elleboogjesmacaroni\n1 el olijfolie\n400 g Italiaanse groentemix\n2 takjes oregano\n250 g ham-kaas reepjes\n1 pakje room culinair (2 dl)\n100 g geraspte kaas",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/Emaq20z.jpeg"
},
{
"id": 99,
"name": "Macaroni met tonijn en zalm",
"recipe": "Macaroni koken. Prei en courgette klein snijden. Prei en courgette 5 min in olie bakken. Crème fraîche erdoor. Tonijn, zalm en pesto erdoor roeren en 1 min verwarmen. Saus door macaroni scheppen.",
"ingredients": "400 g schelpjesmacaroni\n1 courgette\n1 prei\n2 el olijfolie\n200 ml crème fraîche\n1 blikje tonijn op olie (185 g)\n100 g gerookte zalm blokjes\n3 el pesto",
"servings": 2,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/jD3ERWm.jpeg"
},
{
"id": 100,
"name": "Macaroni met tonijn-mosselsaus",
"recipe": "Macaroni koken. Ui snipperen en in olie 2 min bakken. Knoflook erover uitpersen. 2 min bakken. Tonijn en mosselen afgieten Tomatenpuree, wijn, 1,5 dl water, bouillonpoeder en kruiden aan ui toevoegen. 5 min sudderen op zacht vuur. Tonijn, mosselen, kappertjes en olijven toevoegen. 3 min sudderen. Macaroni voorzichtig door saus scheppen.",
"ingredients": "200 g macaroni\n1 ui\n1 el olijfolie\n1 teentje knoflook\n1 blikje tonijn naturel (200 g)\n1 blikje mosselen in pikante saus\n1 blikje tomatenpuree (70 g)\n1 dl droge witte wijn\n2 tl bouillonpoeder\n2 tl Italiaanse kruiden\n1 el kappertjes\nolijven",
"servings": 4,
"serveWith": "parmezaanse kaas",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/4O6aVmG.jpeg"
},
{
"id": 101,
"name": "Maissalade met chorizo",
"recipe": "Ham en chorizo in blokjes snijden. Tomaat in 8 partjes snijden In kom gourmetmix met 1 el water glad roeren. Vinaigrette en peterselie erdoor roeren. Maïs, wortelmix, ham en chorizo erdoor scheppen. Veldsla op 2 borden verdelen. Maïssalade erop scheppen. Garneren met tomaat en tortillachips.",
"ingredients": "300 g maïs\ndikke plak ham (100 g)\n50 g chorizoworst\n1 tomaat\n1 zakje mix voor gourmetsaus\n4 el vinaigrette\n2 takjes peterselie\n150 g wortelrauwkostmix\n0,5 zakje veldsla (75 g)\n50 g tortillachips",
"servings": 2,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/yZQE6AU.jpeg"
},
{
"id": 102,
"name": "Marokkaanse lamsstoofpot",
"recipe": "Doe kruiden in kom en roer er 2 el olijfolie door. Schep lamsvlees erdoor en wrijf kruiden goed in vlees. Bak vlees rondom aan. Schep vlees uit pan. Fruit wortel, bleekselderij en ui. Pers er knoflook bij. Schep rijst erdoor en laat even meebakken. Voeg vlees en bouillon erbij. Kook op zacht vuur tot rijst gaar is. Controleer steeds of er (kokend) water toegevoegd moet worden. Voeg 5 min voor eind doperwtjes toe.",
"ingredients": "600 g mager lamsvlees in blokjes\n1 tl kurkuma\n1 tl koriander\n1/2 tl komijnpoeder\nmespunt geraspte nootmuskaat\nmespunt kaneel\nmespunt kruidnagelpoeder\n2 el olijfolie\n1 grote wortel in blokjes\n2 stelen bleekselderij in boogjes\n1 grote ui gesnipperd\n2 teentjes knoflook\n250 g risottorijst\n6 dl groentebouillon\n250 g doperwtjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/QhBh0dp.jpeg"
},
{
"id": 424,
"name": "Mediterraan draadjesvlees",
"recipe": "Bestrooi het vlees met zout en versgemalen peper. Verhit de boter en olijfolie in een pan en bak hierin het vlees rondom lichtbruin. Voeg de uien, knoflook, rode peper en chorizo toe en bak even mee. Giet de hete vleesbouillon en rode wijn erbij en voeg de rozemarijn toe. Stoof zachtjes 2,5-3 uur met het deksel op de pan. Keer het vlees halverwege een keer om. Voeg de laatste 15 minuten van de stooftijd de olijven toe. Bind de jus eventueel met allesbinder.",
"ingredients": "750 g runderlappen\n50 g boter\n50 ml olijfolie\n2 rode uien (gesnipperd)\n3 teentjes knoflook (in plakjes)\n1 rode peper (in stukjes, zonder zaadjes)\n200 g chorizo (in blokjes)\n250 ml vleesbouillon\n250 ml rode wijn\n1 el verse rozemarijn (gehakt) of\n0.5 el gedroogde italiaanse kruiden of\n0.5 el gedroogde Provençaalse kruiden\n100 g zwarte olijven (zonder pit)",
"servings": 4,
"serveWith": "ciabatta of pasta en broccoli",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/yVLLUH0.jpeg"
},
{
"id": 328,
"name": "Mediterrane bonensalade met gerookte kip",
"recipe": "Snijd de aubergine in plakken van een ½ cm dik en de courgette in plakken van 1 cm dik. Verhit een grillpan zonder olie of boter en gril de plakken in delen, elke portie 8 min. Keer halverwege. Snijd de platte peterselie en de sjalot fijn. Klop een dressing van de olijfolie, peterselie en sjalot. Breng op smaak met peper en eventueel zout. Halveer de cherrytomaten en laat de bonenmix uitlekken. Meng de dressing, tomaten en bonenmix met de kipreepjes. Schep de gegrilde groenten door de salade en serveer direct.\n",
"ingredients": "1 aubergine\n1 courgette\n20 g platte peterselie\n1 sjalot\n4 el extra vierge olijfolie\n250 g cherrytomaten\n620 g bonenmix tricolore\n250 g gerookte kipreepjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/2G5AX43.jpeg"
},
{
"id": 103,
"name": "Mediterrane chilischotel",
"recipe": "Bak spekblokjes krokant. Kruis trostomaten in, bestrooi met peper en wikkel ontbijtspek er omheen. Steek vast met cocktailprikker. Zet 10 min in oven op 200 °C. Snij courgette in blokjes. Ontvel vleestomaten en snij in stukjes zonder zaadjes. Snipper sjalotjes. Bak courgette, sjalotjes, knoflook, tijm en vleestomaat 3 minuten. Voeg wijn toe en laat iets inkoken. Schep kapucijners, crème fraîche en mosterd erdoor en verwarm. Voeg spekblokjes toe. Serveer met bieslook erover en trostomaten erbij.",
"ingredients": "250 g magere spekblokjes\n4 trostomaten\n4 plakken ontbijtspek\n1 courgette\n2 vleestomaten\n2 sjalotjes\n2 teentjes knoflook\n1 el tijm\n1 dl rode wijn\n1 blik kapucijners\n125 ml crème fraîche\n1 el pittige mosterd\n1 el gehakte bieslook",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/nYvT9hf.jpeg"
},
{
"id": 300,
"name": "Mediterrane tagliatelle met kip en aubergine",
"recipe": "Breng in een ruime pan water met een tl zout aan de kook. Voeg de tagliatelle toe zodra het water kookt en kook de pasta gaar volgens de aangegeven tijd op de verpakking. Roer af en toe en giet af. Verhit de olie in een ruime (hapjes)pan en bak hierin de ui, knoflook en rode peper 3 min. Voeg de kipfilet, aubergine en sesamzaadjes toe en bak ze 3 min. mee. Schep regelmatig om. Voeg de tomaten toe en sluit de pan af met een deksel. Laat het gerecht nog 5 min. zachtjes pruttelen. Roer de helft van de basilicum erdoor en breng de saus op smaak met een beetje zout. Verdeel de pasta over borden en schep de saus eroverheen. Strooi de feta en de rest van de basilicumblaadjes erover.",
"ingredients": "400 g tagliatelle\n4 el olijfolie\n1 ui gesnipperd\n3 teentjes knoflook geperst\n1 rode peper fijngehakt, zaden verwijderd\n300 g kipfiletblokjes\n1 aubergine in blokjes\n1 el sesamzaadjes\n4 trostomaten in blokjes\n20 g verse basilicum grof gehakt\n200 g feta verbrokkeld",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/6XhLMAj.jpeg"
},
{
"id": 104,
"name": "Meergranenrijst met vis en banaan",
"recipe": "Kook rijst; snij vis in 8 stukken en bestrooi met peper en zout; smelt boter in pan, voeg 3 el water toe; leg vis erin; laat vis in 10 min zachtjes gaar worden; neem vis uit pan en hou warm; pel banaan en snij schuin in lange dunnen plakken; bak banaan in boter van vis goudbruin; bereid saus met melk volgens zakje; roer bieslook door saus.",
"ingredients": "1 pak meergranenrijst\n400 g kabeljauw\n2 bakbananen\n1 zakje peper-roomsaus\n2,5 dl melk\n3 el fijngeknipte bieslook",
"servings": 4,
"serveWith": "doperwten",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 105,
"name": "Met zuurkoolgehakt gevulde aardappels",
"recipe": "Verwarm oven op 250 °C. Verpak aardappels per stuk in aluminiumfolie en laat in oven gaar worden (20-40 minuten, afhankelijk van grootte). Fruit ui en knoflook in olie goudbruin. Voeg gehakt toe en bak rul. Roer zuurkool erdoor en bak 2-3 minuten mee. Breng op smaak met kerriepoeder, zout en peper. Laat 10 minuten garen op laag vuur. Neem aardappels uit oven, vouw folie open en snijd aardappels tot helft open. Schep in elke aardappel wat van het zuurkoolmengsel en een lepel zure room. Bestrooi met peterselie.",
"ingredients": "8-12 grote aardappels schoongeboend\n1 ui gesnipperd\n1 teentje knoflook fijngesneden\n300 g rundergehakt\n250 g ongekookte zuurkool uitgelekt\n1 tl kerriepoeder\n125 ml zure room\n2 el fijngesneden peterselie",
"servings": 4,
"serveWith": "tomatensalade met basilicum",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 107,
"name": "Mexicaanse bonen uit de oven",
"recipe": "Grill voorverwarmen op de hoogste stand. Snijd de groenten fijn. In braadpan olie verhitten. Gehakt in 3 minuten rul bakken. De groenten toevoegen en nog 3 minuten bakken. De uitgelekte kidneybonen toevoegen en even mee verwarmen. Op smaak brengen met mexicaanse kruiden en peper en zout. Mengsel overdoen in ovenschaal. Chips erover verdelen. Chips bestrooien met kaas en onder grill goudbruin laten worden.",
"ingredients": "3 el olijfolie\n250 g rundergehakt\n1 courgette\n1 rode paprika\n3 bosuitjes\n2 stengels bleekselderij\n2 blikken kidneybonen (a 425 g)\n1 el Mexicaanse kruiden\n150 g tortillachips\n100 g geraspte belegen kaas",
"servings": 4,
"serveWith": "groene salade",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/zoxX4vO.jpeg"
},
{
"id": 106,
"name": "Mexicaanse bonensalade met kalkoen",
"recipe": "In pan boter verhitten. Kalkoen met paprika kruidenmelange inwrijven. Kalkoen rondom bruin en gaar bakken ; in kom saus roeren van citroensap, tijm, olie, zout en peper ; bonen en maïs erdoor scheppen ; ijsbergsla in dunne reepjes snijden ; helft paprika in dunne ringen snijden ; andere helft in stukjes ; ijsbergsla en paprikastukjes door salade scheppen ; paprikaringen en kalkoenblokjes erover verdelen.",
"ingredients": "25 g boter\n200 g kalkoenfilet blokjes\npaprika kruidenmelange\n1 blikje rode bonen (400 g)\n1 blikje maïs (155 g)\n2 el citroensap\n2 tl tijm\n4 el olie\n¼ krop ijsbergsla\n1 rode paprika\nzout\npeper",
"servings": 2,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/kikfTmg.jpeg"
},
{
"id": 108,
"name": "Mexicaanse kipschotel met saffraanrijst",
"recipe": "Rijst volgens gebruiksaanwijzing koken. Ui pellen en snipperen. Kipfilet in reepjes snijden en met cajunkruiden bestrooien. In braadpan olie verhitten. Uien 1 min. fruiten. Kipfilet toevoegen en in 5 min. gaar en bruin bakken. Groenten en bonen laten uitlekken en door kip scheppen, 2 min. mee verwarmen. Rijst na afgieten door mengsel scheppen en met zout, peper en cajunkruiden op smaak brengen. Tomaten wassen en in partjes snijden. Rijstschotel in schaal opdienen en garneren met tomaten.",
"ingredients": "1 pak gele rijst (met saffraan, 325 g)\n2 uien\n2 kipfilets (ca. 300 g)\n2 tl cajunkruiden\n4 el zonnebloemolie\n1 blikje Mexicomelange (400 g)\n1 blikje kidneybonen (400 g)\n4 tomaten",
"servings": 4,
"serveWith": "kropsla met yoghurtdressing",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/h2KaAAl.jpeg"
},
{
"id": 109,
"name": "Mexicaanse rijstschotel",
"recipe": "Paprika's schoonmaken en in blokjes snijden. Bosuitjes schoonmaken en schuin in ringen snijden. Kidneybonen afgieten. Karbonades bestrooien met Mexicaanse kruiden. Rijst in ca. 8 minuten gaarkoken. In koekenpan olie verhitten. Karbonades dichtschroeien en in ca. 5 minuten per kant goudbruin en gaar bakken. Uit pan nemen en warm houden. Paprikablokjes in achtergebleven bakvet ca. 2 minuten zachtjes bakken. Kidneybonen en zure room erdoor scheppen en geheel nog ca. 2 minuten door en door verwarmen. Rijst afgieten en bosuitjes erdoor scheppen. Rijst en bonenmengsel over vier borden verdelen. Karbonades erop leggen.",
"ingredients": "2 paprika's\n3 bosuitjes\n1 blik kidneybonen (400 g)\n4 karbonades\n1 el Mexicaanse kruiden\n1 pak gele rijst (325 g)\n1 bekertje zure room (125 ml)",
"servings": 4,
"serveWith": "tortillachips",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/kV1Pvk0.jpeg"
},
{
"id": 229,
"name": "Mexicaanse vis",
"recipe": "Kook rijst gaar. Bak ondertussen bevroren wokgroenten 5 min op hoog vuur. Voeg komijn toe en bak nog 1 min. Voeg tomatenblokjes toe, breng aan de kook en zet vuur laag. Leg bevroren vis in de pan en stoof met deksel op pan 10 min. Bestrooi met peper, zout en munt.",
"ingredients": "300 g witte rijst\n750 g Mexicaanse wokgroenten\n1 tl gemalen komijn\n400 g tomatenblokjes\n400 g koolvisfilet\n1 tl gedroogde munt",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/zCGiQli.jpeg"
},
{
"id": 110,
"name": "Mie met kipfilet",
"recipe": "Mie koken. In droge koekenpan sesamzaadjes 1 min roosteren. Kipfilet in reepjes van ½ cm dik snijden. Bosuitjes in stukjes snijden. Komkommer en tomaat in plakjes snijden. In wok olie verhitten. Kip 2 min bakken. Mie toevoegen en 2 min meebakken. Bosui, sojasaus en sesamolie 1 min meebakken. Sesamzaadjes erover strooien.",
"ingredients": "4 tl sesamzaadjes\n200 g plakjes kipfilet\n4 bosuitjes\n0,5 pak Chinese eiermie\n0,5 komkommer\n1 tomaat\nolie\n1 el sojasaus\n1 tl sesamolie\n1 el bieslook",
"servings": 2,
"serveWith": "komkommer tomaat bieslook",
"protein": "Vlees",
"starch": "Noedels",
"photo": null
},
{
"id": 471,
"name": "Mie met paddenstoelen en Chinese kool",
"recipe": "Kook de mie volgens de aanwijzingen op de verpakking. Giet af en spoel onder koud water. Verhit 2 el olie in een wok en bak hierin de ui, paddenstoelen, knoflook en rode peper. Schep dit mengsel uit de pan. Voeg de rest van de olie toe en roerbak hierin de kool met de ketjap 3-4 minuten. Rooster de pinda's in een droge hete koekenpan. Voeg het paddenstoelenmengsel en de mie toe aan de kool, schep om en verwarm kort. Bestrooi de wokschotel met de pinda's en de bosui.\n",
"ingredients": "250 g eiermie\n4 el arachideolie\n1 ui (gesnipperd)\n250 g gemengde paddenstoelen\n2 teentjes knoflook (fijngehakt)\n2 rode pepers (in smalle reepjes, zonder zaadjes)\n500 g Chinese kool (in repen)\n2 el ketjap manis\n100 g pinda’s\n1 lente-/bosui (in ringetjes)",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Noedels",
"photo": "https://i.imgur.com/fOURUxW.jpeg"
},
{
"id": 111,
"name": "Mihoen met kip en cashewnoten",
"recipe": "Kip in reepjes snijden. Sojasaus en citroensap met reepjes mengen. Bosuitjes en paprika fijnsnijden. Mihoen koken. Boter smelten. Kip, paprika en bosuitjes 4 min bakken. Alles mengen en bestrooien met noten.",
"ingredients": "200 g mihoen\n2 kipfilet\n2 el sojasaus\n2 tl citroensap\n1 rode paprika\n2 bosuitjes\n2 el cashewnoten",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/RpOuUum.jpeg"
},
{
"id": 265,
"name": "Milde Thaise varkensvleescurry",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Verhit ondertussen de olie in een wok. Bak de varkensreepjes al omscheppend bruin. Voeg de ui toe en bak 1 min. mee. Roer de boemboe en de kokosmelk erdoor en breng aan de kook. Snijd ondertussen de broccoli in roosjes. Kook de roosjes in weinig water met zout in 5 min. beetgaar. Verdeel de rijst en de varkensvleescurry over 4 borden en serveer met de broccoli.",
"ingredients": "300 g pandanrijst\n2 el olie\n360 g varkensreepjes naturel\n1 ui, gesnipperd\n100 g boemboe rode curry\n200 ml kokosmelk\n700 g broccoli",
"servings": 4,
"serveWith": "Kroepoek",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/sUUaOnV.jpeg"
},
{
"id": 362,
"name": "Mini-uienquiche met dragon",
"recipe": "Verwarm de oven voor tot 200 °C. Verhit in een koekenpan de olijfolie. Bak de uienringen 8-10 min. op matig vuur, tot ze zacht zijn en beginnen te kleuren. Bekleed intussen de schaaltjes met een stuk bakpapier. Rol de plakjes bladerdeeg iets groter uit en bekleed er de schaaltjes mee. Prik de deegbodems in met een vork. Bestrooi de uienringen met de kerrie en bak nog 1 min. Neem de pan van het vuur en verdeel de ui over de deegbodems. Klop de eieren los met de crème fraîche. Meng er de kaas, de dragon en zout en peper naar smaak door. Schenk het ei-roommengsel in de bodems. Bak de quiches in de voorverwarmde oven in 20-25 min. goudbruin en gaar.",
"ingredients": "2 el olijfolie\n3 uien\n4 plakjes \tbladerdeeg\n1 tl kerrie\n2 eieren\n3 el crème fraîche\n75 g jonge kaas\n1 tl gedroogde dragon",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/yGF54Y1.jpeg"
},
{
"id": 311,
"name": "Nacho pescado",
"recipe": "Verwarm de oven voor op 200 °C. Pel en snipper de uien. Verhit een scheutje olie in een pan en fruit de uien, komijnpoeder en cayenne peper circa 2 minuten. Halveer de paprika’s in de lengte, verwijder de zaadlijsten en snijd de paprika’s in blokjes. Verwijder de harde draden van de bleekselderij en snijd de bleekselderij in halve maantjes. Giet de kidneybonen af en spoel ze schoon. Voeg de paprika’s, bleekselderij en de kidneybonen toe en bak circa 2 minuten mee.Schenk de tomatenblokjes erbij. Breng aan de kook en laat circa 4 minuten koken. Snijd de vis in plakken. Verdeel de vis over een met olie ingevette ovenschaal.Schenk het tomatenmengsel over de vis. Verdeel de nacho chips over het tomatenmengsel en strooi de kaas eroverheen.Bak de nacho pecado in de oven in circa 10 minuten goudbruin en gaar. Pluk en hak de peterselie fijn en strooi voor het serveren over de nacho pescado.",
"ingredients": "2 rode uien\n2 tl komijnpoeder\n1 tl cayennepeper\n2 rode paprika's\n4 stengels bleekselderij\n600 g kidneybonen\n400 ml tomatenblokjes\n400 g kabeljauwfilet\n100 g nacho chips\n100 g geraspte belegen kaas\n0.5 bos bladpeterselie",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/EZB8tZW.jpeg"
},
{
"id": 226,
"name": "Noedels met biefstukreepjes",
"recipe": "Kook de sugar snaps in 7 min beetgaar. Wel de rozijnen in heet water. Kook noedels gaar en laat uitlekken. Meng sojasaus met basterdsuiker en limoensap. Schep dit door noedels. Schep sugar snaps en lente-uitjes door noedels. Roerbak biefstuk 3 min in wok. Serveer noedels met biefstuk en strooi cashewnoten en uitgelekte rozijnen erover.",
"ingredients": "500 g sugar snaps\n3 lente-uitjes in schuine stukjes\n50 g rozijnen\n200 g noedels\n100 ml sojasaus\n1 el bruine basterdsuiker\n4 el limoensap\n80 g ongezouten cashewnoten\n400 g biefstuk",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/MnyMsgZ.jpeg"
},
{
"id": 112,
"name": "Oma's erwtensoep",
"recipe": "Ribben 2 uur koken. Gesneden groentes erbij. 1 uur koken. Erwten erbij. Paar uur trekken en ondertussen af en toe roeren. Op smaak brengen met een snufje foelie. Verse worst apart 15 min koken, in plakjes snijden en door soep roeren.",
"ingredients": "2 l water\n500 g platte ribben\n400 g verse worst\n1 kleine knolselderij\n2 stengels prei\n1 winterpeen\n1 pak spliterwten\nfoelie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/R1z2Jic.jpeg"
},
{
"id": 365,
"name": "Oma's gevulde appeltjes",
"recipe": "Verwarm de oven voor tot 200 °C. Boor met een appelboor de klokhuizen uit de appels, maar zorg ervoor dat de onderzijde van de appels gesloten blijft. Maak met de appelboor het gat in de appel groter tot ca. 3,5 cm breed. Haal het vel van de worst(en) aan één kant los en druk de vulling eruit. Meng het vlees met de geraspte gember, het ei, het paneermeel, de ui en de pijnboompitten in een kom. Vul de appels met het vleesmengsel en zet ze naast elkaar in de ovenschaal. Snijd de boter in klontjes en leg op elke appel een klontje boter. Bak de appels ca. 25 min. in de voorverwarmde oven en leg er na 15 min. een tweede klontje boter op.",
"ingredients": "800 g elstar of jonagold appels\n2 rundersaucijzen\n2 cm gemberwortel\n1ei\n2 el paneermeel\n1 ui\n50 g pijnboompitten\n50 g boter",
"servings": 4,
"serveWith": "andijviestamppot",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/L4kDhFi.jpeg"
},
{
"id": 446,
"name": "Omelet met rijst en groenten",
"recipe": "Bereid de rijst volgens de aanwijzingen op de verpakking. Snijd de peterselie fijn. Breek de eieren boven een ruime kom en klop los. Schep er de rijst, hamblokjes, roerbakmix, mozzarella en 2/3 van de peterselie door. Breng op smaak met peper. Verhit de olie in een ruime koekenpan. Schenk er het rijstmengsel in en bak met een deksel op de pan in 5-8 min. gaar. Keer de omelet met behulp van het deksel of een bord en bak nog 5 min. Snijd de omelet in 4 stukken en leg op de borden. Garneer met de rest van de peterselie.",
"ingredients": "200 g witte rijst\n15 g peterselie\n6 eieren\n150 g gekookte hamblokjes\n600 g Italiaanse roerbakmix\n150 g geraspte mozzarella\n2 el zonnebloemolie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/lYVBym8.jpeg"
},
{
"id": 113,
"name": "Oosters stoofpotje",
"recipe": "Eieren koken. Bouillon oplossen in 2½ dl kokend water, Bosui, gember, paprika en sperziebonen klein snijden. Bak de ui, gember en currypasta 3 min. Voeg bouillon en kokosmelk toe. Breng aan de kook. Voeg ketjap, paprika en sperziebonen toe. Stoof 20 min afgedekt. Eieren erin leggen en 5 min opwarmen. Taugé erdoor. Nog 1 min verwarmen. Koriander erover.",
"ingredients": "8 eieren\n0,5 groentebouillontablet\n3 bosuitjes\n2 cm gemberwortel\n2 rode paprika's\n250 g sperziebonen\n1 el milde currypasta\nverse koriander\n400 g kokosmelk\n2 el zoete ketjap\n125 g taugé",
"servings": 4,
"serveWith": "wilde en witte rijst of basmati rijst",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/AZg3sFV.jpeg"
},
{
"id": 398,
"name": "Oosterse kikkererwtenauberginestoof",
"recipe": "Verhit in een braadpan de olie en fruit de uienringen 4-5 min. Voeg de aubergine, champignons en amandelen toe en bak ze al omscheppend 3 min. mee. Schep de currypasta, kikkererwten, kokosmelk en het blik tomatenblokjes erdoor en breng aan de kook. Draai het vuur laag en stoof de groenten 10 min. zachtjes. Voeg als de stoof te droog wordt een beetje heet water toe. Bereid intussen de rijst volgens de aanwijzingen op de verpakking. Verdeel de kikkererwtenstoof over 4 borden. Schep de rijst erbij en bestrooi met de koriander.",
"ingredients": "3 el zonnebloemolie\n2 rode uien\n2 aubergines\n250 g champignons\n75 g amandelen\n2 el Indiase milde currypasta\n400 g kikkererwten\n200 ml kokosmelk\n400 g tomatenblokjes\n275 g meergranenrijst\n7 g koriander",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/DYlzbYE.jpeg"
},
{
"id": 114,
"name": "Oosterse rijstschotel met makreel",
"recipe": "Eieren in 6-8 min. hard koken, pellen en in partjes snijden. Intussen citroen in lengte halveren. Helft in 4 partjes snijden, van andere helft schil dun raspen. Peterselie fijnhakken. Makreel in stukjes verdelen. In wok olie verhitten en roerbakgroenten met kerriepoeder, citroenrasp, peterselie en peper naar smaak 3-4 min. roerbakken. Makreel en rijst erdoor scheppen en 2-3 min. roerbakken. Rijstschotel op twee borden scheppen en garneren met ei en citroen.",
"ingredients": "2 eieren\n1 citroen\n15 g verse peterselie\n1 gerookte makreelfilet met peper\n2 el olie\n400 g Thaise roerbakmix\n1,5 el milde kerriepoeder\n150 g langkorrelrijst",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/vcKQ9Yu.jpeg"
},
{
"id": 441,
"name": "Orik arik",
"recipe": "Snijd de paprika in reepjes. Verhit de olie in de wok, pers de knoflook erboven en fruit 2 min. op laag vuur. Zet het vuur middelhoog en voeg het bouillonblokje, de paprika en de kool toe. Roerbak ca. 8 min. tot de kool zacht is. Roer telkens 1 ei door de kool. Blijf roeren tot het ei gestold is en voeg dan weer een ei toe. Breng op smaak met peper.",
"ingredients": "1 rode paprika\n2 el zonnebloemolie\n4 tenen knoflook\n1 runderbouillonblokje\n600 g gesneden witte kool\n4 eieren",
"servings": 4,
"serveWith": "rijst, sambal, kroepoek en Indische gehaktballetjes",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/pU5R20R.jpeg"
},
{
"id": 437,
"name": "Ovengnocchi met tonijn, champignons en tomaat",
"recipe": "Verwarm de oven voor op 180 °C. Verhit 2 el olie in een koekenpan met antiaanbaklaag en bak de gnocchi 10 min. op middelhoog vuur. Schep regelmatig om. Breng op smaak met peper en zout. Verhit de rest van de olie in een ruime pan en bak de champignonroerbakmix 4 min. op middelhoog vuur. Voeg de tomatenblokjes, pesto en tonijn toe. Schep om, warm nog 2 min. door en draai het vuur uit. Scheur ondertussen de ciabattina in stukken en doe met de kruiden in de keukenmachine. Maal tot een fijn broodkruim, voeg peper en eventueel zout toe. Verdeel het tonijn-groentemengsel over de ovenschaal. Schep het broodkruim door de gnocchi en verdeel over het tonijn-groentemengsel. Bak ca. 20 min. in het midden van de oven.\n",
"ingredients": "3 el traditionele olijfolie\n500 g gnocchi\n400 g champignonroerbakmix\n400 g tomatenblokjes\n2 el pesto arrabbiata\n320 g tonijnstukken in water\n1 afbakciabattina\n1 el gedroogde Italiaanse kruiden",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/AfMvOEz.jpeg"
},
{
"id": 221,
"name": "Ovenpasta met gehakt en courgette",
"recipe": "Verwarm de oven voor op 200 °C. Kook de pasta volgens de aanwijzingen op de verpakking. Verhit de olie in een hapjespan en fruit de uien 1 min. Voeg het gehakt toe en bak in 2-3 min. rul. Voeg de courgette toe en bak 3 min. mee. Schep er de tomatensaus door en voeg peper en zout naar smaak toe. Neem de pan van het vuur. Schep de pasta door de tomaten-gehaktsaus en doe in de ovenschaal. Dek de pasta dakpansgewijs af met de tomaten en de mozzarella. Bestrooi met peper en zout. Zet de pasta 20-25 min. in de voorverwarmde oven tot de mozzarella is gesmolten en begint te kleuren.",
"ingredients": "300 g fusilli\n2 el olijfolie\n2 uien fijngesnipperd\n300 g rundergehakt\n1 courgette in blokjes\n450 ml sugo basilico (tomatensaus)\n3 tomaten in plakjes\n250 g mozzarella in plakjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/15ZJAyE.jpeg"
},
{
"id": 403,
"name": "Ovenschotel met rodekool en gehakt",
"recipe": "Verwarm de oven voor tot 200 °C. Smelt de boter in een koekenpan. Bak het gehakt in 3 min. rul. Voeg de ui, de knoflook en de prei toe en bak 3 min. tot de prei knapperig gaar is. Breng op smaak met de tijm en zout en peper. Schep het gehakt in de ovenschaal. Verdeel er de rodekool over en dek af met de aardappelpuree. Meng het paneermeel met de kaas en strooi over de puree. Bak de ovenschotel in de voorverwarmde oven in 30 min. gaar.",
"ingredients": "25 g boter\n500 g rundergehakt\n1 ui\n1 tl knoflook\n1 prei\n1 tl gedroogde tijm\n1 snufje zout\n1 snufje peper\n1 pot rodekool met appel\n500 g aardappelpuree\n4 el kruidenpaneermeel\n100 g geraspte jonge kaas",
"servings": 4,
"serveWith": "appelcompote",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/KVcW09J.jpeg"
},
{
"id": 115,
"name": "Ovenschotel van scholfilet en basilicum",
"recipe": "Paprika, prei en peper klein snijden. Olie verhitten. Paprika en prei 5 min bakken. Ovenschaal invetten. In kom wijn, maïzena en viskruiden mengen. Boven andere kom 3/4 basilicum fijnknippen. Crème fraîche door basilicum roeren. Paprika-preimengsel over bodem van schaal verdelen. Wijnmengsel erover gieten. Scholfilets erop leggen en bestrooien met zout. Basilicummengsel erover strijken. Stukjes peper en citroenrasp over scholfilets strooien. Afdekken met aardappelgolfjes. Kaas erover strooien. 30 min in oven op 200 °C. Rest basilicum erover.",
"ingredients": "1 rode paprika\n500 g prei\n1 el olie\n0,5 dl droge witte wijn\n2 tl maïzena\n3 tl viskruiden\n15 g verse basilicum\n125 ml crème fraîche\n525 g scholfilet\ncitroenrasp\n450 g aardappelgolfjes\n3 el geraspte oude kaas\n1 Spaans pepertje",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/LKQFcrb.jpeg"
},
{
"id": 387,
"name": "Paddenstoelencurry met knolselderij",
"recipe": "Verhit de olie in een grote stoofpan, voeg de ui en knolselderij toe en fruit circa 4 minuten. Voeg de currypasta toe en fruit 1 minuut al roerend mee. Voeg de paddenstoelen toe en roerbak enkele minuten op middelhoge stand tot de paddenstoelen iets gaan slinken. Roer de tomatenblokjes erdoor en breng aan de kook. Laat afgedekt circa 20 minuten stoven op een lage stand. Kook intussen de rijst. Roer de curry even door en breng eventueel op smaak met zout en peper. Serveer in kommen met de rijst en de yoghurt. Bestrooi met de koriander.",
"ingredients": "1 el olie\n1 ui, grof gesnipperd\n200 g knolselderij, geschild, in blokjes\n2.5 el milde Indiase currypasta\n3 bakjes gemengde paddenstoelen, gehalveerd\n1 blik tomatenblokjes\n300 g basmatirijst\n100 ml Griekse yoghurt\n1 bosje koriander, grof gehakt",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/toZ6m33.jpeg"
},
{
"id": 116,
"name": "Paddenstoelenragout met schnitzelreepjes",
"recipe": "Kook rijst. Paddenstoelen klein snijden. Bak vlees 2 min. Voeg paddenstoelen toe en bak 3 min mee. Roer stroganoffsaus erdoor en goed doorverwarmen. Rijst erbij geven",
"ingredients": "300 g meergranenrijst\n4 (kalfs)schnitzels in reepjes\n500 g paddenstoelenmelange\n500 ml stroganoffsaus\n(of 250 ml saus plus 250 ml kookroom)",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/qh7JttA.jpeg"
},
{
"id": 117,
"name": "Paddenstoelen-rijst schotel",
"recipe": "Sjalotjes in 4en snijden. Paddenstoelen en vlees in blokjes snijden. Vlees 3 min bakken. Sjalotjes, paddenstoelen en kruiden toevoegen. 3 min meebakken. Rijst erdoor roeren en glazig bakken. Bouillontablet erover verkruimelen. 6 dl warm water en doperwtjes erdoor roeren. Schaal afdekken en 25 min smoren. Bosuitjes en kaas erover.",
"ingredients": "6 sjalotjes\n250 g kastanjechampignons\n100 g shii takes\n1 el Italiaanse kruiden\n200 g hamlapjes\n50 g boter\n250 g risottorijst\n1 vleesbouillon tablet\n200 g doperwtjes\n2 bosuitjes\n50 g geraspte Parmezaanse kaas",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/7Kedx8o.jpeg"
},
{
"id": 118,
"name": "Paella",
"recipe": "Verhit in een paella- of hapjespan de olijfolie. Bak de chorizo in 3 min. zachtjes uit. Schep op een bord. Doe de garnalen in de pan en bak 5 min. omscheppend. Schep ze naast de chorizo op het bord. Bak ten slotte de kipfilet in 3 min. bruin aan. Leg ook op het bord. Wrijf de saffraan met een snuf zout in een vijzel fijn. Schep de paellarijst door het bakvet en bak 2 min., tot de korrels glanzen. Voeg de saffraan en het paprikapoeder toe. Schep de tomaten, prei en bleekselderij erdoor en bak nog 2 min. Doe de chorizo bij de rijst. Leg de kipfilet erop. Schenk het water erbij en breng aan de kook. Kook de paella 8 min. op matig vuur. Schep de erwtjes en de rozemarijn erdoor. Leg de garnalen erop en laat de paella in nog 5 min. zachtjes gaar worden.",
"ingredients": "300 g paellarijst\n2 el olijfolie\n125 g chorizo\n250 g rauwe ongepelde reuzegarnalen\n300 g kipfilet\n1 zakje saffraan\n1 tl paprikapoeder pikant\n4 rijpe tomaten\n1 prei\n1 stengel bleekselderij\n100 g doperwtjes extra fijn\n10 g verse rozemarijn\n800 ml water\n1 snufje zout",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/6DR3siu.jpeg"
},
{
"id": 228,
"name": "Paella met zomergroenten",
"recipe": "Kook worteltjes beetgaar. Kook peultes met doperwten en tuinboontjes 3 min en spoel ze af met koud water. Verwarm bouillon met saffraan erdoor. Bak amandelen en knoflook in olie 1 min. Bak sjalotjes met paprika 2 min. Schep rijst erdoor en bak tot rijst glazig is. Meng worteltjes en amandelen door het mengsel. Voeg scheut bouillon toeen roer tot deze is opgenomen. Herhaal dit 20 min tot rijst gaar is. Schep 5 min voor einde erwtjes, peultes en boontjes door rijst. Garneer met olijven en gedroogde tomaten.",
"ingredients": "100 g worteltjes in plakjes\n1 rode paprika in stukjes\n1 gele paprika in stukjes\n100 g peultjes\n100 g doperwten\n100 g tuinboontjes\n2 teentjes knoflook\n2 el gehakte ongezouten blanke amandelen\nsaffraanpoeder\n2 sjalotjes gesnipperd\n400 g arboriorijst\n3 dl groentebouillon\n12 zwarte olijven gehalveerd\n3 zongedroogde tomaten in reepjes",
"servings": 4,
"serveWith": "Spaanse worstjes",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/oGvJ9R0.jpeg"
},
{
"id": 444,
"name": "Pappardelle met bloemkoolsaus, gorgonzola en walnoten",
"recipe": "Kook de pasta beetgaar. Verhit de boter en bak hierin de ui met de laurier. Voeg de room en bloemkool toe en kook afgedekt tot de bloemkool helemaal zacht is. Verwijder het laurierblaadje en pureer de saus glad. Voeg de gorgonzola toe en roer tot de kaas helemaal gesmolten is. Voeg eventueel de peperkorrels toe. Giet de pasta af en vang wat van het kookwater op. Schep de pappardelle met 6 el van het kookwater door de saus en verwarm al roerend circa 2 minuten op middelhoge stand, tot de pasta de saus goed heeft opgenomen. Verdeel de pasta over borden en bestrooi met de walnoten.",
"ingredients": "300 g pappardelle\n2 el boter\n3 uien, gesnipperd\n1 laurierblaadje\n200 ml room\n0.5 bloemkool, in roosjes\n150 g gorgonzola\n1 handje walnoot, grof gehakt",
"servings": 4,
"serveWith": "groene salade",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/pMXcPNr.jpeg"
},
{
"id": 119,
"name": "Paprika en kip in oosterse honingsaus",
"recipe": "Kip en paprika's in reepjes snijden. Bosuitjes klein snijden. Helft ketoembar en gemberpoeder door kipreepjes roeren. Amandelen halveren en in pan roosteren. Kip 2 minuten bakken en uit pan nemen. Paprikareepjes 3 minuten roerbakken. Bosui 30 seconden meebakken. Rest ketoembar en gemberpoeder door paprika scheppen. Kip, amandelen, honing, sojasaus, sherry en 2 el water toevoegen. Aan kook brengen.",
"ingredients": "2 rode paprika's\n2 groene paprika's\n2 bosuitjes\n45 g amandelen\n300 g kipfilet\n1 tl ketoembar (gemalen koriander)\n1 tl gemberpoeder\n2 el honing\n3 el sojasaus\n2 el droge sherry",
"servings": 4,
"serveWith": "rijst of mie",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 120,
"name": "Paprika-vis-schotel",
"recipe": "Kabeljauw ontdooien. Oven voorverwarmen 200 °C. Ovenschaal invetten. Kabeljauw erin leggen. Ui snipperen. Ui 5 min bakken in olie. Paprika in blokjes snijden. Knoflook boven pan uitpersen en 1 min meebakken. Gemberpoeder, paprika, ananas (met sap), ketjap, azijn, suiker en bouillonpoeder erdoor roeren. Saus aan kook brengen. Maïzena toevoegen en blijven roeren tot het bindt. Tabasco naar smaak toevoegen. Saus over kabeljauw. 15 min in oven. Amandelschaafsel in droge koekenpan op hoog vuur in 3 min goudbruin roosteren. Over schotel strooien.",
"ingredients": "1 pak kabeljauwfilet (400 g)\n1 ui\n2 el olie\n1 groene paprika\n1 rode paprika\n1 teentje knoflook\n1 tl gemberpoeder\n1 blikje ananasstukjes (227 g)\n2 el ketjap manis\n1 el azijn\n1 el suiker\n1 tl bouillonpoeder\n1,5 el maïzena\ntabasco\n2 el amandelschaafsel",
"servings": 2,
"serveWith": "rijst",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/cPE15Gs.jpeg"
},
{
"id": 268,
"name": "Pasta met andijvie en chorizo",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking beetgaar. Snijd ondertussen de chorizo in blokjes. Verhit een hapjespan zonder olie of boter en bak de chorizo 4 min. op middelhoog vuur. Voeg de ui toe en bak 3 min. mee. Voeg de slagroom en andijvie toe en laat al omscheppend slinken. Giet de pasta af, voeg toe aan het andijviemengsel en schep om. Breng op smaak met peper en zout. Verdeel de pasta over 4 borden en leg de tomaten erop.",
"ingredients": "300 g fusilli\n1 chorizo, ontveld\n1 ui, gesnipperd\n125 ml slagroom\n1 krop andijvie, in repen\n145 g semi-zongedroogde tomaten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/hqEsbta.jpeg"
},
{
"id": 469,
"name": "Pasta met broccolisaus en mozzarella",
"recipe": "Snijd de broccoli in roosjes, schil de steel en snijd in plakjes. Kook de broccoli in 5 min. beetgaar. Kook de pasta volgens de aanwijzingen op de verpakking gaar. Bewaar 400 ml kookvocht Verhit intussen een koekenpan zonder olie of boter. Rooster de pijnboompitten 3 min. Schud op een bord en laat afkoelen. Pluk een paar blaadjes basilicum voor de garnering en houd apart. Giet de broccoli af en doe terug in de pan. Voeg de pijnboompitten, Parmezaanse kaas, olie en de rest van het basilicum toe. Schenk er het kookvocht van de pasta bij en maal met de staafmixer tot een gladde saus. Breng op smaak met peper. Giet de pasta af en schep door de saus. Verdeel de pasta over 4 borden. Giet de mozzarella af, scheur in grove stukken en verdeel over de pasta. Garneer met de blaadjes basilicum.",
"ingredients": "750 g broccoli\n300 g volkorenrigaton\n25 g pijnboompitten\n20 g basilicum\n125 g Parmigiano Reggiano\n2 el milde olijfolie\n440 g mozzarella",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/EEEcJp4.jpeg"
},
{
"id": 447,
"name": "Pasta met puntpaprika en gorgonzola",
"recipe": "Kook de pasta beetgaar. Verhit de olie en fruit hierin de ui. Voeg de paprika en rozijnen toe en bak een paar minuten op middelhoge stand. Voeg de azijn toe en bak tot de azijn is verdampt en opgenomen door de rozijnen. Voeg de gorgonzola, roomkaas en wat kookwater van de pasta toe aan de saus. Roer tot de gorgonzola en roomkaas zijn gesmolten. Giet de pasta af, voeg toe aan de saus en verwarm nog circa 2 minuten, tot de pasta helemaal bedekt is met de saus.",
"ingredients": "200 g tagliatelle\n2 el olijfolie\n2 uien (in halve ringen)\n2 rode puntpaprika’s (in reepjes)\n2 el rozijnen\n1 el wittewijnazijn\n75 g gorgonzola\n75 g roomkaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/a33AAsB.jpeg"
},
{
"id": 121,
"name": "Pasta met romige garnalen",
"recipe": "Pasta volgens gebruiksaanwijzing koken. Sjalotten pellen en snipperen. Tomaten schoonmaken en in partjes snijden. Garnalen volgens gebruiksaanwijzing ontdooien. In koekenpan olie verhitten. Sjalot 2 min. zacht fruiten. Garnalen toevoegen en 3 min. bakken. Sherry bij garnalen schenken. Roomkaas door garnalen scheppen en laten smelten. Tomaatpartjes erdoor roeren en 1 min. meewarmen. Peterselie fijnknippen. Pasta over vier borden verdelen. Romige garnalen erop scheppen en met peterselie garneren.",
"ingredients": "350 g tagliatelle\n2 sjalotten\n400 g tasty tom tomaten\n3 el olijfolie\n250 g tijgergarnalen\n2 el sherry\n100 g verse roomkaas\n15 g verse peterselie",
"servings": 4,
"serveWith": "rucolasalade en balsamicodressing",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/UWVNFKL.jpeg"
},
{
"id": 260,
"name": "Pasta met tonijn en mozzarella",
"recipe": "Kook de pasta volgens de aanwijzing op de verpakking beetgaar. Giet de tonijn af en vang de olie op. Snijd de prei in smalle reepjes. Verdeel de tomaten in stukjes en snipper de teentjes knoflook. Fruit in een wok of hapjespan in 1 el tonijnolie en 1 el olie van de tomaten de preireepjes en de knoflook 2 minuten. Voeg de tonijn en tomaten toe en roerbak nog 2 minuten. Meng de peterselie, gehalveerde olijven, peper en zout erdoor. Snijd de mozzarella in plakjes en schep ze luchtig met de pasta door het mengsel in de wok.",
"ingredients": "400 g pasta (penne of spaghetti)\n2 blikjes tonijn in olie (à 180 g)\n1 prei\n6 gedroogde tomaten in olie\n2 teentjes knoflook\n2 el gehakte peterselie (vers of diepvries)\n2 el groene olijven zonder pit of met piment\nzout\nversgemalen peper\n150 g mozzarella",
"servings": 4,
"serveWith": "komkommersalade",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/GXyAfUc.jpeg"
},
{
"id": 122,
"name": "Pasta met zalm en paddenstoelen",
"recipe": "Snij prei, sjalotjes en knoflook klein. Bak deze 3 min in olijfolie. Voeg wijn toe en laat 3 min inkoken. Roer finesse en kruiden door preimengsel. Kook pasta gaar. Snij zalm in dunne reepjes. Verhit olie en bak paddenstoelen 3 minuten. Schep pasta op bord, giet saus erover, verdeel zalm en paddenstoelen erover. As zalm klein genoeg is gesneden gaart die op gerecht. Zet anders even onder grill.",
"ingredients": "0,5 prei\n3 sjalotjes\n100 ml droge witte wijn\n3 el verse kruiden (tijm peterselie dragon)\n200 ml Finesse voor Verrijken\n500 g fettuccine\n400 g verse zalmfilet\n200 g paddenstoelenmix",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/W7bXrEv.jpeg"
},
{
"id": 123,
"name": "Pasta met zalm in dilleroomsaus",
"recipe": "Kook erwtjes in 5 min gaar. Kook pasta. Bak blokjes zalm voorzichtig 4 minuten. Bedruppel met citroensap en bestrooi met zout en peper. Doe erwtjes, dille en room in pan en schep voorzichtig door. Schep pasta in schaal en schep zalmmengsel erover.",
"ingredients": "400 zalm in blokjes\n400 g doperwtjes (diepvries)\n300 g pasta\n1 dl koksroom\ncitroensap\n2 el fijngehakte dille",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/q1B30GE.jpeg"
},
{
"id": 358,
"name": "Pasta uit de oven met prei en courgette",
"recipe": "Verwarm de oven voor op 180 °C. Kook de pasta beetgaar, giet af en laat uitlekken. Verhit de olijfolie en roerbak hierin de prei en courgette met zout en peper 3-4 minuten. Meng de salami en pasta erdoor. Schep het mengsel in een ovenschaal. Meng de crème fraîche met de eieren en de helft van de kaas en schenk dit over de pasta. Meng de rest van de kaas met paneermeel en strooi dit over het gerecht. Zet de pastaschotel 20 minuten in het midden van de oven.",
"ingredients": "400 g penne\n2 el olijfolie\n2 preien (gewassen, in smalle reepjes)\n1 courgette (in reepjes)\n150 g salami (in reepjes)\n200 ml crème fraîche\n3 eieren (losgeklopt)\n100 g belegen kaas (geraspt)\n2 el paneermeel",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/vyEELSp.jpeg"
},
{
"id": 400,
"name": "Pasta, gerookte kip en kastanjechampignons",
"recipe": "Veeg de champignons met keukenpapier en snijd ze in plakjes. Snijd de knoflook fijn. Verhit de olie in een Koekenpan en bak de champignons, knoflook,prei en doperwten op middelhoog vuur 5 minuten. Voeg de kookroom toe, breng aan de kook, draai het vuur laag en laat nog 5 minuten inkoken. Kook ondertussen de pasta in water met eventueel zout volgens aanwijzigingen op de verpakking beetgaar. Meng de kipreepjes en pasta door de saus en verdeel over de borden.Breng op smaak met peper.",
"ingredients": "400 g kastanjechampignons\n2 tenen knoflook\n1 el traditionele olijfolie\n200 g fijngesneden prei\n200 g verse doperwten\n250 ml kookroom light\n250 g groene-erwtenpasta\n250 g gerookte kipreepjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/I1C8EoZ.jpeg"
},
{
"id": 442,
"name": "Pasta-ovenschotel met tonijn en mozzarella",
"recipe": "Verwarm de oven voor op 180 °C. Kook de pasta volgens de bereidingswijze op het pak. Snijd de ui en paprika’s in stukjes en de mozzarella in plakjes. Giet een scheutje olie in een pan en bak de ui met 2 uitgeperste tenen knoflook en de paprika aan. Voeg na ongeveer 5 minuten de basilicum en tomatenpuree toe. Bak de tomatenpuree 1 minuut mee en voeg dan de tomatenblokjes, tonijn en een snufje zout en peper toe. Laat de saus even pruttelen (minimaal 5 minuten) en voeg dan de gekookte pasta toe. Meng alles door elkaar en schep de pasta en de saus in een ovenschaal. Verdeel de plakjes mozzarella over de bovenkant. Strooi er een beetje geraspte kaas overheen. Zet de pasta-ovenschotel met tonijn ongeveer 15 minuten in de oven.",
"ingredients": "150 g pasta\n160 g tonijn\n1 bol mozzarella\n2 paprika’s\n1 rode ui\n400 g tomatenblokjes\n70 g tomatenpuree\n2 tenen knoflook\n2 tl basilicum\nsnufje zout en peper\ngeraspte kaas",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/yCFc10X.jpeg"
},
{
"id": 235,
"name": "Pastasalade met knakworst",
"recipe": "Kook de macaroni en spoel daarna met koud water. Snij tomaat, kaas, knakworst, ijsbergsla, appel en augurk in stukjes. Meng stukjes met macaroni. Meng mayonaise, ketchup en kruiden. Roer goed door de pasta.",
"ingredients": "200 g macaroni\n1 krop ijsbergsla\n2 tomaten of cherrytomaatjes\n100 g kaas\n1 blik knakworstsjes\n5 augurken\n1 appel\n4 el mayonaise\n4 el ketchup\n1 snufje peper\n1 tl kerrie\n1 tl bieslook of dille",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/gCWif0K.jpeg"
},
{
"id": 124,
"name": "Pastasalade met rivierkreeftjes",
"recipe": "Pasta koken volgens aanwijzingen op verpakking. Afspoelen met koud water tot pasta koud is. Komkommer wassen en in kleine blokjes snijden. In vergiet met wat zout bestrooien en 5 min. laten staan. Bosuitjes in smalle ringen snijden. Komkommer afspoelen en beetje droogdeppen. In ruime schaal mengen met dressing, citroensap, pasta, bosuitjes en rivierkreeftjes. Naar smaak peper toevoegen. Salade over 4 borden verdelen. Alfalfa over salade strooien.",
"ingredients": "350 g penne rigate\n1 grote komkommer\n6 bosuitjes\n8 el sladressing caesar\n2 el citroensap\n300 g rivierkreeftjes\n40 g alfalfa",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/A67aah0.jpeg"
},
{
"id": 303,
"name": "Pastasalade met tomaat en mozzarella",
"recipe": "Kook de pasta gaar volgens de aanwijzingen op de verpakking. Pureer met de blender of staafmixer 1 bakje basilicum met de knoflook, het citroensap, de olie en 2 el water tot een dressing. Voeg peper en zout naar smaak toe. Giet de pasta af en meng meteen in een schaal met de dressing, laat minstens 20 min. afkoelen. Scheur de rest van het basilicum in stukken. Schep vlak voor het serveren de bosui, de tomaat, de mozzarella, ham en het basilicum door de salade. Breng op smaak met zout en peper.",
"ingredients": "250 g schelpjespasta\n30 g verse basilicum\n1 teen knoflook, fijngesneden\n2 el citroensap\n5 el olijfolie extra vierge\n1 zakje bosui, in ringetjes\n4 tomaten, in vieren\n250 g mozzarella, uitgelekt\ndikke plak ham, in blokjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/fV1VsFO.jpeg"
},
{
"id": 125,
"name": "Pastasalade met tonijn",
"recipe": "Kook de pasta beetgaar volgens de aanwijzing op de verpakking. Kook de sperziebonen 5 minuten in ruim water met een beetje zout. Spoel ze in een vergiet af onder koud stromend water, zodat het kookproces stopt en de boontjes mooi groen blijven. Meng in een slaschaal de mosterd met de mayonaise, knoflook, zout en peper. Roer de tonijn erdoor en schep vervolgens de lauwe pasta erdoor. Schep de sperziebonen en olijven door de pastasalade. Snijd de eieren in achten en leg ze met de ansjovis op de salade.",
"ingredients": "250 g pipe rigate\n500 g sperziebonen\n0,5 el mosterd\n3 el mayonaise\n1 teentje knoflook, uitgeperst\n2 blikjes tonijn op water (a 185 g), uitgelekt\n100 g zwarte olijven zonder pit, fijngesneden\n2 eieren, hardgekookt\n1 blikje ansjovisfilets (46 g)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/3CsM9vO.jpeg"
},
{
"id": 359,
"name": "Pastasalade met tonijn, bonen en citroenpesto",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking beetgaar. Kook de sperziebonen in 6 min. knapperig gaar. Rasp de gele schil van de citroen en meng met de pesto. Giet de pasta en de sperziebonen af en spoel beide onder stromend water snel koud. Laat goed uitlekken. Meng de pasta en sperziebonen met de citroenpesto, komkommer en ui. Schep voorzichtig de tonijn erdoor. Schep de pastasalade op 4 borden en bestrooi met peper naar smaak.",
"ingredients": "350 g penne rigate\n250 g sperziebonen\n0,5 citroen\n50 g groene pesto\n1 komkommer\n1 ui\n2 blikjes tonijnstukken in zonnebloemolie (à 185 g)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/mrP5JWE.jpeg"
},
{
"id": 126,
"name": "Pastasalade met zalm en sinaasappeldressing",
"recipe": "Kook pasta. Spoel af en laat goed uitlekken. Kook broccoli in klein laagje water 3 minuten. Doe doperwten in schaal en giet er kokend water op. Laat 3 minuten staan. Spoel broccoli en doperwten af en laat uitlekken. Boen sinaasappel schoon. Schep zure room in schaal en rasp schil van sinaasappel erboven fijn. Pers sinaasappel en roer sap met mosterd door room. Breng op smaak met zout en peper. Snij zalm in reepjes. Schep pasta, broccoli, doperwten, maïs en zalm door dressing.",
"ingredients": "300 g penne\n300 g broccoli in kleine roosjes\n225 g doperwten (diepvries)\n1 sinaasappel\n125 ml zure room\n1 tl mosterd\n200 g gerookte zalm\n300 g maïs",
"servings": 2,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/DsiP2vI.jpeg"
},
{
"id": 484,
"name": "Pastaschotel met bloemkool en witlof",
"recipe": "Verwarm de oven voor op 200 °C. Bereid de pasta volgens de aanwijzijngen op de verpakking. Spoel af onder koud water. Snijd de bloemkool in roosjes, breng een pan water aan de kook, kook 8 min en giet af. Was de witlof en verwijder de buitenste bladen en de stronk. Snijd de witlof over de lengte 2 keer doormidden. Verhit de olijfolie in een koekenpan. Bak het gehakt met peper, zout, nootmuskaat en paprikapoeder in 3 à 5 min rul op middelhoog vuur. Meng de pasta, bloemkoolroosjes en gehakt in een kom. Schep het geheel in een ovenschaal en verdeel de witlof erover. Verdeel vervolgens de kaas over de ovenschaal zoat de bovenkant volledig is bedenkt. Zet de schaal 20 à 25 min in de oven.",
"ingredients": "150 g fusili\n140 g bloemkool\n175 g witlof\n150 g rundergehakt\n1 tl nootmuskaat\n1 tl gerookt paprikapoeder\n75 g geraspte kaas\n3 el olijfolie\nzout\npeper",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/KpNlytP.jpeg"
},
{
"id": 316,
"name": "Penne met garnalen",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking. Verwijder ondertussen de steelaanzet van de haricots verts, halveer ze en kook de laatste 4 min. met de pasta. Giet af, maar vang 50 ml van het kookvocht op. Laat vervolgens goed uitlekken. Snijd ondertussen de courgette in halve schijfjes. Verhit de olie in een koekenpan en bak de garnalen en courgette 8 min. op middelhoog vuur. Breng op smaak met peper en eventueel zout. Schep de pasta, het kookvocht en de pesto erdoor en zet het vuur uit. Garneer met de pijnboompitten en serveer direct.",
"ingredients": "300 g penne\n350 g haricots verts\n1 courgette\n2 el olijfolie\n300 g rauwe gepelde roze\n80 g pesto alla Genovese\n50 g geroosterde pijnboompitten",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/tPERDXQ.jpeg"
},
{
"id": 127,
"name": "Penne met saus van wintergroenten",
"recipe": "Fruit ui en knoflook. Bak peen en bleekselderij 3 min mee. Voeg tomatenblokjes en tijm toe en laat 10 min sudderen. Verdun eventueel met wat water. Kook penne. Bak salamireepjes. Schep penne op bord, verdeel saus erover en garneer met salami.",
"ingredients": "1 grote ui\n2 tenen knoflook\n300 g winterpeen in blokjes\n6 stengels bleekselderij in stukjes\n400 g tomatenblokjes\n2 tl gedroogde tijm\n300 g penne\n100 g salami in dunne reepjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/8ML8SiB.jpeg"
},
{
"id": 128,
"name": "Penne met zalm en sperziebonen",
"recipe": "Penne koken. Bonen in 8 minuten beetgaar koken, afgieten en laten uitlekken. Ui pellen en snipperen. Ui 5 minuten in olie fruiten. Knoflook kort meefruiten. Zalm bestrooien met zout en inwrijven met olie. Zalm 8 minuten aan beide zijden grillen. Dillesaus toevoegen aan ui en verwarmen zonder koken. Roer penne en bonen door elkaar en serveer zalm en saus erover.",
"ingredients": "300 g penne\n500 g gehalveerde sperziebonen\n1 ui\n2 teentjes knoflook\n500 g zalmfilet\n300 ml dillesaus",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/FYaXMfN.jpeg"
},
{
"id": 129,
"name": "Peultjesrisotto met kabeljauw",
"recipe": "Meng rucola, hazelnoot, basilicum, parmezaanse kaas en olie en pureer met staafmixer. Verdun eventueel met wat extra olie. Pureer vervolgens chorizo, roomkaas en water. Bak sjalotje glazig en voeg rijst toe. Roerbak tot rijst glazig en voeg soeplepel bouillon toe. Zodra vocht is opgenomen weer bouillon toevoegen. Herhaal dit 20 minuten. Snij intussen peultjes in reepjes en roerbak 2 min. Roer peultjes met kaas door risotto. Bak vis aan beide kanten bruin en laat 5 min garen. Doe rijst in stekertje op borden. Leg kabeljauw erop en besmeer met chorizopuree. Giet pesto eromheen.",
"ingredients": "400 g risottorijst\n200 g peultjes\n1 sjalotje gesnipperd\n1/2 el boter\n1 l groentebouillon\n4 el geraspte Parmezaanse kaas\n1/2 bosje rucola\n1 el hazelnoot\n1/2 bosje basilicum\n1/2 el geraspte Parmezaanse kaas\n2 el olijfolie\n50 chorizo\n50 g roomkaas\n1 el water\n4 stukken kabeljauw (120 g)\n1 el boter\n1 el olijfolie",
"servings": 4,
"serveWith": "erwtjes",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 367,
"name": "Pikante bonenschotel met pastinaak, chorizo en croutons",
"recipe": "Verhit in een braadpan 1 el olijfolie. Bak de chorizo 5 min. Schep de pastinaak erdoor en bak nog 3 min. Voeg de tomatenblokjes, chilibonen en bonenmix toe. Schep er de prei met het water door en breng aan de kook. Draai het vuur laag en stoof de bonenschotel afgedekt in 30 min. gaar. Snijd de korsten van het brood en scheur het brood in stukjes van 2 cm. Verhit de laatste 4 el olijfolie. Schep het brood erdoor en bak in 4 min. goudbruin en krokant. Verdeel de bonenschotel over 4 diepe borden en bestrooi met de broodcroutons.",
"ingredients": "5 el olijfolie\n100 g chorizo sarta\n500 g pastinaak\n400 g tomatenblokjes\n400 g chilibonen in tomatensaus\n160 g bonenmix\n300 g gesneden prei\n150 g oerbrood origine\n100 ml water",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/pOVt2dY.jpeg"
},
{
"id": 130,
"name": "Pikante eiermie met gehakt",
"recipe": "Kook mie. Snijd bosui en prei in ringen. Rooster pinda's in droge koekenpan. Meng ketjap, 2 el chilisaus, sambal en maïzena door gehakt. Roerbak gehakt rul. Voeg bosui en prei toe en roerbak nog 4 minuten. Schenk bouillon en rest chilisaus erbij. Schep mie er luchtig door. Verwarm en bestrooi met pinda's.",
"ingredients": "300 g Chinese eiermie\n4 bosuitjes\n1 prei\n100 g ongezouten pinda's\n2 el ketjap manis\n2 el zoete chilisaus\n1 el maïzena\n500 g rundergehakt\n100 ml bouillon",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/zyFwhvc.jpeg"
},
{
"id": 131,
"name": "Pikante kalkoenreepjes",
"recipe": "Snij schnitzel schuin op draad in reepjes van 2 cm breed. Maal cashewnoten fijn met bloem, paprikapoeder, cayennepeper, korianderpoeder en zout. Doe mengsel in kom. Klop in andere kom het ei los. Haal kalkoen door ei en daarna door notenmengsel. Bak ze knapperig in hete olie. Frituren kan ook.",
"ingredients": "400 g kalkoenschnitzel\n50 g geroosterde cashewnoten\n2 el bloem\n1 tl paprikapoeder\n1 tl cayennepeper\n1 tl koriander\n1 tl zout\n1 ei",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 132,
"name": "Pikante runderreepjes met gebakken rijst",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking, giet af en vang het kookvocht op. Schep de runderreepjes om met 1 el olie, 1 tl sambalsaus en de knoflook. Verhit de rest van de olie in een wok en roerbak de uien en de spitskool 5 min. Voeg het kerriepoeder en de rest van de sambal- saus toe en roerbak 1 min. Voeg de rijst toe en roerbak 4 min. Verhit ondertussen een koekenpan zonder olie of boter en roerbak de gemarineerde runderreepjes op hoog vuur 4 min. Schenk er 150 ml kookvocht van de rijst bij en breng dit aan de kook. Schep de gebakken rijst op 4 borden. Serveer met de pikante runderreepjes en de jus.",
"ingredients": "250 g witte rijst\n350 g runderreepjes\n3 el olie\n2 tl sambal saus original\n1 teen knoflook, fijngesneden\n2 uien, in halve ringen\n1 spitskool, fijngesneden\n1 el kerriepoeder",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/PljP9YR.jpeg"
},
{
"id": 133,
"name": "Pittige groenterijst met kalkoen",
"recipe": "Bamigroenten wellen volgens pak. Rijst koken. Af laten koelen en af en toe losroeren. Peper en tomaat uit pakket in stukjes snijden. Olie in pan verhitten. Knoflook, peper en sambal enkele seconden bakken. Kalkoen toevoegen en 5 minuten roerbakken. Kalkoen op bord scheppen. Aan bakvet 3 el water toevoegen. Rest van pakket en gewelde bamigroenten in pan scheppen. 2 minuten roerbakken. Rijst toevoegen en 2 minuten roerbakken. Taugé, pinda's en kalkoen erdoor scheppen. 5 minuten verwarmen. Garneren met augurk en tomaat.",
"ingredients": "1 zakje bamigroenten (50 g)\n1 pak rijst (350 g)\n250 g taugé,\n1 bamipakket (500 g)\n4 el olie\nknoflook\n1 mespunt sambal oelek\n400 g kalkoen nasi/bamivlees\n100 g gezouten pinda's\n8 kleine augurken",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 134,
"name": "Pittige kippenragout",
"recipe": "Chilipoeder, koriander, komijn, gemberpoeder en kaneelpoeder door elkaar roeren. Kipfilet in reepjes snijden. Ui en knoflook zeer fijn hakken, Olie verhitten. Ui en knoflook 1 min bakken. Kruidenmengsel ½ min meebakken. Kip erdoor scheppen en 4 min bakken. Yoghurt en bloem mengen. Yoghurtmengsel, citroensap, gezeefde tomaten, slankroom en bouillontablet toevoegen. Afgedekt 15 min sudderen.",
"ingredients": "1 el chilipoeder\n1 el gemalen koriander\n2 tl gemalen komijn\n1 tl gemberpoeder\n0,5 tl kaneelpoeder\n500 g kipfilet\n1 ui\n2 teentjes knoflook\n2 el olie\n1 dl volle yoghurt\n0,5 el bloem\n1 el citroensap\n250 g gezeefde tomaten\n200 ml slankroom\n1 kippenbouillon tablet",
"servings": 4,
"serveWith": "saffraanrijst broccoli",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/uobgUEN.jpeg"
},
{
"id": 334,
"name": "Pittige pasta",
"recipe": "Snij de salami, paprika's en mozzeralla in blokjes. Kook pasta al dente. Bak in droge koekenpan de salami in 3 min zachtjes uit. Voeg ui en paprika toe en bak 5 min mee. Giet pasta af en schep met mozzerella door paprikamengsel. Verdeel basilicum erover.",
"ingredients": "200 g salami\n1 gesnipperde ui\n3 paprika's\n125 g mozzerella\n0,5 basilicumplantje\n300 g pasta",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/612Sxl5.jpeg"
},
{
"id": 269,
"name": "Pittige pasta met tomatensaus en makreel",
"recipe": "Verhit de olijfolie en fruit hierin de pepers, knoflook en ui. Voeg de pastasaus toe en stoof zachtjes 10 minuten. Kook intussen de pasta beetgaar. Giet deze af en laat goed uitlekken. Schep de saus door de pasta en serveer deze met de makreel erop. Bestrooi het gerecht met peterselie.",
"ingredients": "2 rode pepers, zonder zaadjes, in stukjes\n2 teentje knoflook, gehakt\n2 uien, gesnipperd\n1 pot pastasaus\n350 g penne of spaghetti\n500 g gerookte makreel, in stukken\n3 el gehakte platte peterselie",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/UZxZDwn.jpeg"
},
{
"id": 135,
"name": "Pittige rundergoulash",
"recipe": "Ui, paprika en runderlapjes in stukjes snijden. In droge pan de spek 4 min bakken. Boter toevoegen en verhitten. Runderlappen toevoegen en 8 min bakken. Knoflook erover uitpersen. Ui, paprika en paprikapoeder erdoor scheppen. 3 min bakken. Bouillontablet verkruimelen. Tomatenpuree, tomatenblokjes (plus vocht), wijn en 1 dl water toevoegen. Afgedekt 2 uur zachtjes stoven. Aardappel in blokjes snijden en toevoegen. 20 min zachtjes sudderen.",
"ingredients": "1 ui\n2 rode paprika's\n600 g magere runderlappen\n100 g magere spekreepjes\n40 g boter\n2 teentjes knoflook\n1,5 el paprikapoeder\n1 vleesbouillon tablet\n70 g tomatenpuree\n400 g tomatenblokjes\n2 dl rode wijn\n2 vastkokende aardappels",
"servings": 6,
"serveWith": "stokbrood kropsla",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 136,
"name": "Pittige rundvleescurry",
"recipe": "Rasp limoen en pers uit. Vlees in 5 min rondom bruin bakken. Currypasta en helft kokosmelk toevoegen. 1 min mee verwarmen. Knoflook, limoenrasp en sap, vissaus, rest van kokosmelk, suiker en 1 dl water toevoegen. 2,5-3 uur gaar stoven. Met vissaus op smaak brengen. Koriander erover strooien.",
"ingredients": "600 g doorregen runderlappen in blokjes\n2 teentjes knoflook\n1 limoen\n2 el rode currypasta\n200 ml kokosmelk\n2 el bruine basterdsuiker\n3 el vissaus\n7 g verse koriander",
"servings": 4,
"serveWith": "jasmijnrijst en salade",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/ggiEf4Y.jpeg"
},
{
"id": 379,
"name": "Plaattaart met kruidenricotta en cherrytomaatjes",
"recipe": "Verwarm de oven voor tot 200 °C. Leg de deegplakjes op elkaar en rol uit tot een rechthoekige deeglap. Leg het deeg op de bakplaat. Rol de zijkanten van het deeg twee keer op zodat een opstaande rand ontstaat. Meng de ricotta met de knoflook, de reepjes basilicum, de tijm en zout en peper naar smaak. Schep de kruidenricotta op de deegbodem en smeer uit. Verdeel er de tomaatjes, de olijven en de pijnboompitten over. Bestrijk de deegrand dun met ei. Bak de taart in de voorverwarmde oven in 25 min. goudbruin en gaar. Bestrooi de taart uit de oven met wat extra blaadjes basilicum en sprenkel er naar wens nog wat extra vierge olijfolie over.",
"ingredients": "10 plakjes bladerdeeg\n500 g ricotta\n2 tenen knoflook\n4 takjes basilicum\n2 takjes tijm\n1 snufje zout\n1 snufje peper\n250 g cherrytomaatjes\n50 g zwarte olijven zonder pit\n30 g pijnboompitten\n1 ei",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/C4ggW8T.jpeg"
},
{
"id": 137,
"name": "Pollo alla Venezia",
"recipe": "Snij ui, bleekselderij en wortel in stukjes. Fruit ui, spekreepjes en knoflook. Voeg kip, groenten, rozemarijn en citroenrasp toe. Roerbak tot kip gekleurd is en voeg dan olijven, wijn en bouillon toe. Stoof 1 uur. Schep vlak voor serveren citroensap erdoor.",
"ingredients": "kippenpoten in stukken\n2 rode uien\n2 teentjes knoflook\n4 stengels bleekselderij\n4 worteltjes\nsap en rasp van 1 citroen\n100 g gerookte spekreepjes\n2 takjes rozemarijn\n20 zwarte olijven zonder pit\n100 ml droge witte wijn\n200 ml kippenbouillon",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/GARO1vK.jpeg"
},
{
"id": 421,
"name": "Pompoen, zoete aardappel & garnalencurry",
"recipe": "Doe de olie in een hete wokpan. Fruit de ui, gember en knoflook. Voeg de gele currypasta en tomatenpuree toe. Bak even aan en voeg dan de kokosmelk en het water toe. Breng dit aan de kook. Voeg de pompoen en zoete aardappel toe. Na 15 a 20 minuten zachtjes koken zijn deze gaar. Bak snel in een el olie de garnalen en schep deze daarna door de curry heen.",
"ingredients": "4 el olie\n500 g (grote) garnalen\n1 flespompoen\n1 zoete aardappel\n400 g kokosmelk\n100 ml water\n2 uien gepeld en gesnipperd\n1 klein blikje tomatenpuree\n3 tenen knoflook, kleingesneden\n2 cm gember, kleingesneden\n1 flinke el (milde) gele currypasta\n1 bos koriander",
"servings": 4,
"serveWith": "naanbrood of rijst",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/NSiHO7J.jpeg"
},
{
"id": 473,
"name": "Pompoenfrittata met geitenkaas en walnoten",
"recipe": "Verwarm de oven voor op 200 °C. Schil de aardappelen en snijd in blokjes van 1 cm. Snijd de pompoen in stukjes van 1 cm. Snijd de uien in halve ringen. Meng de aardappel, pompoen en ui met de rozemarijn en olie in de ovenschaal en rooster ca. 20 min. in het midden van de oven. Verlaag de oventemperatuur daarna naar 180 °C. Klop ondertussen de eieren los met 50 ml water en eventueel zout. Pers de knoflook en meng erdoor. Verkruimel de geitenkaas. Haal de ovenschaal uit de oven, schep de groenten om en verdeel de geitenkaas erover. Schenk het eimengsel over de groenten en geitenkaas. Bak nog ca. 15 min. in het midden van de oven. Haal de frittata uit de oven en verdeel de walnoten met de platte kant naar beneden erover, druk ze een beetje in de frittata. Bak nog 10-15 min. of tot het ei is gestold en de frittata mooi bruin is aan de randjes.",
"ingredients": "200 g vastkokende aardappelen\n500 g flespompoenen\n400 g middelgrote uien\n1 tl gedroogde rozemarijn\n2 el olijfolie mild\n10 witte scharreleieren\n2 tenen knoflook\n50 ml water\n125 g geitenkaas naturel 45+\n60 g walnoten",
"servings": 4,
"serveWith": "groene salade",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/rnbczRQ.jpeg"
},
{
"id": 305,
"name": "Powerquiche met Hüttenkäse",
"recipe": "Verwarm de oven voor op 200 °C. Kneed met vochtige handen van de havermout, olie, water, zout en peper een soepel deeg. Spoel de bakvorm af zodat deze vochtig is. Druk het deeg uit over de bodem en vorm een opstaand randje van circa 2 cm. Verdeel de paprika- en kipreepjes over de deegbodem. Klop de eieren los met zout, peper, de kruiden en de Hüttenkäse. Giet dit mengsel over de vulling op de deegbodem. Bak de taart in het midden van de oven in circa 40 minuten goudbruin.",
"ingredients": "250 g havermout\n2 tl olijfolie\n100 ml water\n1 rode en 1 groene paprika, in reepjes\n200 g gerookte kipfilet, in reepjes\n4 eieren\n2 el gehakte verse Italiaanse of Provençaalse kruiden of 2 tl gedroogd\n200 g Danone Hüttenkäse\nlage taartvorm of springvorm ø 26 cm",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/q8HUqBW.jpeg"
},
{
"id": 138,
"name": "Prei-gehaktschotel",
"recipe": "Oven voorverwarmen op 200 °C. Gehakt rul bakken in olie. Prei, paprika en rozijnen toevoegen en 2 min meebakken. Ei loskloppen. Mix met 400 ml water en ei mengen. In ovenschaal helft aardappels leggen. Gehaktmengsel erover verdelen. Bedekken met rest aardappels. Mix erover gieten en 45 min in oven.",
"ingredients": "400 g prei in ringen\n1 rode paprika in stukjes\n350 g rundergehakt\n4 el rozijnen\n1 ei\n1 pak maggi ovenschotelmix voor prei\n700 g aardappelschijfjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 139,
"name": "Preipasta met ham en kaas",
"recipe": "Verwarm de oven voor op 200 °C. Kook de penne volgens de aanwijzingen op de verpakking. Verhit ondertussen de olie in een koekenpan en bak de prei in 5 min. zacht en gaar. Voeg de hamblokjes, de bechamelsaus en de helft van de kaas toe. Breng op smaak met peper en zout. Giet de pasta af en schep door de prei. Schep in de ovenschaal en strooi er de rest van de kaas en de oregano over. Bak de pasta in 20-25 min. lichtbruin en gaar.",
"ingredients": "300 g penne rigate\n1 el olijfolie\n3 preien, in ringen\n250 g hamblokjes\n1 pot besciamella saus\n175 g gemalen kaas belegen\n1 tl oregano",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/plCvvpe.jpeg"
},
{
"id": 140,
"name": "Preischotel met ambachtelijke rookworst",
"recipe": "Verwarm de oven voor op 200 °C. Bereid de bechamelsaus met de melk volgens de aanwijzingen op de verpakking. Meng de ui, de paprika en de spekblokjes. Vul de ovenschaal dakpansgewijs en in rijen met de ringen prei, de plakjes rookworst en de aardappelschijfjes, strooi er wat peper en zout over. Verdeel het uienmengsel erover en schenk de bechamelsaus erover. Schuif de schaal 35 minuten in de oven, de saus kleurt dan goudbruin.",
"ingredients": "1 zakje bechamelsaus\n400 ml melk\n1 ui, gesnipperd\n1 rode paprika, in kleine stukjes\n125 g gerookte spekblokjes\n500 g prei, in ringen\n700 g aardappelschijfjes\n1 rookworst, in plakjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/Hik88Y8.jpeg"
},
{
"id": 240,
"name": "Preistamppot met hot dogs",
"recipe": "Paprika wassen, schoonmaken, en in stukjes snijden. In braadpan boter verhitten. Paprika en prei ca. 4 minuten bakken. Puree met melk bereiden volgens gebruiksaanwijzing. Puree mengen met prei, paprika en kaas en goed doorwarmen. Hotdogs verwarmen in magnetron volgens gebruiksaanwijzing. Stamppot serveren met hotdogs.",
"ingredients": "1 rode paprika\n40 g boter of margarine\n600 g gesneden prei\n1/2 pak aardappelpuree (à 2 zakjes à 135 g)\n300 ml melk\n100 g gemalen oude kaas\nhot dogs of Duitse worstjes",
"servings": 4,
"serveWith": "mosterd",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/L1BaOEX.jpeg"
},
{
"id": 264,
"name": "Preistamppot met rauwe ham en ei",
"recipe": "Schil de aardappelen en kook ze in water met zout in 20 min. gaar. Kook de laatste 5 min. de prei mee. Kook ondertussen de eieren in 8 min. hard. Laat schrikken onder koud stromend water. Giet de aardappelen en prei af en vang een kopje kookvocht op. Stamp de aardappelen en prei fijn met de pureestamper. Voeg de roomkaas, ham en peterselie toe en eventueel wat kookvocht. Warm nog 3 min. door. Pel de eieren en snijd in partjes. Serveer de stamppot met het ei erop.",
"ingredients": "1 kg aardappelen iets kruimig\n600 g gesneden prei\n4 eieren\n125 g roomkaas light met knoflook en fijne kruiden\n200 g rauwe ham, in reepjes\n20 g platte peterselie, blaadjes fijngesneden",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/UMpixzM.jpeg"
},
{
"id": 450,
"name": "Preistoof met zalm en tagliatelle",
"recipe": "Verwarm de oven voor tot 200 °C. Snijd de prei in stukken van 4-5 cm en spoel goed schoon onder koud stromend water. Leg de zalmfilet in de ovenschaal en verdeel er 15 g boter in kleine vlokjes over. Bestrooi met peper. Bak de zalm in de voorverwarmde oven in 15-20 min. naar wens gaar. Breng een ruime pan water aan de kook voor de pasta. Smelt in een hapjespan 15 g boter. Schep de prei erdoor en bak 2 min. Voeg 100 ml water toe en stoof de prei afgedekt in 15 min. gaar. Kook de tagliatelle volgens de aanwijzingen op de verpakking. Snipper intussen de sjalot fijn en hak ook de kappertjes fijn. Smelt in een koekenpan de laatste 50 g boter. Fruit de sjalot 2 min. Voeg de kappertjes toe. Houd de boter op laag vuur warm zonder te kleuren. Giet de tagliatelle af en meng met de kappertjesboter. Voeg peper naar smaak toe. Leg de prei op 4 borden. Schep er de tagliatelle en zalmfilet bij.",
"ingredients": "3 preien\n290 g zalmfilet zonder huid\n80 g roomboter\n400 g tagliatelle\n2 sjalotten\n1 el kappertjes",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/YddauY3.jpeg"
},
{
"id": 310,
"name": "Preitaart met spekjes",
"recipe": "Verwarm de oven voor op 200 °C. Laat de plakjes deeg ontdooien. Bak de spekreepjes zachtjes uit in een hapjespan. Was en snijd de prei in ringen. Neem de spekblokjes uit de pan en laat ze uitlekken op keukenpapier. Stoof de prei met een el Blue Band Vloeibaar op laag vuur gedurende een minuut of 10. Vet ondertussen een springvorm (24 cm) in met een beetje vloeibare margarine en bekleed bodem en wand met de plakjes deeg. Leg hierbij de gladde kant van het deeg naar beneden. Verdeel de spekblokjes over de bodem en schep de prei erop. Klop de Blue Band Finesse voor Koken met de melk en de eieren los en meng de kaas erdoor. Breng dit mengsel op smaak met zout en peper en schenk het over de prei. Bak de taart ongeveer 35 minuten in de hete oven. Laat 5 à 10 minuten op een rooster uitdampen, snijd de taart in punten en serveer direct.",
"ingredients": "5 plakjes deeg voor hartige taart\n250 g reepjes spek\n800 g prei\n2 el Blue Band Vloeibaar\n2 dl Blue Band Finesse voor Koken\n1 scheutje melk\n4 eieren\n100 g geraspte oude kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/QHdivQ8.jpeg"
},
{
"id": 141,
"name": "Provençaalse kabeljauwschotel",
"recipe": "Snij kabeljauw in stukken. Ui fijnsnipperen. Tomaten in stukjes snijden. Olie in pan verwarmen. Ui en knoflook bakken. Nog bevroren vis erbij doen en snel bruin bakken. Wijn en gepureerde ansjovis toevoegen. 5 min zachtjes bakken. Tomaten toevoegen. 5 min bakken. Vlak voor serveren garneren met kappertjes en peterselie.",
"ingredients": "400 g diepvries kabeljauwfilet\n1 ui\nknoflook\n350 g tomaten\n5 el olie\n1 dl witte wijn\n2 ansjovisfilets\n1 el kappertjes\n1 el fijngehakte peterselie\nzout\npeper",
"servings": 4,
"serveWith": "rijst, salade",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/1hYzIAD.jpeg"
},
{
"id": 337,
"name": "Provençaalse kapucijners",
"recipe": "Verhit de olie en fruit hierin de ui en knoflook. Voeg de tomaten, hamreepjes en Provençaalse kruiden toe en bak circa 2 minuten mee. Giet de bouillon erbij en verwarm circa 3 minuten. Schep de kapucijners erdoor en verwarm zonder te koken. Roer de crème fraîche en mosterd erdoor.",
"ingredients": "1 ui (gesnipperd)\n2 teentjes knoflook (gesnipperd)\n4 vleestomaten (in partjes)\n250 g hamreepjes\n1 el gedroogde Provençaalse kruiden\n100 ml vleesbouillon\ncirca 800 g kapucijners\n125 ml crème fraîche\n2 el dijonmosterd",
"servings": 4,
"serveWith": "een groene salade of appelcompote en warm stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/brhfcnH.jpeg"
},
{
"id": 257,
"name": "Quiche met ham en prei",
"recipe": "Verwarm de oven voor op 180 °C. Laat het bladerdeeg ontdooien. Snijd de ham in blokjes en de prei in ringen. Klop de eieren los met 2 el water. Roer de inhoud van beide zakjes Knorr mix door het losgeklopte ei en laat het mengsel 2-3 minuten staan. Klop de room, de ham, de geraspte kaas en de preiringen door het eimengsel. Bekleed een ingevette springvorm met het bladerdeeg. Zet de randen van het deeg aan elkaar met een beetje water en druk ze stevig aan. Giet het eimengsel in de vorm. Bak de quiche in ca. 55 minuten goudbruin en gaar. Controleer dit door een prikker midden in de quiche te steken. Als deze er droog uikomt is het gerecht gaar.",
"ingredients": "6 plakjes bladerdeeg\n150 g ham\n100 g prei\n6 middelgrote eieren\n1 Knorr mix voor boerenomelet\n125 ml room\n100 g geraspte kaas\n20 g margarine",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/9BRFAw9.jpeg"
},
{
"id": 142,
"name": "Quiche met zalm en aardappelen",
"recipe": "Vorm kruimelig deeg van bloem, boter en wat zout. Kneed met eierdooier en eventueel een scheutje water tot samenhangende deegbal. Rol uit tot ronde lap en bekleed ingevette vorm. Zet tot gebruik in koelkast. Kook aardappelblokjes in 5 min beetgaar. Bedruppel zalm met citroensap en bestrooi met zout. Doe crème fraîche, bosui, eieren, mosterd, dragon en zout en peper in kom en klop los. Verwarm oven op 180 °C. Verdeel zalm en aardappel over deegbodem. Giet eierroom erover. Bak 45 min in oven.",
"ingredients": "200 g bloem\n125 g boter in blokjes\n1 eierdooier\n500 aardappel in blokjes\n4 bosuitjes in ringetjes.\n400 g gefileerde zalm in blokjes\nsap van 1/2 citroen\n250 g crème fraîche\n3 eieren\n2 tl mosterd\n1 el fijngehakte dragon",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/6Eb8vaQ.jpeg"
},
{
"id": 393,
"name": "Quiche met zuurkool en beenham",
"recipe": "Verwarm de oven voor tot 200 °C. Smelt in een koekenpan de boter. Fruit de sjalot 1 min. Doe intussen de zuurkool in een zeef en druk zoveel mogelijk vocht eruit. Doe de zuurkool in een kom en schep er de sjalot en de beenham door. Rol het deeg uit en bekleed met het bakpapier de vorm ermee. Prik met een vork het deeg gelijkmatig in en bestrooi met het paneermeel. Verdeel de zuurkool over de deegbodem. Klop de eieren los met de crème fraîche, de mosterd en de kaas. Breng op smaak met peper en schenk over de zuurkoolvulling. Bak de quiche in de voorverwarmde oven in 35-40 min. goudbruin en gaar.",
"ingredients": "25 g roomboter\n2 sjalotten\n520 g zuurkool naturel\n150 g gekookte beenham in stukjes\n300 g quiche- en taartdeeg\n3 el paneermeel\n4 eieren\n200 g crème fraîche\n1 snufje peper\n1 el milde grove mosterd\n75 g geraspte jongbelegen kaas\n1 quiche- of taartvorm (ø 24 cm)",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/atyO1VH.jpeg"
},
{
"id": 343,
"name": "Rappe ratatouille",
"recipe": "Verhit de olie en roerbak hierin de aubergine, courgette, aardappel, wortel, ui en knoflook 5-6 minuten. Schep de kruiden, wijn en tomaten met sap erdoor en stoof zachtjes 8-10 minuten. Roer de bonen erdoor en warm even mee. Breng op smaak met zout en peper.",
"ingredients": "3 el olijfolie\n1 aubergine (in blokjes)\n1 courgette (in blokjes)\n400 g aardappelblokjes (koelvers, voorgekookt)\n1 winterwortel (geschrapt, in blokjes)\n1 rode ui (gesnipperd)\n3 teentjes knoflook (fijngehakt)\n1 el gedroogde Provençaalse kruiden\n100 ml rode wijn\n1 blik tomatenblokjes (400 g)\n1 blik borlottibonen (uitgelekt) of\n1 blik reuzenbonen (uitgelekt)\nstokbrood",
"servings": 4,
"serveWith": "worst",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/x3FBkEa.jpeg"
},
{
"id": 352,
"name": "Refried beans met chorizo en ei",
"recipe": "Verwarm de grill voor. Verhit in een hapjespan de olijfolie. Bak de chorizo in 3 min. knapperig uit. Schep het vlees uit de pan. Bak in het chorizovet de ui 2 min. Schep de kidneybonen erdoor en bak 3 min. mee. Voeg de tomaten toe en bak ze 2 min. mee. Voeg de chorizo weer toe en schep de bonen met de tomaat in de ovenschaal. Maak er met een juslepel 4 kuiltjes in. Breek boven elk kuiltje een ei. Schuif de ovenschotel onder de hete grill en laat de eieren in 4 tot 5 min. stollen. Serveer direct.",
"ingredients": "1 el olijfolie\n100 g chorizo\n2 kleine uien\n2 blikken kidneybonen (à 400 g)\n500 g trostomaten\n4 eieren",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/PSLYK5M.jpeg"
},
{
"id": 143,
"name": "Regenboogforelfilet-pakketjes",
"recipe": "Prei en worteltjes in dunne reepjes snijden. 4 stukken bakpapier invetten. Forelfilet in 4 stukken snijden. Bestrooien met zout en peper. Groentereepjes op bakpapier leggen. Forelfilets er boven op. Mierikswortel, bakgember en gembersiroop door elkaar roeren. Gembermengsel en kleine stukjes boter over filets verdelen. Dichtvouwen en 20 min in oven op 175 °C.",
"ingredients": "2 dunne preien\n250 g worteltjes\n400 g regenboogforelfilet\n3 tl mierikswortel\n2 el bakgember\n2 el gembersiroop\nbakpapier\n25 g boter",
"servings": 4,
"serveWith": "gekookte krielaardappeltjes peterselie",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/UiMsPXX.jpeg"
},
{
"id": 144,
"name": "Ribeye in gingermarinade",
"recipe": "Ui, wortel, bleekselderij en knoflook klein snijden. Deze in keukenmachine met azijn, sesamolie, tabasco en gembersiroop tot gladde pasta pureren. Ribeyes aan beide kanten bestrijken met marinade. 6 uur afgedekt in koelkast marineren. Op kamertemperatuur laten komen. Grill voorverwarmen op hoogste stand. 8 min grillen. Halverwege keren. Onder aluminiumfolie 4 min laten rusten.",
"ingredients": "1 kleine ui\n1 worteltje\n1 stengel bleekselderij\n2 teentjes knoflook\n4 el azijn\n2 el sesamolie\n3 tl tabasco\n1 el gembersiroop\n4 ribeyes (of entrecotes)\n1 el olie",
"servings": 4,
"serveWith": "salade van gemengde sla, avocado, sinaasappel en yoghurt",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 145,
"name": "Riblappen in rode wijn",
"recipe": "Snij groenten klein, knoflook in vieren. In schaal de ui, knoflook, wortel, selderij, laurier, kruidnagels, kaneelstokje, rozemarijn en salie met wijn mengen. Riblappen halveren. In wijn leggen. 24 uur in koelkast marineren. Oven voorerwarmen op 150 °C. Vlees uit wijn nemen en droog deppen. In koekenpan vlees 5 min in olie bakken. Vlees in ovenschaal. Bestrooi met zout. Wijnmengsel erbij schenken. Afgedekt 2 uur in oven. Vlees uit oven in aluminium wikkelen. Vocht door zeef in steelpan laten lopen. Vocht inkoken tot 2 dl. Boter in klontjes snijden en door vocht kloppen.",
"ingredients": "1 ui\n25 g selderij\n0,5 winterpeen\n2 teentjes knoflook\n2 blaadjes laurier\n6 kruidnagels\n1 kaneelstokje\n1 takje verse rozemarijn\n1 tl salie\n1 kg riblappen\n4 dl rode wijn\n3 el olijfolie\n50 g boter",
"servings": 4,
"serveWith": "aardappelpuree ; gemengde groene sla",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 419,
"name": "Ribstoof met rozemarijn en kruidnagel",
"recipe": "Dep het vlees droog en bestrooi met peper. Verhit in een braadpan olie en bak het vlees in 5 min aan beide kanten bruin. Neem uit pan. Fruit in het bakvet de wortel en bleekselderij 2 min. Schep de sjalot, kruidnagel en rozemarijn erdoor en bak 1 min mee. Schenk de wijn langs de rand erbij. Voeg de fond en honing toe en breng alles tegen de kook. Draai het vuur terug en leg het vlees terug in de pan. Stoof de riblap afgedekt in 2 uur zachtjes gaar.",
"ingredients": "500 g runderriblappen\n100 g wortel in blokjes\n2 stengels bleekselderij in boogjes\n6 sjalotten gehalveerd\n6 kruidnagels\n2 takjes rozemarijn\n200 ml rode wijn\n400 ml vleesfond\n2 tl honing",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/3DHBsDR.jpeg"
},
{
"id": 416,
"name": "Rigatoni met broccoli en gorgonzola",
"recipe": "Kook de pasta beetgaar. Voeg circa 6 minuten voor het einde van de kooktijd de broccoli toe aan de pasta en kook mee. Rooster intussen de walnoten in een droge, hete koekenpan en hak ze grof. Meng de room met de gorgonzola en knoflook tot een romige saus en breng op smaak met zout en peper. Giet de pasta en broccoli af, roer de gorgonzolasaus erdoor en warm kort door. Bestrooi met de walnoten, verdeel de rucola erover en besprenkel met balsamicoazijn.",
"ingredients": "250 g rigatone of penne\n700 g broccoli (in kleine roosjes)\n200 ml slagroom\n150 g gorgonzola\n1 teentje knoflook (fijngehakt)\n100 g rucola\n2 el balsamicoazijn",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/fPePSA2.jpeg"
},
{
"id": 146,
"name": "Rijst met Hongaarse goulash",
"recipe": "Snij uien, tomaten en paprika's in stukjes. Bak vlees rondom bruin. Voeg uien toe. Bak enkele minuten. Strooi paprikapoeder erover. Voeg tomaten en helft paprikastukjes toe. Knoflook erbij. Stoof 1 à 1½ uur. Roer crème fraîche 5 min voor einde erdoor. Kook intussen rijst. Schep rest paprikastukjes door rijst. Laat rijst 5 min staan.",
"ingredients": "375 g rijst\n2 uien\n8 grote tomaten\n1 gele paprika\n1 rode paprika\n1 groene paprika\n600 g mager rundvlees in blokjes\n2 tl paprikapoeder\n1 teentje knoflook\n1 bekertje crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/5Xj1TWC.jpeg"
},
{
"id": 147,
"name": "Rijst-maïsschotel",
"recipe": "Rijst met bouillonblokje en koenjit gaar koken. Kip 5 min in boter bakken. Voeg zout, peper, kerrie, knoflook, paprika en prei toe. 5 min bakken. Rijst, maïs, ketjap en chilisaus toevoegen. Goed doorwarmen.",
"ingredients": "150 g rijst\n1 kruidenbouillon blokje\n0,5 tl koenjit\n2 el boter\n250 g kipfilet in reepjes\nkerriepoeder\n1 teentje knoflook\n1 rode paprika in reepjes\n1 groene paprika in reepjes\n1 dunne prei in ringen\n300 g maïskorrels\n1 el ketjap asin\n2 el hete chilisaus",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/CR5Y1qj.jpeg"
},
{
"id": 233,
"name": "Rijstsalade met groentemimosa",
"recipe": "Kook de rijst in de bouillon volgens de gebruiksaanwijzing en kook de doperwten de laatste minuut mee. Giet af en laat uitlekken in een vergiet. Doe de rijst met de doperwten terug in een afgesloten pan om 5 minuten uit te stomen. Spreid de rijst daarna uit op een wijde schaal en laat helemaal afkoelen. Spoel de maïs en kidneybonen af en laat ze goed uitlekken. Snijd de paprika’s en eieren in kleine blokjes en meng alles met de maïs en bonen. Klop van de yoghurt, mayonaise en kerrie een sausje en breng op smaak met zout en peper. Schep dit door de rijstsalade en serveer direct.",
"ingredients": "300 g witte of bruine snelkookrijst\n1,5 l groentebouillon van tablet of poeder\n200 g doperwten\n300 g maïs\n250 g kidneybonen\n1 rode paprika\n1 groene paprika\n6 hardgekookte eieren\n2 el yoghurt\n2 el mayonaise\n1 tl kerriepoeder",
"servings": 4,
"serveWith": "Procureurlapjes",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/X8wnClf.jpeg"
},
{
"id": 224,
"name": "Rijstsalade met maïs en kaas",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Kook de tuinerwten volgens de aanwijzingen op de verpakking, voeg de laatste minuut de paprikareepjes toe. Spoel de groente in een vergiet onder de kraan met koud water af. Laat de rijst in een wijde kom afkoelen, schep regelmatig om. Verhit de olie in een wok en bak de ui goudbruin. Voeg de laatste minuut de Italiaanse kruiden toe. Voeg de ui met het bakvet, de tuinerwten, de paprika, de maiskorrels en de kaas bij de afgekoelde rijst en schep om.",
"ingredients": "300 g witte rijst\n2 rode paprika's, in reepjes\n2 el olijfolie\n1 ui, gesnipperd\n1 el Italiaanse kruiden\n300 g maïskorrels, uitgelekt\n250 g jong belegen kaas, in blokjes",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/wQGRyEa.jpeg"
},
{
"id": 148,
"name": "Rijstsalade met makreel",
"recipe": "Rijst bereiden volgens gebruiksaanwijzing en laten afkoelen. Peultjes schoonmaken, wassen en in ca. 4 minuten beetgaar koken. Afspoelen met koud water en laten uitlekken. Komkommer wassen en in blokjes snijden. Bosuitjes schoonmaken en in ringetjes snijden. Vis van vel en graten ontdoen en in stukken verdelen. Rijst met vork losmaken. Groenten, vis en rijst mengen. Op smaak brengen met citroensap, zout en peper. Sla over vier borden verdelen. Rijstsalade erop scheppen.",
"ingredients": "1 pak witte rijst\n150 g peultjes\n1 komkommer\n3 bosuitjes\n350 g gerookte makreel\n2 el citroensap\n100 g gemengde friseesla",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/X7pi4QA.jpeg"
},
{
"id": 149,
"name": "Rijstsalade met zalm",
"recipe": "Eieren hard koken en pellen. Rijst koken en in platte schaal af laten koelen. Ui snipperen. Paprika, mango en zalm in stukjes snijden. Olijven halveren. In een kom zure room, mayonaise en ketchup roeren. Zout en peper erdoor. Rijst erdoor scheppen. Mengen met ui, paprika, mango, zalm, maïs, doperwtjes, olijven en kappertjes. Garneren met plakjes ei.",
"ingredients": "2 eieren\n400 g rijst\n0,5 ui\n1 rode paprika\n1 blik mangoschijfjes (425 g)\n1 blik zalm (440 g)\n1 blik maïs (150 g)\n1 blik doperwtjes (150 g)\n12 gevulde olijven\n1 bekertje zure room\n4 el mayonaise\n1 el tomatenketchup\n2 el kappertjes\nzout\npeper",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 351,
"name": "Risotto met garnalen en bieslook",
"recipe": "Verhit 2 el olie in een pan met dikke bodem en fruit de ui op een lage stand in circa 5 minuten zacht. Voeg de rijst toe en roer door de olie. Giet 150 ml visbouillon bij de rijst en roer tot de bouillon is opgenomen. Voeg steeds een scheut bouillon toe en blijf roeren tot de bouillon is opgenomen door de rijst. Na circa 20 minuten roeren is de risotto beetgaar. Verhit intussen 1 el olie en bak hierin de garnalen om en om in circa 5 minuten gaar. Schep ze samen met de bieslook door de risotto.",
"ingredients": "3 el olijfolie\n1 ui (fijngesnipperd)\n300 g risottorijst\n600 ml visbouillon van 1 tablet (heet)\n400 g grote garnalen (gepeld)\n1 handje bieslook (gehakt)",
"servings": 4,
"serveWith": "geraspte Parmezaanse kaas",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/flIUMwz.jpeg"
},
{
"id": 274,
"name": "Risotto met gegrilde voorjaarsgroenten",
"recipe": "Verwarm de oven voor op 100 °C. Snijd de harde uiteinden van de asperges en schil de asperges indien nodig licht met een dunschiller. Snijd de venkelknol eerst doormidden en daarna in dunne plakken. Houd wat venkelgroen apart om te garneren. Verwarm een grillpan en bestrijk de groenten met 1 el olie. Gril de groenten aan beide kanten mooi bruin en houd ze daarna warm op een schaal in de oven. Verhit de rest van de olie in een pan met dikke bodem en fruit de ui op een lage stand in 5 minuten glazig. Voeg de rijst toe en roer even om in de hete olie. Blus af met de wijn en laat de rijst de wijn opnemen. Voeg dan in gedeeltes de hete bouillon toe en roer op een lage stand steeds tot de rijst de bouillon heeft opgenomen. Het duurt 18-20 minuten tot de rijst beetgaar is. Zet de warmtebron uit en roer de boter en de helft van de kaas door de risotto. Serveer de risotto in diepe borden en schep de gegrilde groenten erbovenop. Bestrooi met versgemalen peper, wat venkelgroen en de rest van de kaas.",
"ingredients": "350 g groene asperges\n1 venkelknol, met loof\n4 el olijfolie\n1 ui fijngesnipperd\n350 g risottorijst\n100 ml witte wijn\n1 l hete groente- of kippenbouillon\n1 el boter\n50 g geraspte parmezaanse kaas",
"servings": 4,
"serveWith": "Gebakken vis",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/688MBFD.jpeg"
},
{
"id": 404,
"name": "Risotto met gerookte forel en Hollandse garnalen",
"recipe": "Pel en snipper de ui. Pel en snijd de knoflook. Laat de boter smelten in een pan met dikke bodem en fruit de ui en de knoflook 3 minuten. Voeg de risottorijst toe en bak al omscheppend tot de korrels glazig zijn. Voeg een scheutje bouillon toe, roer en laat de rijst de bouillon opnemen. Voeg, zodra de bouillon is opgenomen, weer een scheutje bouillon toe. Voeg ook een scheut witte wijn toe. Blijf roeren en bouillon toevoegen tot de rijst beetgaar is. Dit duurt ongeveer 20 minuten. Voeg na 15 minuten de doperwten toe. Snijd de bieslook en de dragon fijn. Roer de dragon door de risotto. Breng op smaak met peper en evt. zout. Voeg driekwart van de garnalen toe en schep de risotto in diepe borden. Leg er stukjes forel en de overige garnalen op. Rasp er wat citroenschil over en bestrooi met de bieslook.",
"ingredients": "1 ui\n1 teentje knoflook\n20 g boter\n300 g risottorijst\n1 l visbouillon\nscheut witte wijn\n200 g (diepvries) doperwten\n15 g bieslook\n5 g dragon\n125 g gerookte forelfilets\nzout en peper\n100 g Hollandse garnalen\n1 citroen",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/HkwX8nx.jpeg"
},
{
"id": 465,
"name": "Risotto met gerookte kip en paddenstoelen",
"recipe": "Verhit 1 el olijfolie in een hapjespan en fruit de sjalot circa 2 minuten. Blus af met 1 el balsamicoazijn. Voeg de paddenstoelen en tijm toe en bak circa 5 minuten mee. Schep de risottorijst erdoor en bak 2 minuten, tot de korrels glazig zijn. Voeg een scheut bouillon toe en roer tot deze is opgenomen. Voeg weer een scheut toe en ga zo circa 20 minuten door, tot de rijst beetgaar is. Schep de mascarpone, kip en de helft van de kaas door de risotto en warm 1 minuut door. Breng op smaak met zout en peper. Meng de rucola met de overige olijfolie en balsamico. Verdeel de risotto over diepe borden. Garneer met een pluk rucola en bestrooi met de overige kaas.",
"ingredients": "2 el olijfolie\n2 sjalotjes (gesnipperd)\n2 el balsamicoazijn\n200 g gemengde paddenstoelen (schoongeveegd, grof gesneden)\n3 el gedroogde tijm\n300 g risottorijst\n750 ml paddenstoelenbouillon\n125 g mascarpone\n2 gerookte kipfilets (in blokjes)\n75 g Parmezaanse kaas (geraspt)\n75 g rucola",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/zXsMP2E.jpeg"
},
{
"id": 150,
"name": "Risotto met gerookte zalm",
"recipe": "Bleekselderijstengels in reepjes snijden, blad apart houden voor garnering. In hapjespan olie verhitten en sjalotsnippers 1 min. fruiten. Rijst erdoor roeren en zachtjes bakken tot alle korrels glanzend en doorzichtig zijn. Reepjes bleekselderij door rijst roeren en helft van bouillon in pan schenken. Op laag vuur verwarmen tot bouillon volledig door rijst is opgenomen, zeer regelmatig roeren met houten lepel. Vervolgens steeds scheut bouillon toevoegen en al roerend helemaal laten opnemen alvorens volgende scheut erbij te schenken. Doorgaan tot risotto na 20-25 min. beetgaar en smeuïg is. Bleekselderijblad fijnsnijden. Pan van vuur nemen en roomkaas door risotto roeren. Op smaak brengen met zout en peper. Risotto in vier diepe borden scheppen en garneren met zalmreepjes en blad van bleekselderij.",
"ingredients": "1 bleekselderij\n2 sjalotten, gesnipperd\n300 g risottorijst\n750 ml tuinkruidenbouillon (van 1 1/2 tablet)\n100 g verse roomkaas naturel\n100 g gerookte zalm, in reepjes",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/9TUXWNA.jpeg"
},
{
"id": 151,
"name": "Risotto met kip en garnalen",
"recipe": "Verhit olie in pan. Bak kip rondom bruin. Neem kip uit pan. Fruit in olie uien, knoflook en paprika enkele minuten. Voeg rijst toe en roerbak tot de korrels glazig zijn. Roer paprikapoeder en cayennepeper erdoor. Verkruimel bouillontabletten erboven. Schenk er 6 dl heet water bij. Breng mengsel aan de kook. Roer ham, tomaten en kip erdoor. Laat met de deksel op de pan in 30 minuten gaar worden. Strooi 5 minuten voor eind garnalen erover. Garneer met peterselie.",
"ingredients": "6 el olie\n4 kippendrumsticks\n2 gesnipperde uien\nknoflook\n2 groene paprika's in stukjes\n300 g rijst\n1 el paprikapoeder\n1 tl cayennepeper\n2 kippenbouillontabletten\n300 g blokjes gekookte ham\n4 tomaten in stukken\n100 g garnalen\npeterselie",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/0t5akWT.jpeg"
},
{
"id": 252,
"name": "Risotto met knolselderij, wortel en salie",
"recipe": "Snijd de knolselderij in plakken en daarna in repen van 2 cm breed. Snijd de repen in schuine stukjes van 1 cm. Snijd de wortels in schuine stukjes van 1 cm. Doe de knolselderij en wortel in een ruime pan en vul aan met water tot de groente net onderstaat. Halveer de citroen en voeg toe. Bind de helft van de salie samen met keukentouw en doe in de pan. Kook de groenten in 15 min. beetgaar. Kook de laatste 3 min. de tuinerwten mee. Verhit ondertussen 3 el olie in een pan met dikke bodem. Snijd van de rest van de salie de helft van de blaadjes fijn. Bak 2 min. met de knoflook. Bak de rijst 1 min. mee. Voeg een scheut bouillon toe en roer tot deze is opgenomen. Voeg dan weer een scheut toe. Ga zo door tot de risotto gaar is. Dit duurt ca. 20 min. Giet de groenten af en neem de citroen en salie eruit. Schep de groenten met de boter en kaas door de risotto. Breng op smaak met peper en zout. Doe de deksel op de pan en laat 3 min. staan. Verhit 3 el olie en bak de laatste blaadjes salie in 3 min. knapperig. Verdeel de risotto over 4 borden en garneer met de gebakken salie.",
"ingredients": "1 knolselderij, geschild\n1 bos peen, schoongemaakt\n1 citroen, schoongeboend\n15 g bakje salie\n150 g tuinerwten\n6 el olijfolie\n2 tenen knoflook, fijngesneden\n300 g risottorijst\n1 l groentebouillon, heet\n15 g boter\n50 g jong belegen kaas, geraspt",
"servings": 4,
"serveWith": "Worst",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/7aWBCyS.jpeg"
},
{
"id": 477,
"name": "Risotto met pastinaak en paddenstoelen",
"recipe": "Pel en snipper de ui en knoflook. Schil de pastinaak en snijd in blokjes van 1,5 cm. Ris de naaldjes van de takjes rozemarijn en hak ¾ fijn. Verhit de olijfolie in een grote pan op middelhoog vuur. Fruit de helft van de ui, knoflook, risottorijst en gehakte rozemarijn tot de rijst glazig is. Voeg de pastinaak toe en laat 2 min. mee bakken. Blus af met de witte wijn. Voeg het eekhoorntjesbrood en de helft van de paddenstoelenbouillon toe. Kook de risotto op laag vuur in 20 tot 25 min. gaar. Voeg steeds een klein beetje de overige bouillon toe wanneer het vocht bijna is verdampt en roer goed door. Halveer ondertussen de grote paddenstoelen, zodat alle paddenstoelen ongeveer even groot zijn. Verwarm de roomboter in een pan op middelhoog vuur. Bak de paddenstoelen samen met de resterende ui in ongeveer 10 min. bruin. Breng op smaak met peper en zout. Roer kort voor serveren de helft van de Parmezaanse kaas door de risotto. Serveer de risotto met daarop de paddenstoelen en maak het gerecht af met de resterende Parmezaanse kaas en rozemarijn.",
"ingredients": "2 uien\n1 teentje knoflook\n200 g pastinaak\n3 takjes rozemarijn\n2 el olijfolie\n160 g risottorijst\n50 ml witte droge wijn\n5 g gedroogd eekhoorntjesbrood\n500 ml paddenstoelenbouillon\n200 g gemengde paddenstoelen\n10 g ongezouten roomboter\npeper en zout\n30 g Parmezaanse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/kOVPZCo.jpeg"
},
{
"id": 480,
"name": "Risotto met rodekool, spekblokjes en pijnboompitten",
"recipe": "Verhit de olie in een pan met dikke bodem en fruit hierin de ui circa 5 minuten. Voeg de rodekool toe en bak een paar minuten mee. Zet de warmtebron laag en voeg de rijst, kruidnagel en laurier toe. Roer kort over de bodem van de pan. Giet de wijn erbij en breng aan de kook. Voeg beetje bij beetje de bouillon toe en blijf circa 20 minuten roeren over de bodem van de pan tot de rijst de meeste bouillon heeft opgenomen. Bak intussen de spekblokjes knapperig in een droge, hete koekenpan. Voeg de pijnboompitten en rozijnen toe aan het spekvet. Roer als de risotto gaar is de boter erdoor, breng op smaak met peper en schep op borden. Verdeel de spekjes, pijnboompitten en rozijnen erover.",
"ingredients": "3 el olijfolie\n1 rode ui (gesnipperd)\n300 g rodekolen (fijngesneden, panklaar)\n300 g risottorijst\n1 kruidnagel\n1 laurierblaadje\n200 ml rode wijn\n600 ml groentebouillon van tablet\n200 g gerookte spekblokjes\n60 g pijnboompitten\n50 g rozijnen\n1 el boter",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/e3beGJq.jpeg"
},
{
"id": 152,
"name": "Risotto met rookworst en ham",
"recipe": "Ui, paprika's, bleekselderij, prei, ham en worst in stukjes snijden. In pan 30 g boter verhitten. Ui, paprika, bleekselderij, prei en ham in 3 minuten zachtjes bakken. Mengsel uit pan nemen. Rest boter toevoegen. Rijst en knoflook 2 minuten roerbakken. Mengsel, kruiden, bouillontablet, tomatenpuree en 6 dl water toevoegen. Aan de kook brengen en in 20 minuten gaar laten worden. Na 10 minuten worst toevoegen. Af en toe omscheppen.",
"ingredients": "2 uien\n1 groene paprika\n1 rode paprika\n4 stengels bleekselderij\n1 prei\n1 dikke plak gekookte ham (150 g)\n1 rookworst (350 g)\n50 g boter\nknoflook\n1 pak rijst (375 g)\n1 tl cayennepeper\n2 laurierblaadjes\n1 tl oregano\n1 vleesbouillontablet\n1 blikje tomatenpuree (70 g)",
"servings": 4,
"serveWith": "gebakken ananas",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/UU0oKaO.jpeg"
},
{
"id": 485,
"name": "Risotto met venkel en garnalen",
"recipe": "Verhit de boter in een grote koekenpan en bak hierin de uien glazig. Voeg de prei en venkel toe en roerbak 10 minuten. Voeg de knoflook en rijst toe en bak tot de rijst glazig is. Giet de azijn erbij en bak kort tot het vocht is opgenomen. Giet steeds de scheut bouillon erbij en wcht tot die is opgenomen. Giet room erbij en roer kort door. Breng op smaak met nootmuskaat. Bestrooi met de kaas en bak nog 5 minuten verder. Verdeel de risotto over borden en bestrooi met de peterselie.",
"ingredients": "50 g boter\n2 uien (gesnipperd)\n1 prei (in ringen)\n2 venkelknollen (in kleine blokjes)\n2 teentjes knoflook (fijngehakt)\n300 g risottorijst\n4 el wittewijnazijn\n800 ml groentebouillon (heet)\n100 ml room\nnootmuskaat\n300 g Hollandse garnalen of\n300 g garnalen\n50 g Parmezaanse kaas (geraspt)\n3 el peterselie (fijngehakt)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/ilbaHev.jpeg"
},
{
"id": 288,
"name": "Risotto met witlof, kaas en cashewnoten",
"recipe": "Snijd eventueel de binnenste kern uit de witlofstronkjes. Verdeel het witlof in reepjes van 1 cm en besprenkel met citroensap. Verhit de olijfolie en fruit hierin de knoflook en ui. Voeg de rijst toe en schep deze om totdat alle korrels glanzen. Giet de bouillon erbij tot de rijst net onderstaat en roer tot de bouillon is opgenomen door de rijst. Herhaal dit en blijf goed roeren tot de risotto na 15-20 minuten beetgaar is. Schep de witlofreepjes, boter, zout, peper en de helft van de kaas erdoor en verwarm nog 1-2 minuten op een lage stand. Bestrooi de risotto voor het serveren met de rest van de kaas, cashewnoten en lente-ui.",
"ingredients": "4 stronkjes witlof\n2 el citroensap\n2 el olijfolie\n1 teentje knoflook gehakt\n1 rode ui gesnipperd\n350 g risottorijst\n1 l hete groente- of kruidenbouillon\n50 g boter\n75 g parmezaanse kaas grof geraspt of in krullen\n50 g cashewnoten grof gehakt\n1 lente-/bosuitje in ringen",
"servings": 4,
"serveWith": "hamblokjes door risotto, tomatendalade",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/wk9KL4k.jpeg"
},
{
"id": 153,
"name": "Rode kool",
"recipe": "Snij de rode kool zo dun mogelijk. Fruit ui in boter. Voeg rode kool, wijn, laurier, peper, zout, jeneverbessen, suiker en kruidnagels toe. Op laag vuur 1 uur (minstens) smoren. Voeg appelschijfjes en azijn toe. Laat nog 15 min zachtjes koken.",
"ingredients": "1 rode kool\n1 ui\n250 ml rode wijn\nlaurier\njeneverbessen\n1 el suiker\n5 kruidnagels\n1 appel in schijfjes\nazijn",
"servings": 4,
"serveWith": "aardappelpuree, runderstoofpot",
"protein": "Vega",
"starch": "Aardappel",
"photo": null
},
{
"id": 279,
"name": "Rodekoolschotel met peer",
"recipe": "Verwarm de oven voor op 200 °C. Schil de peren, snijd ze in 4 parten en verwijder het klokhuis. Snijd de parten in blokjes. Bedek de bodem van de ingevette ovenschaal met de rookworst. Meng in een schaal de rodekool met de peer en de crème fraîche, breng op smaak met peper en zout. Verdeel over de rookworst. Verdeel de ui erover en dek af met de aardappelgratin. Bak in de oven in ca. 25 min gaar.",
"ingredients": "2 handperen\n350 g rookworst Gelders, in plakjes\n450 g rodekool met appel (diepvries; ontdooid)\n125 ml crème fraîche\n1 rode ui, in ringen\n800 g aardappelgratin",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/CWb5oPF.jpeg"
},
{
"id": 462,
"name": "Rode-uientaart met geitenkaas",
"recipe": "Verwarm de oven voor tot 180 °C. Verhit in een hapjespan de olie en fruit de uien ca. 5 min. op halfhoog vuur. Voeg de tijm toe en breng op smaak met versgemalen zwarte peper. Draai het vuur laag, leg het deksel op de pan en stoof de uien in 15 min. zacht. Schep af en toe om. Rasp intussen de kaas. Rol het bladerdeeg met het bakpapier uit over de bakplaat en bestrooi met de helft van de kaas. Verdeel er de gestoofde uien over, maar laat een rand van 1 cm deeg vrij. Vouw de rand rondom terug over de ui. Verdeel de olijven over de uien en strooi er de rest van de geraspte kaas over. Bak de taart 20 min. in de voorverwarmde oven tot het deeg goudgeel en knapperig is. Neem uit de oven en verdeel in 4 stukken.",
"ingredients": "5 rode uien\n1 tl gedroogde tijm\n150 g jong belegen geitenkaas 30+\n1 vers bladerdeeg (rol)\n175 g gemengde olijven zonder pit",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/6QMrtvr.jpeg"
},
{
"id": 399,
"name": "Roerbakmie met kip en paddenstoelen",
"recipe": "Kook de mie volgens de aanwijzingen op de verpakking. Verhit de olie in een wok. Bak de kipfilet in 4 min. rondom bruin en gaar. Voeg de shiitake, de paprika en de bosui toe en bak 2 min. mee. Voeg het en de kruidenmix toe. Breng aan de kook. Giet de mie af en meng met de cashewnoten door de kip met groenten. Schep de mie in diepe borden.",
"ingredients": "350 g mienestjes\n1 pakje Honig mix voor bami speciaal\n3 el olijfolie\n300 g kipfilet\n100 g shiitake\n1 rode paprika\n2 bosuitjes\n100 g ongezouten cashewnoten\n100 ml water",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/HfWeDaR.jpeg"
},
{
"id": 154,
"name": "Roergebakken biefstuk met kokos",
"recipe": "Marineer biefstuk 15 minuten in wat kokosmelk en ketjap. Kook mihoen. Roer santen door ½ dl kokend water en laat oplossen. Roer sambal, suiker, limoensap en kokosmelk erdoor. Biefstuk in reepjes snijden. Snipper sjalotje. In wok sjalotje 1 min fruiten. Biefstuk toevoegen en 1½ min bakken. Groenten toevoegen. Op hoog vuur 2 min roerbakken. Kokossaus erdoor en 1 min verwarmen. Mihoen door groenten scheppen. 2 min verwarmen.",
"ingredients": "125 g mihoen\n3 el santen\n4 tl sambal oelek\n2 tl witte basterdsuiker\n2 el limoensap\n4 el kokosmelk\n200 g biefstuk\n1 sjalotje\n400 g tjap tjoy mix",
"servings": 2,
"serveWith": "seroendeng",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/aziR0Fq.jpeg"
},
{
"id": 155,
"name": "Roergebakken kalkoen",
"recipe": "Bosuitjes in 1 cm stukjes snijden. Gember fijnsnijden. Bak kalkoen 2 min. Sambal, limoenrasp en bosuitjes toeoegen. Bak 3 min. Gember en oestersaus toevoegen en 1 min meewarmen. Cashewnoten erdoor. Koriander erover.",
"ingredients": "3 bosuitjes\n1 limoen\n3 gemberbolletjes\n2 el olijfolie\n500 g kalkoen in reepjes\n2 tl sambal oelek\n3 el oestersaus\n100 g cashewnoten\nverse koriander",
"servings": 4,
"serveWith": "rijst, gemengde sla",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/KTVL7va.jpeg"
},
{
"id": 156,
"name": "Roergebakken kip",
"recipe": "Kip in reepjes snijden. In wok reepjes 3 min bakken. Prei, amandelen en gemberpoeder toevoegen en 3 min meebakken. Sojasaus en gember erdoor roeren.",
"ingredients": "2 kipfilets (of gemarineerde kalkoen)\n500 g prei\ngesneden\n45 g amandelen\n1 tl gemberpoeder\n2 el sojasaus\n2 el gembersiroop",
"servings": 2,
"serveWith": "mie",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/A144mco.jpeg"
},
{
"id": 157,
"name": "Roergebakken noedels met garnalen",
"recipe": "Mie bereiden; ui in ringen snijden. Knoflook en ui 1 min roerbakken. Sugarsnaps 2 min meebakken. Sambal, tomatensap en oestersaus erdoor. Afdekken en 2 min stoven. Mie en garnalen erdoor. 3 min opwarmen.",
"ingredients": "250 g eiermie\n2 rode uien\n2 teentjes knoflook\n125 g panklare sugarsnaps\n2 tl sambal badjak\n1,5 dl tomatensap\n2 el oestersaus\n250 g garnalen",
"servings": 2,
"serveWith": "",
"protein": "Vis",
"starch": "Noedels",
"photo": "https://i.imgur.com/v3EvQjj.jpeg"
},
{
"id": 158,
"name": "Roergebakken rookworstschotel",
"recipe": "Snij rookworst, wortels, boontjes en prei in stukjes. Bak worst in olie. Haal er weer uit. Roerbak aardappelblokjes, worteltjes en boontjes gedurende 5-10 min. Prei, knoflook, rasp, sap en worst erbij. 3 min bakken. Gehakte bieslook en peterselie erover.",
"ingredients": "1 rookworst 350 g\n300 g diepvries aardappelblokjes\n125 g worteltjes\n125 g sperzieboontjes\n1 prei\n1 teentje knoflook\n4 el olie\n1 tl sinaasappelrasp\n2 el sinaasappelsap\npeterselie\nbieslook",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/MilBTk4.jpeg"
},
{
"id": 159,
"name": "Roergebakken sperziebonen met casselerrib",
"recipe": "Bak aardappeltjes 10 min. Bak ui en sperziebonen in andere pan 6 min. Casselerrib toevoegen en 3 min meebakken. Cherrytomaatjes en kruiden toevoegen. Aardappelen op smaak brengen met chilipoeder.",
"ingredients": "600 g gebroken sperziebonen\n350 g Casselerrib in reepjes\n1 ui gesnipperd\n750 g krieltjes\n250 g cherrytomaatjes\n2 tl Italiaanse kruiden\n1 tl chilipoeder",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/s5exw5q.jpeg"
},
{
"id": 418,
"name": "Romig zalm-groentepannetje",
"recipe": "Kook de rijst volgens de verpakking gaar. Breng de room aan de kook en breng op smaak met aromat. Voeg de groenten toe en laat deze ca 3 min sudderen. Voeg de zalm toe en laat het geheel nog 3 min sudderen. Bestrooi met peterselie en serveer met de rijst.",
"ingredients": "200gr diepvries zalmfilet, ontdooid en in blokjes\n400gr snelkookrijst\n680gr doperwtjes met wortel, uitgelekt\n250 ml slagroom of kookroom\n2 tl aromat\n1 takje peterselie, fijngehakt",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/4rF05tu.jpeg"
},
{
"id": 323,
"name": "Romige biefreepjes met champignons",
"recipe": "Fruit de ui circa 4 minuten. Voeg de champignons, rozemarijn en knoflook toe en roerbak circa 3 minuten op een hoge stand. Voeg de crème fraîche toe en breng snel aan de kook. Laat enkele minuten inkoken en bind met de boter. Kook intussen de pasta beetgaar. Bestrooi het vlees met zout en peper. Vet een koekenpan in en bak hierin het vlees op een hoge stand in 2 porties bruin. Schep het vlees door de champignonsaus en breng op smaak met zout en peper. Serveer met de pasta.",
"ingredients": "1 rode ui, gesnipperd\n300 g gesneden champignons\n2 takjes rozemarijn, alleen de naaldjes, grof gehakt\n2 teentjes knoflook, grof gehakt\n200 ml crème fraîche of room\n1 el koude boter of 1 tl allesbinder\n300 g pastaschelpjes\n400 g bieflapjes of biefstuk, in dunne reepjes",
"servings": 4,
"serveWith": "broccoli",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/yK1n2fD.jpeg"
},
{
"id": 459,
"name": "Romige broccolisoep met kaascrostini",
"recipe": "Verwarm de ovengrill voor. Kook de aardappels in circa 15 minuten gaar in de bouillon. Voeg de laatste 10 minuten van de kooktijd de broccoli toe. Snijd intussen de ciabatta in de lengte open en besprenkel met olijfolie. Wrijf vervolgens met een half teentje knoflook stevig over de binnenkant van het broodje. Leg de kaas erop en zet onder de grill totdat de kaas gesmolten is. Pers de overige knoflook en voeg toe aan de soep. Pureer met een staafmixer tot een romige soep. Voeg eventueel wat extra water toe als de soep te dik is en breng op smaak met zout en peper. Serveer de soep met de kaascrostini.",
"ingredients": "100 g kruimige aardappels (geschild, in stukken)\n350 ml groentebouillon\n1 kleine broccoli (in roosjes)\n1 ciabattabroodje\n1 el olijfolie\n1 teentje knoflook (gehalveerd)\n50 g brie of 50 g blauwe kazen",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/jARr2PB.jpeg"
},
{
"id": 413,
"name": "Romige courgettequiche met Paturain",
"recipe": "Verwarm de oven voor op 180 °C. Schaaf met een kaasschaaf de courgettes in de lengte in linten. Halveer de romaatjes. Snijd de selderij fijn. Klop de eieren los en meng met de selderij en Paturain Cuisine. Breng op smaak met peper en eventueel zout. Snijd de plakken rauwe ham in reepjes. Bekleed de quichevorm met het bladerdeeg. Meng de courgettelinten en ham door het eimengsel en verdeel over het bladerdeeg. Verdeel de romaatjes erover met de snijkant naar boven. Bak de quiche in ca. 45 min. iets onder het midden van de oven goudbruin en gaar. Neem uit de oven en laat 15 min. afkoelen.",
"ingredients": "2 courgettes\n250 g romaatjes\n10 g verse selderij\n4 middelgrote eieren\n185 g Paturain Cuisine knoflook & fijne kruiden\n100 g coburgerham\n270 g vers bladerdeeg",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/lrz6wJr.jpeg"
},
{
"id": 242,
"name": "Romige kipfiletreepjes uit de oven",
"recipe": "Verwarm de oven op 200 °C. Snij kipfilet in reepjes. Roerbak kipfilet met uitgeperste knoflook 10 min in wok. Schep kipfilet in ovenschaal. Snij tomaten in stukjes en verdeel over kip. Klop de eieren los en voeg Boursin toe. Roer goed door tot glad mengsel ontstaat. Giet mengsel over kip en tomaat en bak 15 min in oven.",
"ingredients": "4 kipfilets\n4 vleestomaten\n150 g Boursin met tuinkruiden\n1 teentje knoflook\n2 eieren",
"servings": 4,
"serveWith": "basmatirijst komkommersalade",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/Djz64ZO.jpeg"
},
{
"id": 250,
"name": "Romige kip-kerrie",
"recipe": "Kook de rijst volgens de aanwijzingen op de zijkant van de verpakking. Verhit intussen de olie in een koekenpan en fruit de ui 2 min. Bestrooi de kip met kerriepoeder en bloem, zorg dat de kip rondom bedekt is. Voeg de kip toe aan de uien en bak in 4 min. goudbruin. Voeg de paprika toe en bak 1 min. mee. Voeg de crème fraîche en 50 ml water toe en breng aan de kook. Laat op laag vuur nog 5 min. garen. Voeg de laatste 3 min. de doperwten toe en breng op smaak met peper en zout.",
"ingredients": "300 g rijst\n2 el olijfolie\n2 rode uien, in parten\n500 g kip, in reepjes\n2 tl kerriepoeder\n2 el bloem\n2 rode paprika’s, in reepjes\n200 ml crème fraîche\n250 g doperwten (diepvries)",
"servings": 4,
"serveWith": "schijf ananas",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/Bcq8NRc.jpeg"
},
{
"id": 292,
"name": "Romige knolselderij met komijnekaas uit de oven",
"recipe": "Verwarm de oven voor op 200 °C. Schil en snijd de knolselderij in blokjes. Pel en snipper de uien. Pel en snijd de knoflook fijn. Snijd de ham in blokjes. Rasp de komijnekaas. Verhit een scheutje olie in een pan en fruit de ui, knoflook en nootmuskaatpoeder circa 2 minuten. Voeg de knolselderij en de ham toe en bak circa 4 minuten. Schenk de kookroom erbij en strooi de komijnekaas eroverheen. Schuif de pan in de oven en rooster circa 20 minuten. Breng een pan met water en een beetje zout aan de kook.Schil en snijd de aardappels in gelijke stukken. Kook de aardappels in circa 20 minuten gaar. Giet af en stoom droog. Breng op smaak met een beetje zout en versgemalen peper. Halveer de cherrytomaten. Schil de peer, verwijder het klokhuis en snijd de peer in blokjes. Meng voor de dressing in een grote kom de honing en de witte wijnazijn. Schenk al roerend de olijfolie extra vierge erbij. Breng de dressing op smaak met een beetje zout en versgemalen peper. Meng de cherrytomaten, peer en de waterkers door de dressing. Verdeel de romige knolselderij met komijnekaas uit de oven, de aardappels en de salade over borden.",
"ingredients": "1 knolselderij\n2 rode uien\n2 teentjes knoflook\n100 g achterham (dikke plak)\n100 g komijnekaas\n1 tl nootmuskaatpoeder\n800 g vastkokende aardappels\n200 ml kookroom\n250 g cherrytomaten\n1 handpeer\n1 el honing\n1 el witte wijnazijn\n2 el olijfolie extra vierge\n75 g waterkers",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/vtreNls.jpeg"
},
{
"id": 160,
"name": "Romige pasta met kip en courgette",
"recipe": "Kook de pasta volgens de aanwijzing op de verpakking beetgaar. Halveer de courgettes in de lengte en snijd ze vervolgens in plakjes. Verhit de olijfolie in een hapjespan. Bestrooi de kipblokjes met zout en peper en bak ze in 4-5 minuten rondom bruin. Schep de kipblokjes uit de pan en houd ze (onder aluminiumfolie) warm. Bak de ui en plakjes courgette 5 minuten in het achtergebleven bakvet. Voeg de kip aan de courgette toe en pers de teentjes knoflook erboven uit. Fruit de knoflook 1 minuut zachtjes mee. Verkruimel de bouillontablet erboven, voeg de kookroom toe en laat het geheel even zachtjes doorkoken. Voeg peper naar smaak toe. Schep de pasta door de saus en verdeel dit over vier borden. Bestrooi met de geraspte kaas.",
"ingredients": "350 g schelpjespasta\n2 courgettes\n400 g kipfilet, in blokjes\n200 ml kookroom\n50 g geraspte pittige kaas\n1 ui, gesnipperd\n2 teentjes knoflook\n1/2 tuinkruidenbouillontablet",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/wizwpVK.jpeg"
},
{
"id": 468,
"name": "Romige pastaschotel met gehakt",
"recipe": "Verwarm de oven voor tot 180 °C. Kook de penne in ruim water met zout volgens de aanwijzingen op de verpakking beetgaar. Verhit in een hapjespan of wok de helft van de olie. Bak alle groenten met de knoflook, de rode peper en Italiaanse kruiden in 6-8 min. beetgaar. Verhit intussen de laatste olie in een koekenpan. Bak het gehakt in 2 min. rul. Giet de penne af. Meng de penne met het gehakt door de groenten. Schep er de tomatensaus en de crème fraîche door. Breng op smaak met zout en peper. Schep de pasta in een ovenschaal. Bestrooi met de kaas. Bak de pastaschotel in de voorverwarmde oven in ca. 25 min. goudbruin.",
"ingredients": "330 ml tomato fritto\n300 g penne\n4 el olijfolie\n1 ui\n2 rode paprika's\n2 tenen knoflook\n1 rode peper\n1 el Italiaanse mix kruiden\n270 g rundergehakt\n125 ml crème fraîche\n100 g geraspte belegen kaas\n1 snufje zout\n1 courgette\n1 aubergine",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/GS7YVNe.jpeg"
},
{
"id": 432,
"name": "Romige prei-dragonpasta met blauwe kaas",
"recipe": "Kook de pasta gaar volgens de bereidingswijze op de verpakking. Pel en snipper de ui. Pel en snijd de knoflook fijn. Halveer de preien in de lengte. Was en snijd de preien in halve ringen. Verhit een scheutje olie in een pan en fruit de ui en knoflook circa 2 minuten. Voeg de prei toe en bak circa 5 minuten mee. Snijd de zongedroogde tomaten fijn. Snijd de olijven in ringetjes. Voeg de zongedroogde tomaten, olijven, gorgonzola en de mascarpone toe. Breng het geheel aan de kook en roer tot de gorgonzola is opgelost in de saus. Rooster de pijnboompitten in een droge koekenpan in circa 4 minuten goudbruin. Pluk en snijd de dragon fijn. Voeg de doperwten, pijnboompitten en de dragon toe aan de saus en warm goed door. Roer de pasta door de saus. Breng de romige prei-dragonpasta met blauwe kaas op smaak met rasp van de citroen en versgemalen peper.",
"ingredients": "300 g volkoren penne\n2 rode uien\n2 teentjes knoflook\n2 preien\n100 g zongedroogde tomaten\n100 g zwarte olijven zonder pit\n100 g gorgonzola\n200 ml mascarpone\n65 g pijnboompitten\n0.5 bosje dragon\n200 g doperwten\n1 citroen",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/1rpHJOK.jpeg"
},
{
"id": 396,
"name": "Romige preirisotto met tijm",
"recipe": "Verhit in een hapjespan de olijfolie. Fruit de ui 1 min. Schep de prei erdoor en bak nog 3 min. Voeg de risottorijst toe en bak tot de korrels glanzen en glazig zijn. Schenk het warme water in 3 delen bij de rijst; voeg het volgende deel pas toe als het vorige door de rijst is opgenomen. Roer regelmatig. Kook de rijst zo in 25 min. beetgaar. Ris intussen de blaadjes van 3 takjes tijm. Neem de risotto van het vuur. Roer de crème fraîche, de tijmblaadjes en de helft van de kaas erdoor. Breng de risotto op smaak met peper. Schep de risotto op 4 borden, bestrooi met de rest van de kaas en garneer met de overige takjes tijm.",
"ingredients": "2 el olijfolie\n2 uien, gesnipperd\n400 g gesneden prei\n300 g risottorijst\n125 g crème fraîche\n50 g Parmezaanse kaas\n7 takjes tijm\n1 l warm water\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/0LwkojF.jpeg"
},
{
"id": 417,
"name": "Romige ratatouille met stokbrood",
"recipe": "Verhit in een ruime Braadpan de olijfolie. Schep de courgette, aubergine, paprika en ui door de olie en bak 6 min. Verwarm de oven voor tot 220°C. Voeg de tomaten toe aan de groenten en smoor in 8-10 min. gaar. Voeg de knoflook en tijm toe en breng de groenten op smaak met peper. Schep de groenten in de ovenschaal of braadslede. Meng in een schaal de roomkaas met de eieren en melk. Schep het kaas-eimengsel over de groenten. Bak de groenten 10-15 min. in de voorverwarmde oven. Serveer met het stokbrood.",
"ingredients": "90 g Paturain knoflook en fijne kruiden\n3 el olijfolie\n1 courgette\n1 aubergine\n2 rode paprika's\n3 uien\n6 tomaten\n1 teen knoflook\n3 takjes tijm\n2 eieren\n50 ml melk\n1 stokbrood\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/zMMpxO5.jpeg"
},
{
"id": 455,
"name": "Romige tagliatelle met wintergroenten",
"recipe": "Schil en was de knolselderij en snijd de knol in plakken van 1 cm dik. Snijd vervolgens de plakken in kleine blokjes. Verhit de boter in een grote koekenpan en bak hierin de blokjes knolselderij samen met de champignons ca. 5 min. tot de knolselderij beetgaar is. Schep voortdurend om. Voeg de room toe en laat deze kort meekoken met de groenten. Breng alles op smaak met de nootmuskaat, peper en een klein beetje zout. Kook de tagliatelle beetgaar in ruim kokend water met een klein beetje zout. Giet de pasta af en roer deze samen met de veldsla door de knolselderijsaus. Verdeel het gerecht over de borden en rasp er wat Parmezaanse kaas overheen. Bestrooi de pasta eventueel nog met peper uit de molen.",
"ingredients": "1 kleine knolselderij (ca. 700 g)\n2 el boter\n250 g champignons in kwarten\n2 dl slagroom\n1 tl geraspte nootmuskaat\n300 g tagliatelle\n75 g veldsla\n100 g Parmezaanse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/9gocDel.jpeg"
},
{
"id": 371,
"name": "Romige witlofschotel met zalm",
"recipe": "Verwarm de oven voor op 200 °C. Schil de aardappelen en kook ze in water met zout in 20 min. gaar. Snijd de onderkant van de stronken witlof en snijd het witlof doormidden. Verwijder de harde kern en snijd het vervolgens in repen van 2 cm. Verhit ⅔ van de olie in een koekenpan en bak het witlof in 6 min. beetgaar. Schep af en toe om. Roer de crème fraîche erdoor en breng op smaak met peper en zout. Giet de aardappelen af en vang het kookvocht op. Stamp de aardappelen met voldoende kookvocht tot een smeuïge puree. Voeg de dille toe en breng op smaak met peper en zout. Laat de zalm uitlekken. Verwijder het vel en de graten van de zalm en verdeel in stukjes. Vet de ovenschaal in met olie. Verdeel het witlof over de bodem van de ingevette ovenschaal. Leg de zalm tussen het witlof en dek af met de aardappelpuree. Maak met een vork een mooi patroon in de puree en besprenkel met de rest van de olie. Zet de schaal in het midden van de oven en bak in ca. 30 min. lichtbruin en gaar.",
"ingredients": "1,5 kg kruimige aardappelen\n600 g witlof\n3 el traditionele olijfolie\n125 ml crème fraîche\n3 tl gedroogde dille\n420 g roze zalm in blik",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/Z7EIIPQ.jpeg"
},
{
"id": 161,
"name": "Rösti maïsschotel",
"recipe": "Snijd ui en paprika klein. In koekenpan olie verhitten. Ui 3 min fruiten. Maïs, paprika en salami toevoegen. 3 min meebakken. Bevroren rösti toevoegen. Pan afdekken en in 3 min laten ontdooien. In een kom eieren loskloppen. Zout en peper erdoor. Gelijkmatig over mengsel schenken. Al roerend in 6 min knapperig en gaar bakken.",
"ingredients": "1 blikje maïs (300 g)\n1 ui\n1 rode paprika\n150 g salami blokjes\n300 g rösti (diepvries)\n2 eieren\nzout\npeper",
"servings": 2,
"serveWith": "salade",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/8OUmJlu.jpeg"
},
{
"id": 162,
"name": "Rundercassoulet",
"recipe": "Bak spek kort uit. Voeg vlees toe en braad rondom aan. Bestrooi met zout en peper. Voeg ui, knoflook tijm en wortel toe en bak kort mee. Blus af met wijn en voeg bouillontablet toe. Voeg bonen en tomaat toe en laat met deksel op pan 10 min stoven. Bestrooi met peterselie.",
"ingredients": "400 g bieflappen in reepjes\n1 flinke ui gesnipperd\n2 teentjes knoflook\n1 winterwortel in blokjes\n150 g mager rookspek in blokjes\n1/2 tl tijm\n1 glas rode wijn\n1 kruidenbouillontablet\n800 g witte bonen\n400 g blokjes gepelde tomaat\n2 el fijngehakte peterselie",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/3t5ouYw.jpeg"
},
{
"id": 302,
"name": "Rundertartaartjes met paprikaroomsaus",
"recipe": "Breng in een pan water met een beetje zout aan de kook. Pel de knoflook. Schil en snijd de aardappels in gelijke stukken. Kook de aardappels met de knoflook in de pan met water in circa 20 minuten gaar. Giet de aardappels af, bewaar het kookvocht en stoom de aardappels droog. Pureer de aardappels met een pureestamper en maak smeuïg met een scheutje kookvocht. Pel en snipper de sjalot. Verhit de boter in een pan en fruit de sjalot samen met de komijn circa 2 minuten. Voeg de bloem toe en gaar circa 2 minuten. Halveer de paprika’s en verwijder de zaadlijsten. Snijd een gele paprika in kleine blokjes en de overige paprika’s in reepjes. Bak de blokjes paprika kort mee. Voeg de room, een scheut water en de reepjes paprika’s toe en laat circa 5 minuten koken. Breng op smaak met een beetje zout en versgemalen peper. Pluk en hak de peterselie fijn en voeg de helft toe aan de paprikaroomsaus. Verhit olie in een koekenpan en bak de tartaartjes om en om circa 4 minuten. Bestrooi met een beetje zout en versgemalen peper.",
"ingredients": "2 teentjes knoflook\n800 g kruimige aardappels\n1 sjalot\n1 el boter\n1 tl komijnpoeder\n1 el bloem\n3 gele paprika's\n1 rode paprika\n250 ml kookroom\n0.5 bos peterselie\n400 g rundertartaar",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/8shLYfg.jpeg"
},
{
"id": 163,
"name": "Rundvlees gestoofd in Guinnessbier",
"recipe": "In pan op laag vuur spekblokjes in 5 min uitbakken. Uien in ringen snijden. Spek uit pan halen. Uien 3 min bakken. Sukadelapjes in blokjes snijden en bestrooien met zout, peper en bloem. Ui uit pan nemen. Boter toevoegen en vlees 5 min bakken. In steelpan bier met 1½ dl water verwarmen en bij vlees schenken. Spek en ui toevoegen. Vlees op heel laag vuur met deksel op pan in 2 uur stoven. Knolselderij en wortel in kleine plakjes snijden. Aan vlees toevoegen en nog 30 min stoven. Op smaak brengen met zout, peper en peterselie.",
"ingredients": "100 g magere spekblokjes\n2 uien\n1 kg sukadelapjes\nzout\npeper\n2 el bloem\n50 g boter\n1,5 dl Guinness\n¼ knolselderij\n30 g worteltjes\n6 takjes peterselie",
"servings": 4,
"serveWith": "aardappelpuree groene kool",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/IxE3QDL.jpeg"
},
{
"id": 284,
"name": "Salade met paprika en tomaat",
"recipe": "Neem de ansjovisfilets uit het blikje en laat uitlekken. Doe ze met de olie en azijn in een kom en pureer met de staafmixer tot een dressing. Breng op smaak met peper en zout. Leg de tomaten op een grote schaal en verdeel de paprika erover. Laat de bonen uitlekken in een vergiet en spoel af. Meng ze door de groenten. Scheur de mozzarella in stukjes en verdeel met het basilicum over de groenten. Besprenkel met de dressing.",
"ingredients": "4 ansjovisfilets\n4 el olijfolie extra vierge\n2 el balsamicoazijn\n1 schaal tasty tom tomaten, in plakken\n1 rode paprika, in dunne ringen\n800 g cannellinibonen\n125 g buffelmozzarella 22+\n15 g basilicum, alleen de blaadjes",
"servings": 4,
"serveWith": "meergranen stokbrood",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/4kU5q4J.jpeg"
},
{
"id": 239,
"name": "Salami-kaasmuffin",
"recipe": "Verwarm de oven voor tot 180 °C. Zet de muffinvormpjes op een bakblik (of in een muffinvorm) en vet ze in met wat olie. Meng het zelfrijzend bakmeel met het ei, de melk, olijfolie, een snuf zout en peper. Schep de kaas, salami, cashewnoten en bieslook erdoor. Verdeel het mengsel met behulp van twee el over de muffinvormpjes. Bak de muffins in de voorverwarmde oven ca. 15 à 20 min. goudbruin en gaar. Laten afkoelen tot lauwwarm of eet ze koud.",
"ingredients": "125 g zelfrijzend bakmeel\n1 ei\n1 dl melk\n4 el olijfolie\n75 g kaas, geraspt\n50 g salami in reepjes\n25 g cashewnoten ongezouten grof gehakt\n1 el bieslook fijngehakt",
"servings": 4,
"serveWith": "salade",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/kDmHz1n.jpeg"
},
{
"id": 304,
"name": "Sandwichspread met zalm",
"recipe": "Breng in een steelpan de dressing tegen de kook aan. Voeg de zalm toe en verwarm 1 min. zachtjes. Neem de pan van het vuur. Laat de zalm in de dressing afkoelen tot kamertemperatuur. Kook intussen de eieren in 8 min. hard. Pel de eieren en snijd ze in stukjes. Meng het ei, de tomaat en de augurk door de zalmdressing. Voeg zout en peper naar smaak toe. Snijd het stokbrood in vier stukken en snijd deze doormidden. Besmeer de onderste helft van de stokbroden met de spread en leg de bovenkanten erop.",
"ingredients": "150 ml knoflookdressing\n250 g wilde zalm in stukjes\n4 eieren\n10 snoeptomaatjes in stukjes\n4 zoetzure augurken in kleine stukjes\n1 stokbrood",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/Z5VX3cE.jpeg"
},
{
"id": 256,
"name": "Scandinavische salade met zalm",
"recipe": "Schil de aardappelen, snijd in blokjes van 1 x 1 cm en kook in water met zout in 10 min. gaar. Laat afkoelen. Meng de aardappelen met de dille, rauwkost en augurk. Roer de crème fraîche los met de mierikswortel en breng op smaak met peper en zout. Meng door de salade. Verdeel de zalm erover.",
"ingredients": "1 kg aardappelen vastkokend\n15 g dille, blaadjes fijngesneden\n300 g Hollandse rauwkost\n4 grote augurken, in plakjes\n125 ml crème fraîche\n2 tl mierikswortel\n200 g gerookte zalmfilet",
"servings": 4,
"serveWith": "Hardgekookt ei",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/YGO1B4N.jpeg"
},
{
"id": 164,
"name": "Scandinavische vissalade",
"recipe": "Komkommers over lengte halveren, zaadlijsten verwijderen en in stukken van ca. 4 cm snijden. Krieltjes bereiden volgens aanwijzingen op verpakking en afspoelen met koud water. 4 dunne plakken van citroen snijden. Rode ui in dunne halve ringen snijden. Komkommer mengen met ui en krieltjes en besprenkelen met sap van rest citroen. Dille fijnsnijden (houd iets achter ter garnering). Zure room en dille mengen en op smaak brengen met (versgemalen) peper en zout. Haring laten uitlekken en in stukken snijden. Haring en garnalen voorzichtig door dilleroom scheppen. Komkommersalade over 4 borden verdelen, vissalade erop leggen. Garneren met een plukje dille. Knäckebröd beleggen met gerookte zalm en schijfje citroen en serveren bij vissalade.",
"ingredients": "2 komkommers\n450 g krieltjes klein\n1 citroen\n1 rode ui\n5 g verse dille\n125 ml zure room\n1 pot zure haring (355 g)\n1 bakje roze garnalen (125 g)\n0,5 pak knäckebröd (a 200 g)\n1 pak gerookte zalm (200 g)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/qKiv4rt.jpeg"
},
{
"id": 295,
"name": "Selderijschotel met appels en braadworst",
"recipe": "Aardappelen in de schil koken met zout en karweizaad, pellen en laten afkoelen. Snij de aardappelen in plakjes. Selderij in 1 cm dikke plakken snijden, schillen en in 250 ml water met zout en bouillon 15 minuten laten koken. Afgieten en het kookvocht bewaren. Appels wassen, in vieren delen, klokhuizen verwijderen, in plakjes snijden en besprenkelen met citroensap. Braadworst in stukken snijden, tot balletjes vormen, 2 minuten koken in water en uit de pan halen. Prei wassen en in ringetjes snijden. Een ovenschotel met 10 g boter bestrijken. Vleesballetjes en tweederde van de preiringetjes in de ovenschotel leggen. Hierop afwisselend de in stukjes gesneden selderij en appel scheppen. Bestrooien met peper en marjoraan en besprenkelen met het kookvocht van de selderij. Bedekken met plakjes aardappel en strooi kaas en de vlokjes boter erover. In de oven op 220 °C ongeveer 40 min laten garen. De resterende preiringetjes 4 minuten blancheren en voor het serveren over de slederijschotel strooien.",
"ingredients": "500 g aardappelen\nkarwijzaad\n500 g knolselderij\n1 tl bouillonpoeder\n500 g appels\n1-2 el citroensap\n300 g braadworst\n100 g prei\n30 g boter\n0,5 tl majoraan\n30 g geraspte Goudse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/2Y0w8Sm.jpeg"
},
{
"id": 285,
"name": "Selderijstoof met Duitse biefstuk",
"recipe": "Pel en snipper de ui. Pel en snijd de knoflook grof. Schil en snijd de aardappels in blokjes. Verhit een scheutje olie in een pan en bak de ui, knoflook en de aardappels circa 4 minuten. Schenk het water erbij en breng het geheel aan de kook. Verwijder de harde draden van de bleekselderij en snijd de stengels bleekselderij in halve maantjes. Schil en snijd de wortel in blokjes. Voeg de bleekselderij en wortel toe aan de pan met aardappels en laat circa 3 minuten koken met deksel op de pan. Snijd de tomaten in blokjes. Giet de linzen af en spoel ze schoon. Voeg de tomaten, mosterd en linzen toe en warm circa 2 minuten door. Roer in een kommetje de maïzena aan met een scheutje water en roer door de selderijstoof. Breng de stoof op smaak met een beetje zout en versgemalen peper. Pluk en hak de bladselderij fijn. Verhit een scheut olie in een pan en bak de Duitse biefstukken om en om in 8-10 minuten goudbruin en gaar. Verdeel de selderijstoof en de Duitse biefstukken over borden. Bestrooi met bladselderij.",
"ingredients": "1 ui\n3 teentjes knoflook\n400 g aardappels\nolijfolie om in te bakken\n500 ml water\n1 stronk bleekselderij\n1 winterwortel\n4 tomaten\n400 g linzen uit blik\n2 el grove mosterd\n1 el maïzena\n0.5 bosje bladselderij\n4 Duitse biefstukken",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/JlCle6d.jpeg"
},
{
"id": 259,
"name": "Shoarmaschotel met champignons",
"recipe": "Breng ruim water met zout aan de kook en kook hierin de pastaschelpjes beetgaar. Schep ondertussen het vlees om met de bloem. Verwarm de olie en roerbak het vlees in een paar porties op middelhoge stand bruin. Neem het vlees uit de pan en roer het aanbaksel los. Doe de champignons er in één keer bij en roerbak ze op hoge stand snel bruin. Voeg de knoflook en peterselie toe en bak nog een minuut mee. Schep nu het vlees en de pastaschelpjes erdoor en breng verder op smaak met zout en peper.",
"ingredients": "300 g pastaschelpjes\n500 g gekruid shoarmavlees\n1 el bloem\n250 g champignons, schoongemaakt en doormidden\n3 teentjes knoflook, gesnipperd\n1 bos peterselie, fijngehakt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/W6bTDvP.jpeg"
},
{
"id": 165,
"name": "Siciliaanse varkenshaas",
"recipe": "Tomaten in blokjes snijden. Bosuitjes in stukjes van ½ cm snijden. In een kom 3 el olie en citroensap mengen. Munt en basilicum toevoegen. Tomaat en bosui erdoor scheppen. Eieren loskloppen in diep bord. In ander bord knoflook, fijn gekruimelde beschuiten, peterselie en oregano mengen. Varkenshaas in 1 cm plakken snijden. Varkenshaas eerst door ei en dan door paneermeel halen. Bak varkenshaas 5 min. Plakken op bord leggen. Tomaatmengsel erover en garneren met basilicum.",
"ingredients": "2 trostomaten\n4 bosuitjes\n8 el olijfolie\n1 el citroensap\nmunt\nbasilicum\n2 eieren\n2 teentjes knoflook\n5 beschuiten\npeterselie\n1 tl oregano\n2 korte varkenshaasjes à 300 g",
"servings": 4,
"serveWith": "gegratineerde aardappels",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/KZc63Dm.jpeg"
},
{
"id": 276,
"name": "Snijbonenstamppot met cashewnoten",
"recipe": "Breng een pan met water en een beetje zout aan de kook. Schil en snijd de aardappels in gelijke stukken. Kook de aardappels in de pan met water in circa 15 minuten gaar. Giet de aardappels af en stoom ze droog. Breng een pan met water en een beetje zout aan de kook. Snijd de snijbonen in dunne, schuine reepjes. Kook ze in circa 3 minuten beetgaar. Giet de bonen af en laat ze uitwasemen. Verwarm de melk. Pureer de aardappels met een pureestamper en maak smeuïg met de melk. Roer de snijbonen door de puree en breng op smaak met nootmuskaat en een beetje zout en versgemalen peper. Rooster de cashewnoten circa 5 minuten op middelhoog vuur. Verhit een scheut olie in een koekenpan en bak de saucijsjes op middelhoog vuur in circa 8 minuten gaar. Voeg de tomatenpuree toe en bak kort mee. Halveer de cherrytomaten.Voeg de cherrytomaten en de boter toe, zet het vuur laag en laat nog circa 3 minuten pruttelen. Voeg het water toe en roer goed door. Schep de stamppot in het midden van borden. Maak een kuiltje in het midden. Leg de saucijsjes er naast en schep de jus in het kuitje. Strooi de cashewnoten over het gerecht.",
"ingredients": "800 g kruimige aardappels\n400 g snijbonen\n200 ml melk\n1 snufje nootmuskaat\n100 g cashewnoten\n4 saucijzen\n1 el tomatenpuree\n1 el boter\n250 g cashewnoten\n100 ml water",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/zeDzP3q.jpeg"
},
{
"id": 251,
"name": "Spaanse bonenschotel met vis",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Snijd de munt in reepjes. Verhit de olie in een hapjespan. Bak de chorizo in 2 min. uit. Voeg de ui toe en bak 1 min. mee. Doe de tomaten erbij en duw ze met een spatel stuk en kook op middelhoog vuur in 5 min. tot een dikke saus. Schep de bevroren tuinboontjes erdoor. Snijd de vis in stukken en leg erbij. Stoof met de deksel op de pan in 10 min. zachtjes gaar. Breng op smaak met peper en zout. Verdeel over 4 borden, bestrooi met de munt en serveer de rijst erbij.",
"ingredients": "200 g g gele rijst\n1/4 bakje munt, alleen de blaadjes\n75 g chorizo, in blokjes\n1 ui, in ringen\n2 blikken gepelde tomaten (a 400 g)\n300 g tuinbonen fijn\n300 g koolvisfilet, ontdooid",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/MhsoDul.jpeg"
},
{
"id": 166,
"name": "Spaanse kip",
"recipe": "Bak stukken kip rondom aan en haal uit pan. Fruit ui en knoflook. Roer er bloem en paprikapoeder door en bak kort mee. Voeg tomatenpuree toe en bak ook kort mee. Blus af met wijn en bouillon. Voeg gepelde tomaten en paprika toe. Doe kip terug. Stoof met deksel op pan 20 min. Voeg chorizo en olijven toe en stoof nog 15 min. Kan ook 1 uur in oven op 160 °C. Bestrooi met peterselie.",
"ingredients": "4 grote kippenpoten\n2 uien\n2 teentjes knoflook\n1 grote rode paprika\n200 g chorizo in blokjes\n2 el bloem\n1 el paprikapoeder\n1 klein blikje tomatenpuree\n1 glas rode wijn\n0,5 l kippenbouillon\n400 g gepelde tomaten\n100 g zwarte olijven\n2 el fijngehakte peterselie",
"servings": 4,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/NtMLYJn.jpeg"
},
{
"id": 223,
"name": "Spaghetti alla puttanesca",
"recipe": "Breng een pan water aan de kook. Doe de spaghetti met een snufje zout in het kokende water en kook de pasta volgens de aanwijzingen op de verpakking. Giet de olie van de tonijn in een koekenpan, maar laat de tonijn zelf in het blikje zitten. Pers de ongepelde tenen knoflook in de pan en doe er de kappertjes en de ansjovis met olie bij. Hak de Spaanse pepers en de steeltjes van de peterselie fijn en doe die er ook bij. Controleer de spaghetti en roer even. Hak de peterselieblaadjes en zet ze opzij. Roerbak het mengsel in de koekenpan 2 min. en doe er dan de tonijn en de zwarte olijven bij. Maak de stukken vis klein en roer er ten slotte een flinke snuf kaneel en de passata of de gehakte tomaten door. Laat de gekookte pasta uitlekken en houd een beetje van het kookwater apart. Kieper de spaghetti voorzichtig bij de saus in de pan. Doe er het grootste deel van de peterselieblaadjes, het sap van de citroen en een klein beetje extra vierge olijfolie bij en hussel alles goed door elkaar. Roer er om de saus te verdunnen eventueel nog een scheutje van het kookwater door. Schep de spaghetti op een schaal, strooi er het laatste restje peterselie over en serveer.",
"ingredients": "500 g spaghetti\n225 g tonijn op olie\n2 tenen knoflook\n1 el kappertjes, uitgelekt\n30 g ansjovis filets in olie\n1-2 Spaanse rode pepers\n20 g platte peterselie\n8 zwarte olijven\nkaneel\n700 g gezeefde tomaten (passata) of 800 g gehakte tomaten\n1 citroen\nolijfolie extra vierge",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/DdeBpvX.jpeg"
},
{
"id": 374,
"name": "Spaghetti met citroen en krab",
"recipe": "Kook de spaghetti beetgaar. 3 el boter in een grote koekenpan en bak hierin de ui glazig. Voeg de rode peper en het krabvlees toe en bak tot de boter lichtbruin is. Voeg de citroenrasp en -sap toe. Voeg de spaghetti toe en meng goed door de saus. Smelt intussen de rest van de boter in een andere pan en bak hierin het broodkruim goudbruin. Bestrooi de spaghetti met het broodkruim en de basilicum",
"ingredients": "300 g spaghetti\n4 el boter\n2 uien (gesnipperd)\n1 rode peper (in ringetjes)\n2 blikjes krabvlees\n2 citroenen (rasp en sap)\n4 el broodkruim\n1 handje basilicumblaadje",
"servings": 4,
"serveWith": "groene asperges",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/LMn38GJ.jpeg"
},
{
"id": 167,
"name": "Spaghetti met forel, paling, mosselen",
"recipe": "Snij forel en paling in stukjes. Bak forel 2 min. Voeg paling toe. Bak nog 2 min. Schep vis uit pan. Voeg wijn, slagroom en bouillontablet toe. Kook tot een derde is verdampt. Meng saus met vis, mosselen en peterselie.",
"ingredients": "300 g regenboogforelfilet\n50 g palingfilet\n¼ l witte wijn\n125 cl slagroom\n0,5 visbouillontablet\n150 g gekookte mosselen\n2 el fijngehakte peterselie",
"servings": 4,
"serveWith": "spaghetti salade",
"protein": "Vis",
"starch": "Pasta",
"photo": null
},
{
"id": 168,
"name": "Spaghetti met garnalen",
"recipe": "Spaghetti koken. Tomaten in plakjes snijden. Sjalotje klein snijden. Olie verhitten. Sjalotje 3 min bakken. Tomatenketchup, wijn, crème fraîche en 2 el kruiden toevoegen. Aan kook brengen. Peper, suiker en garnalen erdoor. 1 min verwarmen. Tomatenplakjes op borden leggen en daarover rest kruiden strooien. Saus over spaghetti gieten.",
"ingredients": "200 g spaghetti\n4 tomaten\n2 sjalotjes\n2 el olijfolie\n4 el tomatenketchup\n2 el droge witte wijn\n6 el crème fraîche\n4 el Italiaanse kruiden\n1 el suiker\n300 g garnalen",
"servings": 2,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/uJSzPhH.jpeg"
},
{
"id": 169,
"name": "Spaghetti met kip en tonijn",
"recipe": "Spaghetti koken. Sjalotje snipperen en 3 min fruiten. Knoflook uitpersen. Tonijn, crème fraîche, kruiden, melk en bouillonpoeder toevoegen. Aan de kook brengen. Afgedekt 4 min zachtjes laten koken. Zout en peper erbij. Kipfilet, basilicum en kappertjes toevoegen. Over spaghetti schenken.",
"ingredients": "300 g spaghetti\n1 sjalotje\n1 teentje knoflook\n2 el olijfolie\n185 g tonijn\n200 ml crème fraîche\n5 el melk\n3 tl Provençaalse kruiden\n2 tl bouillonpoeder\n150 g gebraden kipfilet\n15 g basilicum\n2 el kappertjes",
"servings": 2,
"serveWith": "olijven",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/5mQHLJJ.jpeg"
},
{
"id": 170,
"name": "Spaghetti met ontbijtspek",
"recipe": "Ontbijtspek in droge koekenpan uitbakken. Bleekselderij 3 min meebakken. Bloem 2 min bakken. Melk en slagroom erdoor roeren tot het een saus wordt. Gorgonzola erin laten smelten.",
"ingredients": "200 g reepjes ontbijtspek\n4 stengels bleekselderij in plakjes\n2 el bloem\n2 dl melk\n2 dl slagroom\n100 g blokjes gorgonzola",
"servings": 4,
"serveWith": "spaghetti",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/jurU4eO.jpeg"
},
{
"id": 171,
"name": "Spaghetti met salami",
"recipe": "Ui en salami fijnsnijden. Knoflook in olie bakken en weer verwijderen. Ui fruiten. Salami mee verwarmen. Ketchup en wijn erbij gieten. Inkoken tot dikke saus, Spaghetti koken, Kaas raspen, Kaas door saus smelten. Spaghetti door saus scheppen.",
"ingredients": "1 ui\n200 g salami\n1 el olijfolie\n40 g boter\n2,5 dl tomatenketchup\n0,5 dl droge witte wijn\n400 g spaghetti\n100 g gerookte kaas\n1 teentje knoflook",
"servings": 2,
"serveWith": "salade",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/u18oFa9.jpeg"
},
{
"id": 172,
"name": "Spaghetti met tuinbonen en zalm",
"recipe": "Kook de spaghetti volgens de aanwijzingen op de verpakking beetgaar. Rasp ondertussen de gele schil van de citroen en pers de vrucht uit. Rooster de amandelen in een koekenpan zonder boter of olie 3 min. Laat afkoelen op een bord. Verhit de olie in de koekenpan, voeg de knoflook en de tuinboontjes toe en bak 1 min. Voeg 50 ml water toe en verwarm nog 4 min. tot de tuinboontjes gaar zijn en het water verdampt is. Voeg de bosui toe en bak 1 min. mee. Roer de zalmsnippers erdoor. Meng de spaghetti met de tuinbonen en de zalm. Voeg het citroenrasp toe en breng op smaak met het citroensap en peper en zout. Verdeel de spaghetti met tuinbonen en zalm over 4 diepe borden. Garneer met de amandelen.",
"ingredients": "300 g spaghetti\n1 citroen, schoongeboend\n3 el amandelen, grof gehakt\n3 el olijfolie\n1 teen knoflook, fijngesneden\n600 g tuinbonen fijn\n3 bosuitjes, in ringetjes\n200 g gerookte zalmsnippers",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/Yve8FF6.jpeg"
},
{
"id": 173,
"name": "Spaghetti met zalm en maïs",
"recipe": "Prei 5 min bakken. Visbouillon toevoegen. 15 min koken. Slagroom erdoor roeren. Aan kook brengen. Zalm en maïs erdoor roeren. 2 min verwarmen.",
"ingredients": "1 prei\n2 el boter\n4 dl visbouillon\n1 dl slagroom\n400 g verse zalm in reepjes\n300 g maïs",
"servings": 4,
"serveWith": "spaghetti",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/frA2M5S.jpeg"
},
{
"id": 461,
"name": "Spaghetti vendura",
"recipe": "Snijd de wortelen en bleekselderij in plakjes. Verwijder de zaadlijsten van de paprika en snijd het vruchtvlees in blokjes. Pel en snipper de ui fijn. Pers de knoflook. Verhit 2 el olie in een hapjespan, fruit hierin de ui met knoflook en tomatenpuree ca. 3 min. en schep 2 el gefruite ui uit de pan. Fruit de wortel, bleekselderij en paprika ca. 3 min. in de hapjespan mee. Voeg de bouillon, tomatenblokjes en Italiaanse kruiden toe en laat de saus ca. 20 min. afgedekt sudderen. Kneed intussen in een mengkom het gehakt met ei, paneermeel, zout, peper en 2 el gefruite ui door elkaar en rol er ca. 30 kleine gehaktballetjes van. Verhit in een koekenpan de overige olie en bak hierin de gehaktballetjes in ca. 15 min. goudbruin en gaar. Kook de spaghetti volgens de gebruiksaanwijzing al dente. Pureer de groentesaus met een staafmixer en roer de gehaktballetjes door de saus. Giet de spaghetti af en verdeel deze met de saus over 4 borden.",
"ingredients": "4 wortels\n2 stengels bleekselderij\n1 groene paprika\n1 grote ui\n1 teentje knoflook\n3 el olijfolie\n1,5 el tomatenpuree\n250 ml runderbouillon\n400 g tomatenblokjes\n2 tl italiaanse kruiden\n500 g rundergehakt\n1 ei\n3 el paneermeel\n400 g spaghetti",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/03NuzP2.jpeg"
},
{
"id": 174,
"name": "Stamppot met gegrilde tilapia en courgette",
"recipe": "Kook aardappels met munt in bodempje water met zout 20 min. Laat maïs laatste 5 minuten meekoken. Snijd courgette in de lengte in plakken en bestrijk dun met olie. Gril ze 2-3 minuten per kant. Bestrooi tilapia met zout en peper en bestrijk dun met olie. Gril de vis 2-3 minuten per kant. Verhit melk in magnetron. Stamp aardappel-maïsmengsel fijn met de melk.",
"ingredients": "300 g kruimige aardappels in stukken\n1 tl gedroogde munt\n100 g maïskorrels\n1 courgette\n150 g tilapiafilet\n50 ml halfvolle melk",
"servings": 2,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/wLDhyiy.jpeg"
},
{
"id": 383,
"name": "Stevige preisoep met gerookte zalm",
"recipe": "Verhit in een soeppan de olijfolie. Fruit de ui en prei 4 min. Schep de aardappel erdoor en bak 2 min. mee. Voeg het water en de bouillonblokjes toe en breng aan de kook. Kook de soep 20 min. zachtjes. Pureer de soep van het vuur met de staafmixer. Breng op smaak met peper. Schep de soep in 4 diepe borden, verdeel er de zalmreepjes over en bestrooi met de peterselie.",
"ingredients": "3 el olijfolie\n2 uien\n700 g prei\n2 grote kruimige aardappelen (400 g)\n2 visbouillonblokjes\n50 g gerookte zalm\n2 el peterselie\n1,5 l water\n1 snufje peper",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/TynKjtO.jpeg"
},
{
"id": 175,
"name": "Stoofschotel met tonijn en paprika",
"recipe": "In braadpan olie verwarmen en ui 5 min. fruiten. Knoflook en paprikablokjes toevoegen en 2 min. meebakken. Paprikapoeder, peterselie en tomaat erdoor scheppen en nog 2-3 min. zachtjes bakken. Aardappelblokjes door paprikamengsel scheppen. Sherry, bouillontablet en 250 ml water in pan schenken en aan de kook brengen. Vuur lager draaien en geheel onafgedekt 15 min. laten stoven, tot aardappel vrijwel gaar is. Af en toe omscheppen, pittig op smaak brengen met zout en peper. Tonijn in blokjes snijden en in saus leggen. Deksel op pan leggen en gerecht nog 5 min. zachtjes stoven (niet meer laten koken), tot vis gaar is.",
"ingredients": "2 grote uien, gesnipperd\n3 teentjes knoflook, fijngehakt\n2 groene paprika's, in kleine blokjes\n1 el pikante paprikapoeder\n1/2 zakje verse peterselie (a 30 g), fijngehakt\n1 blik tomatenblokjes (400 g), uitgelekt\n750 g vastkokende aardappels (bijv. Lady Christl), in blokjes\n100 ml droge sherry\n1 visbouillontablet, verkruimeld\n4 tonijnsteaks",
"servings": 4,
"serveWith": "gemengde groene salade en brood",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/dQBJQTT.jpeg"
},
{
"id": 381,
"name": "Tagliatelle met doperwtensaus en Coburgerham",
"recipe": "Kook de tagliatelle volgens de aanwijzingen op de verpakking. Snipper ondertussen de ui en snijd de champignons in plakjes. Verhit de helft van de olie in een koekenpan en fruit de ui 2 min. Voeg vervolgens de tuinerwten toe en bak nog 2 min. mee. Verkruimel de bouillontablet erboven en voeg het hete water toe. Breng aan de kook en kook de tuinerwten in 4 min. gaar. Verhit de rest van de olie in een andere koekenpan en bak de champignons 5 min. op hoog vuur. Snijd ondertussen de ham in reepjes. Neem de tuinerwten van het vuur en roer de room erdoor. Pureer met de staafmixer tot een gladde saus. Verwarm de saus 3 min. op laag vuur. Breng op smaak met peper en eventueel zout. Schep de tagliatelle door de saus. Verdeel over de borden en serveer met de ham en champignons erop.",
"ingredients": "250 g tagliatelle\n1 ui\n400 g kastanjechampignons\n1 el traditionele olijfolie\n450 g diepvries tuinerwten\n0,5 groentebouillontablet\n150 ml heet water\n140 g Coburgerham\n125 ml kookroom",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/pdtufrG.jpeg"
},
{
"id": 470,
"name": "Tagliatelle met gerookte forel, asperges en peultjes",
"recipe": "Kook de tagliatelle met zout beetgaar. Kook de peultjes 2 minuten, giet ze af, spoel er koud water over en laat uitlekken. Verhit de olijfolie. Roerbak hierin de asperges en de knoflook 3 minuten. Voeg de peultjes toe en bak nog 2 minuten. Meng de citrusrasp door het groentemengsel. Schep de afgegoten tagliatelle, de forel, de mozzarella en 1 el dille erdoor en verwarm. Serveer het gerecht met de rest van de dille en partjes limoen.",
"ingredients": "400 g tagliatelle\n200 g peultjes\n3 el olijfolie\n250 g groene asperges (in stukken van 4 cm)\n2 teentjes knoflook (geperst)\n0.5 limoen (schil geraspt)\n0.5 limoen (in partjes)\n250 g gerookte forelfilets (in brede repen)\n125 g mozzarella (in blokjes\n2 el verse dille (gehakt)\n1 el verse dille (alleen de blaadjes)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/XjykpP0.jpeg"
},
{
"id": 176,
"name": "Tagliatelle met kalkoen en oesterzwam",
"recipe": "Snij kalkoen en oesterzwammen in reepjes. Kook de tagliatelle. Roerbak kalkoenreepjes. Voeg oesterzwammen en sjalotje toe. Bak op matig vuur 5 min. Roer kool en tijm erdoor en bak op hoog vuur nog 1 min. Breng intussen 2½ dl melk aan de kook. Verkruimel mon chou boven melk en laat die al roerende smelten. Roer maïzena tot papje met rest melk. Schenk dit al roerende door de saus. Laat tagliatelle uitlekken. Doe terug in pan en roer mon chousaus erdoor.",
"ingredients": "400 g kalkoenfilet\n1 gesnipperd sjalotje\n200 g oesterzwammen\n250 g gesneden groene kool\n0,5 tl tijm\n3 dl melk\n100 g mon chou\n2 tl maïzena\ntagliatelle",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/ldxHEjb.jpeg"
},
{
"id": 474,
"name": "Tagliatelle met paddenstoelen en kastanjes",
"recipe": "Kook de kastanjes 10 a 15 minuten zoals hier beschreven. Giet ze af en verkruimel ze na het pellen grof. Kook de tagliatelle zoals aangegeven op de verpakking en giet af. Verhit één el olie in een pan met een dikke bodem. Fruit de sjalotjes een minuut en voeg dan de paddenstoelen, knoflook, tijm en rozemarijn toe aan de pan. Bak de ingrediënten zo’n 5 minuten, voeg vervolgens de bouillon & slagroom toe en laat het geheel ca.10 minuten sudderen op laag vuur (met deksel op de pan). Voeg de tuinbonen na ongeveer 5 minuten toe, zodat deze nog 5 minuten mee kunnen sudderen. Verwarm ondertussen de oven voor op 200 °C en vet een ovenschaal in met olie. Doe de gekookte tagliatelle in de ovenschaal, roer de gekookte kastanjes & saus erdoorheen en strooi de kaas over het geheel. Gratineer het gerecht in 5-10 minuten in het midden van de oven.",
"ingredients": "200 g verse tamme kastanjes\n150 g tagliatelle\n1-2 el olie\n2 sjalotjes\n1 teentje knoflook\n400 g gemengde paddenstoelen\n1 takje tijm\n1 takje rozemarijn\n150 ml slagroom\n150 ml bospaddenstoelenbouillon\n200 g tuinbonen\n2 el geraspte Parmezaanse kaas",
"servings": 2,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/Z3J55Dv.jpeg"
},
{
"id": 392,
"name": "Tagliatelle met rivierkreeftjes",
"recipe": "Kook de tagliatelle beetgaar. Verhit intussen de olijfolie en bak hierin de sjalotten glazig. Voeg de slagroom en witte wijn toe en breng aan de kook. Zet de warmtebron op middelhoge stand, voeg citroenrasp, -sap en de kappertjes toe en breng op smaak met zout en peper. Voeg de rivierkreeftjes toe en warm kort mee. Giet de tagliatelle af en schep door de saus. Warm nog circa 3 minuten door en bestrooi met de peterselie.",
"ingredients": "300 g tagliatelle\n2 el olijfolie\n2 sjalotjes, gesnipperd\n250 ml slagroom\n100 ml witte wijn\n1 citroen, rasp en sap\n3 tl kappertjes\n200 g rivierkreeftjes\nhandje platte peterselie, fijngehakt",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/wbEDYiJ.jpeg"
},
{
"id": 177,
"name": "Tagliatelle met tonijn-preisaus",
"recipe": "Tagliatelle in water, zout en olie koken volgens gebruiksaanwijzing; intussen prei op hoog vuur in 5 minuten laten slinken; crème fraîche erdoor roeren; roomkaas erboven verbrokkelen; roerende verwarmen tot kaas gesmolten is; maïs en tonijn afgieten; tonijn in stukjes verdelen; maïs en tonijn door saus roeren; in 3 minuten warm laten worden; saus over de tagliatelle doen.",
"ingredients": "200 g tagliatelle\nzout\n0,5 el olie\n25 g boter\n250 g gesneden prei\n1 bekertje crème fraîche\n100 g verse roomkaas\npeper\n150 g maïs\n1 blikje tonijn in olie (220 g)",
"servings": 2,
"serveWith": "tomatensalade",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/sRDllMs.jpeg"
},
{
"id": 422,
"name": "Tagliatelle met venkel, garnalen en dille",
"recipe": "Kook de pasta beetgaar. Verhit de boter en bak hierin de ui en venkel circa 10 minuten op middelhoge stand. Voeg de garnalen en de room toe en verwarm al roerend. Roer de citroenrasp en de helft van de dille erdoor. Giet de pasta af en vang wat kookwater op. Schep de tagliatelle met 4 el van het kookwater door de saus en verwarm circa 3 minuten. Verdeel de pasta over borden en bestrooi met de rest van de dille.",
"ingredients": "350 g tagliatelle\n4 el boter\n2 uien (gesnipperd)\n1 venkelknol (dun gesneden)\n200 g garnalen\n200 ml room\n1 citroen (rasp)\n0.5 bosje dille (fijngehakt)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/xPMYxRC.jpeg"
},
{
"id": 178,
"name": "Tagliatelle met zalm-preisaus",
"recipe": "Smelt de boter in een braad- of hapjespan en stoof hierin de prei en de paprika ca. 15 minuten. Kook ondertussen de tagliatelle volgens de aanwijzingen op de verpakking. Roer de maïzena glad met 4 el melk. Roer de rest van de melk in de pan door het preimengsel en breng aan de kook. Roer het maïzenapapje erdoor en laat het al roerend binden. Roer de bieslookroomkaas en de zalmsnippers erdoor, dek de pan af en warm het gerecht op laag vuur ca. 5 minuten door. Verdeel de tagliatelle over 4 diepe borden en verdeel de zalm-preisaus erop.",
"ingredients": "30 g boter\n500 g prei, in ringen\n1 groene paprika, fijngesneden\n300 g tagliatelle\n3 el maïzena\n300 ml volle melk\n125 g roomkaas bieslook\n200 g gerookte zalm in snippers",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/YiVGv9J.jpeg"
},
{
"id": 179,
"name": "Tagliatelle met zalmroomsaus",
"recipe": "Tagliatelle koken. Wijn en visbouillon verwarmen en op hoog vuur tot 2/3 laten inkoken. Zalm in stukjes verdelen. Mascarpone door vocht roeren. Zalm aan saus toevoegen en verwarmen. Bieslook erover strooien. Saus over tagliatelle schenken.",
"ingredients": "150 g groene tagliatelle\n1 dl witte wijn\n2 dl visbouillon\n440 g rode zalm\n150 g mascarpone\n2 el bieslook",
"servings": 2,
"serveWith": "salade",
"protein": "Vis",
"starch": "Pasta",
"photo": null
},
{
"id": 436,
"name": "Taglliatelle met garnalen, tomaat en basilicum",
"recipe": "Kook de pasta beetgaar. Giet de pasta af, laat goed uitlekken en houd in afgesloten pan warm. Verhit in een koekenpan de boter. Fruit de ui en knoflook 1 minuut. Voeg de garnalen toe en bak 4 min mee. Schep de pasta en tomaten erdoor en bak nog 4 min mee. Rasp de schil van de citroen en pers de vrucht uit. Voeg citroenrasp en -sap toe aan de pasta. Breng de pasta op smaak met peper en zout en verdeel de basilicumblaadjes erover.",
"ingredients": "50 g gezouten roomboter\n400 g tagliatelle\n2 teentjes knoflook, geperst\n10 rauwe reuze garnalen, ontdooid\n250 g cherrytomaatjes, gehalveerd\n1 citroen, schoongeboend\n2 takjes basilicum, alleen blaadjes",
"servings": 4,
"serveWith": "broccoli",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/6LuQETO.jpeg"
},
{
"id": 180,
"name": "Tajine van rundvlees, pruimen en aubergines",
"recipe": "Snipper uien. Snij aubergine in blokjes en bestrooi met zout. Laat blokjes 20 minuten in vergiet staan. Dep ze droog met keukenpapier. Ontvel tomaten en snij in blokjes. Snij vlees in grote dobbelstenen en bestrooi met zout en peper. Fruit ui in olie. Bak vlees mee. Voeg aubergine, tomaat, pruimen, kaneelpoeder en honing toe. Giet zoveel water in pan dat het driekwart onder staat. Breng aan de kook en laat 2,5 uur stoven. Rooster sesamzaadjes in enkele druppels olie en strooi over gerecht.",
"ingredients": "2 uien\n1 aubergine\n400 tomaten of 0,5 l blik stukjes tomaat\n750 g doorregen riblappen\n12 gedroogde pruimen zonder pit\n2 tl kaneelpoeder\n1 el honing\n1 el sesamzaadjes",
"servings": 4,
"serveWith": "couscous",
"protein": "Vlees",
"starch": "Couscous",
"photo": null
},
{
"id": 430,
"name": "Tartaartje met basilicumsaus en gepofte tomaat",
"recipe": "Houd enkele blaadjes basilicum apart voor de garnering. Pureer de knoflook, kaas, room en de rest van de basilicum tot een frisgroene saus. Houd deze apart. Kook de tagliatelle. Rooster de tomaatjes in de olijfolie in een hete koeken- of grillpan. Bestrooi de tartaartjes met zout en peper en bak ze circa 2 minuten per kant in de boter. Schep ze uit de pan en houd warm onder aluminiumfolie. Voeg de bouillon toe aan het bakvet en kook iets in. Roer de basilicumsaus erdoor tot de saus lichtgebonden is. Serveer de tartaartjes met de saus, tagliatelle en gepofte tomaatjes. Garneer met basilicum.",
"ingredients": "1 handje verse basilicum\n2 teentjes knoflook\n25 g Parmezaanse kaas (geraspt)\n250 ml slagroom of\n300 g tagliatelle\n250 g kerstomaatjes (ingekruist)\n4 tartaartjes\n100 ml vleesbouillon",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/hqhp70E.jpeg"
},
{
"id": 270,
"name": "Tartaartje met kerriesaus",
"recipe": "Schil de aardappelen en snijd ze in stukken. Kook in water met zout in 20 min. gaar. Verhit ondertussen de olie in een koekenpan. Bestrooi de tartaartjes met peper en zout en bak ze in 8 min. bruin en net gaar; keer af en toe. Neem uit de pan en houd warm onder een deksel of aluminiumfolie. Kook de bevroren sperziebonen in weinig water met zout in 4 min. beetgaar. Fruit ondertussen de ui in het bakvet van de tartaartjes. Voeg het kerriepoeder en 50 ml water toe. Roer de aanbaksels met een spatel los. Voeg de slagroom toe en laat 4 min. inkoken. Breng op smaak met de munt, peper en zout. Leg het vlees de laatste minuut terug in de pan. Giet de aardappelen af. Verdeel de tartaartjes over 4 borden en schep de kerriesaus erbij. Serveer met de aardappelen en de sperziebonen",
"ingredients": "1 kg vastkokende aardappelen\n2 el olijfolie\n4 rundertartaartjes\n600 g gebroken sperziebonen\n1 ui, gesnipperd\n1 tl kerriepoeder\n125 ml slagroom\n1 tl gedroogde munt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/zup79Kc.jpeg"
},
{
"id": 246,
"name": "Tartaartjes met andijviesalade",
"recipe": "Schil de aardappelen, snijd ze in plakjes en kook ze in water met zout 10 min. Pel de eieren en snijd ze in stukken. Verhit 25 g boter in een koekenpan en bak de tartaartjes in 8 min. gaar. Verhit ondertussen de rest van de boter in een andere koekenpan en bak de aardappel in 5-6 min. krokant. Verdun de mayonaise met 1 el water en meng met het ei, de tomaat en naar smaak peper en zout. Doe de andijvie in een schaal en schenk er ca. 1 l kokend water over. Giet direct af, laat uitlekken en schep er het ei-tomaatmengsel door. Verdeel de tartaartjes over 4 borden. Schenk 100 ml water in de pan van de tartaartjes en roer de aanbaksels los. Voeg de mosterd toe en laat de jus 1-2 min. inkoken. Schep de jus over de tartaartjes. Leg de aardappelen erbij en serveer met de andijviesalade.",
"ingredients": "1 kg aardappelen vastkokend\n2 eieren, hardgekookt\n50 g boter\n4 rundertartaartjes\n3 el mayonaise\n2 tomaten, in stukjes\n500 g andijvie, in reepjes\n1 el grove mosterd",
"servings": 4,
"serveWith": "gepocheerd ei",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/RNynsKK.jpeg"
},
{
"id": 408,
"name": "Tarte tatin met brie en peren",
"recipe": "Verwarm de oven voor op 200 °C. Pel en snijd de uien in ringen. Verhit een klontje boter in een koekenpan en bak de uien in 5 minuten glazig. Voeg de balsamicoazijn toe en laat 2-3 minuten inkoken. Schil ondertussen de peren, snijd doormidden en verwijder het klokhuis. Snijd de peren in dunne parten. Verhit een klontje boter in de koekenpan en bak de peren in 3 minuten op hoog vuur goudbruin. Bekleed de bodem van de springvorm met bakpapier. Snijd de brie in plakken. Verdeel de parten peer over de bodem. Ris de blaadjes van 2 takjes tijm en strooi over de peren. Leg hierop de ui en daarop de brie. Laat rondom langs de rand iets ruimte vrij. Snijd het deeg bij tot een vierkant. Drapeer het deeg over de springvorm, snijd de hoeken die uitsteken iets bij en vouw de rest langs de randen iets naar binnen. Prik het bladerdeeg op een paar plekken in. Bak de tarte tatin in 20-30 minuten goudbruin en knapperig in de oven. Hak de hazelnoten grof. Rooster ze in een droge koekenpan al roerend of schuddend tot ze goudbruin zijn. Schud ze op een bord. Haal de tarte tatin uit de oven en laat 5 minuten afkoelen. Verwijder de springvorm en keer de tarte tatin om op een bord. Pluk wat toefjes tijm van het laatste takje en strooi met de hazelnoten over de tarte tatin.",
"ingredients": "4 uien\nOlijfolie\n4 tl balsamicoazijn\n2 handperen\n3 takjes tijm\n200 g brie\n1 rol bladerdeeg\n50 g hazelnoten",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/eUlSflD.jpeg"
},
{
"id": 332,
"name": "Thaise curry met speziebonen en ei",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Kook de sperziebonen in water in 6-8 min. beetgaar. Kook de eieren in 8 min. hard. Verhit in een wok de olie. Fruit de ui met de paprika 2 min. Schep de currypasta erdoor en bak nog 1 min. Schep de sperziebonen erdoor. Schenk de kokosmelk in de wok en breng aan de kook. Kook de curry 2-3 min. zachtjes. Pel intussen de eieren, halveer ze en voeg ze aan de curry toe. Verdeel de rijst over 4 borden. Schep de curry op de rijst. Garneer eventueel met koriander.",
"ingredients": "1 pakje Conimex Thaise groene curry paste\n300 g pandanrijst\n300 g sperziebonen\n6 eieren\n2 el olie\n2 uien\n1 gele paprika\n400 ml kokosmelk",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/YPiEoTm.jpeg"
},
{
"id": 308,
"name": "Thaise mihoen met pittige koolvisfilet",
"recipe": "Kook de mihoen volgens de aanwijzingen op de verpakking. Verhit de olie in een wok. Roerbak de paprika met de knoflook, gember, rode peper en bosui 1 min. Voeg de roerbakmix toe en bak nog 1 min. Draai het vuur laag. Voeg de sojasaus, de vissaus, de suiker, het limoensap, de koolvisreepjes en het water toe. Leg de deksel op de pan en stoof 3-4 min., tot de vis gaar is. Verdeel de mihoen over de borden en schep de visroerbak erop.",
"ingredients": "250 g mihoen\n2 el zonnebloemolie\n1 rode paprika\n2 tenen knoflook\n3 cm gemberwortel\n1 rode peper\n400 g Thaise roerbakmix groenten\n3 el sojasaus less salt\n2 el vissaus\n2 el donkere basterdsuiker\n1 sap van 1 limoen\n400 g koolvisfilet (vers of ontdooid uit diepvries)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Noedels",
"photo": "https://i.imgur.com/uUaIG3x.jpeg"
},
{
"id": 463,
"name": "Tian met aardappel en dilleyoghurt",
"recipe": "Verwarm de oven voor tot 200 °C. Vet de ovenschaal in (ø 24 cm). Snijd de courgette en tomaten in plakjes van 2-3 mm. Begin aan de buitenrand en schik de plakken courgette, aardappel en tomaat om en om rechtop rondom in de ovenschaal. Besprenkel de groente met de olie. Bestrooi met de kaas en peper. Bak de tian in de voorverwarmde oven in 30 min bruin en gaar. Hak intussen de dille fijn. Doe de yoghurt in een kom en pers of rasp er de knoflook boven. Meng er de helft van de dille door. Breng op smaak met peper. Neem de tian uit de oven, bestrooi met de rest van de dille en serveer met de dilleyoghurt.",
"ingredients": "1 courgette\n3 tomaten\n450 g aardappelschijfjes\n2 el olijfolie\n75 g geraspte (geiten)kaas\n15 g verse dille\n150 g yoghurt Griekse stijl\n1 teen knoflook",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/NJFH4KK.jpeg"
},
{
"id": 448,
"name": "Tikka masala gehaktballetjes uit de oven",
"recipe": "Verwarm de oven voor tot 200 °C. Snijd de paprika’s in stukken en de uien in parten. Leg de gehaktballetjes in de ovenschaal en verdeel er de paprika en ui over. Schenk er de saus over en zet de schaal 15 min. in de voorverwarmde oven. Bereid intussen de rijst volgens de aanwijzingen op de verpakking. Verdeel de rijst over 4 borden en serveer er de balletjes met groenten in tikka masala- saus bij.",
"ingredients": "1 pot Patak’s tikka masala saus\n2 rode paprika’s\n2 rode uien\n400 g varkensgehaktballetjes naturel\n300 g witte rijst",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/HxEdZzD.jpeg"
},
{
"id": 181,
"name": "Tilapia in sesamsaus",
"recipe": "Verwarm oven op 200 °C. Pers ½ citroen en knoflook. Pureer met staafmixer sesamzaad, 5 el sojaolie, citroensap, honing, bloem en knoflook tot pasta. Verhit 2 el sojaolie en bak tilapiafilets aan beide kanten 2 minuten. Schep sesampasta in ovenschaal en leg vis erop. Laat vis in oven in 6 minuten gaar worden. Bestrooi vis met peterselie.",
"ingredients": "0,5 citroen\n2 teentjes knoflook\n4 el sesamzaad\nsojaolie\n0,5 el honing\n0,5 el bloem\n250 g tilapiafilet\nverse peterselie",
"servings": 2,
"serveWith": "safraanrijst gestoomde paksoi",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 182,
"name": "Tilapia met geelrys",
"recipe": "Leg tilapiafilets naast elkaar op een schaal. Pers knoflook. Snijd peper zeer fijn. Meng peper, knoflook, koriander, komijn, 1/2 tl zout en 1 tl kurkuma tot pasta (vijzel). Meng pasta over tilapia en laat intrekken. Schil gemberwortel in plakjes. Kook water. Voeg rijst, rozijnen, kruidnagels of kaneelstokje, 1/2 tl kurkuma, gember en zout toe en laat rijst gaar koken. Bak tilapia 2-3 min per kant. Snijd citroen in partjes en serveer bij vis en rijst. Halveer geschrapte bospeen, bak wortel met 3 teentjes knoflook, peper, zout, tijm en rozemarijn. Schep voor serveren honing erdoor.",
"ingredients": "4 tilapiafilets\n5 teentjes knoflook\n1 groene peper\n1,5 tl komijn (djinten)\n1,5 tl koriander (ketoembar)\n1,5 tl kurkuma\n1 citroen\n3 cm gemberwortel of 1 tl gemberpoeder\n250 g rijst\n4 el blanke rozijnen\n4 kruidnagels of 1 kaneelstokje\nbospeen\n1/2 tl gehakte tijm\n1/2 tl gehakte rozemarijn\n1-2 el honing",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/wsFYEJ4.jpeg"
},
{
"id": 431,
"name": "Tomaten-courgetterisotto",
"recipe": "Verhit de helft van de olijfolie in een hapjespan. Fruit de ui en de knoflook 1 min. Schep de rijst erdoor en bak 2 min. tot de korrels glanzen. Voeg de wijn toe en laat deze zachtjes kokend door de rijst opnemen. Voeg de helft van de bouillon toe en kook de rijst onder regelmatig roeren in 20 min. zachtjes gaar. Schenk er, telkens als de rijst het vocht heeft opgenomen, een flinke scheut bouillon bij. Schaaf intussen de helft van de kaas in plakjes en rasp de andere helft. Verhit in een koekenpan de laatste olijfolie. Bak de courgette en de champignons in 3-4 min. beetgaar. Schep de groenten met de gezeefde tomaten door de risotto en verwarm nog 1 min. Neem de pan van het vuur. Meng de geraspte kaas door de risotto en breng op smaak met zout en peper. Schep de risotto in diepe borden en maak af met de geschaafde kaas.",
"ingredients": "100 g Heinz tomato gezeefd\n4 el olijfolie\n1 ui\n1 teen knoflook\n250 g risottorijst\n100 ml droge witte wijn\n750 ml groentebouillon\n100 g Parmezaanse kaas\n1 courgette\n250 g kastanjechampignons",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Rijst",
"photo": "https://i.imgur.com/VJA7t3t.jpeg"
},
{
"id": 382,
"name": "Tomatenrisotto met chorizo",
"recipe": "Doe de chorizo samen met de ui en de knoflook in een droge pan, de chorizo geeft voldoende vetvrij. Bak het geheel aan tot de ui glazig wordt. Voeg de tomatenpuree en de cherrytomaatjes toe. Bak dit twee minuten mee voordat je de rijst toevoegt. Bak de rijst al omscheppend mee tot de korrels glazig worden. Doe dan de tomatenblokjes en een eerste soeplepel van de groentebouillon bij de rijst in de pan. Laat de rijst de bouillon zoveel mogelijk opnemen voordat je weer een nieuwe lepel toevoegt. Herhaal dit tot de bouillon op is of de rijst helemaal gaar is. Roer de mascarpone en verse basilicum door de risotto. Verwarm het geheel tot de mascarpone gesmolten is. Serveer de tomatenrisotto met geraspte Parmezaanse kaas.",
"ingredients": "200 g chorizo, grof gesneden\n1 ui, gesnipperd\n2 teentjes knoflook, fijngehakt\n1 el tomatenpuree\n100 g cherrytomaatjes, gehalveerd\n200 g risottorijst\n400 g tomatenblokjes\n1 l groentebouillon, tegen de kook aan\n100 g mascarpone\nverse basilicum naar smaak\nParmezaanse kaas naar smaak",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/hl7gE1W.jpeg"
},
{
"id": 183,
"name": "Tonijnbiefstukjes",
"recipe": "Bestrooi tonijn met tijm. Bak plakken in 3 min bruin. Leg op borden. Schenk alle boter in pan en voeg citroensap, suiker en peterselie toe. Breng aan de kook en schep jus over tonijn.",
"ingredients": "4 plakken tonijn (2 cm dik)\n0,5 tl tijm\n2 el citroensap\n0,5 tl suiker\n1 el fijngehakte peterselie",
"servings": 4,
"serveWith": "gebakken krielaardappeltjes",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 324,
"name": "Tonijnburger met citroenmayonaise",
"recipe": "Meng de tonijn met de ui, de eidooiers en de bloem tot een stevig mengsel. Vorm er met vochtige handen 4 tonijnburgers van. Verhit de grillpan. Bestrijk de tonijnburgers met de olijfolie en gril in 4 min. aan beide kanten bruin. Meng intussen de mayonaise met het citroensap. Snijd de broodjes open en besmeer de onderste helften met de citroenmayonaise. Leg er de slablaadjes, de tonijnburgers, de tomaat en de augurk op. Dek af met de bovenste helften van de broodjes en leg op 4 borden.",
"ingredients": "2 blikjes John West tonijnstukken in olijfolie (160 g)\n1 ui\n2 eidooiers\n4 el bloem\n3 el olijfolie\n4 el mayonaise\n1 citroen\n4 ciabattabroodjes\n4 blaadjes ijsbergsla\n2 trostomaten\n8 plakjes \taugurken zoetzuur",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/LLmoeKS.jpeg"
},
{
"id": 481,
"name": "Tonijnlasagne met groene groenten en selderij-ricottasaus",
"recipe": "Verwarm de oven voor op 200 °C. Snijd de courgettes in blokjes van 1 cm (brunoise) en de selderij fijn. Laat de tonijn uitlekken in een zeef. Verhit de boter in een steelpan, voeg de bloem toe en laat al roerend op laag vuur garen tot de bloem licht begint te kleuren (roux). Dit duurt ca. 5 min. Voeg al roerend de melk toe, breng aan de kook en laat op laag vuur 5 min. zachtjes koken. Neem de pan van het vuur. Roer de ricotta en selderij door de saus en breng op smaak met peper en eventueel zout. Bedek de bodem van de ovenschaal achtereenvolgens met een laagje saus, 4 bladen lasagne, een laagje courgette en tuinerwten, een laagje tonijn en een laagje saus. Ga door met het maken van laagjes tot de lasagne, groenten, tonijn en saus op zijn. Zorg ervoor dat je met een laagje saus eindigt. Bestrooi met de kaas en bak ca. 35 min. in het midden van de oven.",
"ingredients": "2 courgette\n40 g selderij\n320 g tonijnstukken in zonnebloemolie\n40 g ongezouten roomboter\n40 g bloem\n400 ml halfvolle melk\n250 g ricotta\n250 g verse lasagne all’uovo\n450 g fijne diepvries tuinerwten\n75 g geraspte belegen kaas 48+",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/eleYdzq.jpeg"
},
{
"id": 425,
"name": "Tonijnomelet met broccoli",
"recipe": "Verwarm de oven voor op 190 °C. Bekleed de springvorm met bakpapier. Snijd de aardappelen in blokjes en kook 5 min. in water met zout. Kook de broccoli 1 min. mee. Giet af. Verhit de olie in een koekenpan en bak de ui 3 min. Roerbak de aardappelen en broccoli 1 min. mee. Maak de tonijn los met een vork. Schep het aardappelmengsel in de springvorm. Verdeel de tonijn en de olijven erover. Klop de eieren los met de knoflook en peper en zout. Schenk over het aardappelmengsel. Bak in ca. 30 min. gaar",
"ingredients": "4 aardappelen (vastkokend, geschild)\n500 g broccoli (in kleine roosjes)\n2 el olijfolie\n2 uien (in ringen)\n2 blikjes tonijnmoot (in olijfolie, uitgelekt)\n3 el zwarte olijven (zonder pit)\n8 eieren\n1 teen knoflook (fijngesneden)",
"servings": 4,
"serveWith": "groene salade en stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/wGId7PW.jpeg"
},
{
"id": 184,
"name": "Tonijnrisotto met paprika",
"recipe": "Fruit ui 2 minuten. Voeg rijst, kruiden en tomatenpuree toe. Voeg bouillon scheut voor scheut toe. Volgende scheut pas als eerste is opgenomen. Bak ondertussen paprika's in een koekenpan 3 minuten. Voeg tonijn toe en warm 1 minuut door. Voeg mengsel aan rijst toe en meng goed.",
"ingredients": "1 ui gesnipperd\n300 g risottorijst\n2 tl Italiaanse kruiden\n1 blikje tomatenpuree (70 g)\n540 ml groentebouillon\n3 paprika's in stukjes\n2 blikjes tonijn (moot in water à 195 g)",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/bBqBlIB.jpeg"
},
{
"id": 185,
"name": "Tonijnsalade met aardappel en sperziebonen",
"recipe": "Kook aardappelen 15 min. Kook sperziebonen 5 min en spoel ze af. Schep mayonaise en citroensap door tonijn. Breng op smaak met zout en peper. Roer maïs en bonen door de aardappelen. Verdeel vis erover en bestrooi met peterselie.",
"ingredients": "500 g ongeschilde iets kruimige aardappelen in vieren\n500 g sperziebonen\n2 blikjes tonijn in olie (à 185 g)\n2 el mayonaise\n1 el citroensap\n1 blikje maïs (150 g)\n2 el peterselie",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/MZvt8J9.jpeg"
},
{
"id": 341,
"name": "Tortellini met andijvie en walnoten",
"recipe": "Rooster de walnoten in een droge, hete koekenpan. Hak de noten grof en houd apart. Verwarm de olie met de knoflook op een lage stand in een hapjespan tot de knoflook zachtjes bruist, maar niet verkleurt. Voeg de chilivlokken en andijvie toe en roerbak een paar minuten tot de groente slinkt. Kook de tortellini. Schep ze uit de pan en meng ze met de andijvie. Besprenkel met nog wat olijfolie en breng op smaak met zout en peper. Verdeel over borden en bestrooi met de Parmezaanse kaas, walnoten en pijnboompitten.",
"ingredients": "50 g walnoten\n4 el olijfolie\n4 teentjes knoflook (geperst)\n1 snufje chilipepervlokken\n400 g andijvie (voorgesneden)\n500 g tortellini gevuld met kaas (koelvers)\n50 g Parmezaanse kaas (geraspt)\n20 g pijnboompitten",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Pasta",
"photo": "https://i.imgur.com/s0ZrRY5.jpeg"
},
{
"id": 378,
"name": "Tortellini met romige citroenprei",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking. Verhit in een hapjespan de olijfolie. Schep de prei erdoor en bak in 8 min. gaar. Boen de citroen schoon en rasp de gele schil eraf. Pers de vrucht uit. Schep de citroenrasp met het -sap en de crème fraîche door de prei. Verwarm nog 4 min. Schep de tortellini op 4 borden. Verdeel de prei erover en bestrooi met de kappertjes en peper naar smaak.",
"ingredients": "500 g tortellini ham\n2 el olijfolie\n800 g prei\n1 citroen\n200 g crème fraîche\n2 el kappertjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/ylW3cTW.jpeg"
},
{
"id": 272,
"name": "Tortilla-pizzasalade met rode paprikasaus",
"recipe": "Pel en snijd de knoflook fijn. Halveer de paprika’s in de lengte, verwijder de zaadlijsten en snijd de paprika’s in blokjes.Verhit een scheutje olie in een pan en fruit de knoflook circa 1 minuut. Voeg de paprika’s toe en bak circa 3 minuten mee. Voeg een scheutje water toe en kook de paprika’s in circa 10 minuten gaar. Breng op smaak met een beetje zout en peper .Pureer de saus met de staafmixer. Verwarm de oven voor op 200 ºC. Leg de tortilla’s op een met bakpapier beklede bakplaat. Bak de tortilla’s in de oven in circa 5 minuten goudbruin en krokant. Verwarm een koekenpan en rooster de pijnboompitten circa 4 minuten. Pel en snijd de ui in halve ringen. Snijd de tomaten in plakjes en meng de oregano erdoor. Snijd de olijven in ringetjes. Schep een lepel paprikasaus op de tortilla’s en besmeer de tortilla’s ermee. Verdeel de ui, tomaten, olijven, rucola en de Parmaham over de tortilla’s. Besprenkel met de olie en bestrooi met de Parmezaanse kaas.",
"ingredients": "2 teentjes knoflook\n2 rode paprika's\nolijfolie om in te bakken\n4 (volkoren) tortilla's\n65 g pijnboompitten\n1 rode ui\n4 roma tomaten\n2 el zwarte olijven\n75 g rucola\n2 tl gedroogde oregano\n150 g Parmaham in dunne plakjes\nolijfolie extra vierge\n100 g geraspte Parmezaanse kaas",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/iXIjvLK.jpeg"
},
{
"id": 390,
"name": "Toscaanse groentestoof",
"recipe": "Verhit 3 el olijfolie in een braadpan en fruit hierin de ui, de helft van de knoflook en de cayennepeper. Schep de knolselderij en winterwortel erdoor en bak deze 3-4 minuten mee. Voeg de courgette, bouillon, gezeefde tomaten en de helft van de tijm en rozemarijn toe en stoof zachtjes 15-17 minuten. Schep de laatste 5 minuten de bonen en olijven erdoor. Breng de groentestoof op smaak met zout en peper. Meng de rest van de knoflook en groene kruiden door de rest van de olie. Serveer de groentestoof met het brood en de kruidenolie.",
"ingredients": "125 ml olijfolie\n1 ui (gesnipperd)\n5 teentjes knoflook (fijngehakt)\n1 mespunt cayennepeper\n1 knolselderij (geschild, in blokjes)\n2 winterwortels (geschild, in dikke plakken)\n1 courgette (in dikke plakken)\n200 ml groentebouillon\n400 ml gezeefde tomaten (pakje)\n1 el verse tijm of\n1 tl gedroogde tijm\n1 tl gedroogde rozemarijn\n400 g witte bonen\n150 g zwarte olijven",
"servings": 4,
"serveWith": "Ciabatta",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/KVeJpg8.jpeg"
},
{
"id": 186,
"name": "Tournedos met roquefort",
"recipe": "Kook 1 pot fond met 2 dl sherry en 1 el tijm in tot 2/3. Meng in maatbeker rest sherry met andere pot fond en vul aan met water tot 6 dl. Hak ui en peterselie fijn. Snijd 4 dunne plakken Roquefort met warm mes. Verkruimel rest Roquefort. Fruit ui 2 min. Schep rijst erdoor en bak glazig. Voeg rest tijm en maatbekervocht toe. 20 min zachtjes koken. Tournedos 3 min bakken. Tournedos op bord leggen, Daarop plakjes Roquefort leggen. Warm houden. Roer rest Roquefort, boter en peterselie door risotto. 5 min van vuur af laten staan. Ingekookt vocht door bakvet roeren.",
"ingredients": "6 takjes tijm\n2 potten vleesfond\n3 dl sherry\n2 rode uien\n4 takjes peterselie\n125 g Roquefort\n4 tournedos\n200 g risottorijst",
"servings": 4,
"serveWith": "sperziebonen, spekjes, gemengde salade",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 472,
"name": "Traybake met hertenbiefstuk",
"recipe": "Bekleed een bakplaat met bakpapier. Verwarm de oven voor op 200 °C. Hak de peterselie fijn en meng met de olijfolie. Snijd de knoflook in plakjes. Schep de knoflook met de ovengroenten om met de helft van de peterselie olie en leg op de bakplaat. Schuif in de oven en rooster de groenten voor ca. 30 minuten. Bestrooi intussen de hertenbiefstukken met zout en peper. Smelt de boter in een koekenpan en bak de hertenbiefstukken snel rondom bruin. Leg ze de laatste 10 minuten van de ovengroenten op de bakplaat. Bak intussen de sjalot en de peper in dezelfde koekenpan glazig in ca. 3 minuten. Roer de bloem erdoor en bak even mee. Blus af met de port en roer beetje voor beetje de vleesbouillon al roerend door het mengsel tot een gladde gebonden saus. Breng eventueel op smaak met zout. Serveer de traybake met hertenbiefstuk en ovengroenten met de peper-portsaus en rest van de peterselie olie. Breng op smaak met zout en peper en garneer met de extra takjes peterselie.",
"ingredients": "1 bosje peterselie\n75 ml olijfolie\n2 tenen knoflook\n800 g ovengroenten (pompoen, rode aardappel, gele en paarse peen)\n4 hertenbiefstukken\nzout\npeper\n50 g roomboter\n1 sjalot (gesnipperd)\ntl peperkorrels (in de vijzel geplet)\n1 el bloem\n100 ml rode port\n100 ml vleesbouillon",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/mEiefoF.jpeg"
},
{
"id": 443,
"name": "Traybake van geroosterde paprika en kipfilet",
"recipe": "Verwarm de oven voor op 200 °C. Snijd de paprika’s in vieren. Verwijder de zaadlijsten en snijd de kwarten elk in 2 stukken. Snijd de tomaten en de uien in acht parten. Snijd de knoflook in dunne plakjes. Boen de citroen schoon, rasp de gele schil, halveer de vrucht en pers een helft uit. Meng het citroenrasp en het citroensap met de olie. Halveer de kipfilets. Besmeer met de citroenolie. Verdeel de groenten, knoflook en kip over een met bakpapier beklede bakplaat. Breng op smaak met versgemalen peper en zout. Bestrooi met de olijven. Bak ca. 30 min. in het midden van de oven tot de kip goudbruin en gaar is en de groenten zijn geroosterd.",
"ingredients": "3 rode paprika's\n500 g trostomaten\n2 rode uien\n2 tenen knoflook\n1 citroen\n2 el milde olijfolie\n380 g kipfilet\n240 g Kalamata-olijven",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/dB7FMQc.jpeg"
},
{
"id": 187,
"name": "Treiterdwergsalade",
"recipe": "Helft amandelschaafsel lichtbruin roosteren. Andere helft in keukenmachine zeer fijn malen. Olie met citroensap, honing, gemalen amandel en helft peterselie tot dressing roeren. Erwtjes door dressing scheppen. Sla en erwtjes over schaal verdelen. Appel en ham erover verdelen. Garneren met geroosterd amandelschaafsel en rest peterselie.",
"ingredients": "1 zakje amandelschaafsel (45 g)\n30 g peterselie\n4 el zonnebloemolie\n1 el citroensap\n2 tl honing\n1 Granny Smith in plakjes\n150 g gegrilde ham in reepjes\n1 blik doperwtjes (280 g)\n75 g veldsla",
"servings": 4,
"serveWith": "geroosterd brood",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 188,
"name": "Varkensfilet met koriander",
"recipe": "Varkensfilet in dunne reepjes snijden. In een kom suiker, maïzena en sesamolie door elkaar roeren. Vlees erdoor scheppen en 15 min laten staan. Grotchampignons in plakjes snijden. Broccoli in roosjes verdelen. Prei in lengte halveren en in stukjes van 3 cm snijden. In een kopje sherry en sojasaus door elkaar roeren. Op hoog vuur 2 el olie in braadpan verhitten. Vlees toevoegen en 3 min roerbakken. Vlees uit pan halen. Rest olie verhitten. Broccoli, champignons en prei toevoegen en 3 min bakken. Saus en vlees erdoor roeren. Op hoog vuur in 1 min door en door verwarmen. Koriander erboven fijnknippen.",
"ingredients": "400 g varkensfilet\n2 tl suiker\n2 tl maïzena\n1 el sesamolie\n3 grotchampignons\n(250 g)\n200 g broccoli\n0,5 dunne prei\n1 el medium dry sherry\n1 el sojasaus\n3 el olie\nverse koriander",
"servings": 4,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": null
},
{
"id": 189,
"name": "Varkensfilet met romige biersaus",
"recipe": "Aardappel in blokjes snijden en bakken tot lichtbruin. Champignons en ham klein snijden. 2 min meebakken met aardappels. Mengsel in ovenschaal. 20 min op 200 °C in oven. Varkensfilet in 12 medaillons snijden. Aan beide kanten bruin bakken. In ovenschaal leggen en 8 min in oven erbij. Bier bij medaillonbakvet en 5 min koken. Crème fraîche erdoor en 2 min pruttelen.",
"ingredients": "4 vastkokende aardappels\n100 g champignons\n100 g ardennerham\n700 g varkensfilet\n1 flesje dubbel trappistenbier\n200 ml crème fraîche",
"servings": 4,
"serveWith": "broccoli",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/PWT4wGr.jpeg"
},
{
"id": 190,
"name": "Varkenshaas met romige saus",
"recipe": "Varkenshaas halveren en met zout en peper bestrooien. In braadpan boter verhitten en varkenshaas in 5 min. bruinbakken. Ui pellen en snipperen. Vlees uit pan nemen. Ui en paprikapoeder in bakvet fruiten. Finesse toevoegen en aan de kook brengen. Varkenshaas in pan leggen en geheel onafgedekt in 10 min. zachtjes gaarstoven, regelmatig keren. Bieslook fijnsnijden en door saus roeren. Saus met zout en peper op smaak brengen.",
"ingredients": "500 g varkenshaas\n50 g boter\n1 ui\n1 tl paprikapoeder\n150 ml finesse voor koken\n15 g zakje verse bieslook",
"servings": 4,
"serveWith": "aardappels sperziebonen",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/kKXC6o6.jpeg"
},
{
"id": 191,
"name": "Varkenshaas met salie",
"recipe": "Varkenshaas in 1 cm plakjes snijden; plakjes 4 min op hoog vuur bakken; uit pan halen; in vet: salie, wijn, room en bouillonpoeder; op hoog vuur 3 min inkoken; plakjes vlees in pan en 1 min meewarmen.",
"ingredients": "250 g varkenshaas\n1 el olie\n4 blaadjes verse salie\n1 dl droge witte wijn\n100 ml room culinair\n1 tl kruidenbouillon poeder",
"servings": 2,
"serveWith": "pasta, tomatensalade",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/u3AIJGF.jpeg"
},
{
"id": 330,
"name": "Varkenshaas Roberto",
"recipe": "Snijd de varkenshaas in vier medaillons. Grill de medaillons half gaar in een ingevette grillpan. Bestrooi ze daarna met de kruidenmix. Leg op iedere medaillon een plakje tomaat en daarop een plakje mozzarella. Plaats de medaillons in een hete oven (225 °C) en laat de kaas gratineren.",
"ingredients": "400 g varkenshaas\n2 tomaten\n1 bol mozzarella\nprovencaalse kruidenmix",
"servings": 4,
"serveWith": "gekookte krielaardappeltjes en roergebakken Italiaanse groenten",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/xmZv5Rv.jpeg"
},
{
"id": 192,
"name": "Varkenshaasje met amandelsaus",
"recipe": "Amandelen heel fijn stampen. Knoflook, tijm, honing, citroensap. Biogarde en olie toevoegen. Goed mengen tot gladde saus. Minstens 2 uur afgedekt in koelkast zetten. Varkenshaasje in plakken snijden. Bestrooien met zout en peper. Boter verhitten. Blees in 4 minuten bruin en gaar bakken. Peterselie fijnknippen en over de saus strooien",
"ingredients": "50 g amandelschaafsel\nknoflook\n2 tl tijm\n2 tl honing\n2 el citroensap\n1 dl biogarde-roer\n1 dl olie\n400 g varkenshaas\n25 g boter",
"servings": 4,
"serveWith": "bospeen en rösti",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/1ke1QWk.jpeg"
},
{
"id": 193,
"name": "Varkenshaasje met groentemix",
"recipe": "Varkenshaas in plakjes van 2 cm snijden. Inwrijven met 1 el kruidenmix. In pan 2 el olie verhitten. Plakjes vlees in 5 min bruin baken. Preien in ringen snijden. Tomaten in partjes snijden. Plakjes vlees uit pan halen en met aluminiumfolie afdekken. In pan 4 dl water met rest van kruidenmix aan kook brengen. Hierin rijst koken. Intussen aan achtergebleven bakvet rest olie toevoegen en verhitten. Prei, tomaat, taugé en knoflook toevoegen. 3 min bakken. Sojasaus, gembersiroop en sesamolie erdoor roeren. Groentemengsel op borden scheppen. Plakjes varkenshaas erop leggen. Kruidige rijst er apart bij geven.",
"ingredients": "300 g varkenshaas\n1 zakje kruidenmix nasi goreng (25 g)\n5 el olie\n2 preien\n6 grote tomaten\n1 pak rijst ± la minute\nknoflook\n250 g taugé\n2 el sojasaus\n2 el gembersiroop\n3 tl sesamolie",
"servings": 2,
"serveWith": "",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/HmyX852.jpeg"
},
{
"id": 194,
"name": "Varkensvlees met marmelade",
"recipe": "Snij het vlees in blokjes. Snipper geschilde gemberwortel, pepertje en knoflook. Snij paprika en prei in reepjes. Roer marmelade, citroensap of azijn, sojasaus en een scheutje water door elkaar. Bak vlees in boter bruin. Laat gemberwortel, peper en knoflook kort meebakken. Bestrooi met zout en peper en voeg paprika toe. Schep marmelademengsel erdoor en laat 20 minuten stoven met deksel schuin op pan. Af en toe omroeren. Schep na 15 minuten de prei erdoor en vlak voor het einde de taugé.",
"ingredients": "500 g varkensfricandeau\n4 cm verse gemberwortel\n1 rood Spaans pepertje\n1 teentje knoflook\n1 rode paprika\n1 gele paprika\n1 prei\n100 g taugé\n2 el sinaasappelmarmelade\n1 el citroensap of azijn\n2 el sojasaus",
"servings": 4,
"serveWith": "rijst",
"protein": "Vlees",
"starch": "Rijst",
"photo": "https://i.imgur.com/9ZCprrd.jpeg"
},
{
"id": 195,
"name": "Verschillende vissoorten in saffraan",
"recipe": "Ui pellen en snipperen, prei en worteltjes in grove stukken snijden. Knoflook pletten. In olie prei, wortel, ui en knoflook 2 min zachtjes bakken. Wijn, fond, tijm, laurier en saffraan toevoegen. 15 min afgedekt koken. Boven hapjespan zeven. Tot helft laten inkoken (±250 ml). Sinaasappel goed boenen en schil dun afraspen. Tomaat ontvellen en kleinsnijden. Basilicum en bieslook kleinsnijden. Zalmmoot in 4 stukken snijden. Scholfilet halveren in lengte. Boter in blokjes door bouillon roeren en smelten; (hierna NIET meer koken). Zalm, schol, mosselen en garnalen in saus leggen. In 8 min gaar laten worden. Zout, peper, citroensap toevoegen. Vis over borden verdelen. Saus erover schenken. Tomaatblokjes over bord. Sinaasappelrasp, bieslook en basilicum erover strooien.",
"ingredients": "1 ui\n0,5 prei\n2 worteltjes\n1 teentje knoflook\n2 dl droge witte wijn, citroensap\n1 pot visfond (380 ml)\n1 tl tijm\n1 laurierblaadje\n1 zakje saffraan\n1 sinaasappel\n1 vleestomaat\n0,5 zakje basilicum (8 g)\n0,5 zakje bieslook (8 g)\n300 g zalmmoten\n350 g scholfilets\n200 g boter\n125 g gekookte mosselen\n75 g garnalen",
"servings": 4,
"serveWith": "warme broodjes",
"protein": "Vis",
"starch": "Brood",
"photo": null
},
{
"id": 196,
"name": "Vis De Swaen",
"recipe": "Verdeel heilbot in reepjes van 3 cm en haal door bloem. Snij paprika's in reepjes. Snij ui in ringen en champignons, komkommer en tomaat in plakjes. Doe scampi's en knoflook in hete olie en laat even kleuren. Voeg mosselen toe en roerbak even. Doe er paprika, ui en champignons bij. Laat een minuut doorgaren. Bak in aparte koekenpan de heilbot. Schroei op hoog vuur dicht en laat op laag vuur nagaren. Zet ondertussen vuur onder scampi's hoog en voeg grillkruiden en gehakte peterselie toe. Roer goed door en doe er maïs, tomaat en komkommer bij. Roer nogmaals goed door en blus af met wijn. Laat het geheel even inkoken. Verdeel mengsel over borden en leg er de heilbot bij.",
"ingredients": "400 g heilbotfilet\n1 el bloem\n1 rode paprika\n1 gele paprika\n1 groene paprika\n1 ui\n250 g champignons\n1/2 komkommer\n4 tomaten\n16 scampi's\n1 teentje knoflook\n20 grote mosselen in schelp\n1 tl grillkruiden\nfijngehakte peterselie\n1 blikje maïs\n1/2 l droge witte wijn",
"servings": 4,
"serveWith": "stokbrood en knoflooksaus",
"protein": "Vis",
"starch": "Brood",
"photo": null
},
{
"id": 364,
"name": "Visbordje met homemade remouladesaus",
"recipe": "Snijd de kappertjes en de peterselie fijn. Meng met de mayonaise, crème fraîche, mosterd en augurkenblokjes tot een saus. Snijd de korsten van het brood en rooster in de broodrooster. Snijd de toast diagonaal doormidden. Verdeel de zalmplakjes, forelfilet en Hollandse garnalen over de borden. Serveer met de remouladesaus en toast.",
"ingredients": "1 el kappertjes\n10 g verse platte peterselie\n4 el mayonaise\n4 el crème fraîche\n1 tl dijonmosterd\n1 el augurkenblokjes\n8 sneetjes wit brood\n100 g sockeye zalm\n125 g gerookte forelfilet\n100 g Hollandse garnalen",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/wV8awGA.jpeg"
},
{
"id": 445,
"name": "Viscurry met komkommersalade",
"recipe": "Kook de rijst. Schaaf of snijd intussen de komkommer in dunne plakjes en meng in een kom met de sjalot, azijn, suiker, olie, zout en peper. Laat staan. Rooster het sesamzaad in een droge, hete koekenpan en houd apart. Fruit 1-2 el currypasta op een lage stand in een hapjespan en voeg de tomatenblokjes toe. Laat een paar minuten zachtjes bakken en giet dan de kokosmelk erbij. Breng aan de kook en leg de blokjes vis in de saus. Stoof de vis in circa 5 minuten gaar. Strooi vlak voor het serveren de basilicum over de curry. Bestrooi de komkommersalade met de sesam en serveer met de rijst bij de viscurry.",
"ingredients": "300 g snelkookrijst\n2 komkommers\n2 sjalotjes, in dunne ringen\n1 el wittewijnazijn\n1 mespunt suiker\n2 el olie\n2 el sesamzaad\n1 el Thaise rode currypasta\n4 tomaten, in blokjes\n200 ml kokosmelk\n400 g witvisfilets, in blokjes\n1 bosje basilicum, grof gehakt",
"servings": 4,
"serveWith": "naan",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/Sa52jAC.jpeg"
},
{
"id": 197,
"name": "Visfilets met mierikswortelsaus",
"recipe": "2 bosuitjes in dunne reepjes snijden. Reepjes in 4 cm stukjes snijden. In koelkast bewaren. Rest bosuitjes in ringen snijden. 4 cm wortel in blokjes snijden. Rest wortel met kaasschaaf in repen schaven en dan in dunne reepjes snijden. In pan fond met vermout, bosuiringetjes, wortelblokjes, peperkorrels en dille aan kook brengen. Onafgedekt in 12 min tot helft inkoken. Fond in steelpan door zeef schenken. Mierikswortel en crème fraîche erdoor. 5 min inkoken tot saus. Bloem, zout en peper mengen. Kabeljauw- en forelfilet in repen van 4 cm snijden. Door bloem wentelen. In koekenpan 25 g boter verhitten. Kabeljauwrepen 3 min rondom bakken. Kabeljauw warm houden. 15 g boter in pan. Forelfilet bakken. Warm houden. Rest boter in pan. Bosui en wortelreepjes 4 min smoren. Mierikswortelsaus zacht opnieuw verwarmen. Saus over borden en in midden wortel/bosui mengsel leggen. Visrepen eromheen leggen; garneren met dille.",
"ingredients": "4 bosuitjes\n1 winterpeen\n380 ml visfond\n2 el witte vermout\n0,5 el witte peperkorrels\n15 g verse dille\n0,5 el geraspte mierikswortel\n200 ml crème fraîche\n30 g bloem\n200 g kabeljauwfilet\n200 g regenboogforelfilet",
"servings": 4,
"serveWith": "krielaardappelen",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 255,
"name": "Vispie met tortillakorstje",
"recipe": "Laat de vis, de mosselen en de garnalen zonodig ontdooien en snijd de vis in stukken van circa 4x4 cm. Verhit de boter in een steelpan en voeg de bloem toe. Blijf circa 2 minuten roeren en voeg scheut voor scheut de melk toe. Blijf roeren tot het een gladde gebonden saus is. Roer er de crème fraîche, de peterselie, de mosterd en het citroensap door en breng pittig op smaak met wat zout en peper. Snijd de paprika in blokjes en laat de maïskorrels uitlekken. Schep ze door de saus. Kook intussen de pasta volgens de aanwijzingen op de verpakking bijna beetgaar, giet af, laat uitlekken en schud op met een scheutje olie om vastplakken te voorkomen. Verwarm de oven voor op 180°C. Doe de pasta in een ingevette ovenschaal en schep er de vis, de mosselen en de garnalen op. Schep er de saus over. Zet de schaal 20 minuten in de voorverwarmde oven. Neem de schaal uit de oven en bestrooi met de grof verkruimelde tortillachips en de geraspte kaas. Zet de schaal terug in de oven tot de kaas is gesmolten en begint te kleuren. Schakel desgewenst de laatste minuten de ovengrill in, maar let op dat het korstje niet verbrandt.",
"ingredients": "400 g kabeljauwfilet\n100 g gekookte mosselen\n100 g grote garnalen\n40 g boter\n40 g bloem\n3 dl melk\n125 g crème fraîche\n2 el. fijngehakte peterselie\n1 el. mosterd\n0.5 citroen (sap)\nzout\nversgemalen peper\n1 rode paprika\n200 g maiskorrels\n400 g pasta (schelpjes of spiraaltjes)\n150 g tortillachips\n100 g grof geraspte jongbelegen Goudse kaas",
"servings": 4,
"serveWith": "Gemengde salade",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/QsZjBhq.jpeg"
},
{
"id": 198,
"name": "Visragout in een rijstrand",
"recipe": "Kook de visfilet in ruim water met de bouillonblokjes tot de vis gaar is. Snijd de ui fijn en smoor deze circa 10 minuten in een kookpan. Doe de bloem erbij en roer dit door de boter met ui tot het een korrelig mengsel wordt. Voeg langzaam net zoveel visbouillon toe tot een smeuïge massa ontstaat. Voeg de vis en de garnalen toe en kruid met peper en peterselie. Doe er als laatste de crème fraîche bij. Kook ondertussen de rijst volgens de aanwijzingen op de verpakking. Roer er een klontje boter door en vul de rijstrand. Stort de rand op een bord en vul deze met de visragout.",
"ingredients": "800 g kabeljauwfilet\n1 ui\n200 g bloem\n100 g boter\n2 visbouillonblokjes\n200 g Noorse garnalen\npeper\npeterselie\n1 bekertje crème fraîche\n400 g rijst",
"servings": 4,
"serveWith": "frisse komkommer/tomatensalade",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 454,
"name": "Visstoofpotje met dragon",
"recipe": "Verhit 1 el boter in een koekenpan en bak de krieltjes in circa 15 minuten goudbruin en knapperig. Schep regelmatig om. Verhit intussen de overige boter in een hapjespan met deksel en bak de prei en wortel circa 5 minuten. Blus af met de wijn. Voeg de room toe, verkruimel het bouillonblokje erover en voeg de dragon toe. Leg de kabeljauw en garnalen in de pan en laat 7 minuten afgedekt stoven. Serveer de vis met de saus bij de krieltjes.",
"ingredients": "2 el boter\n500 g krieltjes (koelvers)\n1 prei, in dunne ringen\n2 wortels, in plakjes\n50 ml witte wijn\n100 ml kookroom\n0.5 visbouillontablet\n1 el gedroogde dragon\n200 g kabeljauwfilets\n100 g garnalen",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": "https://i.imgur.com/ihgBiDL.jpeg"
},
{
"id": 199,
"name": "Vistaart met kabeljauw",
"recipe": "Bladerdeeg laten ontdooien volgens gebruiksaanwijzing. Oven voorverwarmen op 200 °C of gasovenstand 4. Courgette wassen en in blokjes snijden. In braadpan boter verhitten en courgette ca. 5 minuten zachtjes bakken. Wijn en kabeljauw toevoegen, aan kook brengen en ca. 3 minuten stoven. Eieren loskloppen met melk, zout en peper. Taartvorm invetten en bekleden met bladerdeeg. Courgette-vismengsel en garnalen over bodem verdelen. Eieren erover schenken. Taart in midden van oven in ca. 35 minuten gaar bakken.",
"ingredients": "5 plakjes bladerdeeg\n1 courgette\n2 el boter\n100 ml witte wijn\n1 pakje kabeljauwfilet (diepvries 200 g)\n4 eieren (M)\n3 el melk\n2 bakjes roze garnalen (à 125 g)",
"servings": 4,
"serveWith": "komkommersalade",
"protein": "Vis",
"starch": "Brood",
"photo": null
},
{
"id": 200,
"name": "Vistaart met tonijn",
"recipe": "Deeg laten ontdooien. Oven voorverwarmen op 220 °C. Eieren loskloppen met crème fraîche en kaas. Vorm invetten en bekleden met deeg. Tonijn en fruits de mer over bodem verdelen. Eimengsel erover schenken. Taart in 35 min gaar bakken. Tomaten ontvellen en in partjes snijden. Mengen met dressing tot salade.",
"ingredients": "5 plakjes deeg voor hartige taart\n2 blikjes tonijn (à 85 g)\n5 eieren\n100 g geraspte belegen kaas\n125 ml crème fraîche\n2 bakjes fruits de mer (à 150 g)\n750 g tomaten\n5 el balsamicodressing\ntaartvorm 25 cm",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/bNVb6bo.jpeg"
},
{
"id": 201,
"name": "Vitello tonnato",
"recipe": "Wrijf fricandeau in met peper en zout. Pel ui en steek kruidnagels erin. Giet wijn in pan en voeg fricandeau, ui en 2 ansjovisfilets toe. Kook 40 min op laag vuur met deksel op pan. Keer vlees af en toe om. Haal fricandeau uit pan en laat afkoelen. Wikkel in folie om uitdrogen te voorkomen. Kook vocht in tot 2 dl en zeef het. Laat tonijn uitlekken en voeg met 1 el kappertjes en 1 ansjovisfilet bij vocht. Pureer saus met staafmixer. Laat afkoelen en roer en mayonaise en cayennepeper door. Snij vlees in dunne plakken en verdeel over borden. Giet saus over vlees. garneer met rest kappertjes, ansjovisfilets en citroen. Strooi er paprikapoeder over.",
"ingredients": "500 g kalfsfricandeau\n1 ui\n5 kruidnagels\n5 dl droge witte wijn\n1 klein blikje ansjovisfilets\n1 klein blikje tonijn in olie\n2 el kappertjes\n2 el mayonaise\nmespuntje cayennepeper\n1 citroen\nmespuntje paprikapoeder",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": null
},
{
"id": 202,
"name": "Vlaamse runderstoof",
"recipe": "Laat vlees op kamertemperatuur komen. Snij helft prei in dunne ringetjes en rest in stukken van 3 cm snijden. Vlees met peper bestrooien en rondom aanbraden. Preiringen en knoflook 1 minuut meebakken. Wortel, tijm, laurierblad, bier en 100 ml kokend water toevoegen. Geheel afgedekt 2 uur en 30 minuten laten sudderen. Zo nu en dan omscheppen en indien nodig water toevoegen. Brood met mosterd bestrijken en bij vlees in pan leggen. Stukken prei toevoegen. Geheel nog zo'n 20 minuten laten sudderen tot prei beetgaar. Nu en dan omscheppen zodat brood goed met vocht mengt. Op smaak brengen met zout en peper.",
"ingredients": "800 g rib-runderlappen in grote stukken\n4 dunne stengels prei\n2 teentjes knoflook fijngesneden\n300 g winterwortel in plakjes\n6 takjes tijm gerist\n1 laurierblad\n1 flesje donker bier\n1 snee stevig witbrood ontkorst\n1 el grove mosterd",
"servings": 4,
"serveWith": "gekookte aardappels",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/bvS6tJf.jpeg"
},
{
"id": 329,
"name": "Volkorenmacaronisalade met pesto en Parmaham",
"recipe": "Kook de macaroni in ruim water met zout volgens de aanwijzingen op de verpakking. Kook de erwtjes in water met zout in 2 min. beetgaar. Giet de macaroni af en spoel onder stromend water koud. Giet ook de erwtjes af en spoel kort onder stromend water koud. Meng de pesto door de macaroni. Schep de erwtjes, de tomaat, de Parmaham en de basilicum erdoor. Breng op smaak met peper en verdeel over borden. Tip: Voeg voor extra groente blokjes komkommer en fijngesneden bosui toe.",
"ingredients": "300 g volkorenmacaroni\n200 g tuinerwtjes extra fijn\n3 el rode pesto\n4 tomaten\n100 g Parmaham\n3 el bascilicum",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/Xy1y5DH.jpeg"
},
{
"id": 376,
"name": "Volkorenpastasalade met pestosaus en tonijn",
"recipe": "Kook de pasta volgens de aanwijzingen op de verpakking beetgaar. Giet de pasta af en spoel onder stromend water koud. Laat de pasta goed uitlekken. Meng de pestosaus door de pasta. Meng de overige ingrediënten voorzichtig in een ruime schaal. Schep de pasta erdoor en breng de salade op smaak met peper.",
"ingredients": "350 g penne integrali\n185 g pasta pesto basilico\n150 g zongedroogde tomaten\n1 el kappertjes\n160 g tonijn in olijfolie\n4 tomaten\n30 g geroosterde pijnboompitten\n40 g rucola",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/zueRZGi.jpeg"
},
{
"id": 203,
"name": "Warme bonensalade met krokante ham",
"recipe": "In wok of hapjespan 2 el olie verhitten. Paprika's en oesterzwammen op halfhoog vuur 3-4 min. roerbakken. Knoflook even meebakken. Kidneybonen en azijn erdoor scheppen en meewarmen. Gerecht op smaak brengen met zout en peper. Intussen in droge koekenpan met antiaanbaklaag ham krokant bakken. Kaas over vier borden strooien, bonensalade erover verdelen en ham erop leggen.",
"ingredients": "2 el olijfolie\n3 groene paprika's, in stukjes\n300 g oesterzwammen, in reepjes\n2 teentjes knoflook, geperst\n2 blikken rode kidneybonen (a 400 g)\n250 g rauwe ham, grofgesneden\n150 g oude kaas, geraspt",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/89HjIan.jpeg"
},
{
"id": 204,
"name": "Wintersalade",
"recipe": "Kook aardappel 2-3 min in water met tl azijn. Giet af en laat schrikken onder koude kraan. Klop azijn, mosterd zout en peper door elkaar tot zout is opgelost. Klop er 4 el olijfolie door. Bak aardappel met spek knapperig. Bak ui, knoflook en noten kort mee. Doe sla met wortel en bleekselderij in kom en schep vinaigrette erdoor. Schep aardappelmengsel erover.",
"ingredients": "4 vaste aardappelen in blokjes\n1 tl azijn\n1 grote ui gesnipperd\n1 teentje knoflook\n1 winterwortel in blokjes\n2 stelen bleekselderij in boogjes\n100 gepelde walnoten grof gehakt\ngemengde sla\n1 1/2 el blanke azijn\n2 tl mosterd\n6 el olijfolie\n150 g mager rookspek in blokjes",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 487,
"name": "Witlofsalade met appel en spek",
"recipe": "Snijd de onderkant van de witlof en verwijder de harde kern. Snijd in dunne reepjes. Meng in een schaal de witlof en appel. Bak de spekjes krokant in een droge pan. Laat uitlekken op keukenpapier. Rooster de pecannoten kort in een droge koekenpan. Hak ze daarna grof. Meng in een kom de mayonaise, yoghurt, mosterd, honing, citroensap, peper en dragon tot een romige dressing. Meng de dressing door de witlof. Voeg vlak voor het serveren de spek en pecannoten toe voor extra crunch.",
"ingredients": "500 g witlof\n1 appel in kleine blokjes gesneden\n100 g gerookte spekblokjes\n 75 g pecannoten\n 2,5 el Griekse yoghurt\n 2 el mayonaise\n 1.5 tl grove mosterd\n1 tl honing\n1 tl gedroogde dragon\n0.5 citroen uitgeperst", 
"servings": 4,
"serveWith": "geroosterd brood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/U5I2Ncb.jpeg"
},
{
"id": 397,
"name": "Witlofsalade met kip en peer",
"recipe": "Doe de karnemelk en roquefort in een hoge beker en pureer met de staafmixer tot een dressing. Breng op smaak met (versgemalen) peper. Verhit een koekenpan zonder olie of boter en rooster de pecannoten 3 min. Laat afkoelen op een bord. Snijd de bleekselderij in boogjes van ½ cm. Haal de blaadjes van de stronken witlof los en snijd in 3 stukken. Snijd de kipfilet in blokjes van 1 x 1 cm. Snijd de ongeschilde peren in kwarten en verwijder het klokhuis. Snijd in de lengte in dunne plakjes. Meng het witlof, de bleekselderij, kipfilet, peer en veldsla. Schep de dressing erdoor en bestrooi met de pecannoten.",
"ingredients": "150 ml karnemelk\n100 g Roquefort blauwaderkaas 52+\n70 g ongebrande pecannoten (ongezouten)\n400 g bleekselderij\n450 g witlof\n160 g gerookte kipfilet (stuk)\n2 Conference handperen\n75 g veldsla",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/7KZkeoQ.jpeg"
},
{
"id": 464,
"name": "Witloftaart met rode ui en brie",
"recipe": "Verwarm de oven voor op 200 °C. Bekleed een bakplaat met bakpapier. Leg er de plakjes bladerdeeg in een rechthoek op met de bebloemde kant naar beneden. Laat ze elkaar iets overlappen en druk de naden goed dicht. Prik met een vork gaatjes in het deeg. Bak het deeg 10 minuten inhet midden van de oven. Verhit ondertussen de olie in een koekenpan en bak de ui op middelhoog vuur ca 10 minuten. Snijd de onderkant van de stronken witlof af en halveer de witlof in de lengte. Verwijder de harde kern. Snijd het lof in repen. Voeg toe aan de ui en bak 5 minuten mee. Bestrooi met peper en zout naar smaak. Schep het mengsel op het bladerdeeg, verdeel de brie en de oregano erover. Bak de taart nog 20 minuten in de oven.",
"ingredients": "6 plakjes bladerdeeg , ontdooid\n3 el olijfolie\n4 rode uien, in halve ringen\n500 g witlof\n300 g roombrie, in stukjes\n3 tl oregano",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Brood",
"photo": "https://i.imgur.com/BJ9FGw2.jpeg"
},
{
"id": 325,
"name": "Witte bonen met balletjes",
"recipe": "Verwarm een wok op hoog vuur. Schenk olie in wol en voeg balletjes met specerijen toe. Bak 3 min al omscheppend. Voeg ui, bleekselderij en peper toe. Bak groenten in 5 min beetgaar. Voeg witte bonen met de tomatensaus, gembersiroop en ketjeap toe. Verwarm nog 5 min.",
"ingredients": "24 gehaktballetjes\n0,5 el Chinese 5-spices mix\n0,5 tl gemalen koriander\n0,5 tl gemalen komijn\n1 tl laos\n1 ui, fijngesnipperd\n3 stengels bleekselderij, in plakjes\n1 rode peper, in reepjes\n1 blik witte bonen in tomatensaus\n1,5 el gembersiroop\n1 el ketjap manis",
"servings": 4,
"serveWith": "pitabroodje, stokbrood of tortillachips",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/8QgCvZU.jpeg"
},
{
"id": 205,
"name": "Wittebonenschotel met worst en spekjes",
"recipe": "Knoflook pellen en fijnsnijden. Witte bonen in vergiet afspoelen en laten uitlekken. Worst in dunne schuine plakjes snijden. Brood afbakken volgens aanwijzingen op verpakking. Olie in hapjespan verhitten en hierin knoflook 2 min. bakken. Spekblokjes toevoegen en ca. 3 min. meebakken. Prei toevoegen en ca. 2 min. meebakken. Bonen, tomatenblokjes, worst en Provençaalse kruiden toevoegen en gerecht op laag vuur ca. 5 min. laten stoven. Naar smaak peper toevoegen",
"ingredients": "2 tenen knoflook\n2 potten witte bonen (a 370 g)\n1 Groninger metworst (240 g) (of salami)\n2 el olijfolie\n125 g gerookte spekblokjes mager\n300 g gesneden prei\n1 blik tomatenblokjes (400 g)\n2 tl Provençaalse kruiden",
"servings": 4,
"serveWith": "stokbrood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/ZAHZ1bR.jpeg"
},
{
"id": 282,
"name": "Witvis in romige tomatensaus",
"recipe": "Vet de ovenschaal in met vloeibare margarine en leg de witvis erin. Verwarm de oven voor tot 200 °C. Maak een kruisje in de tomaten en dompel ze ca. 10 seconden in kokend water. Spoel ze af met koud water, haal de velletjes van de tomaten en snijd ze in kleine stukjes. Doe de olijfolie in een pan en fruit hierin de ui tot deze glazig is. Voeg de paprika en de gesneden tomaten toe en warm goed door. Voeg eventueel peper en zout toe. Schenk de saus over de vis en bestrooi met basilicum. Leg tot slot de plakken Chaumes erop en laat de vis gedurende 15 min. in de oven garen. Kook, ca. 10 min. nadat de vis in de oven is gegaan, de gnocchi beetgaar volgens de aanwijzingen op de verpakking. Serveer de gnocchi direct met de vis wanneer deze uit de oven komt.",
"ingredients": "2 el vloeibare margarine\n4 stukken witvis\n5 trostomaten\n2 el olijfolie\n1 grote ui gesneden\npaprika 1 groene en 1 rode gesneden\n1 potje verse basilicum\n200 g Chaumes in plakken\n500 g gnocchi",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Pasta",
"photo": "https://i.imgur.com/0VpcGkY.jpeg"
},
{
"id": 478,
"name": "Woknoedels met gember, groente en kip",
"recipe": "Snijd de kip in reepjes. Verhit een wok en schenk de helft van de olie erin. Roerbak de kip in 2 min. goudbruin. Breng op smaak met peper en eventueel zout en neem uit de wok. Kook de woknoedels volgens de aanwijzingen op de verpakking. Giet af en laat afkoelen onder koud stromend water. Laat uitlekken. Schil intussen de gember en snijd de knoglook in plakjes. Snijd de ui in halve ringen en de paprika in reepjes. Snijd de bosui in schuine stukjes van 2 cm. Snijd de gember fijn. Verhit de rest van de olie in de wok en bak de gember en knoflook 1 min. Voeg de rode ui toe en bak 2 min. mee. Doe de paprika, maiskolfjes, oestersaus en cashewnoten erbij en roerbak nog 1 min. Voeg de kip, woknoedels en bosui toe en roerbak nog 1 min.",
"ingredients": "300 g kipfilet\n4 el zonnebloemolie\n248 g woknoedels\n2 cm verse gember\n3 tenen knoflook\n2 rode uien\n2 stuks zoete puntpaprika's\n3 stuks bosuien\n425 g minimaiskolfjes in blik\n3 el oestersaus\n3 el ongezouten cashewnoten",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/JTPfo4w.jpeg"
},
{
"id": 453,
"name": "Woknoedels met varkenshaas in oestersaus",
"recipe": "Bereid de noedels volgens de aanwijzingen op de verpakking. Giet af. Halveer ondertussen de varkenshaas in de lengte. Bestrooi met de kaneel, kruidnagel, peper en zout. Verhit 2 el olie in de wok en bak de varkenshaas 7 min. Keer regelmatig. Voeg de laatste minuut 2 el woksaus toe. Schep het vlees uit de pan op een bord en houd warm onder aluminiumfolie. Schil en rasp de gember. Verhit de rest van de olie in de wok en roerbak de gember 1 min. Voeg de Chinese roerbakmix toe en bak 4 min. Voeg de noedels en de rest van de woksaus toe en bak nog 1 min. Snijd het vlees in dunne reepjes en verdeel over de noedels.",
"ingredients": "250 g mienestjes\n250 g varkenshaas\n1 tl gemalen kaneel\n1 mespunt gemalen kruidnagel\n3 el arachideolie\n200 ml oestersaus\n2 cm verse gember\n800 g Chinese roerbakmix",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/AddxqpJ.jpeg"
},
{
"id": 314,
"name": "Wokpasta met chorizo en tomaatjes",
"recipe": "Verhit de olijfolie in een hapjespan of wok. Bak de chorizo 3 min. op matig vuur. Voeg de ui toe en bak 1 min. mee. Schep de roerbakmix erdoor en bak nog 3 min. Meng de tomaatjes, de mix voor de kruidensaus, de pasta en het water erdoor en breng al roerend aan de kook. Kook de pasta in 3 min. zachtjes en al roerend gaar. Verdeel de wokpasta over de borden en bestrooi met de reepjes basilicum.",
"ingredients": "250 g Honig Wokpasta spaghettin\n1 pakje Honig Mix voor Italiaanse kruidensaus (76 g)\n800 ml water\n2 el olijfolie\n150 g chorizo\n1 ui\n400 g Italiaanse roerbakmix\n250 g cherrytomaatjes\n2 el basilicum",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/MylVEDX.jpeg"
},
{
"id": 206,
"name": "Wokschotel met varkensschnitzel en peultjes",
"recipe": "Bereid de noedels volgens de aanwijzingen op de verpakking. Verhit de olie in een wok en bak de schnitzelreepjes al omscheppend op hoog vuur goudbruin. Schep de knoflook, de peultjes en de noedels erbij en roerbak ze nog 3 minuten mee. Breng op smaak met de sojasaus, gembersiroop en zout en peper. Bestrooi met de bosui en de geroosterde sesamzaadjes.",
"ingredients": "1 pak woknoedels (248 g), of dunne mie\n3 el olie\n400 g varkensschnitzel, in dunne reepjes\n1 teentje knoflook, fijngesneden\n400 g peultjes\n3 el sojasaus\n1 el gembersiroop\n2 bosuitjes, in ringetjes\n2 el sesamzaadjes, geroosterd",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Noedels",
"photo": "https://i.imgur.com/luMRdn9.jpeg"
},
{
"id": 207,
"name": "Wortelgratin met feta en gegrilde kip",
"recipe": "Maak wortels schoon en snijd in schuine plakken. Kook 5 min in ruim water. Verwarm oven op 200 °C. Leg plakjes winterpeen dakpansgewijs in ovenschaal en verdeel feta erover. Druppel 1 el olie erover en bestrooi met peper. Laat gratin in 20-25 min gaar worden in oven. Verhit grillpan, Bestrijk kip met olie en gril 6-7 min. Keer halverwege.",
"ingredients": "1 kg winterpeen\n150 g feta\n300 g kipfilethaasjes",
"servings": 4,
"serveWith": "aardappelpuree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 287,
"name": "Wortelstamp met runderchipolata",
"recipe": "Snijd de aardappelen in stukken en kook ze in water met zout in 20 min. gaar. Snijd ondertussen de wortels in repen van ca. 4 cm lang en ½ cm dik. Kook ze in water met zout in 6 min. beetgaar. Verhit ondertussen 2 el olie in een koekenpan en bak op middelhoog vuur de runderchipolata in ca. 8 min. gaar. Neem uit de pan en houd warm onder een deksel of aluminiumfolie. Bak in het achtergebleven bakvet de komijn en het kerriepoeder 2 min. Voeg de ui toe en bak 4 min. mee. Bak vervolgens de wortelreepjes nog 2 min. mee. Giet de aardappelen af. Voeg de crème fraîche en de rest van de olie toe en stamp de aardappelen met de pureestamper tot een grove puree. Breng op smaak met peper en zout. Voeg de wortel en ui toe aan de stamppot en schep om. Snijd de worstjes in stukken en serveer erbij.",
"ingredients": "1 kg aardappelen iets kruimig, geschild\n400 g winterpeen, geschild\n4 el olijfolie\n300 g runderchipolata\n2 tl gemalen komijn\n2 tl kerriepoeder\n3 rode uien, in halve ringen\n125 ml crème fraîche",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/oR0itN9.jpeg"
},
{
"id": 208,
"name": "Wortelstoofschotel met kalkoen",
"recipe": "Wortels schrappen en in 4 cm stukken snijden. Bosuitjes schoonmaken en in 4 cm stukken snijden. Peultjes wassen en halveren. Sinaasappel uitpersen. Kalkoen in blokjes snijden en bestrooien met zout en chilipoeder. Boter en olie verhitten. Kalkoen 4 min bakken. Knoflook erover persen. Wortels en aardappeltjes erdoor. 2 min roerbakken. Sinaasappelsap, rozemarijn, tijm, wijn en bouillonpoeder toevoegen. 10 min afgedekt stoven. Peultjes en bosui toevoegen. 10 min afgedekt stoven. Regelmatig omscheppen.",
"ingredients": "750 g bospeen (1 bos)\n6 bosuitjes\n100 g peultjes\n1 perssinaasappel\n400 g kalkoenfilet\n1 tl chilipoeder\n25 g boter\n2 teentjes knoflook\n750 g krielaardappeltjes (koeling)\n1 tl rozemarijn\n0,5 tl tijm\n1 dl droge witte wijn\n2 tl bouillonpoeder\n2 el olijfolie\nzout/peper",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 306,
"name": "Wrap met gerookte kip Caesar Salad",
"recipe": "Snijd de gerookte kip in blokjes. Snijd de bleekselderij in dunne repen en daarna in heel fijne blokjes en de bosui in fijne ringetjes. Meng de sla met de kip, bleekselderij, bosui en dressing. Verdeel over de wraps, rol op en zet vast met een prikker.",
"ingredients": "4 tortilla wraps\n200 g ijsbergsla\n300 g gerookte kip\n2 stengels bleekselderij\n3 bosuitjes\n120 ml Caesar dressing",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/fuxe5AS.jpeg"
},
{
"id": 209,
"name": "Zalm in witte wijnsaus",
"recipe": "Sjalotjes fijn snijden. Wijn en fond met sjalotjes, tijm, laurier en 4 takjes peterselie afgedekt 20 minuten laten trekken. Mengsel boven maatbeker zeven. 2 dl achterhouden. Rest terug in pan. Inkoken tot 1½ dl. Slagroom toevoegen. 5 minuten inkoken tot het bindt. Zalm bestrooien met zout en peper. In schaal leggen. Achtergehouden wijnmengsel erover schenken. Afdekken met aluminiumfolie. In oven 20 minuten op 175 °C. Saus aan de kook brengen. Kruidenboter erdoor kloppen. Rest peterselie erdoor roeren. Verwarmen maar niet koken. Saus over zalm gieten.",
"ingredients": "4 sjalotjes\n3 dl fruitige witte wijn\n380 ml visfond\n1 takje tijm\n2 laurierblaadjes\n6 takjes peterselie\n1/8 l slagroom\n600 g zalmmoot\nkruidenboter",
"servings": 4,
"serveWith": "aardappelkroketjes en broccoli",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 319,
"name": "Zalm met rosésaus en risotto",
"recipe": "Kook 200 ml wijn in ca. 10 min. in tot 2 el. Klop van het vuur met een garde de blokjes boter er 1 voor 1 door. Breng op smaak met peper en zout. Bewaar tot gebruik in een thermoskan. Verwarm de oven voor op 175 ºC. Verhit 3 el olie in een pan. Voeg de sjalot toe en fruit 2 min. Doe de rijst erbij en bak 3 min. mee tot de korrels glazig zijn. Voeg de rest van de wijn toe en roer tot deze is opgenomen. Voeg een scheut bouillon toe en roer tot deze is opgenomen. Voeg dan weer een scheut toe en ga zo door tot de rijst gaar is. Dit duurt ca. 20 min. Snijd de kruiden fijn en meng door de risotto. Breng op smaak met peper en zout. Verdeel ondertussen de zalm in 4 porties en leg in de ovenschaal. Bestrijk met de rest van de olie en bestrooi met peper en zout. Bak ca. 12 min. in de oven. Verdeel de zalm over 4 borden en schenk de saus erover. Serveer met de risotto.",
"ingredients": "300 ml rosé wijn\n150 g ijskoude boter (in blokjes)\n4 el olijfolie\n2 sjalotten (gesnipperd)\n300 g risottorijst\n1 l kippenbouillon\n1 pot verse kruiden voor bij vis (dille)\n600 g zalmfilet",
"servings": 4,
"serveWith": "haricots verts",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/1OQbJsZ.jpeg"
},
{
"id": 210,
"name": "Zalm met witbiersaus",
"recipe": "Witlof kleinsnijden. In pan met suiker, nootmuskaat, zout, peper en 2 el water koken tot witlof licht begint te bruinen. Op laag vuur afgedekt 20 min koken. Intussen fond inkoken tot 2 dl. Crème fraîche erdoor en 5 min koken. 1 el boter mengen met 1 el bloem. Zalm bestrooien met rest bloem. Zalm bakken in rest boter en olie. Amandelen fijnhakken. Boter-bloem mengsel door saus roeren. Bier en amandelen erdoor.",
"ingredients": "4 stronkjes witlof\n1 el suiker\nnootmuskaat\n380 ml visfond\n200 ml crème fraîche\n2 el zachte boter\n2 el bloem\n4 stukken zalmfilet a 200 g\n200 ml witbier\n25 g gezouten amandelen",
"servings": 4,
"serveWith": "gekookte aardappelen",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 412,
"name": "Zalmburger met dille en komkommersalade",
"recipe": "Maal de zalm in de keukenmachine met de helft van de dille, de bosui, het ei, zout en peper tot een smeuïg gehakt. Vorm 4 burgers en laat afgedekt circa 30 minuten opstijven in de koelkast. Meng intussen de komkommer met een snuf zout, schep in een fijne zeef en laat 10 minuten uitlekken. Meng de uitgelekte komkommer met de zure room, mayonaise, mierikswortel en de rest van de dille. Bewaar afgedekt in de koelkast. Bak de zalmburgers in een ingevette (grill)pan in circa 5 minuten aan beide kanten gaar. Snijd de broodjes open en bestrijk met een beetje van de komkommersalade. Beleg 4 helften met een paar blaadjes rucola en leg een burger erop. Schep nog een lepel komkommersalade erop en dek af met het kapje.",
"ingredients": "600 g zalmfilets\n1 bosje dille, grof gehakt\n1 bosje lente-/bosui, fijngehakt\n1 ei\n0.5 komkommer, grof geraspt\n4 el zure room\n2 el mayonaise\n1 tl geraspte mierikswortel\n4 hamburgerbroodjes\n1 handje rucola",
"servings": 4,
"serveWith": "friet of een friszure aardappelsalade met appel en rucola",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/dn5rglG.jpeg"
},
{
"id": 211,
"name": "Zalmfilet met shiitake",
"recipe": "Shiitakes in 4 snijden. Bosuitjes in 3 cm stukjes snijden. Azijn, sojasaus, maïzena en 2 el water mengen. Zalm 6 min bakken. Zalm op borden leggen. In dezelfde pan bosui en shiitake 3 min bakken. Sojamengsel erdoor. Mengsel over zalm serveren.",
"ingredients": "100 g shiitake\n6 bosuitjes\n1 el balsamicoazijn\n1 el sojasaus\n1 tl maïzena\n400 g zalmfilet\n3 el boter",
"servings": 4,
"serveWith": "aardappelkroketjes",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 212,
"name": "Zalmquiche",
"recipe": "Klop eieren. Roer zalm en Boursin erdoor. Bekleed bakvorm met bladerdeeg. Doe zalmmengsel erin. Bak 30 min in ovenolp  200 °C.",
"ingredients": "1 blik zalm\n4 eieren\n1 klein pakje Boursin\nbladerdeeg",
"servings": 2,
"serveWith": "salade",
"protein": "Vis",
"starch": "Brood",
"photo": "https://i.imgur.com/bRsDvpL.jpeg"
},
{
"id": 213,
"name": "Zalmtournedos met tuinkruidensaus",
"recipe": "Om elke tournedos 2 plakjes spek vouwen en vastzetten met prikkers. Bloem op bord strooien en tournedos erdoor wentelen. In kom 4 el olie, citroensap, sinaasappelsap, mosterd, bieslook, basilicum en honing mengen. Tournedos snel dichtschroeien. Op middelhoog vuur 8 min bakken. In andere pan pangroenten in weinig water 6-8 min zachtjes koken. Dressing over groenten.",
"ingredients": "2 zalmtournedos (AH)\n4 plakjes katenspek\n1 el bloem\n6 el olijfolie\n1 el citroensap\n1 el sinaasappelsap\n1 el mosterd\n3 tl bieslook\n1 tl basilicum\n1 tl honing\n25 g boter\n1 pak pangroenten Auberge (300 g)",
"servings": 2,
"serveWith": "gebakken krielaardappeltjes",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 214,
"name": "Zeewolf met lycheesaus",
"recipe": "Eieren loskloppen. Cornflakes verkruimelen en op plat bord strooien. Zeewolf door ei wentelen en dan door cornflakes. Lychees afgieten en pureren (staafmixer). Zeewolf 10 min bakken. In steelpan wijn, lycheepuree, citroensap en ketchup aan kook brengen. Slagroom erdoor. Maïzena erdoor.",
"ingredients": "200 g zeewolffilet\n2 eieren\n50 g cornflakes\n310 g lychees\n75 g boter\n2 dl droge witte wijn\n1,5 el citroensap\n1,5 el tomatenketchup\n125 ml slagroom\n2 el maïzena",
"servings": 2,
"serveWith": "aardappelpuree broccoli",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 215,
"name": "Zeewolf met wijnsaus",
"recipe": "Laat sjalot, azijn, wijn en visfond 15-20 min inkoken tot 2-3 el vocht. Roer crème fraîche erdoor en breng aan de kook. Pan van vuur halen en wegzetten tot gebruik. Oven voorverwarmen tot 200 °C. Zeewolf in 4 gelijke stukken snijden en inwrijven met peper en zout. Bak vis in boter in 3 min op hoog vuur bruin. Leg vis in ingevette ovenschaal en strooi bieslook erover. Anijsdrank en citroensap erover sprenkelen. Bakvet uit koekenpan erover schenken. Zeewolf in 7-8 min gaar laten worden in oven. Roomsaus zachtjes roerend verwarmen. Van vuur af halen en 100 g boter toevoegen. Saus met staafmixer schuimig kloppen.",
"ingredients": "1 sjalot\n2 el witte wijnazijn\n100 ml droge witte wijn\n150 ml visfond\n125 ml crème fraîche\n500 g zeewolf\n150 g boter\n2 el bieslook, fijngeknipt\n1 el anijsdrank\n1 el citroensap",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Aardappel",
"photo": null
},
{
"id": 294,
"name": "Zijdezachte zalmrisotto",
"recipe": "Verwarm de oven voor op 200 °C. Schenk een derde van de witte wijn in een ovenschaal en leg de vis erin. Bestrooi de vis met een beetje zout en versgemalen peper en dek de ovenschaal af met aluminiumfolie. Stoom de zalm in de oven in circa 12 minuten gaar. Breng voor de bouillon een pan met het water en de bouillonblokjes aan de kook. Pel en snipper de sjalotten. Snijd de waspenen in gelijke kleine stukjes. Verhit een scheutje olie in een pan en fruit de sjalotten en het anijszaad circa 2 minuten. Voeg de risottorijst toe, bak circa 2 minuten tot de rijst glazig begint te worden, schenk de wijn erbij en laat de wijn verdamoen. Voeg een lepel bouillon en de waspenen toe en kook tot de bouillon verdampt is. Schenk beetje bij beetje de bouillon erbij en gaar de rijst al roerende circa 20 minuten. Snijd de dille fijn. Halveer de citroen. Haal het vel van de zalm en verdeel de zalm in kleine stukjes. Voeg de zalm, het sap een halve citroen, dille, doperwten, geraspte Parmezaanse kaas en de boter toe aan de rijst en laat circa 3 minuten garen met de deksel op de pan. Breng de rijst op smaak met een beetje versgemalen peper. Snijd de andere helft van de citroen in partjes. Verdeel de zijdezachte zalmrisotto over borden en serveer de citroen erbij.",
"ingredients": "150 ml witte wijn\n300 g zalmfilet met vel\n900 ml water\n2 groentebouillonblokjes\n2 sjalotjes\n300 g waspenen\nolijfolie om in te bakken\n2 tl gemalen anijszaad\n300 g risottorijst\n1 bosje dille\n1 citroen\n200 g diepvriesdoperwten\n75 g Parmezaanse kaas\nklontje boter",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": "https://i.imgur.com/tf5eb25.jpeg"
},
{
"id": 438,
"name": "Zoete aardappelgratin met oesterzwammen en brie",
"recipe": "Verwarm de oven voor tot 180 °C. Schil de aardappelen en snijd of schaaf ze in dunne plakjes van 1 mm. Klop in een kom het ei los. Voeg de crème fraîche toe en pers er de knoflook boven uit. Voeg peper naar smaak toe en klop glad. Schep de zoete aardappelplakjes, oesterzwammen en blokjes brie door het ei-roommengsel. Verdeel het aardappelmengsel over de ovenschaaltjes. Bak de gratins in de voorverwarmde oven in 30 min. goudgeel en gaar. Garneer de gratins met takjes kruiden.",
"ingredients": "600 g oranje zoete aardappelen\n1 ei\n200 g crème fraîche\n1 teen knoflook\n150 g oesterzwammen\n100 g roombrie 60+\n1 kruiden naar keuze (bijv. peterselie)",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/0RipOEi.jpeg"
},
{
"id": 216,
"name": "Zoete puntpaprika's met pandanrijst",
"recipe": "Rijst gaarkoken. Puntpaprika's in lengte halveren en zaadlijsten verwijderen. Ui en knoflook pellen en fijnsnijden. Groene paprika's wassen, zaadlijsten verwijderen en in stukjes snijden. In olie ui en knoflook zacht fruiten. Garnalen en groene paprika kort meebakken. Rijst met garnalen, groenten en koriander mengen. Paprika's met rijstmengsel vullen en met olijfolie besprenkelen. Paprika's (en restant vulling) in ovenschaal 15 minuten bakken op 200 °C in oven.",
"ingredients": "200 g pandanrijst\n4 zoete puntpaprika's\n2 zoete uien\n1 teentje knoflook\n2 groene paprika's\n2 bakjes roze garnalen (à 125 g)\n1 tl koriander",
"servings": 4,
"serveWith": "",
"protein": "Vis",
"starch": "Rijst",
"photo": null
},
{
"id": 420,
"name": "Zoetzure kip met boontjes",
"recipe": "Kook de rijst volgens de aanwijzingen op de verpakking. Snijd de paprika in reepjes. Maak de boontjes schoon. Verhit de olie in een wok en roerbak de kip 3 min. Voeg de paprika toe en roerbak 5 min. mee. Voeg de woksaus toe en verwarm nog 1 min. Kook ondertussen de sperziebonen in 8 min. beetgaar. Verdeel de rijst over de borden. Schep de kip en sperziebonen erbij. Bestrooi met de pinda's.",
"ingredients": "300 g witte rijst\n3 paprika's\n500 g sperziebonen\n2 el zonnebloemolie\n300 g kipfiletreepjes\n200 ml woksaus sweet & sour\n3 el gezouten pinda's",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/d4chAVi.jpeg"
},
{
"id": 286,
"name": "Zoetzure koolsalade met shoarma",
"recipe": "Verwijder de buitenste bladeren van de witte kool en snijd de kool in dunne reepjes. Breng de azijn met de suiker en rozijnen aan de kook en laat circa 3 minuten koken. Halveer de cherrytomaten en de olijven. Meng in een kom de warme azijn, cherrytomaten, olijven en de witte kool. Breng op smaak met een beetje zout en versgemalen peper. Snijd de schnitzels in dunne reepjes. Meng de shoarmakruiden en een scheut olie door het vlees. Verhit een scheut olie in een koekenpan. Bak de shoarma in circa 10 minuten op middelhoog vuur goudbruin en gaar. Pluk en hak de peterselie fijn. Pel en hak de knoflook fijn. Meng de yoghurt met de knoflook en de peterselie. Breng op smaak met een beetje versgemalen peper.",
"ingredients": "1 kleine witte kool\n200 ml witte wijnazijn\n3 el suiker\n50 g rozijnen\n250 g cherrytomaten\n50 g zwarte olijven zonder pit\n400 g ongepaneerde varkensschnitzels\n1 el shoarmakruiden\nolijfolie om in te bakken\n0,5 bosje peterselie\n1 teentje knoflook\n100 ml yoghurt",
"servings": 4,
"serveWith": "Turks brood",
"protein": "Vlees",
"starch": "Brood",
"photo": "https://i.imgur.com/KixRdfg.jpeg"
},
{
"id": 415,
"name": "Zomers stoofpotje met gehaktballetjes",
"recipe": "Snijd de ui in smalle partjes, de paprika grof en de courgette in halve plakjes. Verhit de olie in een braadpan en bak de runderballetjes rondom bruin. Voeg de ui toe en fruit deze bruin. Schep de paprika, de courgette en de tomatenblokjes met vocht toe en breng het al roerend aan de kook. Voeg eventueel wat (warm) water toe, als de saus te dik is. Stoof het geheel 10 minuten. Breng op smaak met peper en zout. Verwarm de aardappelpuree volgens de aanwijzingen op de verpakking. Serveer het zomerse stoofpotje met de aardappelpuree.",
"ingredients": "2 uien\n1 rode paprika\n1 courgette\n2 el traditionele olijfolie\n300 g rundergehaktballetjes\n400 g tomatenblokjes\n750 g aardappelpuree",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/WZ8AfQv.jpeg"
},
{
"id": 217,
"name": "Zomerstamppotje met veldsla en romaatjes",
"recipe": "Aardappels schillen en in pan met bodem water en zout in ca. 20 à 25 minuten gaarkoken. Tomaatjes wassen en halveren. Bieslook fijn knippen. Worteltjes van veldsla verwijderen. Aardappels afgieten en met crème fraîche, peper en mespunt nootmuskaat tot stevige puree stampen. Veldsla, tomaatjes, bieslook en spekreepjes door puree scheppen. Als stamppot te veel is afgekoeld, pan nog even op het vuur zetten.",
"ingredients": "1 1/2 kg kruimige aardappels\n1 bakje romaatjes (kleine tomaatjes) (250 g)\n1/2 zakje verse bieslook (à 25 g)\n2 zakken veldsla (à 75 g)\n1 bekertje crème fraîche (125 ml)\nnootmuskaat\n1 bakje uitgebakken spekreepjes (35 g)",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 218,
"name": "Zuid-Afrikaanse maïspasta",
"recipe": "Kook pasta. Bak ondertussen kipfilet en voeg paprika, knoflook en appel toe. Bak even mee. Voeg 2 dl water toe en Mix. Verwarm 1 min. Voeg gewelde rozijnen toe en schep over pasta.",
"ingredients": "1 pak Maispasta (gnocchi)\n300 g kipfilet gesneden.\n1 groene paprika in stukjes\n1 teen knoflook\n1/2 goudrenet in blokjes\n1 pakje Mix voor Mexicaans pastagerecht\n2 dl water\n60 g gewelde rozijnen",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Pasta",
"photo": "https://i.imgur.com/5mIaiS8.jpeg"
},
{
"id": 219,
"name": "Zuurkool gestoofd in donker bier",
"recipe": "Snij paprika en ui klein. Fruit ui en paprika 10 minuten. Giet bier erbij en breng aan kook. Voeg zuurkool, kruidnagels, laurierblaadjes en tijm erbij. Stoof op zeer lage stand 1 uur. Voeg laatste 25 minuten de rozijnen toe en leg zuurkoolspek en worst op de zuurkool. Verwijder voor serveren kruidnagels en laurierblaadjes.",
"ingredients": "1 rode paprika\n1 ui\n1 flesje donker of bokbier\n500 g zuurkool naturel\n2 kruidnagels\n2 laurierblaadjes\n1 el gehakte tijm\n2 el blanke rozijnen\n200 g zuurkoolspek\n1 rookworst",
"servings": 4,
"serveWith": "gekookte aardappels of puree",
"protein": "Vlees",
"starch": "Aardappel",
"photo": null
},
{
"id": 296,
"name": "Zuurkoolovenschotel met cashewnoten",
"recipe": "Ontdooi de plakjes bladerdeeg. Laat de zuurkool uitlekken. Verwarm de oven voor op 200 °C. Breng een pan met water en een beetje zout aan de kook. Schil en snijd de aardappels en de winterpeen in kleine blokjes. Kook de aardappelblokjes en de winterpeenblokjes in circa 4 minuten beetgaar. Giet af en laat uitwasemen op een bordje met keukenpapier. Pel en snipper de uien. Pel en snijd de knoflook fijn. Smelt een klontje boter in een grote pan en fruit de ui en knoflook circa 2 minuten. Snijd de appels in blokjes ter grootte van de aardappels. Voeg de appels, cashewnoten, aardappelblokjes, winterpeen en de zuurkool toe en bak circa 5 minuten mee. Roer de zure room erdoor en breng het geheel op smaak met een beetje zout en versgemalen peper. Verdeel het mengsel over een ingevette ovenschaal. Kluts de eieren in een kom. Snijd het bladerdeeg in repen. Verdeel het bladerdeeg over de ovenschotel in een roostermotief. Schenk de eieren over de ovenschotel en strooi het maanzaad eroverheen. Bak de ovenschotel in de oven in circa 20 minuten goudbruin en gaar.",
"ingredients": "3 plakjes bladerdeeg\n500 g zuurkool\n400 g vastkokende aardappels\n1 winterpeen\n2 uien\n1 teentje knoflook\nboter\n1 appel, Granny Smith\n1 appel, goudrenet\n150 g cashewnoten\n125 ml zure room\n2 eieren\n1 el maanzaad",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/tvgtnJY.jpeg"
},
{
"id": 353,
"name": "Zuurkoolschotel met appel en spekjes",
"recipe": "Verwarm de oven voor op 200 °C. Meng de zuurkool met de mosterd en zure room. Bak de spekblokjes 3-4 minuten in een droge, hete koekenpan. Schep ze uit de pan en bewaar het bakvet. Boor het klokhuis uit 1 appel met schil. Schil de overige 2 appels en snijd ze in blokjes. Meng de appelblokjes, rozijnen en de spekjes door de zuurkool. Schep het zuurkoolmengsel in de grote ovenschaal en verdeel daarover de rösti. Snijd de geboorde appel in dunne plakken en leg deze in het midden van de zuurkool. Bestrooi met een beetje kaneel en schenk het spekvet over de appelplakken. Bak de schotel in het midden van de oven in 30-45 minuten goudbruin. Dek eventueel af met aluminiumfolie wanneer de appel te bruin wordt.",
"ingredients": "500 g wijnzuurkool\n2 el mosterd\n125 ml zure room\n400 g gerookte spekblokjes\n3 appels\n50 g blanke rozijnen\n600 g diepvriesrösti\nkaneelpoeder",
"servings": 4,
"serveWith": "",
"protein": "Vlees",
"starch": "Aardappel",
"photo": "https://i.imgur.com/lowiyDN.jpeg"
},
{
"id": 440,
"name": "Zuurkooltortilla",
"recipe": "Klop de eieren los met peper naar smaak. Verhit in een ruime koekenpan de olie. Bak de aardappelplakjes 5 min. Schep regelmatig om. Schil intussen de winterpeen en snijd ze in plakjes van een 1/2 cm. Voeg de winterpeen en knoflook toe aan de aardappel en bak nog 3 min. Schep de zuurkool erdoor en bak nog 2-3 min. Schenk het ei over het aardappel-zuurkoolmengsel en schep om. Druk met een spatel aan en bak de omelet 10-15 min. op laag vuur tot de onderkant lichtbruin en de bovenkant bijna gestold is Keer de omelet met behulp van een groot deksel en bak ook de andere kant lichtbruin tot de omelet gaar is. Snijd de omelet in punten en leg ze op 4 borden.",
"ingredients": "10 eieren\n700 g aardappelschijfjes\n4 el olijfolie\n500 g winterpeen\n2 tenen knoflook\n500 g verse zuurkool",
"servings": 4,
"serveWith": "",
"protein": "Vega",
"starch": "Aardappel",
"photo": "https://i.imgur.com/S6Gc0EC.jpeg"
}
];

const PROTEIN_TYPES = ['Alle', 'Vlees', 'Vis', 'Vega'];
const STARCH_TYPES = ['Alle', 'Aardappel', 'Rijst', 'Pasta', 'Noedels', 'Couscous', 'Brood'];

const PROTEIN_COLORS = {
 'Vlees': { bg: '#fee2e2', border: '#ef4444', text: '#991b1b' },
 'Vis': { bg: '#dbeafe', border: '#3b82f6', text: '#1e3a8a' },
 'Vega': { bg: '#dcfce7', border: '#22c55e', text: '#14532d' },
 'Alle': { bg: '#f3f4f6', border: '#d1d5db', text: '#1f2937' },
};
const STARCH_COLORS = {
 'Aardappel': { bg: '#fef9c3', border: '#eab308', text: '#713f12' },
 'Rijst': { bg: '#f3e8ff', border: '#a855f7', text: '#581c87' },
 'Pasta': { bg: '#ffedd5', border: '#f97316', text: '#7c2d12' },
 'Noedels': { bg: '#fce7f3', border: '#ec4899', text: '#831843' },
 'Couscous': { bg: '#e0f2fe', border: '#0ea5e9', text: '#0c4a6e' },
 'Brood': { bg: '#d1fae5', border: '#10b981', text: '#064e3b' },
 'Alle': { bg: '#f3f4f6', border: '#d1d5db', text: '#1f2937' },
};

export default function App() {
 const [searchTerm, setSearchTerm] = useState('');
 const [selectedProtein, setSelectedProtein] = useState('');
 const [selectedStarch, setSelectedStarch] = useState('');
 const [selectedRecipe, setSelectedRecipe] = useState(null);
 const [currentServings, setCurrentServings] = useState(1);
 const [savedServings, setSavedServings] = useState(() => {
 const saved = localStorage.getItem('savedServings');
 return saved ? JSON.parse(saved) : {};
 });
 const [personalNotes, setPersonalNotes] = useState(() => {
 const saved = localStorage.getItem('personalNotes');
 return saved ? JSON.parse(saved) : {};
 });
 const [publicNotes, setPublicNotes] = useState({});
 const [editingPersonalNote, setEditingPersonalNote] = useState(false);
 const [editingPublicNote, setEditingPublicNote] = useState(false);
 const [personalNoteDraft, setPersonalNoteDraft] = useState('');
 const [publicNoteDraft, setPublicNoteDraft] = useState('');
 const [favorites, setFavorites] = useState(() => {
 const saved = localStorage.getItem('favorites');
 return saved ? JSON.parse(saved) : [];
 });
 const [showOnlyFavorites, setShowOnlyFavorites] = useState(false);
 const lastRecipeId = useRef(null);

 useEffect(() => {
 if (!selectedRecipe && lastRecipeId.current) {
 const el = document.getElementById(`recipe-${lastRecipeId.current}`);
 if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
 lastRecipeId.current = null;
 }
 }, [selectedRecipe]);

 const toggleFavorite = (recipeId) => {
 setFavorites(prev => {
 const newFavorites = prev.includes(recipeId)
 ? prev.filter(id => id !== recipeId)
 : [...prev, recipeId];
 localStorage.setItem('favorites', JSON.stringify(newFavorites));
 return newFavorites;
 });
 };

 const loadPublicNote = async (recipeId) => {
 try {
 const { data, error } = await supabase
 .from('public_notes')
 .select('text')
 .eq('recipe_id', recipeId)
 .single();
 if (error && error.code !== 'PGRST116') throw error;
 setPublicNotes(prev => ({ ...prev, [recipeId]: data?.text ?? '' }));
 } catch (e) {
 console.error('Could not load public note', e);
 setPublicNotes(prev => ({ ...prev, [recipeId]: prev[recipeId] ?? '' }));
 }
};

const savePublicNote = async (recipeId, text) => {
 try {
 const { error } = await supabase
 .from('public_notes')
 .upsert({ recipe_id: recipeId, text }, { onConflict: 'recipe_id' });
 if (error) throw error;
 setPublicNotes(prev => ({ ...prev, [recipeId]: text }));
 } catch (e) {
 console.error('Could not save public note', e);
 alert('Opslaan mislukt: ' + e.message); // temporary, remove after debugging
 }
};

 const savePersonalNote = (recipeId, text) => {
 const updated = { ...personalNotes, [recipeId]: text };
 setPersonalNotes(updated);
 localStorage.setItem('personalNotes', JSON.stringify(updated));
 };

 const filteredRecipes = useMemo(() => {
 const terms = searchTerm.toLowerCase().split(' ').filter(t => t.trim() !== '');
 return RECIPES_DATA.filter(recipe => {
 const searchable = (recipe.name + ' ' + recipe.ingredients).toLowerCase();
 const matchesSearch = terms.length === 0 || terms.every(term => searchable.includes(term));
 const matchesProtein = !selectedProtein || selectedProtein === 'Alle' || recipe.protein === selectedProtein;
 const matchesStarch = !selectedStarch || selectedStarch === 'Alle' || recipe.starch === selectedStarch;
 const matchesFavorites = !showOnlyFavorites || favorites.includes(recipe.id);
 return matchesSearch && matchesProtein && matchesStarch && matchesFavorites;
 });
 }, [searchTerm, selectedProtein, selectedStarch, showOnlyFavorites, favorites]);

 return (
 <div className="min-h-screen" style={{ backgroundColor: '#FAFAD2', display: 'flex', flexDirection: 'column', paddingLeft: '20px', paddingRight: '20px' }}>
 {!selectedRecipe && (
 <header className="sticky top-0 z-40 bg-white border-b-2 border-gray-300" style={{ marginLeft: '-20px', marginRight: '-20px', paddingLeft: '20px', paddingRight: '20px' }}>
 <div className="max-w-6xl mx-auto px-4 py-4 sm:py-5">
 <div className="flex items-center gap-3 mb-4">
 <div className="p-2.5 bg-yellow-500 rounded-lg shadow-lg">
 <ChefHat size={28} className="text-white" />
 </div>
 <div>
 <h1 className="text-3xl sm:text-4xl font-bold text-gray-800">van Hoof Recepten</h1>
 </div>
 </div>
 
 <div className="relative mb-6">
 <Search size={20} className="absolute left-3 top-4 text-gray-500" />
 <input
 type="text"
 placeholder="Zoek op naam of ingrediënten (bijv. kip courgette)"
 value={searchTerm}
 onChange={(e) => setSearchTerm(e.target.value)}
 style={{
 width: '100%',
 paddingLeft: '40px',
 paddingRight: '16px',
 paddingTop: '12px',
 paddingBottom: '12px',
 backgroundColor: '#ffffff',
 border: '2px solid #d1d5db',
 borderRadius: '8px',
 fontSize: '16px',
 color: '#1f2937',
 boxSizing: 'border-box',
 transition: 'border-color 0.3s'
 }}
 onFocus={(e) => e.target.style.borderColor = '#eab308'}
 onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
 />
 </div>

 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginTop: '16px' }}>
 <span style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', backgroundColor: '#f3f4f6', border: '1.5px solid #e5e7eb', borderRadius: '999px', padding: '6px 14px', whiteSpace: 'nowrap' }}>
 {filteredRecipes.length} / 488 {showOnlyFavorites && `· ${favorites.length} favorieten`}
 </span>
 
 <select
 value={selectedProtein}
 onChange={(e) => setSelectedProtein(e.target.value)}
 style={{
 padding: '7px 14px',
 backgroundColor: selectedProtein && selectedProtein !== 'Alle' ? PROTEIN_COLORS[selectedProtein]?.bg : '#ffffff',
 border: `1.5px solid ${selectedProtein && selectedProtein !== 'Alle' ? PROTEIN_COLORS[selectedProtein]?.border : '#d1d5db'}`,
 borderRadius: '999px',
 fontSize: '14px',
 fontWeight: '600',
 color: selectedProtein && selectedProtein !== 'Alle' ? PROTEIN_COLORS[selectedProtein]?.text : '#374151',
 cursor: 'pointer',
 transition: 'all 0.2s',
 boxSizing: 'border-box'
 }}
 >
 <option value="" disabled hidden>Eiwit</option>
 {PROTEIN_TYPES.map(type => (
 <option key={type} value={type}>{type}</option>
 ))}
 </select>

 <select
 value={selectedStarch}
 onChange={(e) => setSelectedStarch(e.target.value)}
 style={{
 padding: '7px 14px',
 backgroundColor: selectedStarch && selectedStarch !== 'Alle' ? STARCH_COLORS[selectedStarch]?.bg : '#ffffff',
 border: `1.5px solid ${selectedStarch && selectedStarch !== 'Alle' ? STARCH_COLORS[selectedStarch]?.border : '#d1d5db'}`,
 borderRadius: '999px',
 fontSize: '14px',
 fontWeight: '600',
 color: selectedStarch && selectedStarch !== 'Alle' ? STARCH_COLORS[selectedStarch]?.text : '#374151',
 cursor: 'pointer',
 transition: 'all 0.2s',
 boxSizing: 'border-box'
 }}
 >
 <option value="" disabled hidden>Zetmeel</option>
 {STARCH_TYPES.map(type => (
 <option key={type} value={type}>{type}</option>
 ))}
 </select>

 <button
 onClick={() => setShowOnlyFavorites(!showOnlyFavorites)}
 style={{
 padding: '7px 14px',
 backgroundColor: showOnlyFavorites ? '#ef4444' : '#ffffff',
 border: `1.5px solid ${showOnlyFavorites ? '#ef4444' : '#d1d5db'}`,
 borderRadius: '999px',
 fontSize: '14px',
 fontWeight: '600',
 color: showOnlyFavorites ? '#ffffff' : '#374151',
 cursor: 'pointer',
 transition: 'all 0.2s',
 display: 'flex',
 alignItems: 'center',
 gap: '6px'
 }}
 onMouseEnter={(e) => {
 if (!showOnlyFavorites) {
 e.currentTarget.style.borderColor = '#ef4444';
 e.currentTarget.style.color = '#ef4444';
 }
 }}
 onMouseLeave={(e) => {
 if (!showOnlyFavorites) {
 e.currentTarget.style.borderColor = '#d1d5db';
 e.currentTarget.style.color = '#374151';
 }
 }}
 >
 <Heart size={14} fill={showOnlyFavorites ? 'currentColor' : 'none'} /> Favorieten
 </button>
 </div>
 </div>
 </header>
 )}
 <main className="flex-grow max-w-6xl mx-auto px-4 py-8 w-full" style={{ paddingTop: '32px' }}>
 {selectedRecipe ? (
 <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
 <div style={{ position: 'sticky', top: '0', zIndex: 30, backgroundColor: '#FAFAD2', borderBottom: '1.5px solid #e5e7eb', display: 'flex', gap: '10px', padding: '10px 0', marginBottom: '20px' }} className="no-print">
 <button
 onClick={() => setSelectedRecipe(null)}
 style={{
 backgroundColor: '#CDDC39',
 border: '1.5px solid #d1d5db',
 borderRadius: '8px',
 padding: '9px 20px',
 fontSize: '14px',
 fontWeight: 'bold',
 color: '#1f2937',
 cursor: 'pointer',
 transition: 'all 0.2s',
 display: 'flex',
 alignItems: 'center',
 gap: '6px'
 }}
 onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#eab308'; }}
 onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#d1d5db'; }}
 >
 ← Terug
 </button>
 <button
 onClick={() => {
 const style = document.createElement('style');
 style.id = '__print_override';
 style.textContent = '@page { size: A4 portrait; margin: 8mm; } @page :left { margin: 8mm; } @page :right { margin: 8mm; }';
 document.head.appendChild(style);
 window.print();
 setTimeout(() => { const el = document.getElementById('__print_override'); if (el) el.remove(); }, 1000);
 }}
 style={{
 backgroundColor: '#0891b2',
 border: '1.5px solid #0891b2',
 borderRadius: '8px',
 padding: '9px 20px',
 fontSize: '14px',
 fontWeight: 'bold',
 color: '#ffffff',
 cursor: 'pointer',
 transition: 'all 0.2s',
 display: 'flex',
 alignItems: 'center',
 gap: '6px'
 }}
 onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#0e7490'; e.currentTarget.style.borderColor = '#0e7490'; }}
 onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#0891b2'; e.currentTarget.style.borderColor = '#0891b2'; }}
 >
 <Printer size={15} /> Afdrukken
 </button>
 </div>
 <div style={{ flex: 1 }}>
 <div className="bg-white rounded-lg shadow-xl border-2 border-gray-300">
 <div className="bg-yellow-500 px-6 sm:px-8 py-10">
 {selectedRecipe.photo && (
 <div style={{ marginBottom: '20px', maxWidth: '100%', maxHeight: '400px', overflow: 'hidden', borderRadius: '8px', backgroundColor: '#f3f4f6' }}>
 <img 
 src={selectedRecipe.photo} 
 alt={selectedRecipe.name} 
 style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '8px', display: 'block' }}
 onError={(e) => { e.target.style.display = 'none'; }}
 />
 </div>
 )}
 <button
 onClick={() => toggleFavorite(selectedRecipe.id)}
 style={{
 backgroundColor: 'transparent',
 border: 'none',
 cursor: 'pointer',
 marginBottom: '20px',
 padding: '0'
 }}
 >
 <Heart 
 size={36} 
 style={{ color: favorites.includes(selectedRecipe.id) ? '#ef4444' : '#ffffff' }}
 fill={favorites.includes(selectedRecipe.id) ? '#ef4444' : 'none'}
 />
 </button>
 <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 leading-tight">{selectedRecipe.name}</h2>
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '20px', alignItems: 'center' }}>
 <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#fef08a', borderRadius: '999px', padding: '4px 10px' }}>
 <button
 onClick={() => setCurrentServings(s => {
 const n = Math.max(1, s - 1);
 const updated = { ...savedServings, [selectedRecipe.id]: n };
 setSavedServings(updated);
 localStorage.setItem('savedServings', JSON.stringify(updated));
 return n;
 })}
 style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '18px', color: '#1f2937', lineHeight: 1, padding: '0 4px' }}
 >−</button>
 <span style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', minWidth: '60px', textAlign: 'center' }}>
 {currentServings} pers.
 </span>
 <button
 onClick={() => setCurrentServings(s => {
 const n = s + 1;
 const updated = { ...savedServings, [selectedRecipe.id]: n };
 setSavedServings(updated);
 localStorage.setItem('savedServings', JSON.stringify(updated));
 return n;
 })}
 style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '18px', color: '#1f2937', lineHeight: 1, padding: '0 4px' }}
 >+</button>
 </div>
 <span style={{ backgroundColor: PROTEIN_COLORS[selectedRecipe.protein]?.bg || '#fef08a', color: PROTEIN_COLORS[selectedRecipe.protein]?.text || '#1f2937', border: `1px solid ${PROTEIN_COLORS[selectedRecipe.protein]?.border || '#d1d5db'}`, fontSize: '14px', fontWeight: '600', padding: '6px 14px', borderRadius: '999px' }}>
 {selectedRecipe.protein}
 </span>
 <span style={{ backgroundColor: STARCH_COLORS[selectedRecipe.starch]?.bg || '#fef08a', color: STARCH_COLORS[selectedRecipe.starch]?.text || '#1f2937', border: `1px solid ${STARCH_COLORS[selectedRecipe.starch]?.border || '#d1d5db'}`, fontSize: '14px', fontWeight: '600', padding: '6px 14px', borderRadius: '999px' }}>
 {selectedRecipe.starch}
 </span>
 </div>
 </div>

 <div className="p-6 sm:p-10">
 <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)', gap: '24px', marginBottom: '40px' }} className="recipe-two-col">
 <section>
 <h3 className="text-2xl font-bold text-gray-800 mb-5">Ingrediënten</h3>
 <div className="bg-white p-6 rounded-lg border-2 border-gray-300">
 <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', color: '#1f2937', fontSize: '16px', lineHeight: '1.6' }}>
 {selectedRecipe.ingredients.split('\n').map((line, i) => {
 const factor = currentServings / selectedRecipe.servings;
 const scaled = line.replace(/(\d+([.,]\d+)?)/g, (match) => {
 const num = parseFloat(match.replace(',', '.')) * factor;
 const rounded = Math.round(num * 10) / 10;
 return rounded % 1 === 0 ? rounded.toString() : rounded.toString().replace('.', ',');
 });
 if (!scaled.trim()) return <div key={i} style={{ height: '6px' }} />;
 return (
 <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: '8px', paddingBottom: '4px' }}>
 <span className="ingredient-bullet" style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#eab308', flexShrink: 0, marginTop: '2px', display: 'inline-block' }} />
 <span>{scaled}</span>
 </div>
 );
 })}
 </div>
 </div>
 </section>

 <section>
 <h3 className="text-2xl font-bold text-gray-800 mb-5">Bereidingswijze</h3>
 <div className="bg-white p-6 rounded-lg border-2 border-gray-300">
 <p className="text-gray-700 text-base leading-relaxed">
 {selectedRecipe.recipe}
 </p>
 </div>
 </section>
 </div>

 {selectedRecipe.serveWith && (
 <section className="mb-10">
 <h3 className="text-2xl font-bold text-gray-800 mb-5">Serveren met</h3>
 <div className="bg-white p-6 rounded-lg border-2 border-gray-300">
 <p className="text-gray-700 font-semibold text-lg">{selectedRecipe.serveWith}</p>
 </div>
 </section>
 )}

 {/* Personal Note */}
 <section className="mb-10">
 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
 <h3 className="text-2xl font-bold text-gray-800">🔒 Mijn notitie</h3>
 {!editingPersonalNote && (
 <button
 onClick={() => { setPersonalNoteDraft(personalNotes[selectedRecipe.id] || ''); setEditingPersonalNote(true); }}
 style={{ backgroundColor: '#f3f4f6', border: '1.5px solid #d1d5db', borderRadius: '999px', padding: '4px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '4px' }}
 >✏️ Bewerken</button>
 )}
 </div>
 {editingPersonalNote ? (
 <div>
 <textarea
 value={personalNoteDraft}
 onChange={(e) => setPersonalNoteDraft(e.target.value)}
 placeholder="Schrijf hier je persoonlijke notitie..."
 style={{ width: '100%', minHeight: '100px', padding: '12px', border: '2px solid #eab308', borderRadius: '8px', fontSize: '16px', lineHeight: '1.6', resize: 'vertical', boxSizing: 'border-box' }}
 />
 <div className="note-action-buttons" style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
 <button
 onClick={() => { savePersonalNote(selectedRecipe.id, personalNoteDraft); setEditingPersonalNote(false); }}
 style={{ backgroundColor: '#CDDC39', border: '2px solid #d1d5db', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer' }}
 >Opslaan</button>
 <button
 onClick={() => setEditingPersonalNote(false)}
 style={{ backgroundColor: '#f3f4f6', border: '2px solid #d1d5db', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer' }}
 >Annuleren</button>
 </div>
 </div>
 ) : (
 <div className="bg-white p-6 rounded-lg border-2 border-gray-300">
 <p data-empty={!personalNotes[selectedRecipe.id]?.trim() ? "true" : "false"} style={{ color: personalNotes[selectedRecipe.id] ? '#1f2937' : '#9ca3af', fontSize: '16px', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
 {personalNotes[selectedRecipe.id] || 'Nog geen persoonlijke notitie.'}
 </p>
 </div>
 )}
 </section>

 {/* Public Note */}
 <section className="mb-10" style={{ marginBottom: '40px', paddingBottom: '24px' }}>
 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
 <h3 className="text-2xl font-bold text-gray-800">👨‍👩‍👧 Gezinsnotitie</h3>
 {!editingPublicNote && (
 <button
 onClick={() => { setPublicNoteDraft(publicNotes[selectedRecipe.id] || ''); setEditingPublicNote(true); }}
 style={{ backgroundColor: '#f3f4f6', border: '1.5px solid #d1d5db', borderRadius: '999px', padding: '4px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '4px' }}
 >✏️ Bewerken</button>
 )}
 </div>
 {editingPublicNote ? (
 <div>
 <textarea
 value={publicNoteDraft}
 onChange={(e) => setPublicNoteDraft(e.target.value)}
 placeholder="Schrijf hier een notitie voor iedereen..."
 style={{ width: '100%', minHeight: '100px', padding: '12px', border: '2px solid #0891b2', borderRadius: '8px', fontSize: '16px', lineHeight: '1.6', resize: 'vertical', boxSizing: 'border-box' }}
 />
 <div className="note-action-buttons" style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
 <button
 onClick={() => { savePublicNote(selectedRecipe.id, publicNoteDraft); setEditingPublicNote(false); }}
 style={{ backgroundColor: '#0891b2', border: '2px solid #0891b2', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', color: 'white', cursor: 'pointer' }}
 >Opslaan</button>
 <button
 onClick={() => setEditingPublicNote(false)}
 style={{ backgroundColor: '#f3f4f6', border: '2px solid #d1d5db', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer' }}
 >Annuleren</button>
 </div>
 </div>
 ) : (
 <div className="bg-white p-6 rounded-lg border-2 border-gray-300">
 <p data-empty={!publicNotes[selectedRecipe.id]?.trim() ? "true" : "false"} style={{ color: publicNotes[selectedRecipe.id] ? '#1f2937' : '#9ca3af', fontSize: '16px', lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
 {publicNotes[selectedRecipe.id] === undefined ? 'Laden...' : publicNotes[selectedRecipe.id] || 'Nog geen gezinsnotitie.'}
 </p>
 </div>
 )}
 </section>
 </div>
 </div>
 </div>


 <style>{`
 @media print {
 @page { margin: 8mm; size: A4 portrait; }
 @page :left { margin: 8mm; }
 @page :right { margin: 8mm; }

 /* Hide chrome */
 header, .no-print, button, textarea, .note-action-buttons { display: none !important; }
 body, html { background: white !important; margin: 0 !important; padding: 0 !important; }

 /* Kill all outer spacing */
 #root, main, [class*="max-w"], [class*="mx-auto"], [class*="px"], [class*="py"], [class*="flex-grow"] {
 padding: 0 !important; margin: 0 !important; max-width: 100% !important; width: 100% !important;
 }

 /* Flatten card */
 .bg-white.rounded-lg.shadow-xl { box-shadow: none !important; border: none !important; border-radius: 0 !important; }

 /* Header: compact with small float photo */
 .bg-yellow-500 { background-color: #eab308 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; padding: 8px 12px !important; display: block !important; overflow: hidden !important; }
 .bg-yellow-500 > div:first-child { float: right !important; width: 110px !important; height: 80px !important; margin: 0 0 6px 10px !important; overflow: hidden !important; }
 .bg-yellow-500 img { width: 110px !important; height: 80px !important; object-fit: cover !important; border-radius: 4px !important; }
 .bg-yellow-500 h2 { font-size: 18px !important; margin: 0 0 4px !important; line-height: 1.2 !important; }
 .bg-yellow-500 > div:last-child { margin-top: 4px !important; display: flex !important; flex-wrap: wrap !important; gap: 4px !important; }
 .bg-yellow-500 span { font-size: 10px !important; padding: 2px 7px !important; }

 /* Main content: no padding waste */
 .p-6, .p-10 { padding: 6px 10px !important; }

 /* Ingredients + recipe stacked vertically */
 .recipe-two-col { display: grid !important; grid-template-columns: 1fr !important; gap: 6px !important; margin-bottom: 6px !important; }

 /* Section headings */
 h3, .text-2xl { font-size: 11px !important; font-weight: bold !important; margin: 0 0 3px !important; }

 /* Content boxes: strip padding and border */
 .bg-white.p-6.rounded-lg, .bg-white.p-6.rounded-lg.border-2 { padding: 5px 8px !important; border: 1px solid #ccc !important; border-radius: 3px !important; }

 /* All text tight and small */
 p, div, li { font-size: 10px !important; line-height: 1.35 !important; }
 span { font-size: 10px !important; line-height: 1.35 !important; }

 /* Ingredient bullets: restore size and color */
 span.ingredient-bullet { width: 6px !important; height: 6px !important; min-width: 6px !important; min-height: 6px !important; border-radius: 50% !important; background-color: #eab308 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; display: inline-block !important; flex-shrink: 0 !important; font-size: 0 !important; }

 /* serveWith and notes: compact */
 section.mb-10 { margin-bottom: 4px !important; display: block !important; }

 /* Hide empty notes */
 section.mb-10:has(p[data-empty="true"]) { display: none !important; }

 /* No page breaks anywhere */
 * { page-break-inside: auto !important; page-break-before: auto !important; page-break-after: auto !important; }
 }
 @media (max-width: 640px) {
 .recipe-two-col {
 grid-template-columns: 1fr !important;
 }
 .note-action-buttons {
 flex-wrap: wrap;
 }
 .note-action-buttons button {
 flex: 1;
 min-width: 0;
 padding: 12px 16px !important;
 font-size: 15px !important;
 }
 }
 `}</style>
 </div>
 ) : (
 <div>
 {filteredRecipes.length === 0 ? (
 <div className="text-center py-16">
 <ChefHat size={56} className="mx-auto text-gray-400 mb-4" />
 <p className="text-xl text-gray-800 font-bold">Geen recepten gevonden</p>
 <p className="text-gray-600 text-base mt-2">Probeer andere zoektermen of filters</p>
 </div>
 ) : (
 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
 {filteredRecipes.map((recipe) => (
 <button
 key={recipe.id}
 id={`recipe-${recipe.id}`}
 onClick={() => {
 lastRecipeId.current = recipe.id;
 setSelectedRecipe(recipe);
 setCurrentServings(savedServings[recipe.id] || recipe.servings);
 setEditingPersonalNote(false);
 setEditingPublicNote(false);
 setPersonalNoteDraft(personalNotes[recipe.id] || '');
 loadPublicNote(recipe.id);
 window.scrollTo(0, 0);
 }}
 style={{
 backgroundColor: '#ffffff',
 width: '100%',
 textAlign: 'left',
 borderRadius: '12px',
 boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
 border: '1.5px solid #e5e7eb',
 padding: '0',
 display: 'flex',
 flexDirection: 'column',
 cursor: 'pointer',
 transition: 'all 0.2s',
 overflow: 'hidden'
 }}
 onMouseEnter={(e) => {
 e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.13)';
 e.currentTarget.style.borderColor = '#eab308';
 e.currentTarget.style.transform = 'translateY(-2px)';
 }}
 onMouseLeave={(e) => {
 e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
 e.currentTarget.style.borderColor = '#e5e7eb';
 e.currentTarget.style.transform = 'translateY(0)';
 }}
 >
 {/* Card image */}
 <div style={{ width: '100%', height: '140px', overflow: 'hidden', backgroundColor: '#f3f4f6', flexShrink: 0, position: 'relative' }}>
 {recipe.photo ? (
 <img
 src={recipe.photo}
 alt={recipe.name}
 style={{ width: '100%', height: '100%', objectFit: 'cover' }}
 onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
 />
 ) : null}
 <div style={{ width: '100%', height: '100%', display: recipe.photo ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#CDDC39', position: recipe.photo ? 'absolute' : 'relative', top: 0, left: 0 }}>
 <ChefHat size={40} style={{ color: '#6b7280' }} />
 </div>
 {/* Favorite button overlay */}
 <button
 onClick={(e) => {
 e.stopPropagation();
 toggleFavorite(recipe.id);
 }}
 style={{
 position: 'absolute',
 top: '8px',
 right: '8px',
 backgroundColor: 'rgba(255,255,255,0.85)',
 border: 'none',
 borderRadius: '999px',
 width: '30px',
 height: '30px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 cursor: 'pointer',
 transition: 'transform 0.2s'
 }}
 onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
 onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
 >
 <Heart
 size={16}
 style={{ color: favorites.includes(recipe.id) ? '#ef4444' : '#9ca3af' }}
 fill={favorites.includes(recipe.id) ? '#ef4444' : 'none'}
 />
 </button>
 </div>

 {/* Card body */}
 <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
 <h3 style={{ fontWeight: 'bold', color: '#1f2937', fontSize: '15px', margin: '0', lineHeight: '1.3' }}>
 {recipe.name}
 </h3>
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: 'auto' }}>
 <span style={{ backgroundColor: PROTEIN_COLORS[recipe.protein]?.bg || '#fef08a', color: PROTEIN_COLORS[recipe.protein]?.text || '#1f2937', border: `1px solid ${PROTEIN_COLORS[recipe.protein]?.border || '#d1d5db'}`, fontSize: '11px', fontWeight: '600', padding: '3px 8px', borderRadius: '999px' }}>
 {recipe.protein}
 </span>
 <span style={{ backgroundColor: STARCH_COLORS[recipe.starch]?.bg || '#fef08a', color: STARCH_COLORS[recipe.starch]?.text || '#1f2937', border: `1px solid ${STARCH_COLORS[recipe.starch]?.border || '#d1d5db'}`, fontSize: '11px', fontWeight: '600', padding: '3px 8px', borderRadius: '999px' }}>
 {recipe.starch}
 </span>
 </div>
 </div>
 </button>
 ))}
 </div>
 )}
 </div>
 )}
 </main>
 </div>
 );
}
